(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[118],{

/***/ "+Mso":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _default = BooleanSchema;
exports.default = _default;

function BooleanSchema() {
  var _this = this;

  if (!(this instanceof BooleanSchema)) return new BooleanSchema();

  _mixed.default.call(this, {
    type: 'boolean'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (!this.isType(value)) {
        if (/^(true|1)$/i.test(value)) return true;
        if (/^(false|0)$/i.test(value)) return false;
      }

      return value;
    });
  });
}

(0, _inherits.default)(BooleanSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "+Rc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaTrigger; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("XiOS");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("EkOT");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("1JJ2");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("m1JM");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("sRdV");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("U6GL");
/* harmony import */ var _frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("W+NJ");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("U2fG");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_24__);










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var CUSTOM_HEADER_HEIGHT = 44;
var CriteriaTrigger = function CriteriaTrigger(props) {
  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_15__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_10__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_11__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0];

  var pageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_12__[/* usePageContext */ "b"])();
  var rootRef = Object(react__WEBPACK_IMPORTED_MODULE_10__["useRef"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__[/* useTracking */ "a"])();

  var customLayerHeader = __jsx("div", {
    className: "flex items-center justify-between fixed z-1 top-0 inset-x-0 bg-white border-b px-15",
    style: {
      height: CUSTOM_HEADER_HEIGHT,
      maxHeight: CUSTOM_HEADER_HEIGHT
    }
  }, __jsx("button", {
    onClick: props.onClose,
    type: "button",
    className: "leading-0 ms-auto flex-1"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    hasRtl: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_14__[/* ICONS */ "a"].ARROW_TAIL_LEFT,
    width: "calc(18rem / 16)"
  }), __jsx("span", {
    className: "sr-only"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('common.backNavigation'))), __jsx("span", {
    className: "mx-auto px-10 text-center w-full"
  }, props.layerHeader), __jsx("span", {
    className: "flex-1 h-full"
  }, props.layerHeaderSlot));

  var buttons = props.buttons.map(function (btnProps) {
    var children = btnProps.children,
        allOtherProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(btnProps, ["children"]);

    return __jsx("div", {
      key: Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_16__[/* generateUniqueId */ "b"])([btnProps.theme, btnProps.color, btnProps.colorBg, btnProps.colorBorder], 'criteria-btn-')
    }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_19__[/* Button */ "a"], allOtherProps, children));
  });
  var criteriaDropdownOrLayer = isDesktop ? __jsx("div", {
    className: "flex flex-2"
  }, __jsx(_frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_21__[/* DropDown */ "a"], {
    className: "flex-1" // $FlowFixMe
    ,
    contentStyle: _objectSpread({
      minWidth: props.dropDownMinWidth || 300
    }, props.dropDownStyle),
    isExpanded: props.isOpen,
    onClose: props.onClose,
    relative: props.isDropDownRelative,
    hasArrow: false,
    rootRef: rootRef,
    theme: "hollow",
    unmountsOnClose: true
  }, function () {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_10___default.a.Fragment, null, props.children, props.reassurance.shouldDisplay && __jsx("div", {
      className: "pt-0 p-10 max-w-1/2 mx-auto text-mediumGrey text-start text-10"
    }, props.reassurance.text), !!buttons.length && __jsx("div", {
      className: "p-20"
    }, props.buttonsSlot && __jsx("div", {
      className: "pb-10"
    }, props.buttonsSlot), __jsx("div", {
      className: "flex gap-10 items-center justify-between"
    }, buttons)));
  })) : __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_23__[/* Layer */ "b"], {
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_13__[/* ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER */ "q"],
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('common.close'),
    customHeader: {
      content: customLayerHeader,
      height: CUSTOM_HEADER_HEIGHT
    },
    hasAnimateEnter: true,
    onClose: props.onClose
  }, __jsx("div", {
    className: "flex flex-col h-full"
  }, __jsx("div", {
    className: "scroll-y"
  }, props.children, props.reassurance.shouldDisplay && __jsx("div", {
    className: "sm:border-t-1 mt-10 lg:mt-0 mx-10 sm:pt-10 text-mediumGrey text-start text-12"
  }, props.reassurance.text)), buttons.length && __jsx("div", {
    className: "bg-white border-t-1 p-15 shadow mt-auto"
  }, props.buttonsSlot && __jsx("div", {
    className: "pb-10"
  }, props.buttonsSlot), __jsx("div", {
    className: "flex items-center justify-between mt-auto lg:px-0 relative w-full text-end"
  }, buttons))));
  var defaultTheme = isDesktop ? 'default' : 'remote';
  var theme = props.theme ? props.theme : defaultTheme;
  return __jsx("div", {
    "data-testid": props.dataTestId,
    ref: rootRef,
    className: classnames__WEBPACK_IMPORTED_MODULE_24___default()({
      'border-success border-1': !!props.badgeCount
    }, props.className)
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_24___default()('relative', {
      'criteria-arrow': props.isOpen
    })
  }, __jsx(_frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_22__[/* InputButton */ "a"], {
    badgeCount: props.badgeCount,
    className: "w-full",
    dataTestId: "criteria-trigger-button",
    hasSwitch: props.hasSwitch,
    iconName: props.buttonIcon,
    isActive: props.isOpen,
    isFilled: props.buttonIsFilled,
    isLoading: isDesktop && props.isLoading,
    key: String(isAppMounted),
    onClear: isDesktop ? function () {
      props.onClear && props.onClear();
    } : undefined,
    onClick: function onClick(e) {
      e === null || e === void 0 ? void 0 : e.preventDefault();

      if (props.isOpen) {
        props.onClose && props.onClose();
      } else {
        props.onOpen && props.onOpen();

        if (props.trackingLabel && criteriaContext.trackingActionName) {
          track({
            actionGA: criteriaContext.trackingActionName,
            categoryGA: pageContext.pageId,
            labelGA: props.trackingLabel
          });
        }
      }
    },
    theme: theme
  }, props.buttonLabel)), props.isOpen && criteriaDropdownOrLayer);
};
CriteriaTrigger.defaultProps = {
  buttons: [],
  reassurance: {
    shouldDisplay: false,
    text: ''
  }
};

/***/ }),

/***/ "+VQP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _isodate = _interopRequireDefault(__webpack_require__("y/CH"));

var _locale = __webpack_require__("qr7w");

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var invalidDate = new Date('');

var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

var _default = DateSchema;
exports.default = _default;

function DateSchema() {
  var _this = this;

  if (!(this instanceof DateSchema)) return new DateSchema();

  _mixed.default.call(this, {
    type: 'date'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      value = (0, _isodate.default)(value);
      return value ? new Date(value) : invalidDate;
    });
  });
}

(0, _inherits.default)(DateSchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.date.min;
    }

    var limit = _min;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_min);
      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(limit);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.date.max;
    }

    var limit = _max;

    if (!_Reference.default.isRef(limit)) {
      limit = this.cast(_max);
      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(limit);
      }
    });
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "+mhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureCity; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PFCZ");



function setDepartureCity(_ref) {
  var value = _ref.value;
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_CITY */ "b"], {
    value: value
  });
}



/***/ }),

/***/ "/013":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("piMb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("E9XD");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("nnRT");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flow.js
var flow = __webpack_require__("jPI1");
var flow_default = /*#__PURE__*/__webpack_require__.n(flow);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/findIndex.js
var findIndex = __webpack_require__("FllU");
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("B6y2");

// CONCATENATED MODULE: ./src/utils/immutability/immutability.js










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function updateArrayIndexFp(array, index, updater) {
  // $FlowFixMe
  return Object.values(_objectSpread(_objectSpread({}, array), {}, Object(defineProperty["a" /* default */])({}, index, updater(array[index]))));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-validator-hoc/FormValidator.jsx




























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function FormValidator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FormValidator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormValidator_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormValidator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable flowtype/no-weak-types */




function _isFormValid(fields) {
  return fields.every(function (field) {
    return field.validationState === validationStates["b" /* IS_VALID */];
  });
}

function _isFieldValid(field) {
  var fieldValidators = get_default()(field, 'validators') || [];
  return !isEmpty_default()(fieldValidators) ? fieldValidators.every(function (validator) {
    return validator.isValid(field.value);
  }) : true;
}

function _setFieldValidationState(field) {
  if (isEmpty_default()(get_default()(field, 'validators'))) {
    return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
      validationState: validationStates["b" /* IS_VALID */]
    });
  }

  if (!field.value) {
    return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
      validationState: _isFieldValid(field) ? validationStates["b" /* IS_VALID */] : validationStates["c" /* NOT_VALIDATED */]
    });
  }

  return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
    validationState: _isFieldValid(field) ? validationStates["b" /* IS_VALID */] : validationStates["a" /* IS_INVALID */]
  });
}

var FormValidator_FormValidator = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(FormValidator, _React$Component);

  var _super = _createSuper(FormValidator);

  function FormValidator(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, FormValidator);

    _this = _super.call(this, props);
    var formFields = _this.getFields(_this.props) || [];
    _this.state = FormValidator_objectSpread(FormValidator_objectSpread({}, _this.state), {}, {
      fields: formFields.map(function (field) {
        return _setFieldValidationState(field);
      })
    });
    Object(assertThisInitialized["a" /* default */])(_this).setFieldsInState = _this.setFieldsInState.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).isFormSubmittable = _this.isFormSubmittable.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).isFieldValid = _this.isFieldValid.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).onSubmit = _this.onSubmit.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).updateFieldValue = _this.updateFieldValue.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).validateFields = _this.validateFields.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).getFieldByName = _this.getFieldByName.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).getFieldValueByName = _this.getFieldValueByName.bind(Object(assertThisInitialized["a" /* default */])(_this));
    return _this;
  }

  Object(createClass["a" /* default */])(FormValidator, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isEqual_default()(this.props, prevProps)) {
        this.setFieldsInState(this.props);
      }
    }
  }, {
    key: "setFieldsInState",
    value: function setFieldsInState(props) {
      var formFields = this.getFields(props) || [];
      this.setState({
        fields: formFields.map(function (field) {
          return _setFieldValidationState(field);
        })
      });
    }
    /**
     * getFields has to be implemented by the inherited form class
     *
     * @param props (the props used to get/calculate the form fields)
     * @returns the list of form fields
     *
     * const someValidFormField = {
     *    name : a string to eventually identify the field
     *    value : anything
     *    validators : a list of validators to validate the field
     *        -> ex: utils/common-validator/CommonValidators
     * }
     */
    // eslint-disable-next-line no-unused-vars

  }, {
    key: "getFields",
    value: function getFields(props) {
      return [];
    }
  }, {
    key: "validateFields",
    value: function validateFields(callback) {
      var fieldsWithValidation = this.state.fields.map(_setFieldValidationState);
      this.setState({
        fields: fieldsWithValidation
      }, callback);
      return fieldsWithValidation;
    }
  }, {
    key: "updateFieldValue",
    value: function updateFieldValue(fieldName, options, callback) {
      var _this2 = this;

      return function (newFieldValue) {
        var indexToUpdate = findIndex_default()(_this2.state.fields, {
          name: fieldName
        });

        var newFields = updateArrayIndexFp(_this2.state.fields, indexToUpdate, function (field) {
          return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
            value: newFieldValue
          });
        });

        _this2.setState({
          fields: newFields
        }, function () {
          return get_default()(options, 'validate') ? _this2.validateFields(callback) : callback;
        });
      };
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "updateFieldsValue",
    value: function updateFieldsValue(keyValues, options, callback) {
      var _this3 = this;

      var newFields = keyValues.reduce(function (updatedFields, _ref) {
        var fieldName = _ref.fieldName,
            value = _ref.value;

        var indexToUpdate = findIndex_default()(updatedFields, {
          name: fieldName
        });

        return updateArrayIndexFp(updatedFields, indexToUpdate, function (field) {
          return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
            name: fieldName,
            value: value
          });
        });
      }, this.state.fields);
      this.setState({
        fields: newFields
      }, function () {
        return get_default()(options, 'validate') ? _this3.validateFields(callback) : callback;
      });
    }
  }, {
    key: "isFormSubmittable",
    value: function isFormSubmittable(callback) {
      return flow_default()(this.validateFields, _isFormValid)(callback);
    }
  }, {
    key: "isFieldValid",
    value: function isFieldValid(field) {
      return _isFieldValid(field);
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "isFormValid",
    value: function isFormValid() {
      return _isFormValid(this.state.fields);
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      return this.isFormSubmittable() && this.props.onSubmit(this.state.fields);
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(fieldName) {
      return get_default()(this.state, 'fields', []).find(function (field) {
        return field.name === fieldName;
      });
    }
  }, {
    key: "getFieldValueByName",
    value: function getFieldValueByName(fieldName) {
      var formField = get_default()(this.state, 'fields', []).find(function (field) {
        return field.name === fieldName;
      });

      return get_default()(formField, 'value');
    }
  }]);

  return FormValidator;
}(react["Component"]);

/* harmony default export */ var form_validator_hoc_FormValidator = __webpack_exports__["a"] = (FormValidator_FormValidator);

/***/ }),

/***/ "/FsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_AVAILABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_EXCLUSIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_NO_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_NO_DEPARTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_NOT_BOOKABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_SIBLING_SUMMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_SIBLING_WINTER; });
var API_AVAILABLE = 'available';
var API_CLOSED = 'closed';
var API_EXCLUSIVITY = 'exclusivity';
var API_FULL = 'full';
var API_NO_FLIGHT = 'noFlight';
var API_NO_DEPARTURE = 'noDeparture';
var API_OPEN = 'open';
var API_SIBLING_SUMMER = 'siblingSummer';
var API_SIBLING_WINTER = 'siblingWinter';
var API_NOT_BOOKABLE = [API_CLOSED, API_EXCLUSIVITY, API_FULL, API_NO_DEPARTURE, API_SIBLING_SUMMER, API_SIBLING_WINTER];


/***/ }),

/***/ "/Sb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RateMessages; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _RateMessages_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("tuzA");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("qqKu");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var RateMessages = function RateMessages(_ref) {
  var rate = _ref.rate;

  if (!rate) {
    return null;
  }

  var _getRateMessagesPrope = Object(_RateMessages_utils__WEBPACK_IMPORTED_MODULE_1__[/* getRateMessagesProperties */ "a"])(rate),
      rateContent = _getRateMessagesPrope.rateContent,
      rateTitle = _getRateMessagesPrope.rateTitle;

  return __jsx(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__[/* Text */ "a"], {
    className: "block font-bold text-12",
    text: rateTitle
  }), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_2__[/* Text */ "a"], {
    className: "block text-10 font-sans",
    text: rateContent
  }));
};

/***/ }),

/***/ "/nu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureDate; });
/* unused harmony export hasPriceSuggestions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSuggestionsTrackingData; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UIAR");



var getDepartureDate = function getDepartureDate(_ref) {
  var date = _ref.date,
      duration = _ref.duration,
      format = _ref.format,
      unit = _ref.unit;
  return moment__WEBPACK_IMPORTED_MODULE_1___default()(date, format).add(duration, unit).format(format);
};
var hasPriceSuggestions = function hasPriceSuggestions(proposal, appContext) {
  var _proposal$price;

  return (proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.gap) > 0 && (proposal.price.gap < _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */ "x"] || appContext.isSeller && proposal.price.gap >= _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "y"]);
};
var getSuggestionsTrackingData = function getSuggestionsTrackingData(_ref2) {
  var appContext = _ref2.appContext,
      disableAlternativePrice = _ref2.disableAlternativePrice,
      proposal = _ref2.proposal,
      suggestions = _ref2.suggestions;
  var hasDateSuggestion = suggestions.dates.length > 0;
  var hasResortSuggestion = suggestions.resorts.length > 0;
  var hasDurationSuggestion = suggestions.durations.length > 0;
  var hasPriceSuggestion = !disableAlternativePrice && proposal && hasPriceSuggestions(proposal, appContext);
  var labelGA = "displayCounterProposals".concat(hasPriceSuggestion ? '_rate10' : '').concat(hasDateSuggestion ? '_date' : '').concat(hasResortSuggestion ? '_resort' : '').concat(hasDurationSuggestion ? '_duration' : '');
  return {
    labelGA: labelGA
  };
};

/***/ }),

/***/ "04nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEARCH_CRITERIA_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_TRANSPORT_AXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setSearchCriteria; });
/* unused harmony export fetchTransportAxes */
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("70jX");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("uL19");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("NLwV");










var FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
var SEARCH_CRITERIA_TRANSPORTS = 'SEARCH_CRITERIA_TRANSPORTS';
var FETCH_TRANSPORT_AXES = 'FETCH_TRANSPORT_AXES';

function setSearchCriteria(newSearchCriteria) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(SEARCH_CRITERIA_TRANSPORTS, newSearchCriteria);
}

function _runAdditionalTransportsQuery(_ref) {
  var proposalId = _ref.proposalId,
      appContext = _ref.appContext,
      searchCriterias = _ref.searchCriterias;
  var query = "\n    {\n      additionalTransports(proposalId : \"".concat(proposalId, "\" ").concat(searchCriterias ? ", searchCriteria: ".concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_9__[/* graphqlify */ "d"])(searchCriterias)) : '', ") {\n        id\n        price {\n          ...priceDetails\n        }\n        totalDifferentialPrice {\n          ...priceDetails\n        }\n        inbound {\n          ...transportsDetails\n        }\n        outbound {\n          ...transportsDetails\n        }\n      }\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__[/* transportDetailsFragment */ "q"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_4__[/* getPriceDetailFragment */ "h"])(appContext.locale), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* PROPOSAL_GET_ADDITIONAL_TRANSPORT */ "Mc"]
  });
}

function fetchAxes(_x, _x2) {
  return _fetchAxes.apply(this, arguments);
}

function _fetchAxes() {
  _fetchAxes = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee(proposalId, appContext) {
    var query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = "\n  {\n    transportAxes(proposalId : \"".concat(proposalId, "\") {\n      departureCity\n      arrivalCity\n    }\n  }\n  ");
            return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* PROPOSAL_GET_TRANSPORT_AXES */ "Rc"]
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchAxes.apply(this, arguments);
}

function fetchTransportAxes(_ref2) {
  var proposal = _ref2.proposal,
      appContext = _ref2.appContext;
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* createOptimisticAction */ "a"])(FETCH_TRANSPORT_AXES, {}, {
    optimist: true,
    promise: fetchAxes(proposal.id, appContext)
  });
}

function fetchAdditionalTransports(_ref3) {
  var proposal = _ref3.proposal,
      appContext = _ref3.appContext;
  return function (dispatch, getState) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(FETCH_ADDITIONAL_TRANSPORTS));
    var defaultTransport = proposal.transports;
    var searchCriterias = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_8__[/* getSearchCriteriaTransports */ "w"])(getState());
    return _runAdditionalTransportsQuery({
      proposalId: proposal.id,
      appContext: appContext,
      searchCriterias: searchCriterias
    }).then(function (_ref4) {
      var additionalTransports = _ref4.additionalTransports;
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__["resolve"])(FETCH_ADDITIONAL_TRANSPORTS), {
        additionalTransports: additionalTransports,
        selectedTransport: defaultTransport
      }));
    }, function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_3__["reject"])(FETCH_ADDITIONAL_TRANSPORTS), error));
    });
  };
}



/***/ }),

/***/ "05PS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ getCalendar; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getSelectedMonth; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ getCalendarLoading; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getDays; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getPricesByDays; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getDepartureDateBookable; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getAvailableDurations; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getInitialDuration; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ getCalendarTripPrice; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ getCalendarTripPriceLoading; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getBlockInputDepartureDate; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getCalendarDepartureCity; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getCalendarProductId; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getIsPriceCalendarSelection; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("x0AG");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("E9XD");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("Rfxz");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("JTJg");

// EXTERNAL MODULE: ./src/utils/api-availability/constants.js
var constants = __webpack_require__("/FsK");

// CONCATENATED MODULE: ./src/utils/api-availability/availabilityUtils.js




function isBookable(availability) {
  return !!availability && !constants["d" /* API_NOT_BOOKABLE */].includes(availability);
}


// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.selector.js
















var INITIAL_LIST = [];
var INITIAL_CALENDAR = {};

function getMonthIndex() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var monthId = arguments.length > 1 ? arguments[1] : undefined;
  return months.findIndex(function (_ref) {
    var id = _ref.id;
    return id === monthId;
  });
}

function getMonthIndexFromDays() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dayId = arguments.length > 1 ? arguments[1] : undefined;
  /**
   * return if a day is elligible based on:
   * - dayContent.id equals dayId parameter
   * - dayContent.isCurrentMonth at true
   * @param  {Object} day  objet day from calendar.months[i]
   * @return {boolean}     this day is elligible
   */

  var matchBasedOnDay = function matchBasedOnDay(_ref2) {
    var dayContent = _ref2.dayContent;
    return dayContent.id === dayId && dayContent.isCurrentMonth;
  };

  return months.findIndex(function (_ref3) {
    var days = _ref3.days;
    return days.some(matchBasedOnDay);
  });
}

function getCurrentMonth() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedDay = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDayMonthIndex = arguments.length > 2 ? arguments[2] : undefined;
  var firstMonthIndex = arguments.length > 3 ? arguments[3] : undefined;
  return selectedDay && selectedDayMonthIndex > -1 ? months[selectedDayMonthIndex] : months[firstMonthIndex];
}

function getDaysFromMonths(calendar, monthId) {
  var months = calendar.months;
  var monthIndex = getMonthIndex(months, monthId);
  return get_default()(months, "".concat(monthIndex, ".days"));
}

function getDaysFromDays(calendar, dayId) {
  var months = calendar.months,
      firstAvailableMonthIndex = calendar.firstAvailableMonthIndex;
  var selectedDayMonthIndex = getMonthIndexFromDays(months, dayId);
  var month = getCurrentMonth(months, dayId, selectedDayMonthIndex, firstAvailableMonthIndex);
  return get_default()(month, 'days', INITIAL_LIST);
}

function getDaysSelector() {
  var calendar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_CALENDAR;
  var selectedMonth = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDay = arguments.length > 2 ? arguments[2] : undefined;

  if (isEmpty_default()(calendar)) {
    return INITIAL_LIST;
  }

  var daysFromMonths = getDaysFromMonths(calendar, selectedMonth);
  var daysFromDays = getDaysFromDays(calendar, selectedDay);
  return !daysFromMonths || daysFromMonths === daysFromDays ? daysFromDays : daysFromMonths;
}

var calendarSelector = function calendarSelector(_ref4) {
  var calendar = _ref4.calendar;
  return calendar;
};

var getCalendar = Object(lib["createSelector"])(calendarSelector, function (_ref5) {
  var calendar = _ref5.calendar;
  return calendar;
});
var getSelectedMonth = Object(lib["createSelector"])(calendarSelector, function (_ref6) {
  var selectedMonth = _ref6.selectedMonth;
  return selectedMonth;
});
var getCalendarLoading = Object(lib["createSelector"])(calendarSelector, function (_ref7) {
  var isLoading = _ref7.isLoading;
  return isLoading;
});
var getDays = Object(lib["createSelector"])(getCalendar, getSelectedMonth, tripCriteria_selector["b" /* getDepartureDate */], getDaysSelector);
var getPricesByDays = Object(lib["createSelector"])(calendarSelector, function (_ref8) {
  var byDays = _ref8.byDays;
  return byDays;
});
var getDepartureDateBookable = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], getCalendarLoading, function (_ref9, departureDate, isLoading) {
  var _byDays$dayId;

  var byDays = _ref9.byDays;

  if (!departureDate || isLoading) {
    return false;
  }

  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return byDays && byDays[dayId] && isBookable((_byDays$dayId = byDays[dayId]) === null || _byDays$dayId === void 0 ? void 0 : _byDays$dayId.availability);
});
var getAvailableDurations = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], function (_ref10, departureDate) {
  var _bookableDates$months, _bookableDates$months2, _bookableDates$months3;

  var bookableDates = _ref10.bookableDates,
      bookableDatesLoading = _ref10.bookableDatesLoading;

  if (bookableDatesLoading) {
    return [];
  }

  if (!departureDate || !bookableDates) {
    return null;
  }

  var monthId = moment_default()(departureDate).format(apiDate["b" /* API_MONTH_ID */]);
  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return Array.isArray(bookableDates === null || bookableDates === void 0 ? void 0 : bookableDates.months) ? (bookableDates === null || bookableDates === void 0 ? void 0 : (_bookableDates$months = bookableDates.months.find(function (m) {
    return m.id.toString() === monthId;
  })) === null || _bookableDates$months === void 0 ? void 0 : (_bookableDates$months2 = _bookableDates$months.days.find(function (d) {
    return d.id.toString() === dayId;
  })) === null || _bookableDates$months2 === void 0 ? void 0 : (_bookableDates$months3 = _bookableDates$months2.availabilities.filter(function (a) {
    return a.status === 'AVAILABLE' || a.status === 'UNKNOWN';
  })) === null || _bookableDates$months3 === void 0 ? void 0 : _bookableDates$months3.reduce(function (acc, a) {
    return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(a.durations));
  }, [])) || null : null;
});
var getInitialDuration = Object(lib["createSelector"])(calendarSelector, function (_ref11) {
  var initialDuration = _ref11.initialDuration;
  return initialDuration;
});
var getCalendarTripPrice = Object(lib["createSelector"])(calendarSelector, function (_ref12) {
  var tripPrice = _ref12.tripPrice;
  return tripPrice;
});
var getCalendarTripPriceLoading = Object(lib["createSelector"])(calendarSelector, function (_ref13) {
  var tripPriceIsLoading = _ref13.tripPriceIsLoading;
  return tripPriceIsLoading;
});
var getBlockInputDepartureDate = Object(lib["createSelector"])(calendarSelector, function (_ref14) {
  var blockInputDepartureDate = _ref14.blockInputDepartureDate;
  return blockInputDepartureDate;
});
var getCalendarDepartureCity = Object(lib["createSelector"])(calendarSelector, function (_ref15) {
  var departureCity = _ref15.departureCity;
  return departureCity;
});
var getCalendarProductId = Object(lib["createSelector"])(calendarSelector, function (_ref16) {
  var productId = _ref16.productId;
  return productId;
});
var getIsPriceCalendarSelection = Object(lib["createSelector"])(calendarSelector, function (_ref17) {
  var isPriceCalendarSelection = _ref17.isPriceCalendarSelection;
  return isPriceCalendarSelection;
});

/***/ }),

/***/ "0ibg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setKeywords; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");


function setKeywords(keywords) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SEARCH_SET_KEYWORDS */ "l"], {
    keywords: keywords
  });
}

/***/ }),

/***/ "15pl":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "1aYn":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    isArrayLike = __webpack_require__("9y2L"),
    keys = __webpack_require__("BlJA");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ "1bWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setKids; });
/* unused harmony export updateKid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setKidsWithoutClearProposals; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* eslint-disable flowtype/no-weak-types */



function setKids(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS */ "c"], {
    kids: kids
  });
}

function setKidsWithoutClearProposals(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */ "d"], {
    kids: kids
  });
}

function resetKids() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_RESET_KIDS */ "b"]);
}

function updateKid(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_KID */ "e"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}



/***/ }),

/***/ "1qsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWinterResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWinterMountainResort; });
/* unused harmony export resortHasBeActivities */
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Rfxz");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);





var WINTER_MOUNTAIN_RESORT = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].WINTER_MOUNTAIN_RESORT;
function isWinterResort(resort) {
  var seasons = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(resort, 'seasons', []);

  return seasons.length === 1 && seasons.includes('WINTER') && lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(resort, 'type', '').toUpperCase() === 'VILLAGE';
}
function isWinterMountainResort(resort) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(resort, 'category') === WINTER_MOUNTAIN_RESORT;
}
var resortHasBeActivities = function resortHasBeActivities(resort) {
  return resort.activityCategories.leisure.some(function (_ref) {
    var subCategories = _ref.subCategories;
    return subCategories.length !== 0;
  });
};

/***/ }),

/***/ "2GfD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Technically, this is not related to the address, since it can work with any type of validationSchema
// but other form of schemas, might not be object. So here we went for the simplest case, the one we
// use, i.e. address
var validationSchemaFieldFragment = "\n fragment ValidationSchemaField on SchemaValidationFieldInterface {\n  name\n  ...on ValidationSchemaObjectField {\n    fields {\n      display\n      type\n      name\n      required\n      values {\n        code\n        label\n      }\n      validators {\n        name\n        value\n      }\n    }\n  }\n }\n";
/* harmony default export */ __webpack_exports__["a"] = (validationSchemaFieldFragment);

/***/ }),

/***/ "2N/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ENGINE_ENTRIES; });
/* unused harmony export BOOKING_TRACKING_UPSELL_REVENUE */
var BOOKING_ENGINE_ENTRIES = {
  PRICE_CALENDAR: 'PriceCalendar',
  PRICE_REMOTE: 'PriceRemote',
  QUICK_SEARCH: 'QuickSearch',
  CRUISE_BOOKING: 'CruiseBooking'
};
var BOOKING_TRACKING_UPSELL_REVENUE = 'BOOKING_TRACKING_UPSELL_REVENUE';

/***/ }),

/***/ "393O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHEN_EVENT; });
var OPEN_CRITERIA_WHEN_EVENT = 'openCriteriaWhen';

/***/ }),

/***/ "3OwS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__("gz38"),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__("I2LH"),
    UnmountClosed = _require2.UnmountClosed; // Default export


module.exports = UnmountClosed; // Extra "named exports"

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

/***/ }),

/***/ "4A3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AsyncLoader_AsyncLoader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center h-full items-center'
  },
  labeled: {
    thRoot: 'flex flex-col justify-center items-center my-0 mx-auto text-center w-[20rem]',
    thLabel: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx
var __jsx = react_default.a.createElement;







var AsyncLoader_AsyncLoader = function AsyncLoader(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].TRIDENT1 : _ref$icon,
      iconSize = _ref.iconSize,
      size = _ref.size,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  return __jsx("div", {
    className: classnames_default()(thRoot, className),
    style: style
  }, __jsx(Spinner["a" /* Spinner */], {
    iconName: icon,
    iconSize: iconSize,
    size: size
  }), __jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    className: thLabel,
    label: label
  }));
};

/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var SpinnerLabel = function SpinnerLabel(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-20 text-black text-20', {
      'sr-only': !label
    }, className),
    "aria-live": "polite"
  }, label ? label : 'Loading');
};

/***/ }),

/***/ "4XSA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = NumberSchema;

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

var isNaN = function isNaN(value) {
  return value != +value;
};

var isInteger = function isInteger(val) {
  return (0, _isAbsent.default)(val) || val === (val | 0);
};

function NumberSchema() {
  var _this = this;

  if (!(this instanceof NumberSchema)) return new NumberSchema();

  _mixed.default.call(this, {
    type: 'number'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      var parsed = value;

      if (typeof parsed === 'string') {
        parsed = parsed.replace(/\s/g, '');
        if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

        parsed = +parsed;
      }

      if (this.isType(parsed)) return parsed;
      return parseFloat(parsed);
    });
  });
}

(0, _inherits.default)(NumberSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !isNaN(value);
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.number.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.number.max;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value <= this.resolve(_max);
      }
    });
  },
  lessThan: function lessThan(less, message) {
    if (message === void 0) {
      message = _locale.number.lessThan;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        less: less
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value < this.resolve(less);
      }
    });
  },
  moreThan: function moreThan(more, message) {
    if (message === void 0) {
      message = _locale.number.moreThan;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        more: more
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value > this.resolve(more);
      }
    });
  },
  positive: function positive(msg) {
    if (msg === void 0) {
      msg = _locale.number.positive;
    }

    return this.moreThan(0, msg);
  },
  negative: function negative(msg) {
    if (msg === void 0) {
      msg = _locale.number.negative;
    }

    return this.lessThan(0, msg);
  },
  integer: function integer(message) {
    if (message === void 0) {
      message = _locale.number.integer;
    }

    return this.test({
      name: 'integer',
      message: message,
      test: isInteger
    });
  },
  truncate: function truncate() {
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value | 0 : value;
    });
  },
  round: function round(method) {
    var avail = ['ceil', 'floor', 'round', 'trunc'];
    method = method && method.toLowerCase() || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? Math[method](value) : value;
    });
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "5Yz+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply = __webpack_require__("K6Rb");
var toIndexedObject = __webpack_require__("/GqU");
var toIntegerOrInfinity = __webpack_require__("WSbT");
var lengthOfArrayLike = __webpack_require__("B/qT");
var arrayMethodIsStrict = __webpack_require__("pkCn");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "5r8v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__("yWCo");

var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = ObjectSchema;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(__webpack_require__("c8jO"));

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _snakeCase2 = _interopRequireDefault(__webpack_require__("CzFL"));

var _camelCase2 = _interopRequireDefault(__webpack_require__("S0cN"));

var _mapKeys = _interopRequireDefault(__webpack_require__("A0Zq"));

var _mapValues = _interopRequireDefault(__webpack_require__("y2Ah"));

var _propertyExpr = __webpack_require__("dFUt");

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _sortFields = _interopRequireDefault(__webpack_require__("7pmY"));

var _sortByKeyOrder = _interopRequireDefault(__webpack_require__("OhDV"));

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _makePath = _interopRequireDefault(__webpack_require__("raDx"));

var _runValidations = _interopRequireWildcard(__webpack_require__("wM5X"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", ".", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

function ObjectSchema(spec) {
  var _this2 = this;

  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);

  _mixed.default.call(this, {
    type: 'object',
    default: function _default() {
      var _this = this;

      if (!this._nodes.length) return undefined;
      var dft = {};

      this._nodes.forEach(function (key) {
        dft[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
      });

      return dft;
    }
  });

  this.fields = Object.create(null);
  this._nodes = [];
  this._excludedEdges = [];
  this.withMutation(function () {
    _this2.transform(function coerce(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (err) {
          value = null;
        }
      }

      if (this.isType(value)) return value;
      return null;
    });

    if (spec) {
      _this2.shape(spec);
    }
  });
}

(0, _inherits.default)(ObjectSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  },
  _cast: function _cast(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _mixed.default.prototype._cast.call(this, _value, options); //should ignore nulls here


    if (value === undefined) return this.default();
    if (!this._typeCheck(value)) return value;
    var fields = this.fields;
    var strip = this._option('stripUnknown', options) === true;

    var props = this._nodes.concat(Object.keys(value).filter(function (v) {
      return _this3._nodes.indexOf(v) === -1;
    }));

    var intermediateValue = {}; // is filled during the transform below

    var innerOptions = (0, _extends2.default)({}, options, {
      parent: intermediateValue,
      __validating: false
    });
    var isChanged = false;
    props.forEach(function (prop) {
      var field = fields[prop];
      var exists = (0, _has.default)(value, prop);

      if (field) {
        var fieldValue;
        var strict = field._options && field._options.strict; // safe to mutate since this is fired in sequence

        innerOptions.path = (0, _makePath.default)(_templateObject(), options.path, prop);
        innerOptions.value = value[prop];
        field = field.resolve(innerOptions);

        if (field._strip === true) {
          isChanged = isChanged || prop in value;
          return;
        }

        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
      } else if (exists && !strip) intermediateValue[prop] = value[prop];

      if (intermediateValue[prop] !== value[prop]) isChanged = true;
    });
    return isChanged ? intermediateValue : value;
  },
  _validate: function _validate(_value, opts) {
    var _this4 = this;

    if (opts === void 0) {
      opts = {};
    }

    var endEarly, recursive;
    var sync = opts.sync;
    var errors = [];
    var originalValue = opts.originalValue != null ? opts.originalValue : _value;
    endEarly = this._option('abortEarly', opts);
    recursive = this._option('recursive', opts);
    opts = (0, _extends2.default)({}, opts, {
      __validating: true,
      originalValue: originalValue
    });
    return _mixed.default.prototype._validate.call(this, _value, opts).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !isObject(value)) {
        // only iterate though actual objects
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;

      var validations = _this4._nodes.map(function (key) {
        var path = (0, _makePath.default)(_templateObject2(), opts.path, key);
        var field = _this4.fields[key];
        var innerOptions = (0, _extends2.default)({}, opts, {
          path: path,
          parent: value,
          originalValue: originalValue[key]
        });

        if (field && field.validate) {
          // inner fields are always strict:
          // 1. this isn't strict so the casting will also have cast inner values
          // 2. this is strict in which case the nested values weren't cast either
          innerOptions.strict = true;
          return field.validate(value[key], innerOptions);
        }

        return Promise.resolve(true);
      });

      return (0, _runValidations.default)({
        sync: sync,
        validations: validations,
        value: value,
        errors: errors,
        endEarly: endEarly,
        path: opts.path,
        sort: (0, _sortByKeyOrder.default)(_this4.fields)
      });
    });
  },
  concat: function concat(schema) {
    var next = _mixed.default.prototype.concat.call(this, schema);

    next._nodes = (0, _sortFields.default)(next.fields, next._excludedEdges);
    return next;
  },
  shape: function shape(schema, excludes) {
    if (excludes === void 0) {
      excludes = [];
    }

    var next = this.clone();
    var fields = (0, _extends2.default)(next.fields, schema);
    next.fields = fields;

    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      var keys = excludes.map(function (_ref) {
        var first = _ref[0],
            second = _ref[1];
        return first + "-" + second;
      });
      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = (0, _sortFields.default)(fields, next._excludedEdges);
    return next;
  },
  from: function from(_from, to, alias) {
    var fromGetter = (0, _propertyExpr.getter)(_from, true);
    return this.transform(function (obj) {
      if (obj == null) return obj;
      var newObj = obj;

      if ((0, _has.default)(obj, _from)) {
        newObj = (0, _extends2.default)({}, obj);
        if (!alias) delete newObj[_from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  },
  noUnknown: function noUnknown(noAllow, message) {
    if (noAllow === void 0) {
      noAllow = true;
    }

    if (message === void 0) {
      message = _locale.object.noUnknown;
    }

    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    var next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test: function test(value) {
        return value == null || !noAllow || unknown(this.schema, value).length === 0;
      }
    });
    next._options.stripUnknown = noAllow;
    return next;
  },
  unknown: function unknown(allow, message) {
    if (allow === void 0) {
      allow = true;
    }

    if (message === void 0) {
      message = _locale.object.noUnknown;
    }

    return this.noUnknown(!allow, message);
  },
  transformKeys: function transformKeys(fn) {
    return this.transform(function (obj) {
      return obj && (0, _mapKeys.default)(obj, function (_, key) {
        return fn(key);
      });
    });
  },
  camelCase: function camelCase() {
    return this.transformKeys(_camelCase2.default);
  },
  snakeCase: function snakeCase() {
    return this.transformKeys(_snakeCase2.default);
  },
  constantCase: function constantCase() {
    return this.transformKeys(function (key) {
      return (0, _snakeCase2.default)(key).toUpperCase();
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    base.fields = (0, _mapValues.default)(this.fields, function (value) {
      return value.describe();
    });
    return base;
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "6R5o":
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__("1aYn"),
    findIndex = __webpack_require__("FllU");

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ "6sUC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__("hh1v");

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "6wD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTripDateCriteria; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function updateTripDateCriteria(options) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* UPDATE_TRIP_DATE_CRITERIA */ "p"], options);
}



/***/ }),

/***/ "70jX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export servicesWithSchedulePricingInfoQuery */
/* unused harmony export childcareWithSchedulePricingInfoQuery */
/* unused harmony export childcaresQuery */
/* unused harmony export transfersQuery */
/* unused harmony export insuranceAdditionalServicesQuery */
/* unused harmony export additionalServicesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAccommodationMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addServiceMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTransportMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPaymentScheduleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceDetailFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return proposalsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return proposalFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return proposalPriceQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return transportDetailsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return paymentProvidersRequest; });
/* unused harmony export getKnownAttendeesInformation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return promoCodeProposalMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return autosaveProposalMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return putServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return switchProposalsOffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return refreshProposal; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("H0gB");
/* harmony import */ var _client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("MAH5");
/* harmony import */ var _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("BYx+");
/* harmony import */ var _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SQLw");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("L7OA");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("PIvV");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("CcNa");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("ldK3");
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("NLwV");


















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}












var _constants$PACKAGES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__["constants"].PACKAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;
var paymentScheduleRequest = "paymentSchedule {\n  commissionIncluded\n  total {...priceDetails}\n  depositAmount {...priceDetails}\n  repaymentSchedules{\n    amount {...priceDetails}\n    deadline\n  }\n}";

function getPaymentScheduleRequest(appContext) {
  return Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.deposit') ? paymentScheduleRequest : '';
}

function getPriceDetailFragment(locale) {
  var precision = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_17___default.a.getBookingPrecision(locale);
  return "\n    fragment priceDetails on PriceDetailType {\n      formattedValue(precision : ".concat(precision, ")\n      value\n    }\n  ");
}

var flightFragment = "{\n  id\n  cityId\n  label\n  airportLabel\n  terminalCode\n  date\n  time\n}";
var transportFragment = "{\n  type\n  class\n  travelNumber\n  baggage {\n    quantity\n    weight\n  }\n  companyOperator {\n    id\n    label\n    logo\n  }\n  companyExploiter {\n    id\n    label\n    logo\n  }\n  vehicleType\n}";
var transportDetailsFragment = "\n  fragment transportsDetails on TransportDetailType {\n    isClubmedTransport\n    durationInMin\n    travelSections {\n      connectionDurationInMin\n      isClubmedTransport\n      stopDurationInMin\n      technicalStops\n      departure {\n        ...".concat(flightFragment, "\n      }\n      arrival {\n        ...").concat(flightFragment, "\n      }\n      transport {\n        ...").concat(transportFragment, "\n      }\n    }\n    cancellationPolicyType\n    transferIncluded\n    stayId\n  }\n");
var servicesWithSchedulePricingInfoQuery = "\n    pricingInfo {\n        id\n        progId\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        startingPricePerAdult {\n          ...priceDetails\n          currency\n          discount\n          discountUnit\n          formattedInitialValue\n        }\n        isPartiallyRented\n        attendees {\n          id\n          rentedAmount {\n            ...priceDetails\n            currency\n          }\n          price {\n            discount\n            discountUnit\n            formattedValue(precision:0)\n            formattedInitialValue\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {\n                ...priceDetails\n                currency\n                discount\n                discountUnit\n                formattedInitialValue\n              }\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {\n                ...priceDetails\n              }\n            }\n          }\n        }\n      }";
/**
 * childcare with schedule and childId
 */

var childcareWithSchedulePricingInfoQuery = "\n    pricingInfo {\n        id\n        progId\n        childId\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        startingPricePerAdult {\n          ...priceDetails\n          currency\n          discount\n          discountUnit\n          formattedInitialValue\n        }\n        isPartiallyRented\n        attendees {\n          id\n          rentedAmount {...priceDetails currency}\n          price {\n            discount\n            discountUnit\n            formattedValue(precision:0)\n            formattedInitialValue\n            value\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {\n                ...priceDetails\n                currency\n                discount\n                discountUnit\n                formattedInitialValue\n              }\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {\n                ...priceDetails\n              }\n            }\n          }\n        }\n      }";
var childcaresQuery = "\nchildcares {\n  ".concat(childcareWithSchedulePricingInfoQuery, "\n  productInfo {\n    id\n    label\n    images\n    description\n    durationDescription\n    isIncluded\n    ageInMonths {\n      min\n      max\n    }\n    closingWeekdays\n    openingHours {\n      start\n      end\n    }\n    timeSlots {\n      type\n      opening\n      closing\n    }\n  }\n}");
var transfersQuery = "\ntransfers {\n  pricingInfo {\n    id\n    isIncluded\n    price: startingPricePerAdult {\n      ...priceDetails\n      formattedValueRounded : formattedValue(precision : 0)\n    }\n    totalPrice {\n      value\n      formattedValue\n      currency\n    }\n    isPartiallyRented\n    isFullyRented\n    type\n    rentedAmount {\n      value\n    }\n    schedules {\n      startDate\n      endDate\n      remainingStock\n      attendees {\n        id\n        isRented\n      }\n    }\n  }\n  productInfo {\n    id\n    description\n    durationInMinutes\n    vehicle {\n      id\n      label\n    }\n    label\n  }\n}\n";
var insuranceAdditionalServicesQuery = "insurance {\n        pricingInfo {\n          id\n          type\n          rentedAmount {...priceDetails, currency}\n          totalPrice {\n            value\n            formattedValue(precision: 2)\n            currency\n          }\n          isPartiallyRented\n          isPartiallyPaid\n          isFullyPaid\n          schedules {\n            startDate\n            endDate\n            attendees {\n              id\n            }\n          }\n        }\n        productInfo {\n          id\n          label\n          insuranceDetails {\n            id\n            label\n            images\n            description\n            shortDescription\n            videos\n            attachedDocuments {\n              label\n              url\n            }\n            company {\n              label\n              logo\n            }\n            coverageDescriptions\n            subscriptionConditions {\n              age_min\n              ageMax\n              byAttendees\n            }\n          }\n        }\n      }";
var additionalServicesQuery = "\n  additionalServices(types: [EXCURSION, RENTAL, CHILDCARE, LAND_SPORT, WATER_SPORT, WINTER_SPORT, TRANSFER, WELLNESS, INSURANCE]) {\n    activities {\n      ".concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        isIncluded\n        parentActivityCategoriesId\n        description\n      }\n    }\n    rentals {\n      ").concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        ageInMonths {\n          min\n          max\n        }\n        useCase {\n          id\n          label\n        }\n        typeId: type\n        typeLabel\n        description: longDescription\n        sizes {\n          min\n          max\n          unit\n        }\n        practiceLevels {\n          id\n          label\n        }\n      }\n    }\n    ").concat(childcaresQuery, "\n    ").concat(transfersQuery, "\n    ").concat(insuranceAdditionalServicesQuery, "\n  }\n  ");

function proposalPriceQuery() {
  return "\n    price {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerId\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      insurance {...priceDetails}\n      totalWithoutTransport {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n        offerDescription\n      }\n      transfer {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      excursions {...priceDetails}\n      wellness {...priceDetails}\n      sports {...priceDetails}\n      currency\n      hasFlexRates\n      selectedRate\n      yieldPricingVariation\n      gap\n    }\n    alternativePrice {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerId\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n        offerDescription\n      }\n      transfer {...priceDetails}\n      insurance {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      currency\n    }\n    attendeesPrice {\n      id\n      householdId\n      total {\n        ...priceDetails\n        currency\n      }\n      priceItems {\n        type\n        offerId\n        price {\n          ...priceDetails\n          currency\n        }\n      }\n    }\n    ";
}

function proposalFields(params, appContext) {
  return "\n    id\n    packageId\n    productId\n    originalLocale\n    ".concat(additionalServicesQuery, "\n    ").concat(params.isJoyView ? "\n    alternativePackages {\n      proposalId\n      packageId\n      upsellPrice\n    }\n    packages(packageIds : [\"".concat(JOYVIEW_ROOM_ONLY, "\", \"").concat(JOYVIEW_ALL_INCLUSIVE, "\", \"").concat(JOYVIEW_FOOD_AND_BEVERAGES, "\"]) {\n      id\n      image\n      additionalInfo\n      description\n      label\n      prices {\n        perAdultPerNight {\n          ...priceDetails\n          currency\n        }\n        perKidPerNight {\n          ...priceDetails\n          currency\n        }\n      }\n    }") : '', "\n    label\n    accommodationsCount\n    persistenceExtended\n    accommodations {\n      id\n      label\n      description\n      quantity\n      connectingRoom\n      familyRoom\n      surface\n      view {\n        id\n        label\n      }\n      strengths {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      services {\n        id\n        label\n      }\n      outsideFacilities {\n        id\n        label\n      }\n      bathroomEquipments {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      categories {\n        id\n      }\n      exclusiveCollection\n      floorPlans\n      category\n      categoryId\n      comfortType\n      comfortId\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      roomType\n      attendeesDistribution {\n        attendees {\n          id\n          type\n          birthdate,\n          customerId\n        }\n      }\n      ranking\n    }\n    duration\n    media {\n      photos {\n        url\n      }\n    }\n    ").concat(proposalPriceQuery(), "\n    arrivalDate\n    departureDate\n    attendees {\n      list {\n        id\n        birthdate\n        customerId\n        email\n        civility\n        firstName\n        lastName\n        gmNumber\n        optins {\n          channel\n          optin\n        }\n      }\n      adults {\n        id\n        customerId\n      }\n      children(birthdateSort: asc) {\n        id\n        birthdate\n        customerId\n      }\n    }\n    households(withSchedule: ").concat((!!params.withSchedule).toString(), ") {\n      attendees {\n        id\n        customerId\n        birthdate\n        isAdult\n        isMain\n      }\n      ").concat(getPaymentScheduleRequest(appContext), "\n    }\n    remainingStock\n    optionAvailable\n    isCounterProposal\n    transports {\n      inbound {\n        ...transportsDetails\n      }\n      outbound {\n        ...transportsDetails\n      }\n    }\n    expirationDateTime\n    durationDisclaimer\n    allInclusiveServices {\n      icon\n      label\n      description\n    }\n    ").concat(params.withCommission ? "sellerCommission {\n            formattedValue(precision: 2)\n          }" : '', "\n     ");
}

var paymentProvidersRequest = function paymentProvidersRequest() {
  return "paymentProviders {\n  description\n  id\n  selectorId\n  label\n  logo\n  categoryPaymentMethod\n  withBillingAddress\n  paymentMethods {\n    category\n    id\n    image\n    label\n    timePaymentConditions {\n      chargePercentage\n      id\n      paymentCount\n    }\n  }\n  requiredDelayBeforeDeparture\n  token {\n    format\n    value\n  }\n}";
};

function fetchPayment(proposalId, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposal(id: \"".concat(proposalId, "\") {\n        households(withSchedule: true) {\n          ").concat(getPaymentScheduleRequest(appContext), "\n        }\n      }\n      ").concat(paymentProvidersRequest(), "\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n  "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_GET_SCHEDULE_PAYMENT */ "Oc"]
  });
}

function getKnownAttendeesInformation(attendees, neolaneId) {
  var travelCompanionContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var attendeeInfo = attendees.map(function (attendee, index) {
    var _attendee$neolid = attendee.neolid,
        neolid = _attendee$neolid === void 0 ? '' : _attendee$neolid,
        birthdate = attendee.birthdate;
    var customerId = index === 0 && neolaneId ? neolaneId : neolid; // neolid : Send by CXO in query params
    // neolaneId : In appContext, identify user logged
    // When not seller, set first adult with neolaneId if user is authenticated
    // adding connected user infos creates 2 households for travel companions context which should always only have one household

    return _objectSpread({
      customer_id: travelCompanionContext ? undefined : customerId
    }, birthdate ? {
      birthdate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_26__[/* timestampToApiDate */ "n"])(birthdate)
    } : null);
  });
  return Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(attendeeInfo);
}

function proposalsQuery(_x, _x2) {
  return _proposalsQuery.apply(this, arguments);
}

function _proposalsQuery() {
  _proposalsQuery = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee4(params, appContext) {
    var _params$adultsAttende, _params$kidsAttendees, _proposalsResponse$pr, _proposalsResponse$pr2, _proposalsResponse$pr3, _proposalsResponse$pr4, _proposalsResponse$pr5;

    var adults, _params$kids, kids, attendees, neolaneId, travelCompanionContext, knownAttendeesInformation, displayCommission, displayDurationsCounterProposals, counterDurationExtended, proposalArgs, proposalsResponse, validationSchema;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            adults = params.adults, _params$kids = params.kids, kids = _params$kids === void 0 ? [] : _params$kids;
            attendees = adults.concat(kids || []); // When quick logged neolaneId but should not call profile api
            // TODO: handle quicklogged status and not call profile API every fucking time because 401 is silent

            neolaneId = appContext.isUserLogged ? appContext.neolaneId : null;
            travelCompanionContext = !appContext.isSeller && appContext.isUserLogged && Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.travelCompanions');
            knownAttendeesInformation = getKnownAttendeesInformation( // $FlowFixMe
            attendees, neolaneId, travelCompanionContext);
            displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
            displayDurationsCounterProposals = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayDurationsCounterProposals').toString();
            counterDurationExtended = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayExtendedDurationsCounterProposals').toString();
            proposalArgs = ["productId: \"".concat(params.productId, "\""), "arrivalDate: \"".concat(params.arrivalDate, "\""), "duration: ".concat(params.duration), "numberAttendees: ".concat(params.numberAttendees), "knownAttendeesInformation: ".concat(knownAttendeesInformation)].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.departureCity ? ["departureCity : \"".concat(params.departureCity, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.isJoyView ? ['isJoyView: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.salesNetworkId ? ["salesNetworkId: \"".concat(params.salesNetworkId, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.voucherCode ? ["voucherCode: \"".concat(params.voucherCode, "\"")] : []), ["displayCounterDurations: ".concat(displayDurationsCounterProposals), "displayCounterExtendedDurations: ".concat(counterDurationExtended), "displayCounterDates: ".concat(Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayDateCounterProposals').toString())]);
            _context4.next = 11;
            return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposals(".concat(proposalArgs.join(', '), ") {\n        ... on ErrorsProposalType {\n          errors {\n            errorCode\n          }\n        }\n        ... on ProposalsType {\n          proposals {\n            ").concat(proposalFields(_objectSpread(_objectSpread({}, params), {}, {
              withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
            }), appContext), "\n          }\n          dateSuggestion {\n            dateOffset\n            price {\n              total\n            }\n            resortArrivalDate\n            resortDepartureDate\n          }\n          priceCurrency\n          suggestions {\n            resort {\n              badgeIcon\n              color\n              comfort\n              comfortLabel\n              destination {\n                country\n              }\n              hasECSpace\n              href\n              id\n              images\n              isExplicitEC\n              name\n              type\n            }\n            remainingStock\n            initialStock\n          }\n          durationSuggestions {\n            ids\n            data {\n              price {\n                total {\n                  formattedValue\n                }\n              }\n              duration\n              resortArrivalDate: arrivalDate\n              resortDepartureDate: departureDate\n            }\n          }\n          ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__[/* getResort */ "c"])(params.fetchActivityCategories), "\n        }\n      }\n      ").concat(appContext.isUserLogged ? 'profile { ...BookingProfile }' : '', "\n      ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__[/* getAttendeesData */ "b"])(params), "\n    }\n\n    ").concat(params.fetchActivityCategories ? _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* activityCategoryFragment */ "a"] : '', "\n    ").concat(params.fetchActivityCategories || _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* thematicFragment */ "g"] ? _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* activityFragment */ "b"] : '', "\n    ").concat(params.fetchActivityCategories ? _client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* rentalsFragment */ "f"] : '', "\n    ").concat(_client_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_19__[/* thematicFragment */ "g"], "\n    ").concat(appContext.isUserLogged ? _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_21__[/* profileFragment */ "a"] : '', "\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    ").concat(((_params$adultsAttende = params.adultsAttendeesIds) === null || _params$adultsAttende === void 0 ? void 0 : _params$adultsAttende[0]) || ((_params$kidsAttendees = params.kidsAttendeesIds) === null || _params$kidsAttendees === void 0 ? void 0 : _params$kidsAttendees[0]) ? _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"] : '', "\n    "), appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_GET_SEVERAL */ "Qc"]
            });

          case 11:
            proposalsResponse = _context4.sent;

            if (!(proposalsResponse === null || proposalsResponse === void 0 ? void 0 : (_proposalsResponse$pr = proposalsResponse.proposals) === null || _proposalsResponse$pr === void 0 ? void 0 : (_proposalsResponse$pr2 = _proposalsResponse$pr.proposals) === null || _proposalsResponse$pr2 === void 0 ? void 0 : _proposalsResponse$pr2.length)) {
              _context4.next = 18;
              break;
            }

            _context4.next = 15;
            return Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_20__[/* fetchValidationSchema */ "a"])(proposalsResponse === null || proposalsResponse === void 0 ? void 0 : (_proposalsResponse$pr3 = proposalsResponse.proposals) === null || _proposalsResponse$pr3 === void 0 ? void 0 : (_proposalsResponse$pr4 = _proposalsResponse$pr3.proposals) === null || _proposalsResponse$pr4 === void 0 ? void 0 : (_proposalsResponse$pr5 = _proposalsResponse$pr4[0]) === null || _proposalsResponse$pr5 === void 0 ? void 0 : _proposalsResponse$pr5.id, appContext, 'profile');

          case 15:
            _context4.t0 = _context4.sent;
            _context4.next = 19;
            break;

          case 18:
            _context4.t0 = {};

          case 19:
            validationSchema = _context4.t0;
            return _context4.abrupt("return", _objectSpread(_objectSpread({}, proposalsResponse), validationSchema));

          case 21:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _proposalsQuery.apply(this, arguments);
}

function addTransportMutation(transportId, proposalsId, isJoyView, appContext) {
  var displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addTransport (proposalsId: [\"".concat(proposalsId.join('","'), "\"], transportId: \"").concat(transportId, "\") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }, appContext), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADD_TRANSPORT */ "Jc"]
  });
}

function addAccommodationMutation(arrangement, proposalsId, isJoyView, appContext) {
  var displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addAccommodation (proposalsId: [\"".concat(proposalsId.join('","'), "\"], arrangement: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(arrangement), ") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }, appContext), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ACCOMMODATION_ADD */ "Fc"]
  });
}

var putServicesGraphQLQuery = function putServicesGraphQLQuery(proposalsId, services, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      putServices(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(proposalsId), ", attendees: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(services), ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADDITIONAL_SERVICES_UPDATE */ "Ic"]
  });
};
/**
 * We don't want to have this request in parallel, it's a put and it can be really long, so we create a queue to do
 * these requests synchronously
 */


var serviceRequestRunning = null;

var putServicesMutation = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee(proposalIds, attendees, appContext) {
    var result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (serviceRequestRunning) {
              _context.next = 15;
              break;
            }

            serviceRequestRunning = putServicesGraphQLQuery(proposalIds, attendees, appContext);
            _context.prev = 2;
            _context.next = 5;
            return serviceRequestRunning;

          case 5:
            result = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            throw _context.t0;

          case 11:
            _context.prev = 11;
            serviceRequestRunning = null;
            return _context.finish(11);

          case 14:
            return _context.abrupt("return", result);

          case 15:
            _context.next = 17;
            return serviceRequestRunning;

          case 17:
            return _context.abrupt("return", putServicesMutation(proposalIds, attendees, appContext));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8, 11, 14]]);
  }));

  return function putServicesMutation(_x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var deleteServiceGraphQLQuery = function deleteServiceGraphQLQuery(_ref2) {
  var proposalIds = _ref2.proposalIds,
      serviceIds = _ref2.serviceIds,
      attendeeIds = _ref2.attendeeIds,
      overloadForSpecificProposalIds = _ref2.overloadForSpecificProposalIds,
      appContext = _ref2.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      deleteService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(proposalIds), " serviceIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(serviceIds), " attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(attendeeIds), " ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADDITIONAL_SERVICES_DELETE */ "Hc"]
  });
};

var deleteServicesMutation = /*#__PURE__*/function () {
  var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee2(_ref3) {
    var proposalIds, serviceIds, attendeeIds, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalIds = _ref3.proposalIds, serviceIds = _ref3.serviceIds, attendeeIds = _ref3.attendeeIds, overloadForSpecificProposalIds = _ref3.overloadForSpecificProposalIds, appContext = _ref3.appContext;

            if (serviceRequestRunning) {
              _context2.next = 16;
              break;
            }

            serviceRequestRunning = deleteServiceGraphQLQuery({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            });
            _context2.prev = 3;
            _context2.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context2.sent;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            throw _context2.t0;

          case 12:
            _context2.prev = 12;
            serviceRequestRunning = null;
            return _context2.finish(12);

          case 15:
            return _context2.abrupt("return", result);

          case 16:
            _context2.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context2.abrupt("return", deleteServicesMutation({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9, 12, 15]]);
  }));

  return function deleteServicesMutation(_x6) {
    return _ref4.apply(this, arguments);
  };
}();

var addServiceGraphQLQuery = function addServiceGraphQLQuery(_ref5) {
  var proposalIds = _ref5.proposalIds,
      serviceId = _ref5.serviceId,
      attendeeIds = _ref5.attendeeIds,
      schedules = _ref5.schedules,
      overloadForSpecificProposalIds = _ref5.overloadForSpecificProposalIds,
      appContext = _ref5.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(proposalIds), ", serviceId: \"").concat(serviceId, "\", attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(attendeeIds), ", schedules: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(schedules), "  ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_27__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_ADDITIONAL_SERVICES_ADD */ "Gc"]
  });
};

var addServiceMutation = /*#__PURE__*/function () {
  var _ref7 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.mark(function _callee3(_ref6) {
    var proposalIds, serviceId, attendeeIds, schedules, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_16___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            proposalIds = _ref6.proposalIds, serviceId = _ref6.serviceId, attendeeIds = _ref6.attendeeIds, schedules = _ref6.schedules, overloadForSpecificProposalIds = _ref6.overloadForSpecificProposalIds, appContext = _ref6.appContext;

            if (serviceRequestRunning) {
              _context3.next = 16;
              break;
            }

            serviceRequestRunning = addServiceGraphQLQuery(_objectSpread(_objectSpread({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules
            }, overloadForSpecificProposalIds && {
              overloadForSpecificProposalIds: {
                proposalIds: overloadForSpecificProposalIds.proposalIds,
                serviceId: overloadForSpecificProposalIds.serviceIds[0]
              }
            }), {}, {
              appContext: appContext
            }));
            _context3.prev = 3;
            _context3.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context3.sent;
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            throw _context3.t0;

          case 12:
            _context3.prev = 12;
            serviceRequestRunning = null;
            return _context3.finish(12);

          case 15:
            return _context3.abrupt("return", result);

          case 16:
            _context3.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context3.abrupt("return", addServiceMutation({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 9, 12, 15]]);
  }));

  return function addServiceMutation(_x7) {
    return _ref7.apply(this, arguments);
  };
}();

function promoCodeProposalMutation(params, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      promoCodeProposal(id: \"".concat(params.proposalId, "\", promoCode: \"").concat(params.promoCode, "\" ").concat(params.partnerId && params.accessCode ? ", partnerId: \"".concat(params.partnerId, "\", accessCode: \"").concat(params.accessCode, "\"") : '', ", customerId: ").concat(params.customerId, ") {\n        id\n        price {\n          aggregateDiscount {\n            offerColor\n            offerName\n            amount {...priceDetails}\n          }\n          aggregateDiscountPromoCode {\n            offerColor\n            offerName\n            amount {...priceDetails}\n         }\n          promoCode {\n            offerColor\n            offerName\n            amount {\n              value\n              formattedValue\n            }\n          }\n          total {...priceDetails}\n          discounts {\n            offerId\n            amount {...priceDetails}\n            offerName\n            offerColor\n            offerDescription\n          }\n        }\n        attendeesPrice {\n          id\n          householdId\n          total {\n            ...priceDetails\n            currency\n          }\n          priceItems {\n            type\n            offerId\n            price {\n              ...priceDetails\n              currency\n            }\n          }\n        }\n        households {\n          attendees {\n            id\n            customerId\n            birthdate\n            isAdult\n            isMain\n          }\n          paymentSchedule {\n            commissionIncluded\n            total {...priceDetails}\n            depositAmount {...priceDetails}\n            repaymentSchedules{\n              amount {...priceDetails}\n              deadline\n            }\n          }\n        }\n      }\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_USE_PROMO_CODE */ "Zc"]
  });
}

function autosaveProposalMutation(params, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      autosaveProposal(id: \"".concat(params.proposalId, "\") {\n        id\n        }\n    }\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_AUTOSAVE */ "Kc"]
  });
}

function switchProposalsOffers(proposalIds, offerIds, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("mutation {\n      proposals: switchProposalsOffers(proposalIds: [\"".concat(proposalIds.join('","'), "\"], offerIds: [\"").concat(offerIds.join('","'), "\"]) {\n        id\n        optionAvailable\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_SWITCH_OFFER */ "Wc"]
  });
}

function refreshProposal(proposalId, salesNetworkId, appContext) {
  var graphqlParams = "id: \"".concat(proposalId, "\"").concat(salesNetworkId ? ", salesNetworkId: \"".concat(salesNetworkId, "\"") : '');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"].runNoCacheQuery("\n    query {\n      refreshProposal (".concat(graphqlParams, ") {\n        proposal {\n          id\n          productId\n          optionAvailable\n          optionDurability {\n            expirationDateTime\n            isReliable\n          },\n          duration\n          extendPersistence\n          price {\n            ...refreshProposalPrice\n          }\n          remainingStock\n          households {\n            attendees {\n              id\n              customerId\n              customerType\n              birthdate\n            }\n          }\n          transportationSummary {\n            way\n            departureCity\n            arrivalCity\n            transportationType\n            cancellationPolicyType\n            clubmedTransport\n            departureDate\n            arrivalDate\n          }\n          isBookable\n          creationDateTime\n          packageId\n          resortArrivalDate\n          resortDepartureDate\n          accommodations {\n            id\n            quantity\n            sharedRoom\n          }\n          label\n          locale\n          alternativePrice {\n            ...refreshProposalPrice\n          }\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n          errorDescription\n        }\n      }\n    }\n    fragment refreshProposalPrice on RefreshProposalPriceType {\n      currency\n      total {...priceDetails}\n      totalWithoutFees {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      totalWithoutTransport {...priceDetails}\n      discounts {\n        type\n        amount {...priceDetails}\n        offerId\n      }\n      yieldPricingVariation {...priceDetails}\n      trip {\n        initialPrice {...priceDetails}\n        initialPriceWithFees {...priceDetails}\n        fees {\n          type\n          amount {...priceDetails}\n        }\n      }\n      includedServices {\n        id\n        amount {...priceDetails}\n      }\n      packageOptions {\n        type\n        amount {...priceDetails}\n      }\n    }\n    ").concat(getPriceDetailFragment(lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_25__[/* PROPOSAL_REFRESH */ "Uc"]
  });
}



/***/ }),

/***/ "7CPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toggler; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SuFq");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }


var Toggler = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Toggler, _Component);

  var _super = _createSuper(Toggler);

  function Toggler() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, Toggler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_this), "state", {
      isActive: _this.props.isActive || false
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_this), "toggle", function () {
      var onToggle = _this.props.onToggle;

      _this.setState(function (prevState) {
        return {
          isActive: !prevState.isActive
        };
      }, function () {
        if (onToggle) {
          onToggle(_this.state.isActive);
        }
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Toggler, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isActive = this.props.isActive;

      if (isActive !== prevProps.isActive) {
        this.setState({
          isActive: isActive
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var isActive = this.state.isActive;
      return children(this.toggle, isActive);
    }
  }]);

  return Toggler;
}(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);

/***/ }),

/***/ "7knX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExclusiveCollectionBadge; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var ExclusiveCollectionBadge = function ExclusiveCollectionBadge(_ref) {
  var className = _ref.className;
  return __jsx("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('font-bold gap-5 inline-flex items-center leading-1 shrink-0 text-12 text-initial text-ultramarine', className)
  }, __jsx("span", {
    className: "aspect-square bg-ultramarine inline-flex items-center justify-center leading-0 h-[1.65em] sm:h-[2em] rounded-full text-white w-[1.65em] sm:w-[2em]"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].DIAMOND,
    width: "0.85em"
  })), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.product.exclusiveCollectionTag'));
};

/***/ }),

/***/ "7pmY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = sortFields;

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _toposort = _interopRequireDefault(__webpack_require__("VNI2"));

var _propertyExpr = __webpack_require__("dFUt");

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

function sortFields(fields, excludes) {
  if (excludes === void 0) {
    excludes = [];
  }

  var edges = [],
      nodes = [];

  function addNode(depPath, key) {
    var node = (0, _propertyExpr.split)(depPath)[0];
    if (!~nodes.indexOf(node)) nodes.push(node);
    if (!~excludes.indexOf(key + "-" + node)) edges.push([key, node]);
  }

  for (var key in fields) {
    if ((0, _has.default)(fields, key)) {
      var value = fields[key];
      if (!~nodes.indexOf(key)) nodes.push(key);
      if (_Reference.default.isRef(value) && value.isSibling) addNode(value.path, key);else if ((0, _isSchema.default)(value) && value._deps) value._deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  }

  return _toposort.default.array(nodes, edges).reverse();
}

module.exports = exports["default"];

/***/ }),

/***/ "8fx4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLeadScore; });
var getLeadScore = function getLeadScore(_ref) {
  var leadInfos = _ref.leadInfos;
  return parseFloat(leadInfos.score);
};



/***/ }),

/***/ "8soX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isSymbol2 = __webpack_require__("a88S");

var _isSymbol3 = _interopRequireDefault(_isSymbol2);

var _isString2 = __webpack_require__("nDih");

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = __webpack_require__("Kkar");

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFSA(action) {
  return (0, _isPlainObject3.default)(action) && ((0, _isString3.default)(action.type) || (0, _isSymbol3.default)(action.type)) && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return action.error === true;
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

/***/ }),

/***/ "93Yv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_MIN_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_MAX_AGE; });
var DEFAULT_MIN_AGE = 0;
var DEFAULT_MAX_AGE = 18;

/***/ }),

/***/ "97Jx":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "9BC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPhoneRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return salesmanIDRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return internationalPhoneRegex; });
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TWNs");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SYor");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4__);




 // WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js

function isPhoneNumber(stringToTest) {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

var emailRegex = new RegExp(/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/);
var salesmanIDRegex = new RegExp(/(^\d{6,8}$|^$)/);

var getPhoneRegex = function getPhoneRegex(locale) {
  var _domainsService$getDo, _domainsService$getDo2;

  return new RegExp(((_domainsService$getDo = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4___default.a.getDomain(locale)) === null || _domainsService$getDo === void 0 ? void 0 : (_domainsService$getDo2 = _domainsService$getDo.fields) === null || _domainsService$getDo2 === void 0 ? void 0 : _domainsService$getDo2.phoneNumber) || /^ *\+? *(?:[ \-()\.\/]*[0-9][ \-()\.\/]*){6,20}$/);
};

var internationalPhoneRegex = new RegExp(/\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/);


/***/ }),

/***/ "9LZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBookingEngineI18nQuery; });
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");


function fetchBookingEngineI18nQuery(appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].runQuery('', appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"],
    queryId: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"]
  });
}

/***/ }),

/***/ "9OZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductService; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4Brf");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("gA51");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qBqs");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;







var ProductService = function ProductService(_ref) {
  var className = _ref.className,
      service = _ref.service;
  var description = service.description,
      icon = service.icon,
      label = service.label;
  return description ? __jsx(_frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_7__[/* CollapsePanel */ "a"], {
    className: className,
    collapseIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ARROW_DOWN,
    collapseLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('common.included'),
    expandIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].ARROW_DOWN,
    expandLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('common.included'),
    hasKeepCollapsedContent: false,
    iconName: icon,
    id: icon,
    isExpanded: false,
    key: icon,
    theme: "remote",
    title: label
  }, __jsx("p", {
    className: "pb-15 px-15 text-14"
  }, description)) : __jsx("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('animate-fadeIn animation-duration-500 bg-white border-1 border-lightGrey flex gap-10 items-center justify-between p-15 rounded-12 shadow-diffuse', className)
  }, __jsx("span", {
    className: "flex flex-1 font-semibold gap-10 items-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    className: "shrink-0",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].SIENNA,
    name: icon,
    width: "1.875rem"
  }), label), __jsx("span", {
    className: "flex items-center shrink-0 text-14 text-black whitespace-nowrap"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('common.included')));
};

/***/ }),

/***/ "9QcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACETING_CHILDCARE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FACETING_CLEAR_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACETING_CLEAR_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FACETING_PRICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FACETING_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FACETING_LOAD_PRODUCTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FACETING_LOAD_OFFSET_SELL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FACETING_SET_CUSTOM_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FACETING_SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FACETING_SET_SEARCH_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FACETING_SET_INITIAL_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FACETING_SET_IS_DATE_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACETING_SET_IS_SEARCH_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACETING_SET_KIDS_VALIDATION_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FACETING_SET_ORDER_BY_PRICE; });
/* unused harmony export FACETING_SET_SCROLL_TO_RESULTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FACETING_SET_SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FACETING_RESET_CUSTOM_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FACETING_RESET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FACETING_RESET_REDIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FACETING_RESET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FACETING_TOGGLE_FACET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FACETING_UPDATE_CUSTOM_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FACETING_UPDATE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS; });
var FACETING_CHILDCARE_REQUEST = 'FACETING_CHILDCARE_REQUEST';
var FACETING_CLEAR_FACETS = 'FACETING_CLEAR_FACETS';
var FACETING_CLEAR_ALL = 'FACETING_CLEAR_ALL';
var FACETING_PRICES_REQUEST = 'FACETING_PRICES_REQUEST';
var FACETING_SEARCH_REQUEST = 'FACETING_SEARCH_REQUEST';
var FACETING_LOAD_PRODUCTS_REQUEST = 'FACETING_LOAD_PRODUCTS_REQUEST';
var FACETING_LOAD_OFFSET_SELL_REQUEST = 'FACETING_LOAD_OFFSET_SELL_REQUEST';
var FACETING_SET_CUSTOM_FILTERS = 'FACETING_SET_CUSTOM_FILTERS';
var FACETING_SET_FILTERS = 'FACETING_SET_FILTERS';
var FACETING_SET_SEARCH_FILTERS = 'FACETING_SET_SEARCH_FILTERS';
var FACETING_SET_INITIAL_PRICES = 'FACETING_SET_INITIAL_PRICES';
var FACETING_SET_IS_DATE_REQUIRED = 'FACETING_SET_IS_DATE_REQUIRED';
var FACETING_SET_IS_SEARCH_ENABLED = 'FACETING_SET_IS_SEARCH_ENABLED';
var FACETING_SET_KIDS_VALIDATION_STATE = 'FACETING_SET_KIDS_VALIDATION_STATE';
var FACETING_SET_ORDER_BY_PRICE = 'FACETING_SET_ORDER_BY_PRICE';
var FACETING_SET_SCROLL_TO_RESULTS = 'FACETING_SCROLL_TO_RESULTS';
var FACETING_SET_SEARCH_QUERY = 'FACETING_SET_SEARCH_QUERY';
var FACETING_RESET_CUSTOM_FILTERS = 'FACETING_RESET_CUSTOM_FILTERS';
var FACETING_RESET_FILTERS = 'FACETING_RESET_FILTERS';
var FACETING_RESET_REDIRECTION = 'FACETING_RESET_REDIRECTION';
var FACETING_RESET_SEARCH = 'FACETING_RESET_SEARCH';
var FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_FACET_SELECTED = 'FACETING_TOGGLE_FACET_SELECTED';
var FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON = 'FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON';
var FACETING_UPDATE_CUSTOM_FILTERS = 'FACETING_UPDATE_CUSTOM_FILTERS';
var FACETING_UPDATE_FILTERS = 'FACETING_UPDATE_FILTERS';
var FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING = 'FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING';
var FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS = 'FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS';

/***/ }),

/***/ "9TP6":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("OBn4"),
    noop = __webpack_require__("nnm9"),
    setToArray = __webpack_require__("XlL0");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "A0Zq":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("wC3K"),
    baseForOwn = __webpack_require__("zKkv"),
    baseIteratee = __webpack_require__("S3pA");

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),

/***/ "AdY7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__("yWCo");

var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(__webpack_require__("c8jO"));

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var _makePath = _interopRequireDefault(__webpack_require__("raDx"));

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _runValidations = _interopRequireWildcard(__webpack_require__("wM5X"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["", "[", "]"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = ArraySchema;
exports.default = _default;

function ArraySchema(type) {
  var _this = this;

  if (!(this instanceof ArraySchema)) return new ArraySchema(type);

  _mixed.default.call(this, {
    type: 'array'
  }); // `undefined` specifically means uninitialized, as opposed to
  // "no subtype"


  this._subType = undefined;
  this.withMutation(function () {
    _this.transform(function (values) {
      if (typeof values === 'string') try {
        values = JSON.parse(values);
      } catch (err) {
        values = null;
      }
      return this.isType(values) ? values : null;
    });

    if (type) _this.of(type);
  });
}

(0, _inherits.default)(ArraySchema, _mixed.default, {
  _typeCheck: function _typeCheck(v) {
    return Array.isArray(v);
  },
  _cast: function _cast(_value, _opts) {
    var _this2 = this;

    var value = _mixed.default.prototype._cast.call(this, _value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this._subType) return value;
    var isChanged = false;
    var castArray = value.map(function (v) {
      var castElement = _this2._subType.cast(v, _opts);

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  },
  _validate: function _validate(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var errors = [];
    var sync = options.sync;
    var path = options.path;
    var subType = this._subType;

    var endEarly = this._option('abortEarly', options);

    var recursive = this._option('recursive', options);

    var originalValue = options.originalValue != null ? options.originalValue : _value;
    return _mixed.default.prototype._validate.call(this, _value, options).catch((0, _runValidations.propagateErrors)(endEarly, errors)).then(function (value) {
      if (!recursive || !subType || !_this3._typeCheck(value)) {
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value;
      var validations = value.map(function (item, idx) {
        var path = (0, _makePath.default)(_templateObject(), options.path, idx); // object._validate note for isStrict explanation

        var innerOptions = (0, _extends2.default)({}, options, {
          path: path,
          strict: true,
          parent: value,
          originalValue: originalValue[idx]
        });
        if (subType.validate) return subType.validate(item, innerOptions);
        return true;
      });
      return (0, _runValidations.default)({
        sync: sync,
        path: path,
        value: value,
        errors: errors,
        endEarly: endEarly,
        validations: validations
      });
    });
  },
  _isPresent: function _isPresent(value) {
    return _mixed.default.prototype._cast.call(this, value) && value.length > 0;
  },
  of: function of(schema) {
    var next = this.clone();
    if (schema !== false && !(0, _isSchema.default)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + (0, _printValue.default)(schema));
    next._subType = schema;
    return next;
  },
  min: function min(_min, message) {
    message = message || _locale.array.min;
    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    message = message || _locale.array.max;
    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  ensure: function ensure() {
    var _this4 = this;

    return this.default(function () {
      return [];
    }).transform(function (val) {
      if (_this4.isType(val)) return val;
      return val === null ? [] : [].concat(val);
    });
  },
  compact: function compact(rejector) {
    var reject = !rejector ? function (v) {
      return !!v;
    } : function (v, i, a) {
      return !rejector(v, i, a);
    };
    return this.transform(function (values) {
      return values != null ? values.filter(reject) : values;
    });
  },
  describe: function describe() {
    var base = _mixed.default.prototype.describe.call(this);

    if (this._subType) base.innerType = this._subType.describe();
    return base;
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "Akr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useSyncDepartureCity; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("uDfI");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("loSl");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kNiU");





var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["constants"].NO_TRANSPORT_VALUE;
function useSyncDepartureCity(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      departureCity = _ref.departureCity,
      initialTransport = _ref.initialTransport,
      onChange = _ref.onChange,
      withValidDepartureCity = _ref.withValidDepartureCity;
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useDispatch */ "d"])();
  var isDepartureCityAvailable = Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_4__[/* hasDepartureCityAvailable */ "l"])(departureCitiesOptions, departureCity);

  var _departureCity = withValidDepartureCity && departureCity && !isDepartureCityAvailable ? null : departureCity;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(_departureCity || initialTransport || NO_TRANSPORT_VALUE),
      inputDepartureCity = _useState[0],
      setInputDepartureCity = _useState[1]; // Store update effect


  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var newDepartureCity = departureCity;

    if (withValidDepartureCity && newDepartureCity && !isDepartureCityAvailable) {
      newDepartureCity = initialTransport || NO_TRANSPORT_VALUE;
      dispatch(Object(_client_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_3__[/* changeDepartureCity */ "a"])(newDepartureCity));
    } // 1. Sync local state with store updates


    if (inputDepartureCity !== newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
    } // 2. Sync criteria validation with store updates


    if (onChange) {
      onChange(newDepartureCity);
    }
  }, [departureCity]);
  return {
    inputDepartureCity: inputDepartureCity,
    setInputDepartureCity: setInputDepartureCity
  };
}

/***/ }),

/***/ "AnR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ setPromoCode; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ addAccommodation; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ putTransportAndDispatchProposals; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ proposals_action_addAdditionalService; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ proposals_action_deleteAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "x", function() { return /* binding */ updateAttendees; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ clearProposals; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ fetchProposalsAndRedirect; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ fetchProposalsById; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ proposals_action_fetchSelectedProposalPayment; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ proposals_action_saveCustomerProposalsHandler; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ proposals_action_patchProposalHandler; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ proposals_action_deleteInsurances; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ proposals_action_addInsurances; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ refuseInsuranceAction; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ proposals_action_prepareBe; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ displayToastOnContextShare; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ editCriteriaFetchProposals; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* binding */ simpleFetchProposals; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ proposals_action_saveDonationToProposals; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ proposals_action_addOrReplaceAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* binding */ proposals_action_switchProposalsOffers; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getSearchCriteria; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ fetchRefreshProposal; });

// UNUSED EXPORTS: getNumberOfAttendees, handleError, setProposalAsAutosaved, saveCustomerProposalsOpportunityIdHandler

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("yyme");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("Rfxz");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("qePV");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("zKZe");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("B6y2");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("5s+n");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.finally.js
var es_promise_finally = __webpack_require__("p532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("JTJg");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("hByQ");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("EnZy");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/snakeCase.js
var snakeCase = __webpack_require__("CzFL");
var snakeCase_default = /*#__PURE__*/__webpack_require__.n(snakeCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("E9XD");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/attendees/attendeesUtils.js












function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var ATTENDEE_SCHEMA_PROPERTIES = ['id', 'lastName', 'firstName', 'unicodeLastName', 'unicodeFirstName', 'birthdate', 'email', 'mobile', 'optinSms', 'optinMail', 'optinFosun', 'optinEmail', 'optinPhone', 'optinClubmedPlus', 'civility', 'identityNumber', 'healthPassId', 'travelDocuments', 'customerId', 'address', 'mainContactId', 'isChild'];
/**
 * Remove all properties that don't match GQL Schema Otherwise the mutation fails
 */

var attendeesUtils_removeUselessProperties = function removeUselessProperties(attendee) {
  var travelDocuments = attendee.document ? Object.keys(attendee.document).reduce(function (fullDocuments, type) {
    var document = attendee.document[type] || {};

    if (!isEmpty_default()(document)) {
      var newDocument = {}; // We fill all fields once we have a documentNumber

      if (document.documentNumber) {
        newDocument.document_number = document.documentNumber || undefined;
        newDocument.issuing_country = (document === null || document === void 0 ? void 0 : document.issuingCountry) || undefined;
        newDocument.birth_country = (document === null || document === void 0 ? void 0 : document.birthCountry) || undefined;
        newDocument.expiration_date = Object(apiDate["n" /* timestampToApiDate */])(document === null || document === void 0 ? void 0 : document.expirationDate) || undefined;
        newDocument.issuing_date = Object(apiDate["n" /* timestampToApiDate */])(document === null || document === void 0 ? void 0 : document.issuingDate) || undefined;
        newDocument.nationality = document.nationality || undefined;
        newDocument.type = (document === null || document === void 0 ? void 0 : document.type) || undefined;
      }

      if (!isEmpty_default()(newDocument)) {
        fullDocuments.push(newDocument);
      }
    }

    return fullDocuments;
  }, []) : [];
  return pick_default()(_objectSpread(_objectSpread({}, attendee), {}, {
    travelDocuments: travelDocuments,
    // keep customerId like this because we cannot update attendees for B2C
    customerId: attendee.neolid,
    birthdate: Object(apiDate["n" /* timestampToApiDate */])(attendee.birthdate)
  }), ATTENDEE_SCHEMA_PROPERTIES);
};
// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/attendees/attendeesQuery.js








/**
 * Connected customer experience : Put attendees
 */

function updateAttendeesMutation(_ref) {
  var proposalId = _ref.proposalId,
      attendees = _ref.attendees,
      appContext = _ref.appContext;
  var formatedAttendees = {
    adults: attendees.adults.map(attendeesUtils_removeUselessProperties),
    children: attendees.children.map(attendeesUtils_removeUselessProperties)
  };
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation { \n      modifyAttendees (\n        proposalId: \"".concat(proposalId, "\",\n        households: ").concat(Object(graphql["d" /* graphqlify */])([formatedAttendees]), "\n        ) {\n        proposal {\n          id\n          attendees {\n            list {\n              id\n              customerId\n              civility\n              firstName\n              lastName\n              birthdate\n              email\n              optins {\n                channel\n                optin\n              }\n            }\n          }\n          households {\n            attendees {\n              id\n              customerId\n              birthdate\n              isAdult\n              isMain\n            }\n            ").concat(Object(proposalQuery["g" /* getPaymentScheduleRequest */])(appContext), "\n          }\n          ").concat(Object(proposalQuery["l" /* proposalPriceQuery */])(), "\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n          errorDescription\n        }\n        attendees {\n          id\n          ").concat(appContext.isSeller ? 'gmNumber' : '', "\n          customerId\n          customerType\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(get_default()(appContext, 'locale')), "\n    "), appContext, {
    requestName: requestDictionary["Yc" /* PROPOSAL_UPDATE_ATTENDEES */]
  });
}

var attendeesQuery_queryBookingAttendees = function queryBookingAttendees(bookingId) {
  return graphqlClient["a" /* default */].runQuery("query {\n    bookingAttendees(bookingId: ".concat(bookingId, ") {\n      civility\n      gmNumber\n      customerId\n      identityNumber\n      healthPassId\n      mainContact\n      lastName\n      unicodeLastName\n      firstName\n      unicodeFirstName\n      email\n      birthdate\n    }\n  }"));
};


// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/additionalTransports.action.js
var additionalTransports_action = __webpack_require__("04nu");

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var trip_information_storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/client/store/booking/attendees/attendees.selector.js
var attendees_selector = __webpack_require__("eZ08");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.action.js




























var _BOOKING_ENGINE_ENTRY;

function proposals_action_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function proposals_action_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? proposals_action_ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : proposals_action_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






























var BOOKING_ENGINE_ENTRY_TRACKING_LABELS = (_BOOKING_ENGINE_ENTRY = {}, Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR, 'calendarPrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE, 'remotePrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].QUICK_SEARCH, 'quickSearch'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].CRUISE_BOOKING, 'cruiseBooking'), _BOOKING_ENGINE_ENTRY);

function throwFormatError(data) {
  // $FlowFixMe
  var error = Object.assign(new Error(), data);
  throw error;
}

function setPromoCode(proposalId, params, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["E" /* SET_PROMO_CODE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["j" /* promoCodeProposalMutation */])(proposals_action_objectSpread({
      proposalId: proposalId
    }, params), appContext)
  });
}

function setProposalAsAutosaved(proposalId, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["g" /* AUTOSAVE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["d" /* autosaveProposalMutation */])({
      proposalId: proposalId
    }, appContext)
  });
}

function fetchProposalsById(_ref) {
  var proposalsId = _ref.proposalsId,
      appContext = _ref.appContext,
      shouldRequestPayment = _ref.shouldRequestPayment,
      adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return function (dispatch, getState) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["n" /* FETCH_PROPOSALS_BY_ID */], {}, {
      optimist: true,
      promise: Object(BookingEngine_query["e" /* proposalsByIdQuery */])({
        proposalsId: proposalsId,
        shouldRequestPayment: shouldRequestPayment,
        adultsAttendeesIds: adultsAttendeesIds,
        kidsAttendeesIds: kidsAttendeesIds,
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities'),
        selectedProposalId: Object(booking_selector["x" /* getSelectedProposalId */])(getState())
      }, appContext)
    }));
  };
}

function getNumberOfAttendees() {
  var nbAdults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var nbKids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isSeller = arguments.length > 2 ? arguments[2] : undefined;
  var numberOfAttendees = nbAdults + nbKids;
  var maxPaxByUser = isSeller ? faceting_constants["L" /* MAX_PAX_SELLER */] : faceting_constants["K" /* MAX_PAX */];
  /** reset to default adults number if no adults or if the number exceeds the allowed sum (maxPaxByUser) */

  return numberOfAttendees === 0 || numberOfAttendees > maxPaxByUser ? adults_constants["a" /* DEFAULT_ADULTS_NB */] : numberOfAttendees;
}

function getSearchCriteria(_ref2) {
  var _proposal$transports, _proposal$transports2, _ref3, _inboundTravelSection, _outboundTravelSectio, _outboundTravelSectio2, _outboundTravelSectio3, _outboundTravelSectio4;

  var proposal = _ref2.proposal,
      searchedDepartureID = _ref2.searchedDepartureID,
      searchedDepartureDate = _ref2.searchedDepartureDate,
      _ref2$searchByAeropor = _ref2.searchByAeroport,
      searchByAeroport = _ref2$searchByAeropor === void 0 ? false : _ref2$searchByAeropor,
      flightClass = _ref2.flightClass,
      _ref2$directFlights = _ref2.directFlights,
      directFlights = _ref2$directFlights === void 0 ? false : _ref2$directFlights;
  var inboundTravelSection = (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : _proposal$transports.inbound.travelSections[0];
  var outboundTravelSection = (_proposal$transports2 = proposal.transports) === null || _proposal$transports2 === void 0 ? void 0 : _proposal$transports2.outbound.travelSections[0];
  var departureSearchId = searchByAeroport ? 'id' : 'cityId';
  return [{
    departure: {
      locationId: searchedDepartureID || (inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : inboundTravelSection.departure[departureSearchId]),
      date: (_ref3 = searchedDepartureDate || (inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : (_inboundTravelSection = inboundTravelSection.departure) === null || _inboundTravelSection === void 0 ? void 0 : _inboundTravelSection.date)) === null || _ref3 === void 0 ? void 0 : _ref3.toString()
    },
    arrival: {
      locationId: outboundTravelSection === null || outboundTravelSection === void 0 ? void 0 : (_outboundTravelSectio = outboundTravelSection.departure) === null || _outboundTravelSectio === void 0 ? void 0 : _outboundTravelSectio.cityId
    },
    flightClass: flightClass,
    maxConnections: directFlights ? 0 : undefined
  }, {
    departure: {
      locationId: outboundTravelSection === null || outboundTravelSection === void 0 ? void 0 : (_outboundTravelSectio2 = outboundTravelSection.departure) === null || _outboundTravelSectio2 === void 0 ? void 0 : _outboundTravelSectio2.cityId,
      date: outboundTravelSection === null || outboundTravelSection === void 0 ? void 0 : (_outboundTravelSectio3 = outboundTravelSection.departure) === null || _outboundTravelSectio3 === void 0 ? void 0 : (_outboundTravelSectio4 = _outboundTravelSectio3.date) === null || _outboundTravelSectio4 === void 0 ? void 0 : _outboundTravelSectio4.toString()
    },
    arrival: {
      locationId: searchedDepartureID || (inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : inboundTravelSection.departure[departureSearchId])
    },
    flightClass: flightClass,
    maxConnections: directFlights ? 0 : undefined
  }];
}
/*
  ATTENTION:
  Les valeurs par défaut de departureCity et duration sont mises dans le CMS,
  on ne peut donc pas récupérer les valeurs du store
 */


function fetchProposalsAndRedirect(params, appContext, router) {
  var pageType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Booking Engine';
  return function (dispatch, getState) {
    var _queryParams$kids, _queryParams$kids$spl;

    var state = getState();
    var intArrivalDate = params.newArrivalDate || Object(storeHelper["a" /* getArrivalDate */])(state) || Object(apiDate["n" /* timestampToApiDate */])(state.tripCriteria.departureDate);

    if (!intArrivalDate) {
      // $FlowFixMe
      logger["default"].error('the arrivalDate is required in fetchProposalsAndRedirect action');
      return;
    }

    var queryParams = omit_default()(router.query, ['dynamicPage']);

    var adultsAttendees = Object(trip_information_storeHelper["a" /* getAdults */])(state) || [];
    var kidsAttendees = Object(trip_information_storeHelper["c" /* getKids */])(state) || [];
    var nbAdults = appContext.isSeller ? Number(queryParams.number_of_adults || adultsAttendees.length) : adultsAttendees.length;
    var nbKids = appContext.isSeller ? ((_queryParams$kids = queryParams.kids) === null || _queryParams$kids === void 0 ? void 0 : (_queryParams$kids$spl = _queryParams$kids.split('_')) === null || _queryParams$kids$spl === void 0 ? void 0 : _queryParams$kids$spl.length) || 0 : kidsAttendees.length;
    var allowedAttendeesNumber = getNumberOfAttendees(nbAdults, nbKids, appContext.isSeller);

    var proposalParams = proposals_action_objectSpread(proposals_action_objectSpread({
      arrivalDate: intArrivalDate.toString(),
      kids: kidsAttendees,
      adults: adultsAttendees,
      numberAttendees: allowedAttendeesNumber,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }, appContext.isSeller ? {
      salesNetworkId: queryParams.cxo_sales_network_id
    } : null), params);

    var redirectUri = Object(sellerUtils["d" /* getSigninURIWithRedirection */])({
      locale: appContext.locale,
      proposalId: null,
      step: null,
      isCmta: appContext.isCmta
    });
    /**  Method 5 steps
     * 1. fetch BE i18n config
     * 2. fetch proposal
     * 3. send tracking
     * 4. Set search criteria if transport for MoreTransports
     * 5. redirect to signin redirection URL
     */

    /* 1. fetch BE i18n config */

    dispatch(Object(cms_actions["c" /* getBookingEngineI18n */])(appContext));
    /* 2. fetch proposal */

    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["m" /* FETCH_PROPOSALS */], {
      globalLoaderLabel: params.globalLoaderLabel,
      bookingEngineEntry: params.bookingEngineEntry
    }, {
      optimist: true,
      promise: Object(proposalQuery["m" /* proposalsQuery */])(proposalParams, appContext).then(function (response) {
        var _proposals$errors, _proposals$errors$;

        var proposals = response.proposals;
        var isFetchProposalsFailed = Object(proposalUtils["r" /* hasFetchProposalsFailed */])(proposals);

        if (!isFetchProposalsFailed) {
          /* 4. Set search criteria if transport for MoreTransports */
          // this was added to save the selected departureCity which can either be the cityID or the aeroportID
          if (params.departureCity) {
            var _proposals$proposals = Object(slicedToArray["a" /* default */])(proposals.proposals, 1),
                firstProposal = _proposals$proposals[0];

            dispatch(Object(additionalTransports_action["e" /* setSearchCriteria */])(getSearchCriteria({
              proposal: firstProposal,
              searchedDepartureID: params.departureCity,
              searchedDepartureDate: params.newArrivalDate
            })));
          }

          var bookingUrl = Object(BookingPagesUtils["j" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals || [], proposals.resort, undefined, queryParams);
          /* 5. redirect to signin redirection URL */

          router.push(bookingUrl);
        }

        var errorCode = proposals === null || proposals === void 0 ? void 0 : (_proposals$errors = proposals.errors) === null || _proposals$errors === void 0 ? void 0 : (_proposals$errors$ = _proposals$errors[0]) === null || _proposals$errors$ === void 0 ? void 0 : _proposals$errors$.errorCode;
        tracking_api["b" /* setDataLayer */]({
          categoryGA: 'resort',
          actionGA: BOOKING_ENGINE_ENTRY_TRACKING_LABELS[params.bookingEngineEntry],
          labelGA: isFetchProposalsFailed ? "errorCheckPrices".concat(errorCode ? "_".concat(snakeCase_default()(errorCode).toUpperCase()) : '') : 'checkPrices',
          siteSection: "Shopping_".concat(pageType)
        }, appContext);
        return response;
      }),
      redirect_uri: redirectUri
    }));
  };
}

function handleError(errors, appContext) {
  var _error$errors, _error$errors$; // We don't do anything specific with the errors, but this will let us display per field errors


  logger["default"].error(errors);
  var error = errors.errors ? errors : {
    errors: errors
  }; // Redirect to oidc if the statusCode is 401

  if (ple_utils["l" /* hasAuthResponseError */](error)) {
    redirectUtils["a" /* default */].redirectToOidc(appContext);
    return;
  } // Some errors are properly handled by graphql. But we don't handle them explicitly
  // We rely on the message to know the source of the error because of babel < 7


  throwFormatError(proposals_action_objectSpread(proposals_action_objectSpread({}, error), {}, {
    statusCode: error.message === 'Unhandled field form error' ? statusCode_constants["b" /* STATUS_CODE_400 */] : // $FlowFixMe
    error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : _error$errors$.statusCode
  }));
}

function editCriteriaFetchProposals(criteria, proposalsLoderLabel, appContext, queryParams) {
  return function (dispatch, getState) {
    var _attendees$kids;

    var search = criteria.search,
        departure = criteria.departure,
        attendees = criteria.attendees,
        departureCity = criteria.departureCity;
    var payload = {
      globalLoaderLabel: proposalsLoderLabel
    };
    var state = getState();

    var _selectAttendeesWithI = Object(attendees_selector["c" /* selectAttendeesWithInfosByHouseholds */])(state),
        _selectAttendeesWithI2 = _selectAttendeesWithI.attendees,
        adultsAttendees = _selectAttendeesWithI2.adults,
        kidsAttendees = _selectAttendeesWithI2.children;

    var adults = new Array(attendees.adults).fill({}).map(function (_, index) {
      return {
        neolid: (adultsAttendees[index] || {}).customerId
      };
    });
    var kids = attendees.kids.map(function (kid) {
      var kidFromStore = kidsAttendees === null || kidsAttendees === void 0 ? void 0 : kidsAttendees.find(function (kidAtt) {
        return kidAtt.birthdate === kid.birthdate;
      });
      return {
        neolid: kidFromStore === null || kidFromStore === void 0 ? void 0 : kidFromStore.customerId,
        birthdate: kid.birthdate
      };
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["o" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */], payload, {
      optimist: true,
      promise: Object(proposalQuery["m" /* proposalsQuery */])(proposals_action_objectSpread({
        productId: search.value,
        arrivalDate: moment_default()(departure.date).format('YYYYMMDD'),
        duration: departure.duration,
        departureCity: departureCity.value,
        isJoyView: criteria.isJoyView,
        kids: kids,
        adults: adults,
        numberAttendees: getNumberOfAttendees(attendees.adults, (attendees === null || attendees === void 0 ? void 0 : (_attendees$kids = attendees.kids) === null || _attendees$kids === void 0 ? void 0 : _attendees$kids.length) || 0, appContext.isSeller),
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
      }, appContext.isSeller ? {
        salesNetworkId: queryParams.cxo_sales_network_id
      } : null), appContext)
    }));
  };
}

function simpleFetchProposals(criterias, proposalsLoaderLabel, appContext, location) {
  var productId = criterias.productId,
      arrivalDate = criterias.arrivalDate,
      duration = criterias.duration,
      attendees = criterias.attendees,
      departureCity = criterias.departureCity,
      bookingEngineEntry = criterias.bookingEngineEntry;
  var payload = {
    globalLoaderLabel: proposalsLoaderLabel,
    bookingEngineEntry: bookingEngineEntry
  };

  var sellerParams = proposals_action_objectSpread(proposals_action_objectSpread({}, Object(ContactInfoUtils["f" /* getAllAttendeesIds */])({
    adults: attendees.adults,
    kids: attendees.kids
  })), {}, {
    salesNetworkId: location.queryParams.cxo_sales_network_id
  });

  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["m" /* FETCH_PROPOSALS */], payload, {
    optimist: true,
    promise: Object(proposalQuery["m" /* proposalsQuery */])(proposals_action_objectSpread(proposals_action_objectSpread({}, appContext.isSeller ? sellerParams : null), {}, {
      productId: productId,
      arrivalDate: arrivalDate,
      duration: duration,
      departureCity: departureCity,
      numberAttendees: attendees.adults.length + attendees.kids.length,
      // $FlowFixMe
      adults: attendees.adults,
      // $FlowFixMe
      kids: attendees.kids,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }), appContext)
  });
}

function putTransportAndDispatchProposals(transportId, proposalsId, isJoyview, appContext, globalLoaderLabel, toastLabel) {
  return function (dispatch) {
    // TODO show a toast if error
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["f" /* ADD_TRANSPORT */], {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel,
      transportId: transportId
    }, {
      optimist: true,
      promise: Object(proposalQuery["c" /* addTransportMutation */])(transportId, proposalsId, isJoyview, appContext)
    }));
  };
}

function fetchRefreshProposal(proposalId, salesNetworkId, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["z" /* PROPOSAL_REFRESH */], {}, {
    optimist: true,
    promise: Object(proposalQuery["o" /* refreshProposal */])(proposalId, salesNetworkId, appContext)
  });
}

function displayToastOnContextShare(toastLabel) {
  return {
    type: proposals_constants["k" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */],
    payload: {
      toastLabel: toastLabel
    }
  };
}

function addAccommodation(_ref4) {
  var arrangement = _ref4.arrangement,
      proposalsId = _ref4.proposalsId,
      isJoyview = _ref4.isJoyview,
      appContext = _ref4.appContext,
      globalLoaderLabel = _ref4.globalLoaderLabel,
      toastLabel = _ref4.toastLabel,
      _ref4$reduxAction = _ref4.reduxAction,
      reduxAction = _ref4$reduxAction === void 0 ? proposals_constants["a" /* ADD_ACCOMMODATION */] : _ref4$reduxAction;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(reduxAction, {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel
    }, {
      optimist: true,
      promise: Object(proposalQuery["a" /* addAccommodationMutation */])(arrangement, proposalsId, isJoyview, appContext)
    }));
  };
}

function updateAttendees(_ref5) {
  var proposalId = _ref5.proposalId,
      attendees = _ref5.attendees,
      appContext = _ref5.appContext;
  return function (dispatch) {
    dispatch(Object(globalLoader_action["d" /* startLoading */])());
    return updateAttendeesMutation({
      proposalId: proposalId,
      attendees: attendees,
      appContext: appContext
    }).then(function (_ref6) {
      var _proposal$attendees, _proposal$attendees$l, _proposal$attendees$l2, _modifiedAttendees$;

      var modifyAttendees = _ref6.modifyAttendees;
      var errors = modifyAttendees.errors,
          proposal = modifyAttendees.proposal,
          modifiedAttendees = modifyAttendees.attendees;

      if (errors) {
        throwFormatError({
          errors: errors
        });
      }

      var cookieToSet = proposals_action_objectSpread(proposals_action_objectSpread({}, tracking_storage_api["b" /* get */](constants["c" /* BE_TRACKING */])), {}, {
        neolaneId: proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$l = _proposal$attendees.list) === null || _proposal$attendees$l === void 0 ? void 0 : (_proposal$attendees$l2 = _proposal$attendees$l[0]) === null || _proposal$attendees$l2 === void 0 ? void 0 : _proposal$attendees$l2.customerId,
        BE_customerStatus: modifiedAttendees === null || modifiedAttendees === void 0 ? void 0 : (_modifiedAttendees$ = modifiedAttendees[0]) === null || _modifiedAttendees$ === void 0 ? void 0 : _modifiedAttendees$.customerType
      });

      tracking_storage_api["c" /* set */](cookieToSet);
      dispatch(Object(createAction["b" /* default */])(proposals_constants["I" /* UPDATE_ATTENDEES */], modifyAttendees));
    })["catch"](function (error) {
      return handleError(error, appContext);
    })["finally"](function () {
      return dispatch(Object(globalLoader_action["c" /* endLoading */])());
    });
  };
}

function refuseInsuranceAction(insuranceId) {
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(proposals_constants["s" /* INSURANCE_DELETED */], insuranceId));
  };
}

function clearProposals() {
  return Object(createAction["b" /* default */])(proposals_constants["h" /* CLEAR_PROPOSALS */]);
}

var proposals_action_fetchSelectedProposalPayment = function fetchSelectedProposalPayment(selectedProposal, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["p" /* FETCH_SELECTED_PROPOSAL_PAYMENT */], {
    selectedProposalId: selectedProposal.id
  }, {
    optimist: true,
    promise: Object(proposalQuery["f" /* fetchPayment */])(selectedProposal.id, appContext)
  });
};

var proposals_action_saveCustomerProposalsHandler = function saveCustomerProposalsHandler(proposalId, appContext, customerId) {
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["B" /* SAVE_CUSTOMER_PROPOSAL */], {}, {
      optimist: true,
      promise: Object(sellerUtils["h" /* saveCustomerProposal */])(proposalId, appContext, customerId)
    }));
  };
};

var proposals_action_patchProposalHandler = function patchProposalHandler(proposalId, appContext, extend) {
  var options = {
    operation: 'extend_persistence',
    parameters: extend.toString()
  };
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["u" /* PATCH_PROPOSAL */], {}, {
      optimist: true,
      promise: Object(sellerUtils["g" /* patchProposal */])(proposalId, appContext, options.operation, options.parameters)
    }));
  };
};

var proposals_action_saveCustomerProposalsOpportunityIdHandler = function saveCustomerProposalsOpportunityIdHandler(proposalId, appContext, customerId, opportunityId) {
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["C" /* SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID */], {}, {
      optimist: true,
      promise: Object(sellerUtils["j" /* saveCustomerProposalOpportunityId */])(proposalId, appContext, customerId, opportunityId)
    }));
  };
};

var proposals_action_addOrReplaceAdditionalServices = function addOrReplaceAdditionalServices(_ref7) {
  var proposalIds = _ref7.proposalIds,
      attendees = _ref7.attendees,
      _ref7$showNotificatio = _ref7.showNotification,
      showNotification = _ref7$showNotificatio === void 0 ? false : _ref7$showNotificatio,
      appContext = _ref7.appContext;
  return function (dispatch, getState) {
    var proposal = Object(booking_selector["j" /* getCurrentProposal */])(getState());
    var servicesIds = attendees.map(function (_ref8) {
      var productInfoId = _ref8.productInfoId;
      return productInfoId;
    });
    var additionalServicesValues = Object.values(proposal.additionalServices);
    var isUpdatingAlreadyReservedService = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref9) {
          var pricingInfo = _ref9.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.isPartiallyRented;
        })
      );
    });
    var newReservedServiceToastLabel = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref10) {
          var pricingInfo = _ref10.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.type === 'RENTAL';
        })
      );
    }) ? 'booking.activities.skiEquipment.newEquipmentSelection' : 'booking.activities.newActivitySelection';
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["K" /* UPDATE_SERVICES */], showNotification ? {
      toastLabel: isUpdatingAlreadyReservedService ? 'booking.activities.activityUpdate' : newReservedServiceToastLabel
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["n" /* putServicesMutation */])(proposalIds, attendees, appContext)
    }));
  };
};

var proposals_action_deleteAdditionalServices = function deleteAdditionalServices(_ref11) {
  var proposalIds = _ref11.proposalIds,
      serviceIds = _ref11.serviceIds,
      attendeeIds = _ref11.attendeeIds,
      _ref11$showNotificati = _ref11.showNotification,
      showNotification = _ref11$showNotificati === void 0 ? false : _ref11$showNotificati,
      overloadForSpecificProposalIds = _ref11.overloadForSpecificProposalIds,
      appContext = _ref11.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["j" /* DELETE_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["e" /* deleteServicesMutation */])({
        proposalIds: proposalIds,
        serviceIds: serviceIds,
        attendeeIds: attendeeIds,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};

var proposals_action_addAdditionalService = function addAdditionalService(_ref12) {
  var proposalIds = _ref12.proposalIds,
      serviceId = _ref12.serviceId,
      attendeeIds = _ref12.attendeeIds,
      schedules = _ref12.schedules,
      _ref12$showNotificati = _ref12.showNotification,
      showNotification = _ref12$showNotificati === void 0 ? false : _ref12$showNotificati,
      overloadForSpecificProposalIds = _ref12.overloadForSpecificProposalIds,
      appContext = _ref12.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["d" /* ADD_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["b" /* addServiceMutation */])({
        proposalIds: proposalIds,
        serviceId: serviceId,
        attendeeIds: attendeeIds,
        schedules: schedules,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};
/**
INSURANCE ADD/DELETE
* */


var proposals_action_addInsurances = function addInsurances(_ref13) {
  var proposalIds = _ref13.proposalIds,
      insurance = _ref13.insurance,
      attendeeIds = _ref13.attendeeIds,
      appContext = _ref13.appContext;
  var _insurance$pricingInf = insurance.pricingInfo,
      id = _insurance$pricingInf.id,
      schedules = _insurance$pricingInf.schedules;
  return function (dispatch) {
    return dispatch(proposals_action_addAdditionalService({
      proposalIds: proposalIds,
      serviceId: id,
      attendeeIds: attendeeIds,
      schedules: schedules.map(function (_ref14) {
        var startDate = _ref14.startDate,
            endDate = _ref14.endDate;
        return {
          startDate: startDate,
          endDate: endDate
        };
      }),
      appContext: appContext
    })).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["J" /* UPDATE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["r" /* INSURANCE_ADDED */], id));
    });
  };
};

var proposals_action_deleteInsurances = function deleteInsurances(_ref15) {
  var proposalIds = _ref15.proposalIds,
      insurance = _ref15.insurance,
      attendeeIds = _ref15.attendeeIds,
      appContext = _ref15.appContext;
  var insuranceId = insurance.pricingInfo.id;
  return function (dispatch) {
    return dispatch(proposals_action_deleteAdditionalServices({
      proposalIds: proposalIds,
      serviceIds: [insuranceId],
      attendeeIds: attendeeIds,
      appContext: appContext
    })).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["i" /* DELETE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["s" /* INSURANCE_DELETED */], insuranceId));
    });
  };
};
/**
END INSURANCE
* */


var proposals_action_prepareBe = function prepareBe(payload) {
  return Object(createAction["b" /* default */])(proposals_constants["v" /* PREPARE_BE */], payload);
};

var proposals_action_saveDonationToProposals = function saveDonationToProposals(donation) {
  return function (dispatch) {
    dispatch({
      type: proposals_constants["D" /* SAVE_DONATION_TO_PROPOSALS */],
      payload: donation
    });
  };
};

var proposals_action_switchProposalsOffers = function switchProposalsOffers(offers, appContext) {
  return function (dispatch, getState) {
    var state = getState();
    var proposals = Object(booking_selector["A" /* proposalsSelector */])(state); // TODO : remove filter when proposals array in store is fixed and does not include a random object

    var proposalsIds = proposals.map(function (_ref16) {
      var id = _ref16.id;
      return id;
    }).filter(function (id) {
      return !!id;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["G" /* SWITCH_PROPOSALS_OFFERS */], {}, {
      optimist: true,
      promise: Object(proposalQuery["p" /* switchProposalsOffers */])(proposalsIds, offers, appContext)
    }));
  };
};



/***/ }),

/***/ "B3yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keywordsSelector; });
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hByQ");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_2__);




var searchSelector = function searchSelector(_ref) {
  var search = _ref.search;
  return search || {};
};

var querySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_2__["createSelector"])(searchSelector, function (_ref2) {
  var query = _ref2.query;
  return query || {};
});
var keywordsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_2__["createSelector"])(querySelector, function (_ref3) {
  var keywords = _ref3.keywords;
  return keywords;
});


/***/ }),

/***/ "BU6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WECHAT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ECYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EPAYGATE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPLIFT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PLEDG_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIPAY_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PAYPAL_PSP_ID; });
/* unused harmony export ESSPSCT_PSP_ID */
/* unused harmony export ESSPSDD_PSP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NODELCRERE_TRANSFER_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NODELCRERE_CHEQUE_PSP_ID; });
/* unused harmony export HIPAY_CMTA_PSP_ID */
/* unused harmony export EGLOBALCOLLECT_PSP_ID */
/* unused harmony export OGONE_CMTA_PSP_ID */
/* unused harmony export OGONE_PSP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PAYMENT_METHOD_LABEL; });
/* unused harmony export BANK_TRANSFER_LABEL */
/* unused harmony export CHEQUE_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREDIT_CARD_LABEL; });
/* unused harmony export PAYPAL_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return VOXPAY_PSP_ID_PREFIX; });
/* unused harmony export VOXPAY_PHONE_PSP_ID */
/* unused harmony export VOXPAY_PHONE_LABEL */
/* unused harmony export VOXPAY_EMAIL_PSP_ID */
/* unused harmony export VOXPAY_EMAIL_LABEL */
/* unused harmony export VOXPAY_SMS_PSP_ID */
/* unused harmony export VOXPAY_SMS_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NAPAY_PSP_ID; });
/* unused harmony export PROVIDER_ID_EVOPAY_PREFIX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PAYMENT_METHOD_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TRACKING_PAYMENT_METHOD_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INVALID_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INVALID_PHONE; });
var WECHAT_PSP_ID = 'M99BILLW';
var CYBERSOURCE_PSP_ID = 'MCYBERSOURCE';
var ECYBERSOURCE_PSP_ID = 'ECYBERSOURCE';
var EPAYGATE_PSP_ID = 'EPAYGATE';
var UPLIFT_PSP_ID = 'MUPLIFT';
var PLEDG_PSP_ID = 'MPLEDG';
var HIPAY_PSP_ID = 'MHIPAY';
var PAYPAL_PSP_ID = 'MHIPAYPP';
var ESSPSCT_PSP_ID = 'ESSPSCT'; // TRANSFER

var ESSPSDD_PSP_ID = 'ESSPSDD'; // DEBIT

var NODELCRERE_TRANSFER_PSP_ID = 'NODELCRERE_TRANSFER'; // TRANSFER

var NODELCRERE_CHEQUE_PSP_ID = 'NODELCRERE_CHEQUE'; // DEBIT

var HIPAY_CMTA_PSP_ID = 'EHIPAYCMTA';
var EGLOBALCOLLECT_PSP_ID = 'EGLOBALCOLLECT'; // DEBIT

var OGONE_CMTA_PSP_ID = 'MOGONE';
var OGONE_PSP_ID = 'EOGONE';
var PAYMENT_METHOD_LABEL = 'paymentMethodLabel';
var BANK_TRANSFER_LABEL = 'Bank Transfer';
var CHEQUE_LABEL = 'Cheque';
var CREDIT_CARD_LABEL = 'Credit Card';
var PAYPAL_LABEL = 'Paypal';
var VOXPAY_PSP_ID_PREFIX = 'EVOXPAY';
var VOXPAY_PHONE_PSP_ID = 'EVOXPAY_PHONE';
var VOXPAY_PHONE_LABEL = 'Phone';
var VOXPAY_EMAIL_PSP_ID = 'EVOXPAY_EMAIL';
var VOXPAY_EMAIL_LABEL = 'Email';
var VOXPAY_SMS_PSP_ID = 'EVOXPAY_SMS';
var VOXPAY_SMS_LABEL = 'Sms';
var NAPAY_PSP_ID = 'NAPAY';
var PROVIDER_ID_EVOPAY_PREFIX = 'EVOXPAY';
var PAYMENT_METHOD_CATEGORY = {
  BUY_NOW_PAY_LATER: 'BuyNowPayLater',
  CREDIT_CARD: 'CreditCard',
  CARD: 'card',
  PAYPAL: 'Paypal',
  DIRECT_DEBIT: 'DirectDebit',
  BANK_TRANSFER: 'BankTransfer'
};
var TRACKING_PAYMENT_METHOD_CATEGORY = {
  CreditCard: 'credit_card',
  DirectDebit: 'direct_debit',
  BankTransfer: 'bank_transfer'
};
var INVALID_EMAIL = 'INVALID_EMAIL';
var INVALID_PHONE = 'INVALID_PHONE';

/***/ }),

/***/ "BYx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export documentFragment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return profileFragment; });
/* unused harmony export commonProfileFieldsFragment */
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kH/m");


var documentFragment = "{ issuingDate\n  expirationDate\n  nationality\n  documentNumber\n  issuingCountry\n  birthCountry\n  type }";
var profileFragment = "\n  fragment BookingProfile on Profile {\n    optinEmail\n    optinSms\n    optinPhone\n    optinMail\n    optinClubmedPlus\n    address {\n      ...Address\n    }\n    document {\n      passport {\n        ...".concat(documentFragment, "\n      }\n      idcard{\n        ...").concat(documentFragment, "\n      }\n    }\n    passport {\n      issuingDate\n      expirationDate\n      nationality\n      documentNumber\n    }\n   dateOfBirth\n   civility\n   mobilePhoneNumber\n   identityNumber\n   travelCompanions {\n    id: customerId\n    civility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n    birthdate: dateOfBirth\n    document {\n      passport {\n        ...").concat(documentFragment, "\n      }\n      idcard{\n        ...").concat(documentFragment, "\n      }\n    }\n   }\n  }\n  ").concat(_utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__[/* addressFragment */ "a"], "\n");
/**
 * Common fields between adults and children
 * customerId is used as temp id, till being override by real proposal attendees id
 * see addSearchDataToAttendees
 *  */

var commonProfileFieldsFragment = "\n  fragment CommonProfileFields on Profile {\n    birthdate:dateOfBirth\n    civility\n    firstName\n    gmNumber\n    id\n    lastName\n    neolid:customerId\n    unicodeFirstName\n    unicodeLastName\n  }\n";


/***/ }),

/***/ "BhBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AlternativeProposalsModal_AlternativeProposalsModal; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsUtils.js
var AlternativeProposalsUtils = __webpack_require__("/nu6");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("oVuX");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-lock/dist/es2015/AutoFocusInside.js
var AutoFocusInside = __webpack_require__("JPie");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.themes.js
var themes = {
  "default": {
    thRoot: 'bg-white',
    thCloseButton: 'bg-white cursor-pointer leading-0 m-20 p-15 rounded-full text-black text-16',
    thCloseButtonLabel: 'sr-only'
  }
};
var POSITIONS_CLASSES = {
  top: {
    pin: 'inset-x-0 top-0',
    transform: '-translate-y-full',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'ltr:animate-slideInRight rtl:animate-slideInLeft animation-duration-500 bottom-0 end-0'
  },
  bottom: {
    pin: 'inset-x-0 bottom-0',
    transform: 'translate-y-full',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'ltr:animate-slideInRight rtl:animate-slideInLeft animation-duration-500 top-0 end-0'
  },
  left: {
    pin: 'inset-y-0 left-0',
    transform: '-translate-x-full',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 right-0'
  },
  right: {
    pin: 'inset-y-0 right-0',
    transform: 'translate-x-full',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 left-0'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var SidePanel_SidePanel = function SidePanel(_ref) {
  var _classnames;

  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? '#000' : _ref$backdropColor,
      _ref$backdropOpacity = _ref.backdropOpacity,
      backdropOpacity = _ref$backdropOpacity === void 0 ? 0.8 : _ref$backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      height = _ref.height,
      isExpanded = _ref.isExpanded,
      onClose = _ref.onClose,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? Portal_constants["d" /* OVER_BOT */] : _ref$portalName,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var sidePanelBodyref = Object(react["useRef"])();

  var onScroll = throttle_default()(function () {
    Object(lib["forceCheck"])();
  }, 250);

  Object(react["useEffect"])(function () {
    // $FlowFixMe
    sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.removeEventListener('scroll', onScroll);
    };
  }, []);
  Object(react["useEffect"])(function () {
    if (isExpanded) {
      Object(lib["forceCheck"])();
    }
  }, [isExpanded]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thRoot = _themes$theme.thRoot;
  var positionClasses = POSITIONS_CLASSES[position];
  var closeBtnSidePanel = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: isExpanded
  }, isExpanded && __jsx("div", {
    className: "animate-fadeIn animation-duration-500 fixed h-screen inset-0",
    "data-testid": "SidePanel-backdrop",
    style: {
      backgroundColor: backdropColor,
      opacity: backdropOpacity
    }
  }), __jsx("div", {
    "aria-hidden": !isExpanded,
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    className: "isolate",
    role: "document"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: isExpanded,
    onClickOutside: onClose,
    onEscapeKey: onClose
  }, isExpanded && __jsx(AutoFocusInside["a" /* default */], null, __jsx("button", {
    className: classnames_default()('fixed z-2', thCloseButton, positionClasses.button),
    onClick: onClose,
    type: "button"
  }, closeBtnSidePanel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnSidePanel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("aside", {
    className: classnames_default()(thRoot, positionClasses.pin, 'fixed h-full overflow-y-scroll duration-250 ease-in transform transition-all w-full z-1', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, positionClasses.transform, !isExpanded), Object(defineProperty["a" /* default */])(_classnames, 'translate-x-0 translate-y-0', isExpanded), _classnames), className),
    ref: sidePanelBodyref,
    style: _objectSpread({
      height: height
    }, positionClasses.style)
  }, isExpanded && children))))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposals.jsx + 20 modules
var AlternativeProposals = __webpack_require__("YRNe");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals-modal/AlternativeProposalsModal.jsx

var AlternativeProposalsModal_jsx = react_default.a.createElement;







var AlternativeProposalsModal_AlternativeProposalsModal = function AlternativeProposalsModal(_ref) {
  var trackingDefaultPayload = _ref.trackingDefaultPayload,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["trackingDefaultPayload"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var modal = Object(react["useRef"])();
  var track = Object(useTracking["a" /* useTracking */])(trackingDefaultPayload);
  var proposal = props.proposals[0];
  Object(react["useEffect"])(function () {
    var trackingData = Object(AlternativeProposalsUtils["b" /* getSuggestionsTrackingData */])({
      appContext: appContext,
      disableAlternativePrice: props.disableAlternativePrice,
      proposal: proposal,
      suggestions: props.suggestions
    });
    track(trackingData);
  }, [proposal]);
  return AlternativeProposalsModal_jsx(SidePanel_SidePanel, {
    ariaLabel: Object(i18n["h" /* t */])('booking.counterProposalPopIn.rateCounterProposalTitle'),
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    isExpanded: true,
    onClose: function onClose(event) {
      if (modal.current && !modal.current.contains(event.target)) {
        props.onClose();
        track({
          labelGA: 'exit'
        });
      }
    }
  }, AlternativeProposalsModal_jsx("div", {
    ref: modal
  }, AlternativeProposalsModal_jsx(AlternativeProposals["a" /* AlternativeProposals */], props)));
};

/***/ }),

/***/ "C5R2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDuration; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _duration_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RBvG");


function setDuration(value) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_duration_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DURATION */ "c"], {
    value: value
  });
}

/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createPropsForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRentalAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabel; });
/* unused harmony export getServiceAgesLabelTranslateOptions */
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");



var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getServiceAgesLabel = function getServiceAgesLabel(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  });
};

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}

var getRentalAgesLabel = function getRentalAgesLabel(ageInMonths) {
  if (!ageInMonths || !ageInMonths.min) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.forAllAges');
  }

  if (ageInMonths.max) {
    return getServiceAgesLabel(ageInMonths);
  }

  if (ageInMonths.min < 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFromMonths', {
      amount: ageInMonths.min
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFrom', {
    age: Math.floor(ageInMonths.min / 12)
  });
};

var createPropsForPictures = function createPropsForPictures(images) {
  if (!Array.isArray(images)) {
    return [];
  }

  return images.map(function (link) {
    return {
      src: link
    };
  });
};

var createPropsForProduct = function createPropsForProduct(resort) {
  var _resort$destination;

  return {
    id: resort.id,
    header: {
      className: 'border-r-1',
      heading: {
        subtitle: resort === null || resort === void 0 ? void 0 : (_resort$destination = resort.destination) === null || _resort$destination === void 0 ? void 0 : _resort$destination.country,
        title: resort.name || ''
      },
      link: {
        url: resort.href
      },
      productId: resort.id,
      productType: resort.type
    },
    thumbnail: {
      link: {
        url: resort.href
      },
      pictures: createPropsForPictures(resort.images),
      productId: resort.id,
      productType: resort.type
    },
    url: resort.href,
    type: resort.type || ''
  };
};



/***/ }),

/***/ "CzFL":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ");

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("A5Hi");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;








var ImageSlideShow = function ImageSlideShow(_ref) {
  var centerPadding = _ref.centerPadding,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      fadeUnseenItems = _ref.fadeUnseenItems,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasOverlappingControls = _ref.hasOverlappingControls,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasLazyLoading = _ref.hasLazyLoading,
      itemClassName = _ref.itemClassName,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      _ref$nbItemsToShow = _ref.nbItemsToShow,
      nbItemsToShow = _ref$nbItemsToShow === void 0 ? 1 : _ref$nbItemsToShow,
      nextLabel = _ref.nextLabel,
      onChangeIndex = _ref.onChangeIndex,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__[/* default */ "c"].XL : _ref$ratio,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 : _ref$ratioDisplay,
      _ref$spacerWidth = _ref.spacerWidth,
      spacerWidth = _ref$spacerWidth === void 0 ? 0 : _ref$spacerWidth;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  if (!media.length) {
    return null;
  }

  var updateActiveIndex = function updateActiveIndex(index) {
    setActiveIndex(index);
  };

  var gk = hasFullScreenMode ? null : groupKey;
  var items = media.filter(function (_ref2) {
    var src = _ref2.src;
    return Boolean(src);
  }).map(function (_ref3) {
    var _ref3$alt = _ref3.alt,
        alt = _ref3$alt === void 0 ? '' : _ref3$alt,
        _onClick = _ref3.onClick,
        src = _ref3.src;

    var children = __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* default */ "b"], {
      altMsg: alt,
      className: itemClassName,
      groupKey: gk,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio,
      ratioDisplay: ratioDisplay,
      spacerWidth: ratioDisplay
    });

    var isButton = hasFullScreenMode || _onClick;
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], {
      key: "Image-".concat(src)
    }, isButton ? __jsx("button", {
      className: "block h-full w-full",
      onClick: function onClick() {
        _onClick && _onClick();

        if (hasFullScreenMode) {
          setIsFullScreen(true);
        }
      },
      type: "button"
    }, children) : __jsx("div", {
      className: "h-full"
    }, children));
  });
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__[/* SliderHandler */ "a"], {
    centerPadding: centerPadding,
    fadeUnseenItems: fadeUnseenItems,
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items,
    nbItemsToShow: nbItemsToShow,
    onChangeIndex: updateActiveIndex,
    spacerWidth: spacerWidth
  }, function (_ref4) {
    var hasControls = _ref4.hasControls,
        isNextControlDisabled = _ref4.isNextControlDisabled,
        isPreviousControlDisabled = _ref4.isPreviousControlDisabled,
        itemsNode = _ref4.itemsNode,
        onNext = _ref4.onNext,
        onPrevious = _ref4.onPrevious;
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('group relative', className)
    }, itemsNode, hasControls && __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('transition-opacity duration-250 ease-in will-change-transform absolute flex items-center justify-between m-auto inset-0 pointer-events-none w-full z-2', {
        'px-10 sm:px-20': !hasOverlappingControls
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('me-auto pointer-events-auto shadow-sm z-2', {
        'transform -translate-x-1/2': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('ms-auto pointer-events-auto shadow-sm z-2', {
        'transform translate-x-1/2': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-10 sm:px-20 w-full"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "me-auto pointer-events-auto shadow-sm z-2",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "ms-auto pointer-events-auto shadow-sm z-2",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "DwNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormFeedback; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RUiN");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var BEACON_SELECTOR = 'FormFeedbackBeacon';
var FormFeedback = function FormFeedback(_ref) {
  var className = _ref.className,
      hasAutoScroll = _ref.hasAutoScroll,
      isError = _ref.isError,
      message = _ref.message;
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (hasAutoScroll) {
      Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__[/* scrollToElement */ "a"])("[data-testid=\"".concat(BEACON_SELECTOR, "\"]"));
    }
  }, []);
  return __jsx("p", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('flex font-bold gap-10 items-center leading-1 my-10 text-14', "".concat(isError ? 'text-red' : 'text-success'), className),
    "data-testid": BEACON_SELECTOR
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('shrink-0', {
      'pt-5 px-5': !isError
    }),
    name: isError ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].WARNING : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].CHECK,
    width: "1.25rem"
  }), __jsx("span", {
    "data-testid": "FormFeedback-message"
  }, message));
};

/***/ }),

/***/ "E8R/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = StringSchema;

var _inherits = _interopRequireDefault(__webpack_require__("rokF"));

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

var _locale = __webpack_require__("qr7w");

var _isAbsent = _interopRequireDefault(__webpack_require__("kMkq"));

// eslint-disable-next-line
var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

var isTrimmed = function isTrimmed(value) {
  return (0, _isAbsent.default)(value) || value === value.trim();
};

function StringSchema() {
  var _this = this;

  if (!(this instanceof StringSchema)) return new StringSchema();

  _mixed.default.call(this, {
    type: 'string'
  });

  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      return value != null && value.toString ? value.toString() : value;
    });
  });
}

(0, _inherits.default)(StringSchema, _mixed.default, {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  },
  _isPresent: function _isPresent(value) {
    return _mixed.default.prototype._cast.call(this, value) && value.length > 0;
  },
  length: function length(_length, message) {
    if (message === void 0) {
      message = _locale.string.length;
    }

    return this.test({
      message: message,
      name: 'length',
      exclusive: true,
      params: {
        length: _length
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length === this.resolve(_length);
      }
    });
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = _locale.string.min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = _locale.string.max;
    }

    return this.test({
      name: 'max',
      exclusive: true,
      message: message,
      params: {
        max: _max
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value.length <= this.resolve(_max);
      }
    });
  },
  matches: function matches(regex, options) {
    var excludeEmptyString = false;
    var message;

    if (options) {
      if (options.message || options.hasOwnProperty('excludeEmptyString')) {
        excludeEmptyString = options.excludeEmptyString;
        message = options.message;
      } else message = options;
    }

    return this.test({
      message: message || _locale.string.matches,
      params: {
        regex: regex
      },
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === '' && excludeEmptyString || regex.test(value);
      }
    });
  },
  email: function email(message) {
    if (message === void 0) {
      message = _locale.string.email;
    }

    return this.matches(rEmail, {
      message: message,
      excludeEmptyString: true
    });
  },
  url: function url(message) {
    if (message === void 0) {
      message = _locale.string.url;
    }

    return this.matches(rUrl, {
      message: message,
      excludeEmptyString: true
    });
  },
  //-- transforms --
  ensure: function ensure() {
    return this.default('').transform(function (val) {
      return val === null ? '' : val;
    });
  },
  trim: function trim(message) {
    if (message === void 0) {
      message = _locale.string.trim;
    }

    return this.transform(function (val) {
      return val != null ? val.trim() : val;
    }).test({
      message: message,
      name: 'trim',
      test: isTrimmed
    });
  },
  lowercase: function lowercase(message) {
    if (message === void 0) {
      message = _locale.string.lowercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toLowerCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toLowerCase();
      }
    });
  },
  uppercase: function uppercase(message) {
    if (message === void 0) {
      message = _locale.string.uppercase;
    }

    return this.transform(function (value) {
      return !(0, _isAbsent.default)(value) ? value.toUpperCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return (0, _isAbsent.default)(value) || value === value.toUpperCase();
      }
    });
  }
});
module.exports = exports["default"];

/***/ }),

/***/ "ELg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductFlag_ProductFlag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 1 modules
var ProductPriceModal = __webpack_require__("yfdt");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.themes.js
var themes = {
  thumbnail: {
    thPriceTheme: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx



var __jsx = react_default.a.createElement;









var ProductFlag_ProductFlag = function ProductFlag(_ref) {
  var _ref$isLinkDisabled = _ref.isLinkDisabled,
      isLinkDisabled = _ref$isLinkDisabled === void 0 ? false : _ref$isLinkDisabled,
      _ref$isPriceLoading = _ref.isPriceLoading,
      isPriceLoading = _ref$isPriceLoading === void 0 ? false : _ref$isPriceLoading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop_default.a : _ref$onClick,
      _ref$onCtaClick = _ref.onCtaClick,
      onCtaClick = _ref$onCtaClick === void 0 ? noop_default.a : _ref$onCtaClick,
      _ref$onEmptyPriceClic = _ref.onEmptyPriceClick,
      onEmptyPriceClick = _ref$onEmptyPriceClic === void 0 ? noop_default.a : _ref$onEmptyPriceClic,
      _ref$onIconBubbleClic = _ref.onIconBubbleClick,
      onIconBubbleClick = _ref$onIconBubbleClic === void 0 ? noop_default.a : _ref$onIconBubbleClic,
      _ref$onPriceClick = _ref.onPriceClick,
      onPriceClick = _ref$onPriceClick === void 0 ? noop_default.a : _ref$onPriceClick,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? {} : _ref$price,
      _ref$priceInfo = _ref.priceInfo,
      priceInfo = _ref$priceInfo === void 0 ? {} : _ref$priceInfo,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'thumbnail' : _ref$theme;

  if (isEmpty_default()(price)) {
    return null;
  }

  var thPriceTheme = themes[theme].thPriceTheme;
  var hasPrice = !isPriceLoading && Object(price_util["d" /* hasAtLeastOnePrice */])(price);

  var handleEmptyPriceClick = function handleEmptyPriceClick() {
    onEmptyPriceClick && onEmptyPriceClick();

    if (!isLinkDisabled) {
      onClick && onClick();
    }
  };

  var handlePriceClick = function handlePriceClick() {
    onPriceClick && onPriceClick();
  };

  var handleProductPriceModalOnClickButton = function handleProductPriceModalOnClickButton() {
    onCtaClick && onCtaClick();
    onClick && onClick();
  };

  var priceNode = __jsx("span", {
    className: "flex gap-5"
  }, __jsx("button", {
    className: "flex items-center justify-end w-full",
    onClick: hasPrice ? handlePriceClick : handleEmptyPriceClick,
    type: "button"
  }, __jsx(Price["a" /* Price */], {
    bestPrice: price.bestPrice,
    color: price.color || colors["a" /* COLORS */].SIENNA,
    "data-testid": "Price-wrapper",
    from: price.from,
    hasInitialPrice: true,
    initialPrice: price.initialPrice,
    isLoading: isPriceLoading,
    theme: thPriceTheme,
    unit: price.unit,
    viewRates: price.viewRates
  })), hasPrice && Object(i18n["d" /* getKeyValue */])('price.displayIconBubble') && __jsx("button", {
    className: "mt-5",
    onClick: function onClick() {
      return onIconBubbleClick && onIconBubbleClick();
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].SIENNA,
    name: icons["a" /* ICONS */].INFORMATION,
    width: "1.25rem"
  })));

  return hasPrice ? __jsx(ProductPriceModal["a" /* ProductPriceModal */], Object(esm_extends["a" /* default */])({}, priceInfo, {
    onClickButton: handleProductPriceModalOnClickButton
  }), priceNode) : __jsx("div", {
    className: "m-5"
  }, priceNode);
};

/***/ }),

/***/ "EWLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutside; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: className,
    ref: ref
  }), children);
};

/***/ }),

/***/ "EvYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Modal_Modal; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("oVuX");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.themes.js
var MAX_HEIGHT = '70vh';
var sizes = {
  auto: 'auto',
  small: '23.75rem',
  // 380px
  medium: '40rem',
  // 640px
  large: '50rem' // 800px

};
var themes = function themes(_ref) {
  var size = _ref.size;
  return {
    "default": {
      thRoot: 'animate-fadeIn animate-scaleIn animation-duration-500 flex isolate relative ',
      thRootStyles: {
        width: sizes[size],
        maxWidth: '100%',
        maxHeight: MAX_HEIGHT,
        minHeight: 100
      },
      thCloseButton: 'absolute bg-white border-1 cursor-pointer leading-0 top-0 mb-10 end-0 p-5 rounded-full z-2',
      thCloseButtonLabel: 'sr-only',
      thCloseButtonStyles: {
        top: 'auto',
        bottom: '100%',
        width: 40,
        height: 40
      },
      thBody: 'bg-white max-h-full relative z-1 overflow-hidden rounded-12 shadow w-full flex flex-col',
      thBodyStyles: {
        maxHeight: MAX_HEIGHT
      },
      // ⚠️ relative is only needed to prevent a weird bug of reflow on chrome
      thContent: 'isolate max-h-full overflow-auto relative w-full',
      thAddendum: 'max-h-full fixed bottom-0 inset-x-0 overflow-hidden rounded-4 md:rounded-2 shadow w-full',
      thAddendumStyles: {
        maxHeight: MAX_HEIGHT
      },
      thAddendumContent: 'max-h-full overflow-auto relative w-full'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.jsx

var __jsx = react_default.a.createElement;






var Modal_Modal = function Modal(_ref) {
  var addendum = _ref.addendum,
      ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      backdropColor = _ref.backdropColor,
      backdropOpacity = _ref.backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton,
      header = _ref.header,
      id = _ref.id,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'Modal' : _ref$dataTestId,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var modalButtonRef = Object(react["useRef"])();
  var closeBtnModal = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  Object(react["useEffect"])(function () {
    modalButtonRef.current && modalButtonRef.current.focus();
  }, []);
  var _themes$theme = themes({
    size: size
  })[theme],
      thAddendum = _themes$theme.thAddendum,
      thAddendumStyles = _themes$theme.thAddendumStyles,
      thAddendumContent = _themes$theme.thAddendumContent,
      thBody = _themes$theme.thBody,
      thBodyStyles = _themes$theme.thBodyStyles,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thCloseButtonStyles = _themes$theme.thCloseButtonStyles,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thContent = _themes$theme.thContent,
      thRoot = _themes$theme.thRoot,
      thRootStyles = _themes$theme.thRootStyles;
  return __jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: ariaLabel,
    ariaLabelledby: ariaLabelledby,
    bgColor: backdropColor,
    onClose: onClose,
    opacity: backdropOpacity,
    portalName: portalName
  }, __jsx("aside", {
    className: thRoot,
    id: id,
    style: thRootStyles,
    "data-testid": dataTestId
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    "data-testid": "Modal-close",
    onClick: onClose,
    ref: modalButtonRef,
    style: thCloseButtonStyles,
    type: "button"
  }, closeBtnModal && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnModal), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), __jsx("div", {
    className: thBody,
    style: thBodyStyles
  }, header, __jsx("div", {
    className: classnames_default()(thContent, className)
  }, children)), addendum && __jsx("div", {
    className: thAddendum,
    style: thAddendumStyles
  }, __jsx("div", {
    className: classnames_default()(thAddendumContent, className)
  }, addendum))));
};

/***/ }),

/***/ "Fe0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export grid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateProductLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return localeHasCmtaLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateCmtaLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCruiseExclusivity; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("igjW");
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");







var grid = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3
};
var generateProductLink = function generateProductLink(url, offer) {
  var newLink = offer && offer.seoName ? new urijs__WEBPACK_IMPORTED_MODULE_2___default.a(url).addSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["appQueryParameters"].shopping.offer, _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeSlug(offer.seoName)).toString() : url;
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeUrl(newLink);
};
var generateLinkProp = function generateLinkProp(url, offer) {
  return url ? {
    url: generateProductLink(url, offer),
    queryParamsToIgnore: offer ? [] : ['offer']
  } : undefined;
};
var localeHasCmtaLinks = function localeHasCmtaLinks(cmtaLinks) {
  return cmtaLinks && cmtaLinks.cmtaIntegLink && cmtaLinks.cmtaStagingLink && cmtaLinks.cmtaProdLink;
};
var generateCmtaLinkProp = function generateCmtaLinkProp(resortId, cmtaLinks) {
  var cmtaIntegLink = cmtaLinks.cmtaIntegLink,
      cmtaStagingLink = cmtaLinks.cmtaStagingLink,
      cmtaProdLink = cmtaLinks.cmtaProdLink;
  var cmtaUrl = cmtaProdLink;

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyIntegrationEnv */ "e"])()) {
    cmtaUrl = cmtaIntegLink;
  }

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyStagingEnv */ "g"])()) {
    cmtaUrl = cmtaStagingLink;
  }

  return {
    url: cmtaUrl + resortId,
    isExternalLink: true
  };
};
var getCruiseExclusivity = function getCruiseExclusivity() {
  var _data$cruiseExclusivi;

  var productId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _runGQLQuery = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_5__[/* useGQL */ "a"])({
    query: "query {\n      cruiseExclusivity(productId: \"".concat(productId, "\") {\n        isExclusive\n      }\n    }"),
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* LINE_CRUISE_EXCLUSIVITY */ "qb"]
    }
  }),
      data = _runGQLQuery.data,
      isCruiseExclusivityLoading = _runGQLQuery.isLoading;

  return {
    isCruiseExclusive: !!(data === null || data === void 0 ? void 0 : (_data$cruiseExclusivi = data.cruiseExclusivity) === null || _data$cruiseExclusivi === void 0 ? void 0 : _data$cruiseExclusivi.isExclusive),
    isCruiseExclusivityLoading: isCruiseExclusivityLoading
  };
};

/***/ }),

/***/ "FllU":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("DuXo"),
    baseIteratee = __webpack_require__("S3pA"),
    toInteger = __webpack_require__("m2YG");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ "GZgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_OF_STAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRICE_OF_STAY_REQUEST_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_PRICE_OF_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_SERVICES_REQUEST; });
var PRICE_OF_STAY_REQUEST = 'PRICE_OF_STAY_REQUEST';
var PRICE_OF_STAY_REQUEST_ABORT = 'PRICE_OF_STAY_REQUEST_ABORT';
var RESET_PRICE_OF_STAY = 'RESET_PRICE_OF_STAY';
var ALL_INCLUSIVE_SERVICES_REQUEST = 'ALL_INCLUSIVE_SERVICES_REQUEST';

/***/ }),

/***/ "H0gB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return productChildcareDetailQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return productChildcaresQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activityCategoryFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return activityFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return thematicFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return rentalsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return productActivitiesQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");



function productFeatureServiceQuery(lineProps) {
  var ageInformation = lineProps.ageInformation,
      groupMin = lineProps.groupMin,
      groupMax = lineProps.groupMax,
      groupRange = lineProps.groupRange;
  return "\n    hasBookingOnline\n    hasBookingOnsite\n    id\n    isIdealForFamily\n    label\n    description\n    detailedDescription\n    durationDescription\n    ageRestriction(message: \"".concat(ageInformation, "\")\n    level\n    note\n    group(min: \"").concat(groupMin, "\" max: \"").concat(groupMax, "\" range: \"").concat(groupRange, "\")\n    specificConditions\n    equipments {\n      label\n      included\n    }\n    utilities {\n      label\n      included\n    }\n    targetPrice {\n      price\n      currency\n    }\n  ");
}

var productFeatureFacilityQuery = "\n    description\n    distance\n    id\n    label\n    localisation\n    nightLighting\n    onSite\n    outdoor\n    quantity\n    specificInformation {\n      type\n      value\n    }\n    technicalSpecificities {\n      typeDescription\n      length\n      width\n      minDepth\n      maxDepth\n      unit\n    }\n  ";
function productChildcareDetailQuery(productId, activityId, _ref) {
  var lineProps = _ref.lineProps,
      urlParams = _ref.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  var productActivitiesArgs = "activityId : \"".concat(activityId, "\"");
  var activityArgs = "categoryId: \"".concat(activityId, "\"");
  var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
  return "query {\n    config {\n      common { previous next }\n    }\n    resort(".concat(productArgs, ") {\n      facilities(types: [\"CHILDREN\"], withEquipments: true) {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n      productActivities(idFilter: \"").concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n    }\n    productActivities(").concat(productArgs, ") {\n      childcare(").concat(productActivitiesArgs, ") {\n        closingWeekdays\n        description\n        duration\n        furtherInformation\n        id\n        label\n        openingDates {\n          opening\n          closing\n        }\n        openingHours {\n          start\n          end\n        }\n        timeSlots {\n          type\n          opening\n          closing\n        }\n        philosophy\n        targetPrice {\n          currency\n          price\n        }\n      }\n      facilities(").concat(productActivitiesArgs, ") {\n        ").concat(productFeatureFacilityQuery, "\n      }\n    }\n    includedServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n    onDemandServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyNotIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n  }");
}
/* lists of features */

var productFeaturesConfigQuery = "\n    config {\n      common {\n        allInclusive\n        backNavigation\n        bookOnlineOnly\n        bookOnlineOrOnsite\n        bookOnsiteOnly\n        childcarealacarte\n        downloadLeafletLabel\n        extraCost\n        howToBookLabel\n        idealForFamilyLabel\n        included\n        loadLess\n        onDemandService\n        philosophyLabel\n        price {\n          priceFrom\n        }\n        scrollBackward\n        scrollForward\n        treatmentsLabel\n        viewMore\n      }\n    }\n  ";

function productFeaturesCategoriesFields(defaultLabel) {
  var activityLabel = defaultLabel ? "label(defaultLabel: \"".concat(defaultLabel, "\")") : 'label';
  return "\n    activities: subCategories {\n      bookingDescription\n      bookletUrl\n      brandLogoUrl\n      description\n      equipmentRentalDescription\n      id\n      image: imageUrl\n      isChildrenClub\n      isIncluded\n      keywords\n      ".concat(activityLabel, "\n      name\n      numberOfIncludedActivities\n      numberOfOnDemandActivities\n      philosophy\n      ranking\n      rentalEquipmentsUsecasesId\n      supervisionDescription\n      termsAndConditionsDescription\n    }\n    id\n    label\n    ranking\n  ");
}

function productChildcaresQuery(productId, _ref2) {
  var urlParams = _ref2.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    ".concat(productFeaturesConfigQuery, "\n    resort(").concat(productArgs, ") {\n      kidsActivitiesIntroduction {\n        description\n        shortDescription\n      }\n      categories: activityCategories {\n        children {\n          ").concat(productFeaturesCategoriesFields(), "\n        }\n      }\n    }\n  }");
}
/* ACTIVITIES */

var activityCategoryFragment = "fragment activityCategory on UpsellsActivityCategoryType {\n  activitiesCounters {\n    included\n    onDemand\n  }\n  bookingDescription\n  bookletUrl\n  description\n  equipmentRentalDescription\n  facilities {\n    areaId\n    categoriesIds\n    description\n    distanceAndTransferDescription\n    equipments {\n      id\n      label\n    }\n    hasFreeAccess\n    hasNightLighting\n    id\n    isOnSite\n    isOutdoor\n    level\n    localisation\n    name\n    quantity\n    ranking\n    specificInformation {\n      type\n      value\n    }\n    subTitle\n    technicalSpecificities {\n      height\n      isHeated\n      length\n      maxDepth\n      minDepth\n      typesDescription\n      unit\n      width\n    }\n  }\n  id\n  images\n  keywords\n  name\n  philosophy\n  ranking\n  shortDescription\n  supervisionDescription\n  termsAndConditionsDescription\n  upsellType\n}";
var activityFragment = "fragment activity on UpsellsActivityType {\n  ageRestriction {\n    formatted\n    min\n    max\n    specificConditions\n  }\n  categoriesIds\n  description\n  duration\n  equipments {\n    id\n    isIncluded\n    label\n  }\n  furtherInformation\n  hasBookingOnline\n  hasBookingOnsite\n  id\n  images\n  isIncluded\n  level\n  name\n  openingDates {\n    endDate\n    startDate\n  }\n  participants {\n    min\n    max\n  }\n  price {\n    currency\n    formattedValue\n    value\n  }\n  ranking\n  seasonality\n  services {\n    id\n    isIncluded\n    label\n  }\n  subtitle\n  transportation\n  treatments\n  upsellType\n}";
var thematicFragment = "fragment thematics on UpsellsActivityThematicType {\n  activitiesCounters {\n    included\n    onDemand\n  }\n  description\n  id\n  images\n  name\n}\n";
var rentalsFragment = "fragment rentals on RentalsTreeType {\n  id\n  label\n  items {\n    id\n    label\n    items {\n      ageRestriction {\n        formatted\n        max\n        min\n      }\n      availableBrands\n      furtherInformation\n      formalities\n      id\n      images\n      levels {\n        id\n        label\n      }\n      longDescription\n      name\n      price {\n        currency\n        formattedValue\n        value\n      }\n      productRange {\n        id\n        label\n      }\n      shortDescription\n      sizes {\n        max\n        min\n        unit\n      }\n      type {\n        id\n        label\n      }\n      upsellType\n      usecase {\n        id\n        label\n      }\n    }\n  }\n}";
var productActivitiesQuery = function productActivitiesQuery(_ref3) {
  var productId = _ref3.productId,
      urlParams = _ref3.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    resort(".concat(productArgs, ") {\n      activityTree {\n        ...activityCategory\n        activities {\n          ...activity\n        }\n        categories {\n          ...activityCategory\n          activities {\n            ...activity\n          }\n          categories {\n            ...activityCategory\n            activities {\n              ...activity\n            }\n          }\n        }\n      }\n      thematicActivityTree {\n        ...thematics\n        activities {\n          ...activity\n        }\n      }\n      id\n      name\n      rentalsTree {\n        ...rentals\n      }\n    }\n  }\n  ").concat(activityCategoryFragment, "\n  ").concat(activityFragment, "\n  ").concat(rentalsFragment, "\n  ").concat(thematicFragment, "\n  ");
};

/***/ }),

/***/ "HFnK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("bWFh");
var collectionStrong = __webpack_require__("ZWaQ");

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "HRNz":
/***/ (function(module, exports, __webpack_require__) {

var isIndex = __webpack_require__("pnw1");

/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return isIndex(n, length) ? array[n] : undefined;
}

module.exports = baseNth;


/***/ }),

/***/ "Hz96":
/***/ (function(module, exports, __webpack_require__) {

var baseNth = __webpack_require__("HRNz"),
    toInteger = __webpack_require__("m2YG");

/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
}

module.exports = nth;


/***/ }),

/***/ "I2LH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _Collapse = __webpack_require__("gz38");

var _excluded = ["isOpened"],
    _excluded2 = ["isOpened"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnmountClosed = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  var _super = _createSuper(UnmountClosed);

  function UnmountClosed(props) {
    var _this;

    _classCallCheck(this, UnmountClosed);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onWork", function (_ref) {
      var isOpened = _ref.isOpened,
          rest = _objectWithoutProperties(_ref, _excluded);

      _this.setState({
        isResting: false,
        isOpened: isOpened
      });

      var onWork = _this.props.onWork;

      if (onWork) {
        onWork(_objectSpread({
          isOpened: isOpened
        }, rest));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRest", function (_ref2) {
      var isOpened = _ref2.isOpened,
          rest = _objectWithoutProperties(_ref2, _excluded2);

      _this.setState({
        isResting: true,
        isOpened: isOpened,
        isInitialRender: false
      });

      var onRest = _this.props.onRest;

      if (onRest) {
        onRest(_objectSpread({
          isOpened: isOpened
        }, rest));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialStyle", function () {
      var _this$state = _this.state,
          isOpened = _this$state.isOpened,
          isInitialRender = _this$state.isInitialRender;

      if (isInitialRender) {
        return isOpened ? {
          height: 'auto',
          overflow: 'initial'
        } : {
          height: '0px',
          overflow: 'hidden'
        };
      }

      return {
        height: '0px',
        overflow: 'hidden'
      };
    });

    _this.state = {
      isResting: true,
      isOpened: props.isOpened,
      isInitialRender: true
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpened = this.props.isOpened;

      if (prevProps.isOpened !== isOpened) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isResting: false,
          isOpened: isOpened,
          isInitialRender: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          isResting = _this$state2.isResting,
          isOpened = _this$state2.isOpened;
      return isResting && !isOpened ? null : /*#__PURE__*/_react["default"].createElement(_Collapse.Collapse, _extends({}, this.props, {
        initialStyle: this.getInitialStyle(),
        onWork: this.onWork,
        onRest: this.onRest
      }));
    }
  }]);

  return UnmountClosed;
}(_react["default"].PureComponent);

exports.UnmountClosed = UnmountClosed;

_defineProperty(UnmountClosed, "defaultProps", {
  onWork: undefined,
  onRest: undefined
});

/***/ }),

/***/ "IGGJ":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "IuYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Price_Price; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.themes.js

var themes = {
  "default": function _default(_ref) {
    var color = _ref.color,
        hasInitialPriceDisplayed = _ref.hasInitialPriceDisplayed;
    return {
      thRoot: 'flex flex-wrap gap-x-10 isolate items-baseline relative text-14',
      thFirstLine: 'flex gap-x-10 items-baseline',
      thFrom: classnames_default()('text-12 first-letter:uppercase', {
        'absolute top-0': hasInitialPriceDisplayed
      }),
      thInitialPrice: "font-semibold line-through text-14 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-32',
      thUnit: 'text-12'
    };
  },
  column: function column(_ref2) {
    var color = _ref2.color;
    return {
      thRoot: 'flex flex-col isolate leading-tight relative text-14',
      thFirstLine: 'flex gap-x-10 items-baseline',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-14 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-28 w-full',
      thUnit: 'text-12'
    };
  },
  inline: function inline(_ref3) {
    var color = _ref3.color;
    return {
      thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
      thFirstLine: 'flex gap-x-5 items-baseline shrink-0',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-10 sm:text-12 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold shrink-0 text-20 underline',
      thUnit: 'text-10 sm:text-12'
    };
  },
  inlineSmall: function inlineSmall(_ref4) {
    var color = _ref4.color;
    return {
      thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
      thFirstLine: 'flex gap-x-5 items-baseline',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-10 sm:text-12 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-14 sm:text-20',
      thUnit: 'text-10 sm:text-12'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.jsx


var __jsx = react_default.a.createElement;








var PriceDiscount_PriceDiscount = function PriceDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref$color,
      from = _ref.from,
      hasAsterisk = _ref.hasAsterisk,
      _ref$hasDiscount = _ref.hasDiscount,
      hasDiscount = _ref$hasDiscount === void 0 ? false : _ref$hasDiscount,
      _ref$hasInitialPrice = _ref.hasInitialPrice,
      hasInitialPrice = _ref$hasInitialPrice === void 0 ? false : _ref$hasInitialPrice,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      hasTaxesAndFeesIncludedLabel = _ref.hasTaxesAndFeesIncludedLabel,
      _ref$hasTotalPrice = _ref.hasTotalPrice,
      hasTotalPrice = _ref$hasTotalPrice === void 0 ? false : _ref$hasTotalPrice,
      initialPrice = _ref.initialPrice,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      unit = _ref.unit,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["bestPrice", "className", "color", "from", "hasAsterisk", "hasDiscount", "hasInitialPrice", "hasInstalment", "hasTaxesAndFeesIncludedLabel", "hasTotalPrice", "initialPrice", "theme", "unit"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var initialPriceFormattedValue = hasInstalment && initialPrice ? Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.floor(initialPrice.value), locale, initialPrice.currency, {
    precision: 0
  }) : initialPrice && initialPrice.formattedValue;
  var totalBestPrice = bestPrice && bestPrice.formattedValue;
  var bestPriceFormattedValue = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])(bestPrice, locale) : totalBestPrice;
  var hasInitialPriceDisplayed = hasInitialPrice && initialPriceFormattedValue && (hasDiscount || !bestPrice);
  var hasTotalPriceDisplayed = hasTotalPrice && hasInstalment && bestPriceFormattedValue !== totalBestPrice;

  var _themes$theme = themes[theme]({
    color: color,
    hasInitialPriceDisplayed: hasInitialPriceDisplayed
  }),
      thBestPrice = _themes$theme.thBestPrice,
      thFirstLine = _themes$theme.thFirstLine,
      thFrom = _themes$theme.thFrom,
      thInitialPrice = _themes$theme.thInitialPrice,
      thRoot = _themes$theme.thRoot,
      thTotalPrice = _themes$theme.thTotalPrice,
      thUnit = _themes$theme.thUnit;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(thRoot, className)
  }), (hasInitialPriceDisplayed || hasTotalPriceDisplayed || from) && __jsx("span", {
    className: thFirstLine
  }, from && __jsx("span", {
    className: thFrom
  }, from), hasInitialPriceDisplayed && __jsx("span", {
    className: thInitialPrice,
    "data-testid": "PriceItem-value"
  }, initialPriceFormattedValue), hasTotalPriceDisplayed && __jsx("span", {
    className: thTotalPrice,
    "data-testid": "PriceItem-value"
  }, totalBestPrice)), bestPriceFormattedValue && __jsx("span", {
    className: thBestPrice,
    "data-testid": "PriceItem-value"
  }, bestPriceFormattedValue), unit && __jsx("div", {
    className: thUnit
  }, hasTaxesAndFeesIncludedLabel && Object(i18n["d" /* getKeyValue */])(Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.displayTaxesAndFeesIncludedMention')) ? null : unit, hasAsterisk && __jsx("sup", null, "*"), hasTaxesAndFeesIncludedLabel && Object(i18n["d" /* getKeyValue */])(Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.displayTaxesAndFeesIncludedMention')) && __jsx("div", null, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.taxesAndFeesIncludedLabel'))));
};
// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.themes.js
var PriceViewRate_themes_themes = {
  "default": {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  },
  column: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  },
  inline: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.jsx


var PriceViewRate_jsx = react_default.a.createElement;





var PriceViewRate_PriceViewRate = function PriceViewRate(_ref) {
  var className = _ref.className,
      label = _ref.label,
      theme = _ref.theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "theme"]);

  var _themes$theme = PriceViewRate_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thRoot = _themes$theme.thRoot;

  if (!label) {
    return null;
  }

  return PriceViewRate_jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(thRoot, className)
  }), PriceViewRate_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].DATE,
    width: "1em"
  }), label);
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/prices/Prices.jsx


var Prices_jsx = react_default.a.createElement;






var Prices_PriceLoader = function PriceLoader(_ref) {
  var className = _ref.className;
  return Prices_jsx("span", {
    className: classnames_default()('block after:animate-loadingDots after:content-["."] pr-30 text-32 w-[2em]', className),
    "data-testid": "Price-loader"
  });
};

var Prices_Prices = function Prices(_ref2) {
  var bestPrice = _ref2.bestPrice,
      className = _ref2.className,
      color = _ref2.color,
      from = _ref2.from,
      hasAsterisk = _ref2.hasAsterisk,
      hasInitialPrice = _ref2.hasInitialPrice,
      hasInstalment = _ref2.hasInstalment,
      hasTaxesAndFeesIncludedLabel = _ref2.hasTaxesAndFeesIncludedLabel,
      hasTotalPrice = _ref2.hasTotalPrice,
      initialPrice = _ref2.initialPrice,
      isLoading = _ref2.isLoading,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      unit = _ref2.unit,
      viewRates = _ref2.viewRates,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref2, ["bestPrice", "className", "color", "from", "hasAsterisk", "hasInitialPrice", "hasInstalment", "hasTaxesAndFeesIncludedLabel", "hasTotalPrice", "initialPrice", "isLoading", "theme", "unit", "viewRates"]);

  var displayPrice = Object(price_util["d" /* hasAtLeastOnePrice */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  });

  if (isLoading) {
    return Prices_jsx(Prices_PriceLoader, {
      className: className
    });
  }

  if (!displayPrice && !viewRates) {
    return null;
  }

  if (!displayPrice) {
    return Prices_jsx(PriceViewRate_PriceViewRate, Object(esm_extends["a" /* default */])({}, rest, {
      className: className,
      label: viewRates,
      theme: theme
    }));
  }

  return Prices_jsx(PriceDiscount_PriceDiscount, Object(esm_extends["a" /* default */])({}, rest, {
    bestPrice: bestPrice,
    className: className,
    color: color,
    from: from,
    hasAsterisk: hasAsterisk,
    hasDiscount: Object(price_util["e" /* hasDiscount */])({
      bestPrice: bestPrice,
      initialPrice: initialPrice
    }),
    hasInitialPrice: hasInitialPrice,
    hasInstalment: hasInstalment,
    hasTaxesAndFeesIncludedLabel: hasTaxesAndFeesIncludedLabel,
    hasTotalPrice: hasTotalPrice,
    initialPrice: initialPrice,
    unit: unit,
    theme: theme
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.jsx



var Price_jsx = react_default.a.createElement;




var INSTALMENT_LOCALES = ['pt-BR', 'es-AR'];
var Price_Price = function Price(_ref) {
  var _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["hasInstalment"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var displayInstalment = hasInstalment && Object(i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice') && INSTALMENT_LOCALES.includes(locale);
  return Price_jsx(Prices_Prices, Object(esm_extends["a" /* default */])({}, props, {
    hasInstalment: displayInstalment
  }));
};

/***/ }),

/***/ "JPie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");


/* eslint-disable react/require-default-props */





var AutoFocusInside = function AutoFocusInside(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? undefined : _ref$className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? undefined : {};
/* harmony default export */ __webpack_exports__["a"] = (AutoFocusInside);

/***/ }),

/***/ "JSB9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ BookingEngineForm_container_mapStateToProps; });

// UNUSED EXPORTS: mapDispatchToProps

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("JTJg");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 2 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.action.js
var departureDate_action = __webpack_require__("fflk");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/tripDateCriteria.action.js
var tripDateCriteria_action = __webpack_require__("6wD6");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/adults.action.js
var adults_action = __webpack_require__("VO7D");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var trip_information_storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/utils/trip-information/tripInformationUtils.js
var tripInformationUtils = __webpack_require__("bMF2");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("Rfxz");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("nnRT");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/constants.js
var BOOKING_ENGINE_FORM_SELECTOR = '#booking';
// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/client/components/widgets/price-remote/constants.js
var price_remote_constants = __webpack_require__("Lc/n");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/resort/resortUtils.js
var resortUtils = __webpack_require__("1qsz");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 2 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineI18n.query.js
var BookingEngineI18n_query = __webpack_require__("9LZ4");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals-modal/AlternativeProposalsModal.jsx + 2 modules
var AlternativeProposalsModal = __webpack_require__("BhBy");

// EXTERNAL MODULE: /opt/webapp/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.action.js
var departureCity_action = __webpack_require__("+mhw");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.action.js
var duration_action = __webpack_require__("C5R2");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/kids.action.js
var kids_action = __webpack_require__("1bWg");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/values.js
var values = __webpack_require__("0iyY");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-booking/participantsErrors.jsx
var participantsErrors = __webpack_require__("tPlR");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-booking/participants.validator.js
var participants_validator = __webpack_require__("PhFM");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// CONCATENATED MODULE: ./src/client/components/utils/watch-location-query-change/WatchLocationQueryChange.jsx









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





var WatchLocationQueryChange_WatchLocationQueryChange = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_WatchLocationQueryChange, _Component);

  var _super = _createSuper(_WatchLocationQueryChange);

  function _WatchLocationQueryChange() {
    Object(classCallCheck["a" /* default */])(this, _WatchLocationQueryChange);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(_WatchLocationQueryChange, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          queryKey = _this$props.queryKey,
          onChange = _this$props.onChange,
          router = _this$props.router;

      if (router.query[queryKey]) {
        onChange(router.query[queryKey]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          queryKey = _this$props2.queryKey,
          onChange = _this$props2.onChange,
          router = _this$props2.router;
      var previousPathname = new URI_default.a(prevProps.router.asPath).pathname();
      var pathname = new URI_default.a(router.asPath).pathname();

      if (prevProps.router.query[queryKey] !== router.query[queryKey] && previousPathname === pathname) {
        onChange(router.query[queryKey]);
      }
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _WatchLocationQueryChange;
}(react["Component"]); // $FlowFixMe


var WatchLocationQueryChange = Object(next_router["withRouter"])(WatchLocationQueryChange_WatchLocationQueryChange);
// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/widgets/booking-step-title/BookingStepTitle.jsx
var __jsx = react_default.a.createElement;


var BookingStepTitle_BookingStepTitle = function BookingStepTitle(_ref) {
  var className = _ref.className,
      number = _ref.number,
      title = _ref.title;
  return __jsx("h3", {
    className: classnames_default()('font-bold font-sans leading-tight text-20', className),
    "data-testid": "BookingCriteriaStep-title--".concat(number)
  }, __jsx("span", {
    className: "text-28 lg:text-22"
  }, number, "."), " ", title);
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-information/participants/Participants.jsx + 1 modules
var Participants = __webpack_require__("rFVZ");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-information/participants/participants.constants.js
var participants_constants = __webpack_require__("93Yv");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/tracking/last-visited-tracking-api/index.js
var last_visited_tracking_api = __webpack_require__("evRn");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("SYor");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx + 2 modules
var SeeMore = __webpack_require__("NPTU");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/ReassuranceBlock.jsx


var ReassuranceBlock_jsx = react_default.a.createElement;








var ReassuranceBlock_ReassuranceBlock = function ReassuranceBlock(_ref) {
  var _t;

  var items = _ref.items;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'calendarPrice',
    labelGA: 'reinsuranceTravel_readMore',
    siteSection: 'Shopping_Resort'
  });
  var reinsuranceLinkURL = Object(src_i18n["d" /* getKeyValue */])('booking.form.reinsuranceLinkURL');
  var reinsuranceLegalMentions = (_t = Object(src_i18n["h" /* t */])('booking.form.reinsuranceLegalMentions')) === null || _t === void 0 ? void 0 : _t.trim();
  var TagName = isTablet ? react["Fragment"] : SeeMore["a" /* SeeMore */];
  var seeMoreProps = isTablet ? null : {
    classNameButton: 'text-end',
    color: colors["a" /* COLORS */].LIGHT_SAND,
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: !isTablet,
    seeLessLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.loadMore'),
    seeMoreSize: 110
  };
  return ReassuranceBlock_jsx("aside", {
    className: "border-1 border-lightGrey font-sans p-15 rounded-12 space-y-15 text-14 text-black"
  }, ReassuranceBlock_jsx("header", null, ReassuranceBlock_jsx("h4", {
    className: "font-bold text-16"
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceTitle')), ReassuranceBlock_jsx("p", {
    className: "font-bold"
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceSubtitle'))), ReassuranceBlock_jsx(TagName, seeMoreProps, !!items.length && ReassuranceBlock_jsx("ul", {
    className: "space-y-10"
  }, items.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label;
    return ReassuranceBlock_jsx("li", {
      className: "flex gap-5 items-center",
      key: iconName
    }, ReassuranceBlock_jsx(Icon["a" /* Icon */], {
      className: "shrink-0",
      name: iconName,
      width: "1.25rem"
    }), label);
  })), !!reinsuranceLinkURL && ReassuranceBlock_jsx(DynamicLink["a" /* default */], {
    className: "inline-block mt-15 md:mt-0 hocus:text-black-active underline",
    onClick: function onClick() {
      return track();
    },
    target: "_blank",
    url: reinsuranceLinkURL
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceLinkLabel')), !!reinsuranceLegalMentions && ReassuranceBlock_jsx("p", {
    className: "mt-15 md:mt-0"
  }, reinsuranceLegalMentions)));
};
// EXTERNAL MODULE: ./src/client/components/widgets/booking-criteria/TransportCriteria.jsx
var TransportCriteria = __webpack_require__("yFoA");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/BookingCriteria.jsx









var BookingCriteria_jsx = react_default.a.createElement;





























var BookingCriteria_BookingCriteriaComponent = function BookingCriteriaComponent(props) {
  var _i18n$bookingCriteria, _i18n$bookingCriteria2, _i18n$booking, _i18n$booking$form, _bookingConfig$form;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var adultOnly = props.adultOnly,
      _props$adultsNumber = props.adultsNumber,
      adultsNumber = _props$adultsNumber === void 0 ? 2 : _props$adultsNumber,
      bookingConfig = props.bookingConfig,
      _props$childAge = props.childAge,
      childAge = _props$childAge === void 0 ? 0 : _props$childAge,
      children = props.children,
      config = props.config,
      _props$departureCity = props.departureCity,
      departureCity = _props$departureCity === void 0 ? '' : _props$departureCity,
      _props$i18n = props.i18n,
      i18n = _props$i18n === void 0 ? {} : _props$i18n,
      isDepartureDateAvailaible = props.isDepartureDateAvailaible,
      _props$isWinterResort = props.isWinterResort,
      isWinterResort = _props$isWinterResort === void 0 ? false : _props$isWinterResort,
      _props$kids = props.kids,
      kids = _props$kids === void 0 ? [] : _props$kids,
      resort = props.resort;

  var _useState = Object(react["useState"])(props.departureDate),
      departureDate = _useState[0],
      setDepartureDate = _useState[1];

  var _useState2 = Object(react["useState"])(props.tripDurationCriteria),
      tripDurationCriteria = _useState2[0],
      setTripDurationCriteria = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isLoading = _useState3[0];

  var _useState4 = Object(react["useState"])(false),
      hasCheckedPrice = _useState4[0],
      setHasCheckedPrice = _useState4[1];

  var departureCities = (i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingCriteria = i18n.bookingCriteria) === null || _i18n$bookingCriteria === void 0 ? void 0 : _i18n$bookingCriteria.departureCities.map(function (departureCityToMap) {
    return {
      value: departureCityToMap === null || departureCityToMap === void 0 ? void 0 : departureCityToMap.value,
      label: (departureCityToMap === null || departureCityToMap === void 0 ? void 0 : departureCityToMap.name) || ''
    };
  })) || [];
  var initialTransport = (i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingCriteria2 = i18n.bookingCriteria) === null || _i18n$bookingCriteria2 === void 0 ? void 0 : _i18n$bookingCriteria2.initialTransport) || '';
  var transportIcon = (resort === null || resort === void 0 ? void 0 : resort.transportType) || '';
  var withTransport = departureCities.some(function (_ref) {
    var value = _ref.value;
    return value !== 'NO';
  });

  if (departureDate !== props.departureDate || tripDurationCriteria !== props.tripDurationCriteria) {
    setDepartureDate(props.departureDate);
    setHasCheckedPrice(false);
    setTripDurationCriteria(props.tripDurationCriteria);
  }

  Object(react["useEffect"])(function () {
    var _kids = props.tripInformation.kids;

    if (adultOnly && (_kids === null || _kids === void 0 ? void 0 : _kids.length)) {
      props.resetKids();
    }
  }, []);

  var checkFormErrors = function checkFormErrors() {
    var dateFormat = get_default()(props, 'i18n.dateFormat', 'DD/MM/YYYY');

    var birthdays = Object(tripInformationUtils["a" /* getFormattedKidsBirthdate */])(kids, dateFormat);
    var adultAgeInYear = +get_default()(props, 'i18n.adultAge', participants_constants["a" /* DEFAULT_MAX_AGE */]);

    var _childAge = typeof childAge === 'number' ? childAge : participants_constants["b" /* DEFAULT_MIN_AGE */];

    var childAgeInYear = _childAge / 12;
    return participants_validator["a" /* default */].checkFormErrors({
      adults: adultsNumber,
      children: kids.length,
      departureDate: tripDurationCriteria ? departureDate : null,
      birthdays: birthdays,
      dateFormat: dateFormat,
      adultAge: adultAgeInYear,
      childAge: childAgeInYear,
      birthdayFormatErrorMessage: get_default()(props, 'i18n.birthdayFormatErrorMessage'),
      adultAgeErrorMessage: get_default()(props, 'i18n.adultAgeErrorMessage'),
      minAgeErrorMessage: get_default()(props, 'i18n.minAgeErrorMessage'),
      isSeller: appContext.isSeller
    });
  };

  var handleChange = function handleChange(action) {
    return function (payload) {
      setHasCheckedPrice(false); // $FlowExpectedError

      action(payload);
    };
  };

  var handleCheckPrice = function handleCheckPrice() {
    var haveError = values_default()(checkFormErrors()).some(function (error) {
      return error;
    });

    if (!haveError) {
      return props.getPackages(departureDate);
    }
  };

  var onSubmit = function onSubmit() {
    Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageContext.pageType, {
      id: resort.resortId,
      be: true,
      timestamp: Date.now()
    });
    setHasCheckedPrice(!!isDepartureDateAvailaible || hasCheckedPrice);

    if (isDepartureDateAvailaible) {
      handleCheckPrice();
    }

    if (tripDurationCriteria !== null && window.pageYOffset > 0) {
      window.scrollTo(0, 0);
    }
  };

  var formErrors = checkFormErrors();
  return BookingCriteria_jsx(react["Fragment"], null, BookingCriteria_jsx(WatchLocationQueryChange, {
    onChange: function onChange(value) {
      return value && Object(duration_action["a" /* setDuration */])(parseInt(value, 10) || duration_constants["a" /* DEFAULT_NO_DURATION */]);
    },
    queryKey: uri_constants["h" /* QUERY_DURATION */]
  }), withTransport && BookingCriteria_jsx(react["Fragment"], null, BookingCriteria_jsx(WatchLocationQueryChange, {
    onChange: function onChange(value) {
      return value && Object(departureCity_action["a" /* setDepartureCity */])({
        value: value
      });
    },
    queryKey: uri_constants["m" /* QUERY_TRANSPORT */]
  }), BookingCriteria_jsx(BookingStepTitle_BookingStepTitle, {
    className: "mb-15",
    number: 1,
    title: Object(src_i18n["h" /* t */])('booking.form.transportFrom')
  }), BookingCriteria_jsx("div", {
    className: "md:flex gap-x-100 mb-30"
  }, BookingCriteria_jsx("div", {
    className: "mb-20 md:mb-0 md:flex-1"
  }, BookingCriteria_jsx(TransportCriteria["a" /* TransportCriteria */], {
    departureCitiesOptions: departureCities,
    departureCity: departureCity,
    initialTransport: initialTransport,
    isJoyview: resort.isJoyview,
    transportIcon: transportIcon,
    withValidDepartureCity: true
  }), BookingCriteria_jsx(Text["a" /* Text */], {
    className: "hidden md:block md:mt-30 px-5",
    text: Object(src_i18n["h" /* t */])('bookingConfig.form.legalNotice'),
    theme: "text-sans-n2"
  })), BookingCriteria_jsx("div", {
    className: "md:flex-2"
  }, BookingCriteria_jsx(ReassuranceBlock_ReassuranceBlock, {
    items: (i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$form = _i18n$booking.form) === null || _i18n$booking$form === void 0 ? void 0 : _i18n$booking$form.items) || []
  }), BookingCriteria_jsx(Text["a" /* Text */], {
    className: "md:hidden mt-20",
    text: Object(src_i18n["h" /* t */])('bookingConfig.form.legalNotice'),
    theme: "text-sans-n2"
  })))), BookingCriteria_jsx(BookingStepTitle_BookingStepTitle, {
    className: "mb-15",
    number: withTransport ? 2 : 1,
    title: Object(src_i18n["h" /* t */])('booking.form.resortCriteriaDatesSelectionTitle')
  }), react["Children"].map(children, function (child) {
    return /*#__PURE__*/Object(react["cloneElement"])(child, {
      handleChange: handleChange
    });
  }), isWinterResort && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.reinsuranceSkiPass') && BookingCriteria_jsx(Notification["a" /* Notification */], {
    className: "mb-40",
    color: colors["a" /* COLORS */].SIENNA,
    text: i18n === null || i18n === void 0 ? void 0 : i18n.skiPassIncludedDescription,
    title: i18n === null || i18n === void 0 ? void 0 : i18n.skiPassIncludedLabel
  }), BookingCriteria_jsx(BookingStepTitle_BookingStepTitle, {
    className: "mb-15",
    number: withTransport ? 3 : 2,
    title: bookingConfig === null || bookingConfig === void 0 ? void 0 : (_bookingConfig$form = bookingConfig.form) === null || _bookingConfig$form === void 0 ? void 0 : _bookingConfig$form.guestCriteriaTitle
  }), BookingCriteria_jsx(Participants["a" /* Participants */], {
    adultAge: get_default()(props, 'i18n.adultAge'),
    adultsLabel: get_default()(props, 'i18n.common.participants.adultsLabel'),
    adultOnly: adultOnly,
    adultsNumber: adultsNumber,
    childAge: get_default()(props, 'childAge'),
    childrenBirthdayDateFormatPlaceholder: get_default()(props, 'i18n.childrenBirthdayDateFormatPlaceholder', ''),
    dateFormat: get_default()(props, 'i18n.dateFormat'),
    dayPlaceholder: get_default()(props, 'i18n.dayPlaceholder'),
    departureDate: get_default()(props, 'departureDate'),
    kids: kids,
    kidsAgeLimit: get_default()(props, 'i18n.common.participants.kidsAgeLimit'),
    kidsLabel: get_default()(props, 'i18n.common.participants.kidsLabel'),
    minAgeInformation: get_default()(props, 'i18n.minAgeInformation'),
    monthPlaceholder: get_default()(props, 'i18n.monthPlaceholder'),
    selectAdultsLabels: get_default()(props, 'i18n.selectAdultsLabels'),
    selectChildrenLabels: get_default()(props, 'i18n.selectChildrenLabels'),
    setAdultsNumber: handleChange(props.setAdultsNumber),
    setKids: handleChange(function (_ref2) {
      var _kids = _ref2.kids,
          kidsValidations = _ref2.kidsValidations;
      Object(es["b" /* batch */])(function () {
        props.setKids(_kids);
        props.setKidsValidationState(kidsValidations);
      });
    }),
    yearPlaceholder: get_default()(props, 'i18n.yearPlaceholder')
  }), (resort === null || resort === void 0 ? void 0 : resort.isResort) && !!kids.length && BookingCriteria_jsx(Notification["a" /* Notification */], {
    className: "mt-20",
    color: colors["a" /* COLORS */].SAFFRON,
    text: "**".concat(i18n.didYouKnowLabel, "** ").concat(i18n.kidStayIncludedDescription),
    title: i18n === null || i18n === void 0 ? void 0 : i18n.kidStayIncludedLabel
  }), BookingCriteria_jsx(participantsErrors["a" /* ParticipantsErrors */], {
    className: "mt-20 justify-end",
    config: pick_default()(config.booking.form, ['errorMaxGuestsLabel', 'departureDateErrorMessage']),
    errors: formErrors,
    isSubmitted: hasCheckedPrice
  }), BookingCriteria_jsx("div", {
    className: "flex justify-end mt-40"
  }, BookingCriteria_jsx(Button["a" /* Button */], {
    className: "w-full md:w-auto",
    dataTestId: "BookingCriteria-checkPrice",
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_RIGHT
    },
    isDisabled: isLoading || !!formErrors.maxPax,
    onClick: onSubmit
  }, i18n === null || i18n === void 0 ? void 0 : i18n.checkPriceLabel)));
}; // $FlowFixMe


var BookingCriteria_BookingCriteria = function BookingCriteria(_ref3) {
  var myRef = _ref3.myRef,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref3, ["myRef"]);

  return BookingCriteria_jsx(BookingCriteria_BookingCriteriaComponent, Object(esm_extends["a" /* default */])({
    ref: myRef
  }, otherProps));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/BookingCriteria.container.jsx












var mapDispatchToProps = {
  resetKids: kids_action["a" /* resetKids */],
  setKidsValidationState: facetingSearch_action["o" /* setKidsValidationState */],
  setAdultsNumber: adults_action["a" /* setAdultsNumber */],
  setDepartureCity: departureCity_action["a" /* setDepartureCity */],
  setDepartureDate: departureDate_action["a" /* setDepartureDate */],
  setDuration: duration_action["a" /* setDuration */],
  setKids: kids_action["b" /* setKids */],
  endLoading: globalLoader_action["c" /* endLoading */]
};

var BookingCriteria_container_mapStateToProps = function mapStateToProps(state) {
  return {
    tripInformation: Object(trip_information_storeHelper["d" /* tripInformationSelector */])(state),
    tripDurationCriteria: Object(tripCriteria_selector["c" /* getTripDuration */])(state)
  };
};

var BookingCriteriaContainer = Object(redux["d" /* compose */])(Object(es["c" /* connect */])(BookingCriteria_container_mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
}))(BookingCriteria_BookingCriteria);
// EXTERNAL MODULE: ./src/client/components/widgets/booking-errors/BookingErrors.jsx
var BookingErrors = __webpack_require__("rFb4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("qePV");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("UxlC");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/has.js
var has = __webpack_require__("1mr4");
var has_default = /*#__PURE__*/__webpack_require__.n(has);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("x0AG");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-months/month/BookingCalendarMonth.jsx

var BookingCalendarMonth_jsx = react_default.a.createElement;



var BookingCalendarMonth_BookingCalendarMonth = function BookingCalendarMonth(_ref) {
  var className = _ref.className,
      id = _ref.id,
      isActive = _ref.isActive,
      name = _ref.name,
      _onClick = _ref.onClick,
      price = _ref.price,
      shortName = _ref.shortName,
      style = _ref.style,
      year = _ref.year;
  return BookingCalendarMonth_jsx("button", {
    className: classnames_default()('cursor-pointer flex flex-col items-center justify-center overflow-hidden sm:p-10 rounded-12 w-full', {
      'bg-white text-black': !isActive,
      'bg-ultramarine font-bold text-white': isActive
    }, className),
    onClick: function onClick() {
      return _onClick(id);
    },
    style: style,
    type: "button"
  }, BookingCalendarMonth_jsx("div", {
    className: "text-center text-12 sm:text-14 truncate uppercase w-full"
  }, isActive ? name : shortName, isActive && BookingCalendarMonth_jsx("span", null, " ", year)), !!price && BookingCalendarMonth_jsx(react["Fragment"], null, BookingCalendarMonth_jsx("div", {
    className: "text-10 sm:text-12 truncate uppercase w-full"
  }, Object(src_i18n["h" /* t */])('price.format.from')), BookingCalendarMonth_jsx("div", {
    className: "sm:mt-10 text-10 sm:text-14"
  }, price)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-months/BookingCalendarMonths.jsx



var BookingCalendarMonths_jsx = react_default.a.createElement;






var BookingCalendarMonths_BookingCalendarMonths = function BookingCalendarMonths(_ref) {
  var _ref$current;

  var className = _ref.className,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$months = _ref.months,
      months = _ref$months === void 0 ? [] : _ref$months,
      onClick = _ref.onClick;

  var _useState = Object(react["useState"])(null),
      hovering = _useState[0],
      setHovering = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      initialPosition = _useState2[0],
      setInitialPosition = _useState2[1];

  var ref = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
      setInitialPosition(months.findIndex(function (m) {
        return m.isActive;
      }));
    }
  }, [isLoading]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var containerWidth = (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth) || 0; // eslint-disable-next-line no-nested-ternary

  var width = !isTablet ? containerWidth / 4 : isDesktop ? containerWidth / 8 : containerWidth / 5;
  var elementWidth = isTablet ? width : width * 0.95;
  return BookingCalendarMonths_jsx("div", {
    className: ('isolate relative', className)
  }, BookingCalendarMonths_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["h" /* t */])('booking.common.previousMonths'),
    className: "z-1",
    controlsClassName: "mb-20 pb-10 sm:pb-20",
    deltaScrollFactorClick: elementWidth * 2,
    elementWidth: elementWidth,
    forwardLabel: Object(src_i18n["h" /* t */])('booking.common.nextMonths'),
    initialPosition: elementWidth ? initialPosition : null,
    theme: "calendar"
  }, BookingCalendarMonths_jsx("div", {
    className: "flex mb-20 mx-5 sm:mx-15 md:mx-0",
    ref: ref
  }, months.map(function (month) {
    return BookingCalendarMonths_jsx("div", {
      className: classnames_default()('flex-none px-5 sm:px-10 relative transition-width duration-250 ease-in', {
        'w-1/4 sm:w-1/5 md:w-1/8': !month.isActive && hovering !== month.id,
        'w-1/2 sm:w-2/5 md:w-1/4': month.isActive,
        'w-3/10 sm:w-1/4 md:w-1/6': !month.isActive && hovering === month.id
      }),
      key: month.id,
      onMouseEnter: function onMouseEnter() {
        return setHovering(month.id);
      },
      onMouseLeave: function onMouseLeave() {
        return setHovering(null);
      },
      style: !isTablet && elementWidth ? {
        width: month.isActive ? elementWidth * 2 : elementWidth
      } : null
    }, BookingCalendarMonths_jsx(BookingCalendarMonth_BookingCalendarMonth, Object(esm_extends["a" /* default */])({}, month, {
      className: "mb-10 sm:mb-15",
      onClick: onClick,
      style: {
        height: isTablet ? 85 : 52
      }
    })), month.isActive && BookingCalendarMonths_jsx("div", {
      className: "arrow-down arrow-large arrow-lightSand arrow-bg arrow-bg-large arrow-bg-ultramarine border-b-2 border-ultramarine -mb-1 bottom-0 start-0 w-full transition-opacity duration-250 ease-in"
    }));
  }))), BookingCalendarMonths_jsx("hr", {
    className: "absolute block border-0 border-solid border-ligthGrey border-t-1 h-1 m-0 -mt-20 p-0 w-full z-0"
  }));
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("+2oP");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/widgets/rate-messages/RateMessages.jsx
var RateMessages = __webpack_require__("/Sb8");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-resume/BookingCalendarResume.jsx

var BookingCalendarResume_jsx = react_default.a.createElement;










var BookingCalendarResume_BookingCalendarResume = function BookingCalendarResume(_ref) {
  var className = _ref.className,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      id = _ref.id,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      onClose = _ref.onClose,
      onReset = _ref.onReset,
      price = _ref.price,
      priceIsLoading = _ref.priceIsLoading,
      rate = _ref.rate,
      realPrice = _ref.realPrice,
      realPriceIsLoading = _ref.realPriceIsLoading,
      startDate = _ref.startDate,
      style = _ref.style;
  var track = Object(useTracking["a" /* useTracking */])();

  var onClickSeeMore = function onClickSeeMore(_, isExpanded) {
    if (!isExpanded) {
      track({
        actionGA: 'calendarPrice',
        labelGA: 'viewMore'
      });
    }
  };

  return BookingCalendarResume_jsx("div", {
    className: classnames_default()('bg-white rounded-12 shadow', className),
    id: id,
    style: style
  }, BookingCalendarResume_jsx("div", {
    className: "isolate relative"
  }, BookingCalendarResume_jsx("button", {
    className: "absolute leading-0 end-0 text-14 top-0 m-10",
    onClick: onClose,
    type: "button"
  }, BookingCalendarResume_jsx("span", {
    className: "sr-only"
  }, Object(src_i18n["h" /* t */])('common.close')), BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  })), BookingCalendarResume_jsx("div", {
    className: "p-20"
  }, BookingCalendarResume_jsx("p", {
    className: "flex gap-10 items-start mb-30  text-12 sm:text-14"
  }, BookingCalendarResume_jsx("span", {
    className: "leading-0 text-sienna text-28"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CHECK_OUTLINE,
    width: "1em"
  })), ' ', BookingCalendarResume_jsx("span", null, BookingCalendarResume_jsx(TemplateString["a" /* TemplateString */], {
    className: "gap-5 inline-flex",
    template: Object(src_i18n["h" /* t */])('resort.startingPrice.stayDeparture'),
    values: {
      departure_date: startDate.charAt(0).toUpperCase() + startDate.slice(1)
    },
    valuesClassName: {
      departure_date: 'text-sienna'
    }
  }), BookingCalendarResume_jsx("br", null), BookingCalendarResume_jsx(TemplateString["a" /* TemplateString */], {
    className: "gap-5 inline-flex",
    template: Object(src_i18n["h" /* t */])('resort.startingPrice.endDateLabel'),
    values: {
      end_date: endDate.charAt(0).toUpperCase() + endDate.slice(1)
    },
    valuesClassName: {
      departure_date: 'text-sienna'
    }
  }))), (priceIsLoading || realPriceIsLoading) && BookingCalendarResume_jsx("div", {
    className: "flex justify-center py-10"
  }, BookingCalendarResume_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })), (realPrice && !realPriceIsLoading || price && !priceIsLoading) && BookingCalendarResume_jsx("div", {
    className: "flex gap-10 items-center justify-center mb-20 text-12"
  }, BookingCalendarResume_jsx("span", {
    className: "hidden md:inline-block leading-0 text-sienna text-18"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ACCOMODATIONS,
    width: "1em"
  }), hasTransport && BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    className: "ms-5",
    name: icons["a" /* ICONS */].TRANSPORT,
    width: "1em"
  })), BookingCalendarResume_jsx("span", null, "".concat(Object(src_i18n["h" /* t */])('price.format.unitTotalPerTripIndicative'), " ")), BookingCalendarResume_jsx("span", {
    className: "font-bold text-sienna text-20"
  }, realPrice || price)), BookingCalendarResume_jsx("p", {
    className: "flex flex-col text-center text-10 sm:text-12"
  }, isJoyview ? BookingCalendarResume_jsx("span", {
    className: "leading-1 text-blueWave"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CLUBMED_JOYVIEW,
    isNotSquare: true,
    width: "10em"
  })) : BookingCalendarResume_jsx(react["Fragment"], null, price && !priceIsLoading ? Object(src_i18n["h" /* t */])('booking.form.priceIsLabel') : '', ' ', BookingCalendarResume_jsx("span", {
    className: "font-brand leading-1 text-sienna text-14 sm:text-16"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    className: "-mb-2",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE
  }), ' ', Object(src_i18n["h" /* t */])('resort.startingPrice.allInclusive'))))), BookingCalendarResume_jsx("button", {
    className: "px-20 py-10 text-center text-14 underline w-full",
    onClick: function onClick() {
      onReset();
      track({
        actionGA: 'calendarPrice',
        labelGA: 'resetDates'
      });
    },
    type: "button"
  }, Object(src_i18n["h" /* t */])('booking.priceCalendar.resetCalendar')), !!rate && BookingCalendarResume_jsx("div", {
    className: "p-20 border-t-1 border-mediumGrey font-text-left"
  }, BookingCalendarResume_jsx(SeeMore["a" /* SeeMore */], {
    className: "flex-1 mt-10 md:mt-0",
    classNameButton: "text-end",
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: true,
    onClick: onClickSeeMore,
    seeMoreSize: 70,
    seeMoreSizeTolerance: 0
  }, BookingCalendarResume_jsx(RateMessages["a" /* RateMessages */], {
    rate: rate
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/ArrivalDepartureDate.jsx
var ArrivalDepartureDate_jsx = react_default.a.createElement;


var ArrivalDepartureDate_ArrivalDepartureDate = function ArrivalDepartureDate(_ref) {
  var arrivalDate = _ref.arrivalDate,
      departureDate = _ref.departureDate;
  return ArrivalDepartureDate_jsx("div", {
    className: "block sm:hidden p-10 text-14"
  }, ArrivalDepartureDate_jsx("p", {
    className: "flex gap-5 justify-between mb-5"
  }, Object(src_i18n["h" /* t */])('faceting.when.arrivalDateTitle'), ArrivalDepartureDate_jsx("span", {
    className: "font-bold text-sienna"
  }, arrivalDate ? arrivalDate : ' -')), ArrivalDepartureDate_jsx("p", {
    className: "flex gap-5 justify-between"
  }, Object(src_i18n["h" /* t */])('faceting.when.departureDateTitle'), ArrivalDepartureDate_jsx("span", {
    className: "font-bold text-sienna"
  }, departureDate ? departureDate : ' -')));
};
// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/widgets/price-remote/price-remote-form/useAvailableDurations.js
var useAvailableDurations = __webpack_require__("jLVw");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx + 4 modules
var TripDatePicker = __webpack_require__("pteD");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// EXTERNAL MODULE: ./src/hooks/use-block-input-departure-date/useBlockInputDepartureDate.js
var useBlockInputDepartureDate = __webpack_require__("VQ9C");

// EXTERNAL MODULE: ./src/hooks/use-price-of-stay/usePriceOfStay.js
var usePriceOfStay = __webpack_require__("QkNd");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.action.js
var calendar_action = __webpack_require__("rueY");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.selector.js + 1 modules
var calendar_selector = __webpack_require__("05PS");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-form/price-calendar/PriceLegend.jsx
var PriceLegend_jsx = react_default.a.createElement;





var PriceLegend_PriceLegend = function PriceLegend(_ref) {
  var canReset = _ref.canReset,
      durationLabel = _ref.durationLabel,
      onReset = _ref.onReset;
  var track = Object(useTracking["a" /* useTracking */])();
  return PriceLegend_jsx("div", {
    className: "p-20 md:px-0 w-full"
  }, PriceLegend_jsx("div", {
    className: "flex gap-10 items-center justify-between"
  }, PriceLegend_jsx("p", {
    className: "text-16"
  }, Object(src_i18n["h" /* t */])('faceting.when.pricesBasedOn'), PriceLegend_jsx("strong", {
    "data-testid": "prices-duration-label"
  }, "\xA0", durationLabel)), PriceLegend_jsx(Button["a" /* Button */], {
    "data-testid": "PriceLegend-calendarReset",
    iconLeft: {
      name: icons["a" /* ICONS */].RELOAD
    },
    isDisabled: !canReset,
    onClick: function onClick() {
      onReset();
      track({
        actionGA: 'calendarPrice',
        categoryGA: 'resort',
        labelGA: 'resetCalendar'
      });
    },
    size: "small"
  }, Object(src_i18n["h" /* t */])('booking.priceCalendar.resetCalendar'))), PriceLegend_jsx("ul", {
    className: "flex flex-wrap font-bold gap-15 mt-10"
  }, PriceLegend_jsx("li", {
    className: "flex gap-5 items-center text-12 sm:text-14 text-green"
  }, PriceLegend_jsx("span", {
    className: "aspect-square bg-current h-[1em] inline-block rounded-full"
  }), Object(src_i18n["h" /* t */])('faceting.when.bestPrice')), PriceLegend_jsx("li", {
    className: "flex gap-5 items-center text-12 sm:text-14 text-orange"
  }, PriceLegend_jsx("span", {
    className: "aspect-square bg-current h-[1em] inline-block rounded-full"
  }), Object(src_i18n["h" /* t */])('faceting.when.lastAvailability')), PriceLegend_jsx("li", {
    className: "flex gap-5 items-center text-12 sm:text-14 text-grey"
  }, PriceLegend_jsx("span", {
    className: "aspect-square bg-current h-[1em] inline-block rounded-full"
  }), Object(src_i18n["h" /* t */])('faceting.when.notAvailable'))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-form/price-calendar/PriceCalendar.jsx











var PriceCalendar_jsx = react_default.a.createElement;
































var NO_TRANSPORT_VALUE = dist["constants"].NO_TRANSPORT_VALUE;
var HASH = 'PriceCalendarResume';
var SCROLL_ANCHOR = 'PriceCalendar';
var YEAR_MONTH = 'YYYYMM';

var defaultHandleChange = function defaultHandleChange(cb) {
  return function () {
    return cb();
  };
};

var PriceCalendar_PriceCalendar = function PriceCalendar(props) {
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var uri = new URI_default.a(router.asPath);
  var uriRef = react_default.a.useRef(null);
  uriRef.current = uri;
  var queryParams = router.query;
  var bookingConfig = props.bookingConfig,
      didMountCallback = props.didMountCallback,
      duration = props.duration,
      _props$handleChange = props.handleChange,
      handleChange = _props$handleChange === void 0 ? defaultHandleChange : _props$handleChange,
      isJoyview = props.isJoyview,
      offsetSell = props.offsetSell,
      product = props.product,
      productId = props.productId,
      transport = props.transport;
  var urgentisationRate = bookingConfig.priceCalendar.offers.urgentisation.rateToDisplay;
  var dispatch = Object(es["d" /* useDispatch */])();
  var calendar = Object(es["e" /* useSelector */])(calendar_selector["c" /* getCalendar */]);
  var days = Object(es["e" /* useSelector */])(calendar_selector["i" /* getDays */]);
  var selectedMonth = Object(es["e" /* useSelector */])(calendar_selector["n" /* getSelectedMonth */]);
  var selectedDay = Object(es["e" /* useSelector */])(storeHelper["b" /* getDepartureDate */]);
  var isLoading = Object(es["e" /* useSelector */])(calendar_selector["e" /* getCalendarLoading */]);
  var prices = Object(es["e" /* useSelector */])(calendar_selector["m" /* getPricesByDays */]);
  var departureDate = Object(es["e" /* useSelector */])(function (state) {
    return state.tripCriteria.departureDate;
  });
  var tripDuration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);

  var _useBlockInputDepartu = Object(useBlockInputDepartureDate["a" /* useBlockInputDepartureDate */])(true),
      blockInputDepartureDate = _useBlockInputDepartu.blockInputDepartureDate,
      setBlockInputDepartureDate = _useBlockInputDepartu.setBlockInputDepartureDate;

  var _useState = Object(react["useState"])(duration),
      durationPrice = _useState[0];

  var price = Object(es["e" /* useSelector */])(calendar_selector["g" /* getCalendarTripPrice */]);
  var priceIsLoading = Object(es["e" /* useSelector */])(calendar_selector["h" /* getCalendarTripPriceLoading */]);

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'calendarPrice'
  });

  var _useState2 = Object(react["useState"])(false),
      hasToaster = _useState2[0],
      setHasToaster = _useState2[1];

  var _useState3 = Object(react["useState"])(tripDuration),
      inputDuration = _useState3[0],
      setInputDuration = _useState3[1];

  var _usePriceOfStay = Object(usePriceOfStay["a" /* usePriceOfStay */])(productId, transport),
      hasValidCriteria = _usePriceOfStay.hasValidCriteria,
      isPriceOfStayLoading = _usePriceOfStay.isLoading,
      priceOfStay = _usePriceOfStay.priceOfStay;

  Object(react["useEffect"])(function () {
    if (inputDuration && inputDuration !== durationPrice) {
      dispatch(Object(calendar_action["d" /* fetchCalendarTripPrice */])({
        appContext: appContext,
        duration: inputDuration,
        forceAdultPerTrip: true,
        // $FlowFixMe
        location: {
          // this done to avoid regression, to do clean this when every thing is migrated
          queryParams: queryParams,
          urlParams: queryParams
        },
        productId: productId,
        transport: transport
      }));
    }
  }, [productId, inputDuration, transport]);

  var _useState4 = Object(react["useState"])(!blockInputDepartureDate && departureDate ? moment_default()(departureDate) : moment_default()(selectedMonth, YEAR_MONTH)),
      openCalendarToDate = _useState4[0],
      setCalendarToDate = _useState4[1];

  Object(react["useEffect"])(function () {
    if (tripDuration !== inputDuration) {
      setInputDuration(tripDuration);
    }
  }, [tripDuration]);
  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
    }
  }, [selectedMonth]);
  var availableDurations = Object(useAvailableDurations["a" /* useAvailableDurations */])({
    productId: productId,
    initialTransport: transport
  });

  var setUrlQueries = function setUrlQueries(queries) {
    if (uriRef.current) {
      var searchPageUrl = uriRef.current.clone().setQuery(queries);
      router.replace(searchPageUrl.toString(), undefined, {
        shallow: true,
        scroll: false
      });
      Object(scrollToElement["a" /* scrollToElement */])("[data-scroll-anchor=\"".concat(SCROLL_ANCHOR, "\"]"), 500, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
    }
  };

  var onSelect = function onSelect(dates) {
    var timestamp = dates.from && moment_default()(dates.from).valueOf();

    if (blockInputDepartureDate) {
      setBlockInputDepartureDate(false);
    }

    if (departureDate !== timestamp) {
      handleChange(function () {
        Object(es["b" /* batch */])(function () {
          dispatch(Object(departureDate_action["a" /* setDepartureDate */])(timestamp));
          dispatch(Object(facetingSearch_action["h" /* clearTripDuration */])());
        });
        setInputDuration(null);
        requestAnimationFrame(function () {
          var _setUrlQueries;

          setUrlQueries((_setUrlQueries = {}, Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["g" /* QUERY_DEPARTURE_DATE */], (timestamp || undefined) && moment_default()(timestamp).format(uri_constants["f" /* QUERY_DATE_FORMAT */])), Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["h" /* QUERY_DURATION */], undefined), _setUrlQueries));
        });

        if (timestamp) {
          track({
            labelGA: "when_".concat(moment_default()(timestamp).format('DD/MM/YYYY'))
          });
          setCalendarToDate(moment_default()(timestamp));
        }
      })();
    }

    if (dates.from && dates.to) {
      var updatedDuration = Object(TripDatePicker_utils["c" /* dateDiff */])(dates.from, dates.to);
      track({
        labelGA: "duration_".concat(updatedDuration)
      });
      setInputDuration(updatedDuration);
      Object(es["b" /* batch */])(function () {
        dispatch(Object(facetingSearch_action["d" /* changeTripDuration */])(updatedDuration));
        var dayId = parseInt(moment_default()(dates.from).format(apiDate["a" /* API_DATE_FORMAT */]), 10);
        var day = days.find(function (calendarDay) {
          return calendarDay.dayContent.id === dayId;
        });
        day && dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])({
          day: day.dayContent
        }));
        dispatch(Object(calendar_action["h" /* setIsPriceCalendarSelection */])(true));
      });
      setHasToaster(true);
      setUrlQueries(Object(defineProperty["a" /* default */])({}, uri_constants["h" /* QUERY_DURATION */], updatedDuration));
    } else {
      setInputDuration(null);
      dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])(null));
      setHasToaster(false);
    }
  };

  Object(react["useEffect"])(function () {
    dispatch(Object(calendar_action["g" /* setInitialDuration */])(duration));
    return function () {
      dispatch(Object(calendar_action["a" /* clearCalendar */])());
    };
  }, []);
  var transportQueryValue = queryParams[uri_constants["m" /* QUERY_TRANSPORT */]];
  Object(react["useEffect"])(function () {
    var hasProposalIdQueryParam = has_default()(queryParams, 'proposalId');

    if (hasProposalIdQueryParam || !productId || transportQueryValue && transportQueryValue !== transport) {
      return; // because a Redux action will fetch the calendar
    }

    if (selectedMonth) {
      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
    }

    dispatch(Object(calendar_action["c" /* fetchCalendar */])({
      resortId: productId,
      transport: transport,
      duration: durationPrice,
      urgentisationRate: urgentisationRate
    }, appContext));

    if (hasToaster) {
      setHasToaster(false);
    }
  }, [productId, transport, transportQueryValue, urgentisationRate]);
  Object(react["useEffect"])(function () {
    dispatch(Object(calendar_action["i" /* setPossibleDepartureDate */])());
    /**
     * Should fetch proposals after state update for arrivaldate
     * see BookingEngineForm, ligne 170.
     * */

    didMountCallback && didMountCallback();
  }, [calendar.months]);

  var onSelectDate = function onSelectDate(day) {
    props.onSelectDate(day);
  };
  /**
   * make sure the selected date is up to date after a transport update
   */


  Object(react["useEffect"])(function () {
    if (selectedDay) {
      var day = days.find(function (calendarDay) {
        return calendarDay.dayContent.id === selectedDay;
      });
      day && onSelectDate(day.dayContent);
    }
  }, [JSON.stringify(calendar), transport, selectedDay]);
  Object(react["useEffect"])(function () {
    if (hasToaster) {
      requestAnimationFrame(function () {
        Object(scrollToElement["a" /* scrollToElement */])("#".concat(HASH), 500, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
      });
    }
  }, [hasToaster]);
  var offsetCalendar = appContext.isSeller ? 0 : offsetSell;
  var from = departureDate && !blockInputDepartureDate ? moment_default()(departureDate).toDate() : null;
  var to = from && inputDuration ? moment_default()(from).add({
    days: inputDuration
  }).toDate() : null;

  var _useState5 = Object(react["useState"])(from),
      hovered = _useState5[0],
      setHovered = _useState5[1];

  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setHovered(null);
    }
  }, [departureDate]);

  var onSelectMonth = function onSelectMonth(monthId) {
    if (monthId !== selectedMonth) {
      if (!from && departureDate) {
        var _setUrlQueries3;

        setUrlQueries((_setUrlQueries3 = {}, Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["g" /* QUERY_DEPARTURE_DATE */], undefined), Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["h" /* QUERY_DURATION */], undefined), _setUrlQueries3));
        dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
        dispatch(Object(facetingSearch_action["h" /* clearTripDuration */])());
      }

      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
      requestAnimationFrame(function () {
        setCalendarToDate(moment_default()(monthId, YEAR_MONTH));
        dispatch(Object(calendar_action["e" /* selectMonth */])(monthId));
      });
    }
  };

  var onReset = function onReset() {
    var _setUrlQueries4;

    requestAnimationFrame(function () {
      Object(scrollToElement["a" /* scrollToElement */])("[data-scroll-anchor=\"".concat(SCROLL_ANCHOR, "\"]"), 500, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
    });
    setUrlQueries((_setUrlQueries4 = {}, Object(defineProperty["a" /* default */])(_setUrlQueries4, uri_constants["g" /* QUERY_DEPARTURE_DATE */], undefined), Object(defineProperty["a" /* default */])(_setUrlQueries4, uri_constants["h" /* QUERY_DURATION */], undefined), _setUrlQueries4));
    dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
    dispatch(Object(facetingSearch_action["h" /* clearTripDuration */])());
    setInputDuration(null);
    setHasToaster(false);
  };

  var onDayMouseOver = function onDayMouseOver(day) {
    setHovered(day);
  };

  var displayedDuration = from && (to || hovered) ? Object(TripDatePicker_utils["c" /* dateDiff */])(from, to || hovered || from) || durationPrice : durationPrice;
  var durationLabel = Object(dist["messageFormat"])({
    n: Object(src_i18n["h" /* t */])('faceting.when.durationPlural'),
    _0: '-',
    _1: Object(src_i18n["h" /* t */])('faceting.when.durationSingular')
  }).format({
    n: displayedDuration,
    count: displayedDuration
  });
  var locale = appContext.locale;
  var selectedDayPrice = selectedDay && prices && prices[selectedDay];
  var instalmentSelectedDayPrice = Object(price_util["b" /* getInstallmentPrice */])({
    currency: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.currency,
    formattedValue: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.price,
    value: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.priceValue
  }, locale);
  var selectedBestPrice = inputDuration && inputDuration !== durationPrice ? Object(price_util["b" /* getInstallmentPrice */])(price === null || price === void 0 ? void 0 : price.bestPrice, locale) : instalmentSelectedDayPrice;
  var shouldRenderRealPrice = Boolean(!isLoading && !isPriceOfStayLoading && priceOfStay && hasValidCriteria);
  var selectedRealPrice = shouldRenderRealPrice ? Object(price_util["b" /* getInstallmentPrice */])(priceOfStay.bestPrice, locale) : '';
  var selectedDuration = inputDuration ? inputDuration : 0;
  var dateFormat = Object(src_i18n["h" /* t */])('booking.form.dateFormat');
  var longDateFormat = Object(src_i18n["h" /* t */])('resort.startingPrice.longDateFormat');
  return PriceCalendar_jsx("div", {
    className: "isolate -mx-20 md:mx-0 relative",
    "data-scroll-anchor": SCROLL_ANCHOR,
    id: "calendar",
    style: {
      minHeight: 450
    }
  }, !isEmpty_default()(calendar) && PriceCalendar_jsx(react["Fragment"], null, PriceCalendar_jsx(BookingCalendarMonths_BookingCalendarMonths, {
    isLoading: isLoading,
    months: calendar.blocks.map(function (b) {
      return {
        id: b.id,
        isActive: b.id === selectedMonth,
        name: b.name,
        price: Object(price_util["b" /* getInstallmentPrice */])(b.price, locale),
        shortName: b.shortName,
        year: b.year
      };
    }),
    onClick: onSelectMonth
  }), PriceCalendar_jsx(PriceLegend_PriceLegend, {
    durationLabel: durationLabel,
    canReset: !!from,
    onReset: onReset
  }), PriceCalendar_jsx(TripDatePicker["a" /* TripDatePicker */], {
    className: "md:mb-40 -mx-1 md:mx-0",
    displayPrices: true,
    duration: durationPrice,
    hasInstalment: true,
    isJoyview: isJoyview,
    navbarElement: function navbarElement(_ref) {
      var month = _ref.month;
      var datePickerMonth = Number(moment_default()(month).format(YEAR_MONTH));

      if (datePickerMonth !== selectedMonth && !isLoading && (from || to)) {
        dispatch(Object(calendar_action["e" /* selectMonth */])(datePickerMonth));
      }

      return null;
    },
    onSelect: onSelect,
    onDayMouseOver: onDayMouseOver,
    optionsDuration: (availableDurations === null || availableDurations === void 0 ? void 0 : availableDurations.length) ? availableDurations : [],
    openCalendarToDate: openCalendarToDate,
    prices: prices,
    product: product,
    offsetCalendar: offsetCalendar,
    selectedBestPrice: selectedBestPrice,
    selectedRealPrice: selectedRealPrice,
    selectedDays: {
      from: from,
      to: to
    },
    selectedDuration: selectedDuration,
    selectedMonth: selectedMonth,
    withLongDayFormat: isTablet,
    withPriceDetails: isDesktop
  }), PriceCalendar_jsx(ArrivalDepartureDate_ArrivalDepartureDate, {
    arrivalDate: from && moment_default()(from).format(dateFormat),
    departureDate: to && moment_default()(to).format(dateFormat)
  }), from && to && hasToaster && !isLoading && PriceCalendar_jsx(BookingCalendarResume_BookingCalendarResume, {
    className: "absolute ltr:animate-slideInRight rtl:animate-slideInLeft bottom-0 md:bottom-auto end-0 mx-20 md:mx-0 z-3",
    hasTransport: Boolean(transport && transport !== NO_TRANSPORT_VALUE),
    id: HASH,
    isJoyview: isJoyview,
    endDate: moment_default()(to).format(longDateFormat),
    onClose: function onClose() {
      return setHasToaster(false);
    },
    onReset: onReset,
    price: selectedBestPrice,
    priceIsLoading: priceIsLoading,
    rate: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.rate,
    realPrice: selectedRealPrice,
    realPriceIsLoading: isPriceOfStayLoading,
    startDate: moment_default()(from).format(longDateFormat),
    style: isTablet ? {
      marginTop: -350,
      width: 380
    } : {
      marginTop: -100,
      width: 'calc(100% - 2.5rem)'
    }
  })), isLoading && PriceCalendar_jsx("div", {
    className: "absolute bg-lightSand flex items-center justify-center inset-0 w-full z-1"
  }, PriceCalendar_jsx(AsyncLoader["a" /* AsyncLoader */], null)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/BookingEngineForm.jsx


























var BookingEngineForm_jsx = react_default.a.createElement;


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function BookingEngineForm_createSuper(Derived) { var hasNativeReflectConstruct = BookingEngineForm_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function BookingEngineForm_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

























var defaultProps = {
  clearProposals: noop_default.a,
  kids: [],
  i18n: null,
  dataSelector: 'BookingEngineForm',
  // $FlowFixMe
  fetchProposalsAndRedirect: noop_default.a,
  // $FlowFixMe
  suggestions: {
    dates: [],
    resorts: []
  }
};

var BookingEngineForm_BookingEngineForm = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(BookingEngineForm, _Component);

  var _super = BookingEngineForm_createSuper(BookingEngineForm);

  function BookingEngineForm(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, BookingEngineForm);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "bookingCriteriaNode", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setShouldFetchProposals", function () {
      var queryParams = _this.props.queryParams;
      var fetch = queryParams.fetch;
      var shouldFetch = Boolean(fetch && "".concat(fetch) === '1');
      return function () {
        _this.setState({
          shouldFetchProposals: shouldFetch
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "checkLoading", function () {
      if (_this.props.suggestions.dates.length > 0 || _this.props.suggestions.durations.length > 0 || _this.props.suggestions.resorts.length > 0 || // errors are so badly handle that it's easier to check if there is no proposal rather that there is an error
      _this.props.proposals.some(function (_ref) {
        var id = _ref.id;
        return !id;
      }) || _this.props.proposals.some(function (proposal) {
        return proposal.price.gap > proposals_constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];
      })) {
        _this.props.endLoading();
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleDepartureDate", function () {
      var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var newDepartureDate = moment_default()(String(day === null || day === void 0 ? void 0 : day.id)).valueOf();

      if (_this.props.departureDate !== (day === null || day === void 0 ? void 0 : day.id)) {
        _this.props.setDepartureDate(newDepartureDate);
      }

      _this.props.updateTripDateCriteria({
        day: day
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onFormSubmit", function (event) {
      event.preventDefault();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getPackages", function (newArrivalDate) {
      var router = _this.props.router;

      var fetchParams = _objectSpread(_objectSpread({
        productId: _this.props.resort.id,
        departureCity: _this.props.departureCity,
        duration: _this.props.duration,
        isJoyView: _this.props.resort.isJoyview,
        // $FlowFixMe it's a recomposition
        globalLoaderLabel: _this.context.isSeller ? _this.props.i18n.booking.partners.form.proposalsLoaderLabel : _this.props.i18n.booking.form.proposalsLoaderLabel
      }, Object(sellerUtils["f" /* isSeller */])(_this.context) ? Object(ContactInfoUtils["f" /* getAllAttendeesIds */])(_this.props.tripInformation) : null), {}, {
        newArrivalDate: newArrivalDate,
        bookingEngineEntry: booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR
      });

      return _this.props.fetchProposalsAndRedirect(fetchParams, _this.context, router);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "redirectToBE", function (newArrivalDate) {
      _this.setState({
        showModal: false
      });

      _this.getPackages(newArrivalDate).then(function () {
        _this.setState({
          showModal: true
        });
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldDisplayModal", function () {
      return _this.hasCounterProposals() && _this.canDisplayCounterProposals() && _this.state.showModal;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToBookingEngine", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _this$props, resort, router, proposals, attendees, setCms, setAttendees, prepareBe, _yield$fetchBookingEn, config, legalInformations, proposalId;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, resort = _this$props.resort, router = _this$props.router, proposals = _this$props.proposals, attendees = _this$props.attendees, setCms = _this$props.setCms, setAttendees = _this$props.setAttendees, prepareBe = _this$props.prepareBe;

              _this.setState({
                showModal: false
              });

              _context.next = 4;
              return Object(BookingEngineI18n_query["a" /* fetchBookingEngineI18nQuery */])(_this.context);

            case 4:
              _yield$fetchBookingEn = _context.sent;
              config = _yield$fetchBookingEn.config;
              legalInformations = _yield$fetchBookingEn.legalInformations;

              if (config && legalInformations) {
                setCms(config, legalInformations);
                setAttendees(attendees);
              }

              proposalId = proposals[0].id;
              prepareBe({
                resort: resort,
                proposals: {
                  proposals: proposals,
                  resort: resort
                },
                proposalId: proposalId
              });
              router.push(Object(BookingPagesUtils["j" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals, resort, proposalId, omit_default()(router.query, ['dynamicPage'])));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.state = {
      showModal: true,
      shouldFetchProposals: false,
      isDepartureDateAvailaible: true
    };
    _this.bookingCriteriaNode = /*#__PURE__*/Object(react["createRef"])();
    return _this;
  }

  Object(createClass["a" /* default */])(BookingEngineForm, [{
    key: "scrollToBookingEngineEntryPoint",
    value: function scrollToBookingEngineEntryPoint() {
      var _this2 = this;

      /**
       * The setTimeout is needed to make sure the modal is closed before trying to scroll
       */
      setTimeout(function () {
        var bookingEngineEntry = _this2.props.bookingEngineEntry;
        var PRICE_CALENDAR = booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR,
            PRICE_REMOTE = booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE;
        var bookingEngineFormSelector = document.querySelector(BOOKING_ENGINE_FORM_SELECTOR);
        var priceRemoteSelector = document.querySelector(price_remote_constants["c" /* PRICE_REMOTE_STICKY_WRAPPER_SELECTOR */]);

        if (bookingEngineEntry === PRICE_CALENDAR && bookingEngineFormSelector) {
          // $FlowFixMe the validity of this check in the condition above
          bookingEngineFormSelector.scrollIntoView();
        } else if (bookingEngineEntry === PRICE_REMOTE && priceRemoteSelector) {
          // $FlowFixMe the validity of this check in the condition above
          priceRemoteSelector.scrollIntoView();
        }
      }, 0);
    }
  }, {
    key: "setIsDepartureDateAvailaible",
    value: function setIsDepartureDateAvailaible(departureDate, offsetSell) {
      this.setState({
        isDepartureDateAvailaible: !Object(BookingPagesUtils["h" /* checkIsDepartureDateAvailaible */])(String(departureDate), offsetSell)
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // We assume that if we have proposals, it implies we come from the booking engine.
      this.props.clearSelectedProposal();
      this.props.clearProposals();
      this.setIsDepartureDateAvailaible(this.props.departureDate, this.props.bookingCriteria.offsetSell);
      /**
       * This setTimeout is needed also (plus the one used in scrollToBookingEngineEntryPoint)
       * because of a race condition with RouteChangeListener scroll (a bugfix for hash)
       * See RouteChangeListener line 29
       */

      setTimeout(function () {
        return _this3.scrollToBookingEngineEntryPoint();
      }, 0);
    }
    /**
     * #10731
     * This means the user comes from a metasearch and has already selected trip criterias.
     * We force fetching proposals to avoid one more click on continue button
     * but we cannot make the query on componentDidMount hook because state is not yet hydrated from query params
     * arrivalDate is mandatory and will be set after calendar did mount.
     * See PriceCalendar & didMountCallback
     * url format: ?duration=6&date=2019-04-30&number_of_adults=2&kids=2015-03-02_2014-12-20&fetch=1&_ab2=b
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.departureDate !== prevProps.departureDate) {
        this.setIsDepartureDateAvailaible(this.props.departureDate, this.props.bookingCriteria.offsetSell);
      }

      if (this.state.shouldFetchProposals && !prevState.shouldFetchProposals && this.bookingCriteriaNode.current) {
        // $FlowFixMe
        this.bookingCriteriaNode.current.onSubmit();
      }

      var oldProposal = prevProps.proposals[0];
      var newProposal = this.props.proposals[0];

      if (!isEqual_default()(oldProposal, newProposal) || !isEqual_default()(prevProps.suggestions, this.props.suggestions)) {
        this.checkLoading(); // scroll to errors if any

        if (Object(proposalUtils["q" /* hasErroredProposals */])(this.props.proposals) || this.hasCounterProposals() && !this.canDisplayCounterProposals()) {
          // the setTimeout is needed to make sure the global loader is closed before trying to scroll
          setTimeout(function () {
            Object(scrollToElement["a" /* scrollToElement */])('#Package-error', 600, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
          });
        }
      } // makes sure the counter proposal modal will be closed on resort change


      if (prevProps.resort.id !== this.props.resort.id) {
        this.setState({
          showModal: false
        });
      }
    }
    /**
     * In case the fetch proposals return counter proposals the global loader stay so we need to end it ourself
     * IT stay because we want to keep it when we redirect to the BE for prevent any flickering
     */

  }, {
    key: "canDisplayCounterProposals",
    value: function canDisplayCounterProposals() {
      var _this$props$proposals, _this$props$proposals2;

      return ((_this$props$proposals = this.props.proposals[0]) === null || _this$props$proposals === void 0 ? void 0 : (_this$props$proposals2 = _this$props$proposals.price) === null || _this$props$proposals2 === void 0 ? void 0 : _this$props$proposals2.gap) >= proposals_constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */] || this.props.suggestions.dates.length > 0 || this.props.suggestions.durations.length > 0 || this.props.suggestions.resorts.length > 0;
    }
  }, {
    key: "hasCounterProposals",
    value: function hasCounterProposals() {
      var _proposal$price;

      var proposal = this.props.proposals[0];
      var _this$props$suggestio = this.props.suggestions,
          dates = _this$props$suggestio.dates,
          durations = _this$props$suggestio.durations,
          resorts = _this$props$suggestio.resorts;
      return dates.length > 0 || durations.length > 0 || resorts.length > 0 || !isEmpty_default()(proposal) && (proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.gap) >= proposals_constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$bookingCo,
          _this$props$bookingCo2,
          _this$props$bookingCo3,
          _this$props$bookingCo4,
          _this$props$resort,
          _this$props$resort2,
          _this4 = this,
          _this$props$proposals3;

      var failedProposals = Object(proposalUtils["q" /* hasErroredProposals */])(this.props.proposals);

      var i18n = _objectSpread(_objectSpread({}, this.props.i18n), {}, {
        adultAge: get_default()(this.props, 'bookingConfig.form.adultAge'),
        bookingCriteria: this.props.bookingCriteria,
        childrenBirthdayDateFormatPlaceholder: get_default()(this.props, 'bookingConfig.form.childrenBirthdayDateFormatPlaceholder'),
        dateFormat: get_default()(this.props, 'bookingConfig.form.dateFormat'),
        dayPlaceholder: get_default()(this.props, 'bookingConfig.form.dayPlaceholder'),
        monthPlaceholder: get_default()(this.props, 'bookingConfig.form.monthPlaceholder'),
        yearPlaceholder: get_default()(this.props, 'bookingConfig.form.yearPlaceholder'),
        dateValidate: get_default()(this.props, 'bookingConfig.form.dateValidate'),
        durationTitle: get_default()(this.props, 'bookingConfig.form.durationTitle'),
        durationOptionsFormat: get_default()(this.props, 'bookingConfig.form.selectDuration'),
        selectAdultsLabels: get_default()(this.props, 'bookingConfig.form.selectAdultsLabels'),
        selectChildrenLabels: get_default()(this.props, 'bookingConfig.form.selectChildrenLabels'),
        legalNotice: get_default()(this.props, 'bookingConfig.form.legalNotice'),
        minAgeInformation: get_default()(this.props, 'resort.minAuthorizedAge.formattedValue'),
        birthdayFormatErrorMessage: get_default()(this.props, 'bookingConfig.form.errors.birthdayFormat'),
        adultAgeErrorMessage: get_default()(this.props, 'bookingConfig.form.errors.adultChild'),
        skiPassIncludedLabel: get_default()(this.props, 'bookingConfig.form.reinsurance.skiPassIncludedLabel'),
        skiPassIncludedDescription: get_default()(this.props, 'bookingConfig.form.reinsurance.skiPassIncludedDescription'),
        kidStayIncludedLabel: get_default()(this.props, 'bookingConfig.form.reinsurance.kidStayIncludedLabel'),
        didYouKnowLabel: get_default()(this.props, 'bookingConfig.form.reinsurance.didYouKnowLabel'),
        kidStayIncludedDescription: get_default()(this.props, 'bookingConfig.form.reinsurance.kidStayIncludedDescription'),
        minAgeErrorMessage: get_default()(this.props, 'resort.minAgeErrorMessage.formattedValue'),
        proposalsLoaderLabel: get_default()(this.props, 'bookingConfig.form.proposalsLoaderLabel')
      });

      Object(src_i18n["a" /* addTranslationKeys */])({
        booking: this.props.i18n.booking,
        common: this.props.i18n.common,
        package: this.props.i18n.package,
        priceRemote: this.props.i18n.priceRemote,
        resort: this.props.i18n.resort,
        bookingConfig: {
          form: {
            legalNotice: (_this$props$bookingCo = this.props.bookingConfig) === null || _this$props$bookingCo === void 0 ? void 0 : (_this$props$bookingCo2 = _this$props$bookingCo.form) === null || _this$props$bookingCo2 === void 0 ? void 0 : _this$props$bookingCo2.legalNotice
          }
        }
      });
      return BookingEngineForm_jsx(SiteContainer["a" /* SiteContainer */], {
        className: "bg-lightSand"
      }, BookingEngineForm_jsx("form", {
        className: "py-30 lg:py-40",
        id: "booking",
        onSubmit: this.onFormSubmit
      }, BookingEngineForm_jsx("h2", {
        className: "air360-replay-ignore border-b-1 border-sand font-bold font-brand leading-tight mb-20 pb-10 lg:pb-20 text-black text-24 md:text-28",
        "data-cs-mask": true
      }, (_this$props$bookingCo3 = this.props.bookingConfig) === null || _this$props$bookingCo3 === void 0 ? void 0 : (_this$props$bookingCo4 = _this$props$bookingCo3.form) === null || _this$props$bookingCo4 === void 0 ? void 0 : _this$props$bookingCo4.title), BookingEngineForm_jsx(BookingCriteriaContainer, {
        myRef: this.bookingCriteriaNode,
        adultOnly: get_default()(this.props, 'resort.adultOnly'),
        isWinterResort: Object(resortUtils["b" /* isWinterResort */])(this.props.resort),
        adultsNumber: this.props.adultsNumber,
        bookingConfig: this.props.bookingConfig,
        duration: this.props.duration,
        departureDate: this.props.departureDate,
        isDepartureDateAvailaible: this.state.isDepartureDateAvailaible,
        departureCity: this.props.departureCity,
        enableTransfer: get_default()(this.props, 'bookingConfig.enableTransfer'),
        kids: this.props.kids,
        getPackages: this.getPackages,
        isJoyView: get_default()(this.props, 'resort.isJoyview', false),
        isTransportEnabled: get_default()(this.props, 'package.transport.enableTransport', false),
        pushImage: this.props.pushImage,
        config: this.props.config,
        childAge: get_default()(this.props, 'resort.minAuthorizedAge.value'),
        resort: get_default()(this.props, 'resort'),
        i18n: i18n
      }, BookingEngineForm_jsx(PriceCalendar_PriceCalendar, {
        bookingConfig: this.props.bookingConfig,
        cmsPrice: this.props.cmsPrice,
        cmsStartingPrice: this.props.cmsStartingPrice,
        duration: this.props.duration,
        didMountCallback: this.setShouldFetchProposals(),
        isJoyview: !!((_this$props$resort = this.props.resort) === null || _this$props$resort === void 0 ? void 0 : _this$props$resort.isJoyview),
        key: (_this$props$resort2 = this.props.resort) === null || _this$props$resort2 === void 0 ? void 0 : _this$props$resort2.id,
        offsetSell: this.props.bookingCriteria.offsetSell,
        onSelectDate: this.handleDepartureDate,
        product: this.props.resort,
        productId: this.props.resort.id,
        selectedDay: this.props.departureDate,
        transport: this.props.departureCity,
        travelAdvisorConfig: this.props.travelAdvisorConfig
      })), !this.state.isDepartureDateAvailaible || failedProposals || this.props.proposals.some(function (proposal) {
        return proposal.price && proposal.price.gap >= proposals_constants["x" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */] && !Object(sellerUtils["f" /* isSeller */])(_this4.context);
      }) ? BookingEngineForm_jsx(BookingErrors["a" /* BookingErrors */], {
        className: "mt-20 md:mt-30",
        errorCode: (_this$props$proposals3 = this.props.proposals.find(function (_ref3) {
          var errorCode = _ref3.errorCode;
          return !!errorCode;
        })) === null || _this$props$proposals3 === void 0 ? void 0 : _this$props$proposals3.errorCode
      }) : null, this.shouldDisplayModal() && BookingEngineForm_jsx(AlternativeProposalsModal["a" /* AlternativeProposalsModal */], {
        trackingDefaultPayload: {
          categoryGA: 'resort',
          actionGA: 'checkPricesKO'
        },
        searchCriteria: {
          arrivalDate: String(this.props.arrivalDate),
          duration: this.props.duration,
          adultsCount: this.props.adultsNumber,
          kidsCount: this.props.kids.length,
          departureCity: this.props.departureCity
        } // $FlowFixMe
        ,
        i18n: i18n,
        onClose: this.props.clearProposals,
        onSubmit: this.redirectToBE,
        proposals: this.props.proposals,
        suggestions: this.props.suggestions,
        resort: this.props.resort,
        goToBookingEngine: this.goToBookingEngine,
        bookingEngineEntryPoint: this.props.bookingEngineEntry,
        scrollToBookingEngineEntryPoint: function scrollToBookingEngineEntryPoint() {
          return _this4.scrollToBookingEngineEntryPoint();
        },
        onSelectNewDuration: function onSelectNewDuration(_ref4) {
          var proposalIds = _ref4.proposalIds;

          var queryParams = _objectSpread(_objectSpread({}, omit_default()(_this4.props.router.query, ['dynamicPage'])), {}, {
            proposalIds: proposalIds,
            selectedProposalId: proposalIds[0]
          });

          _this4.props.router.push(routeBuilder["a" /* buildUrl */]('booking', {
            page: BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */]
          }, queryParams));
        }
      })));
    }
  }]);

  return BookingEngineForm;
}(react["Component"]);

Object(defineProperty["a" /* default */])(BookingEngineForm_BookingEngineForm, "defaultProps", defaultProps);

Object(defineProperty["a" /* default */])(BookingEngineForm_BookingEngineForm, "contextType", ReactAppContext["a" /* B2CAppContext */]);

/* harmony default export */ var booking_engine_form_BookingEngineForm = (Object(next_router["withRouter"])(BookingEngineForm_BookingEngineForm));
// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/BookingEngineForm.container.jsx













function BookingEngineForm_container_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingEngineForm_container_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingEngineForm_container_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingEngineForm_container_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















function getValue(value, initialValue) {
  return !value && initialValue ? initialValue : value;
}

function getQueryParamValue(name, queryParams) {
  return get_default()(queryParams, name);
}

function getValidDepartureCity(state, props) {
  var _props$bookingCriteri;

  var availableTransports = (props === null || props === void 0 ? void 0 : (_props$bookingCriteri = props.bookingCriteria) === null || _props$bookingCriteri === void 0 ? void 0 : _props$bookingCriteri.departureCities) || [];
  var transportIATACodes = availableTransports.map(function (t) {
    return t.value;
  });
  var departureCity = Object(tripCriteria_selector["a" /* getDepartureCity */])(state) || getQueryParamValue(uri_constants["m" /* QUERY_TRANSPORT */], props.queryParams);
  return transportIATACodes.includes(departureCity) ? departureCity : '';
} // $FlowFixMe


function BookingEngineForm_container_mapStateToProps(state, props) {
  var _props$bookingCriteri2, _props$bookingCriteri3;

  var kids = Object(trip_information_storeHelper["c" /* getKids */])(state);
  var adults = Object(trip_information_storeHelper["a" /* getAdults */])(state).length;
  var duration = Object(tripCriteria_selector["c" /* getTripDuration */])(state);
  var departureCity = getValidDepartureCity(state, props);
  var departureDate = Object(storeHelper["b" /* getDepartureDate */])(state);
  return {
    adultsNumber: getValue(adults, props === null || props === void 0 ? void 0 : (_props$bookingCriteri2 = props.bookingCriteria) === null || _props$bookingCriteri2 === void 0 ? void 0 : _props$bookingCriteri2.initialNumberOfAdults) || constants["a" /* DEFAULT_ADULTS_NB */],
    arrivalDate: Object(storeHelper["a" /* getArrivalDate */])(state),
    bookingEngineEntry: state.booking.bookingEngineEntry,
    departureDate: departureDate,
    departureCity: departureCity,
    duration: getValue(duration, props === null || props === void 0 ? void 0 : (_props$bookingCriteri3 = props.bookingCriteria) === null || _props$bookingCriteri3 === void 0 ? void 0 : _props$bookingCriteri3.initialDuration) || duration_constants["b" /* DEFAULT_TRIP_DURATION */],
    kids: Object(tripInformationUtils["b" /* getResortInitialKids */])(kids, get_default()(props, 'bookingCriteria.initialNumberOfChildren'), get_default()(props, 'resort.adultOnly')),
    proposals: Object(booking_selector["u" /* getProposals */])(state),
    selectedProposalId: Object(booking_selector["x" /* getSelectedProposalId */])(state),
    resort: BookingEngineForm_container_objectSpread(BookingEngineForm_container_objectSpread({}, Object(booking_selector["k" /* getCurrentResort */])(state)), props.resort),
    attendees: Object(booking_selector["m" /* getDetailedAttendees */])(state),
    tripInformation: Object(trip_information_storeHelper["d" /* tripInformationSelector */])(state),
    suggestions: Object(booking_selector["z" /* getSuggestions */])(state)
  };
}
var BookingEngineForm_container_mapDispatchToProps = {
  clearProposals: proposals_action["e" /* clearProposals */],
  endLoading: globalLoader_action["c" /* endLoading */],
  startLoading: globalLoader_action["d" /* startLoading */],
  updateTripDateCriteria: tripDateCriteria_action["a" /* updateTripDateCriteria */],
  setDepartureDate: departureDate_action["a" /* setDepartureDate */],
  clearSelectedProposal: selectedProposalId_action["c" /* clearSelectedProposal */],
  selectProposal: selectedProposalId_action["d" /* selectProposal */],
  fetchProposalsAndRedirect: proposals_action["j" /* fetchProposalsAndRedirect */],
  setCms: cms_actions["d" /* setCms */],
  setAttendees: adults_action["b" /* setAttendees */],
  prepareBe: proposals_action["p" /* prepareBe */]
};
/* harmony default export */ var BookingEngineForm_container = __webpack_exports__["a"] = (Object(es["c" /* connect */])(BookingEngineForm_container_mapStateToProps, BookingEngineForm_container_mapDispatchToProps)(booking_engine_form_BookingEngineForm));

/***/ }),

/***/ "JeoY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.createErrorFactory = createErrorFactory;
exports.default = createValidation;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("LdEA"));

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _mapValues = _interopRequireDefault(__webpack_require__("y2Ah"));

var _ValidationError = _interopRequireDefault(__webpack_require__("fnDY"));

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _synchronousPromise = __webpack_require__("V5RX");

var formatError = _ValidationError.default.formatError;

var thenable = function thenable(p) {
  return p && typeof p.then === 'function' && typeof p.catch === 'function';
};

function runTest(testFn, ctx, value, sync) {
  var result = testFn.call(ctx, value);
  if (!sync) return Promise.resolve(result);

  if (thenable(result)) {
    throw new Error("Validation test of type: \"" + ctx.type + "\" returned a Promise during a synchronous validate. " + "This test will finish after the validate call has returned");
  }

  return _synchronousPromise.SynchronousPromise.resolve(result);
}

function resolveParams(oldParams, newParams, resolve) {
  return (0, _mapValues.default)((0, _extends2.default)({}, oldParams, newParams), resolve);
}

function createErrorFactory(_ref) {
  var value = _ref.value,
      label = _ref.label,
      resolve = _ref.resolve,
      originalValue = _ref.originalValue,
      opts = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["value", "label", "resolve", "originalValue"]);
  return function createError(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$path = _ref2.path,
        path = _ref2$path === void 0 ? opts.path : _ref2$path,
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? opts.message : _ref2$message,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? opts.name : _ref2$type,
        params = _ref2.params;

    params = (0, _extends2.default)({
      path: path,
      value: value,
      originalValue: originalValue,
      label: label
    }, resolveParams(opts.params, params, resolve));
    return (0, _extends2.default)(new _ValidationError.default(formatError(message, params), value, path, type), {
      params: params
    });
  };
}

function createValidation(options) {
  var name = options.name,
      message = options.message,
      test = options.test,
      params = options.params;

  function validate(_ref3) {
    var value = _ref3.value,
        path = _ref3.path,
        label = _ref3.label,
        options = _ref3.options,
        originalValue = _ref3.originalValue,
        sync = _ref3.sync,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["value", "path", "label", "options", "originalValue", "sync"]);
    var parent = options.parent;

    var resolve = function resolve(item) {
      return _Reference.default.isRef(item) ? item.getValue({
        value: value,
        parent: parent,
        context: options.context
      }) : item;
    };

    var createError = createErrorFactory({
      message: message,
      path: path,
      value: value,
      originalValue: originalValue,
      params: params,
      label: label,
      resolve: resolve,
      name: name
    });
    var ctx = (0, _extends2.default)({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options
    }, rest);
    return runTest(test, ctx, value, sync).then(function (validOrError) {
      if (_ValidationError.default.isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
    });
  }

  validate.OPTIONS = options;
  return validate;
}

/***/ }),

/***/ "JevA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var parseInt = __webpack_require__("wg0c");

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt !== parseInt }, {
  parseInt: parseInt
});


/***/ }),

/***/ "Jsmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tripInformationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdultsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKids; });
/* unused harmony export getMainContactOptins */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);

var tripInformationSelector = function tripInformationSelector(state) {
  return (state === null || state === void 0 ? void 0 : state.tripInformation) || {};
};

var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var getAdults = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref2) {
  var adults = _ref2.adults;
  return adults || [];
});
var getAdultsNumber = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref3) {
  var adults = _ref3.adults;
  return (adults || []).length;
});
var getKids = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref4) {
  var kids = _ref4.kids;
  return kids || [];
});
var getMainContactOptins = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var mainContact = _ref5.mainContact;
  return mainContact;
});


/***/ }),

/***/ "Lc/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRICE_REMOTE_STICKY_WRAPPER_SELECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRICE_REMOTE_FORM_ID; });
var PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME = 'PriceRemoteStickyWrapper-initialPosition';
var PRICE_REMOTE_STICKY_WRAPPER_SELECTOR = ".".concat(PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME);
var PRICE_REMOTE_FORM_ID = 'price-remote-form';

/***/ }),

/***/ "LdEA":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "Lo6J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = setLocale;

var _locale = _interopRequireDefault(__webpack_require__("qr7w"));

function setLocale(custom) {
  Object.keys(custom).forEach(function (type) {
    Object.keys(custom[type]).forEach(function (method) {
      _locale.default[type][method] = custom[type][method];
    });
  });
}

module.exports = exports["default"];

/***/ }),

/***/ "M3jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTransport; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("1JJ2");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("7amT");





var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

/* eslint-disable clubmed/no-fake-component */








var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["constants"].NO_TRANSPORT_VALUE;
var FilterTransport = function FilterTransport(_ref) {
  var changeDepartureCity = _ref.changeDepartureCity,
      className = _ref.className,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'FilterTransport' : _ref$dataTestId,
      departureCity = _ref.departureCity,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      optionsDepartureCities = _ref.optionsDepartureCities,
      toggleCriteriaExpansion = _ref.toggleCriteriaExpansion,
      validateDepartureCity = _ref.validateDepartureCity,
      withNoTransport = _ref.withNoTransport,
      _ref$shouldShowNoTran = _ref.shouldShowNoTransportButtonMobile,
      shouldShowNoTransportButtonMobile = _ref$shouldShowNoTran === void 0 ? true : _ref$shouldShowNoTran;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_9__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var value = departureCity || '';
  var loading = isLoading || optionsDepartureCities.length === 0;
  var otherDepartureCities = withNoTransport ? optionsDepartureCities : optionsDepartureCities.filter(function (_ref2) {
    var departureCityCode = _ref2.value;
    return departureCityCode !== NO_TRANSPORT_VALUE;
  });
  var mainCities = Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* getListValue */ "e"])('faceting.transport.departureCities.mainCitiesList') || [];
  var optionsMainDepartureCities = optionsDepartureCities.filter(function (_ref3) {
    var cityCode = _ref3.value;
    return mainCities.includes(cityCode);
  });

  var renderTitle = function renderTitle(shouldShowNoTransportButton) {
    if (!isDesktop) {
      return __jsx("div", {
        className: "flex flex-col"
      }, shouldShowNoTransportButton && __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('py-15 px-20', {
          'font-bold text-success': value === NO_TRANSPORT_VALUE
        })
      }, __jsx("label", {
        className: "rounded-2 hocus:bg-lightGrey cursor-pointer flex items-baseline justify-between",
        htmlFor: NO_TRANSPORT_VALUE
      }, __jsx("input", {
        checked: value === NO_TRANSPORT_VALUE,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(NO_TRANSPORT_VALUE),
        disabled: isDisabled,
        id: NO_TRANSPORT_VALUE,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        onClick: function onClick(e) {
          return validateDepartureCity(e.target.value);
        },
        type: "radio",
        value: NO_TRANSPORT_VALUE
      }), Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.noTransportNeededMobile'), value === NO_TRANSPORT_VALUE && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      }))), __jsx("div", {
        className: "border-b-1 border-lightGrey p-20 py-15"
      }, __jsx("p", {
        className: "font-bold  text-16"
      }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.transportNeededMobile'))));
    }

    return __jsx("div", {
      className: "border-b-1 border-lightGrey p-20 py-15"
    }, __jsx("p", {
      className: "font-bold  text-16"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.when.from')));
  };

  var renderDepartureCitiesOptions = function renderDepartureCitiesOptions(departureCities) {
    return departureCities.map(function (o) {
      return __jsx("li", {
        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()({
          'font-bold text-success': o.value === value
        }),
        key: o.value
      }, __jsx("label", {
        className: "-mx-20 px-20 rounded-2 hocus:bg-lightGrey cursor-pointer flex items-baseline justify-between py-5",
        htmlFor: o.value
      }, __jsx("input", {
        checked: o.value === value,
        className: "hidden",
        "data-testid": "".concat(dataTestId, "-").concat(o.value),
        disabled: o.isDisabled || isDisabled,
        id: o.value,
        name: "TransportSelectFilter",
        onChange: function onChange(e) {
          return changeDepartureCity(e.target.value, toggleCriteriaExpansion);
        },
        type: "radio",
        value: o.value
      }), o.label, o.value === value && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_11__[/* Icon */ "a"], {
        name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_8__[/* ICONS */ "a"].CHECK,
        width: "0.625rem"
      })));
    });
  };

  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('flex flex-col', className),
    "data-testid": "FilterTransport"
  }, renderTitle(shouldShowNoTransportButtonMobile), loading ? __jsx("div", {
    className: "flex-1 flex items-center justify-center leading-0 p-20"
  }, __jsx(_frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_12__[/* Spinner */ "a"], {
    size: "small"
  })) : __jsx("div", {
    className: "max-h-none overflow-y-auto text-14 px-20",
    style: isDesktop ? {
      maxHeight: 'calc(240rem / 16)'
    } : {}
  }, optionsMainDepartureCities.length > 0 && __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx("p", {
    className: "border-b-1 border-grey text-mediumGrey border-dashed py-5"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.mainCities')), __jsx("ul", {
    className: "flex-1 lg:flex-none  pb-5 mb-10"
  }, renderDepartureCitiesOptions(optionsMainDepartureCities)), __jsx("p", {
    className: "border-b-1 border-grey text-mediumGrey border-dashed py-5"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_10__[/* t */ "h"])('faceting.transport.departureCities.allCities'))), __jsx("ul", {
    className: "flex-1 lg:flex-none "
  }, renderDepartureCitiesOptions(otherDepartureCities))));
};

/***/ }),

/***/ "MAH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchValidationSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttendeesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return proposalsByIdQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return streetViewsByAccommodationCategoryId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getValidationSchema; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("QsI/");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("H0gB");
/* harmony import */ var _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("SQLw");
/* harmony import */ var _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("BYx+");
/* harmony import */ var _store_validation_schema_validationSchemaField_fragment__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("2GfD");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("70jX");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("L7OA");
















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
function getResort() {
  var fetchActivityCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "\n    resort {\n      accommodations {\n        area {\n          max\n          min\n          unit\n        }\n        bathroomEquipments {\n          id\n          label\n        }\n        category\n        categoryId\n        comfortId\n        comfortType\n        connectingRoom\n        description\n        equipments {\n          id\n          label\n          ranking\n        }\n        exclusiveCollection\n        floorPlans\n        id\n        label\n        maxCapacity\n        media {\n          photos {\n            url\n          }\n        }\n        minCapacity\n        outsideFacilities {\n          id\n          label\n        }\n        ranking\n        roomType\n        services {\n          id\n          label\n          ranking\n        }\n        strengths {\n          id\n          label\n        }\n        surface\n        view {\n          id\n          label\n        }\n      }\n      thematicActivityTree {\n        ...thematics\n        activities {\n          ...activity\n        }\n      }\n      ".concat(fetchActivityCategories ? "activityTree {\n        ...activityCategory\n        activities {\n          ...activity\n        }\n        categories {\n          ...activityCategory\n          activities {\n            ...activity\n          }\n          categories {\n            ...activityCategory\n            activities {\n              ...activity\n            }\n          }\n        }\n      }" : '', "\n      adultOnly\n      associatedResort{\n        id\n        name\n      }\n      badgeIcon\n      category\n      childcareDetails {\n        isIncluded: included\n        ageInMonths {\n          min\n          max\n        }\n      }\n      childrenActivities: productActivities(idFilter: \"").concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        ageInMonths {\n          max\n          min\n        }\n        description\n        equipments {\n          id\n          label\n        }\n        id\n        isIncluded\n        label\n        subtitle\n      }\n      color\n      comfort\n      comfortLabel\n      destination {\n        area\n        country\n      }\n      facilities(types: [\"CHILDREN\",\"PARKING\"], withEquipments: true) {\n        equipments {\n          id\n          label\n        }\n        label\n        subtitle\n        type\n      }\n      factSheetUrl\n      href\n      id\n      image\n      images\n      hasECSpace\n      isCruise\n      isExclusiveCollection\n      isExplicitEC\n      isJoyview\n      isWinter\n      name\n      offsetSell\n      openingDates {\n        opening\n        closing\n      }\n      ").concat(fetchActivityCategories ? "rentalsTree {\n        ...rentals\n      }" : '', "\n      seasonName\n      seasons\n      title\n      transportType\n      type\n      ").concat(fetchActivityCategories ? "activityCategories {\n        leisure {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            startDate\n            endDate\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n        wellness {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n      }" : '', "\n    }");
}

function getValidationSchema(proposalIds, resource, locale) {
  var proposalId = Array.isArray(proposalIds) ? proposalIds[0] : proposalIds;
  return "\n    {\n      validationSchema(\n        proposalId: \"".concat(proposalId || '', "\",\n        resource : \"").concat(resource, "\",\n        fields: [\"address\"],\n        locale: \"").concat(locale || '', "\") {\n        ...ValidationSchemaField\n      }\n    }\n    ").concat(_store_validation_schema_validationSchemaField_fragment__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"], "\n    ");
}

function fetchValidationSchema(_x, _x2, _x3) {
  return _fetchValidationSchema.apply(this, arguments);
}

function _fetchValidationSchema() {
  _fetchValidationSchema = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee(proposalId, appContext, resource) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery(getValidationSchema(proposalId, resource), appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* PROPOSAL_GET_SCHEMA */ "Pc"]
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchValidationSchema.apply(this, arguments);
}

var getAttendeesData = function getAttendeesData(_ref) {
  var adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return "".concat(adultsAttendeesIds && adultsAttendeesIds[0] ? "adultsAttendees: attendees(attendeesIds: [\"".concat(adultsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n          birthdate: dateOfBirth\n          email\n          mobile: mobilePhoneNumber\n          optinEmail\n          optinSms\n          optinPhone\n          optinMail\n          optinClubmedPlus\n          identityNumber\n          healthPassId\n          address {\n            streetNumber\n            streetName\n            additionalInformation1\n            additionalInformation2\n            addOn\n            zipCode\n            city\n            town\n            stateOrDistrict\n            countryCode\n            country\n          }\n          document {\n            passport {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n              birthCountry\n              type\n            }\n            idcard {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n              birthCountry\n              type\n            }\n          }\n        }") : '', "\n  ").concat( // no need of birthday, we already have it
  kidsAttendeesIds && kidsAttendeesIds[0] ? "kidsAttendees: attendees(attendeesIds: [\"".concat(kidsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n          healthPassId\n          document {\n            passport {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n            }\n            idcard {\n              documentNumber\n              issuingCountry\n              expirationDate\n              issuingDate\n            }\n          }\n        }") : '', "\n");
};
/*
 * * Used in fetchProposalsById to get transports list and node for <TransportsSection/>
 * * Uses  API route /v2/proposals/{proposal_id}
 */


function proposalsByIdQuery(_x4, _x5) {
  return _proposalsByIdQuery.apply(this, arguments);
}
/*
 * * Used in fetchStreetViewsByAccommodationCategoryId to get street views list for <AccommodationRoomSlideshow/>
 * * Uses  API route GET /v0/products/{product_id}/accommodation_categories/{accommodation_category_id}/virtual_visits
 */


function _proposalsByIdQuery() {
  _proposalsByIdQuery = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee2(params, appContext) {
    var _proposalsResponse$pr, _params$adultsAttende, _params$kidsAttendees;

    var proposalsArgs, displayCommission, proposalsResponse, proposals, selectedProposal, adultsAttendeesIds, kidsAttendeesIds, hasAttendeeIds, validationSchema, attendeesResponse;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalsArgs = ["ids: [\"".concat(Array.isArray(params.proposalsId) ? params.proposalsId.join('","') : params.proposalsId, "\"]")];
            displayCommission = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_23__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
            _context2.next = 4;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery("\n      {\n        proposals: proposalsById(".concat(proposalsArgs.join(', '), ") {\n          ... on ProposalsType {\n            proposals {\n              ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* proposalFields */ "k"])({
              isJoyView: true,
              withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission,
              withSchedule: params.shouldRequestPayment
            }, appContext), "\n            }\n            ").concat(getResort(params.fetchActivityCategories), "\n          }\n        }\n        ").concat(appContext.isUserLogged ? 'profile {...BookingProfile}' : '', "\n        ").concat(params.shouldRequestPayment ? Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* paymentProvidersRequest */ "i"])() : '', "\n      }\n      ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* transportDetailsFragment */ "q"], "\n      ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_21__[/* getPriceDetailFragment */ "h"])(lodash_get__WEBPACK_IMPORTED_MODULE_14___default()(appContext, 'locale')), "\n      ").concat(appContext.isUserLogged ? _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_18__[/* profileFragment */ "a"] : '', "\n      ").concat(params.fetchActivityCategories ? _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* activityCategoryFragment */ "a"] : '', "\n      ").concat(params.fetchActivityCategories || _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* thematicFragment */ "g"] ? _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* activityFragment */ "b"] : '', "\n      ").concat(params.fetchActivityCategories ? _cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* rentalsFragment */ "f"] : '', "\n      ").concat(_cms_toolkit_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_16__[/* thematicFragment */ "g"], "\n    "), appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* PROPOSAL_GET_BY_ID */ "Nc"]
            });

          case 4:
            proposalsResponse = _context2.sent;
            proposals = ((_proposalsResponse$pr = proposalsResponse.proposals) === null || _proposalsResponse$pr === void 0 ? void 0 : _proposalsResponse$pr.proposals) || [];
            selectedProposal = params.selectedProposalId && proposals.find(function (_ref2) {
              var id = _ref2.id;
              return id === params.selectedProposalId;
            }) || proposals[0];

            if (selectedProposal) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", _objectSpread({}, proposalsResponse));

          case 9:
            adultsAttendeesIds = (params === null || params === void 0 ? void 0 : (_params$adultsAttende = params.adultsAttendeesIds) === null || _params$adultsAttende === void 0 ? void 0 : _params$adultsAttende.length) ? params.adultsAttendeesIds : ((selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.attendees.adults) || []).map(function (_ref3) {
              var customerId = _ref3.customerId;
              return customerId;
            }).filter(Boolean);
            kidsAttendeesIds = (params === null || params === void 0 ? void 0 : (_params$kidsAttendees = params.kidsAttendeesIds) === null || _params$kidsAttendees === void 0 ? void 0 : _params$kidsAttendees.length) ? params.kidsAttendeesIds : ((selectedProposal === null || selectedProposal === void 0 ? void 0 : selectedProposal.attendees.children) || []).map(function (_ref4) {
              var customerId = _ref4.customerId;
              return customerId;
            }).filter(Boolean);
            hasAttendeeIds = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(adultsAttendeesIds) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(kidsAttendeesIds);
            _context2.next = 14;
            return fetchValidationSchema(selectedProposal.id, appContext, 'profile');

          case 14:
            validationSchema = _context2.sent;

            if (!(!appContext.isSeller || !hasAttendeeIds)) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", _objectSpread(_objectSpread({
              selectedProposal: selectedProposal
            }, proposalsResponse), validationSchema));

          case 17:
            _context2.next = 19;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery("\n      {\n        ".concat( // When it is an attendee identified on the Cxo side we already know the customerIds
            // via the cxo_traveler query param
            getAttendeesData({
              adultsAttendeesIds: adultsAttendeesIds,
              kidsAttendeesIds: kidsAttendeesIds
            }), "\n      }\n      ").concat(appContext.isUserLogged ? 'profile {...BookingProfile}' : '', "\n      ").concat(adultsAttendeesIds && adultsAttendeesIds[0] || kidsAttendeesIds && kidsAttendeesIds[0] ? _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"] : '', "\n    "), appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* PROPOSAL_GET_BY_ID */ "Nc"]
            });

          case 19:
            attendeesResponse = _context2.sent;
            return _context2.abrupt("return", _objectSpread(_objectSpread(_objectSpread({
              selectedProposal: selectedProposal
            }, proposalsResponse), attendeesResponse), validationSchema));

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _proposalsByIdQuery.apply(this, arguments);
}

function streetViewsByAccommodationCategoryId(params, appContext) {
  var streetViewsArgs = ["productId: \"".concat(params.productId, "\"")];
  streetViewsArgs.push(Array.isArray(params.accommodationCategoryIds) ? "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds.join('","'), "\"]") : "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds, "\"]"));
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].runNoCacheQuery("\n    {\n      streetViews(".concat(streetViewsArgs.join(', '), ") {\n        accommodationCategoryId\n        streetView {\n          latitude\n          longitude\n          heading\n          pitch\n          fov\n          url\n        }\n      }\n    }\n  "), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_22__[/* STREET_VIEW_GET_SEVERAL */ "md"]
  });
}



/***/ }),

/***/ "MX/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_TRANSPORT_EVENT; });
var OPEN_CRITERIA_TRANSPORT_EVENT = 'openCriteriaTransport';

/***/ }),

/***/ "Mn1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripDateCriteriaSelector = function tripDateCriteriaSelector(_ref) {
  var tripDateCriteria = _ref.tripDateCriteria;
  return tripDateCriteria || {};
};

var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref2) {
  var arrivalDate = _ref2.arrivalDate;
  return arrivalDate;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref3) {
  var departureDate = _ref3.departureDate;
  return departureDate;
});


/***/ }),

/***/ "N5WC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tag_Tag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.themes.js



var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
        _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$colorBg,
        colorBorder = _ref.colorBorder;
    return {
      thRoot: classnames_default()("bg-".concat(colorBg, " border-1 border-").concat(colorBorder || colorBg, " text-").concat(color), 'font-bold font-sans gap-5 inline-flex items-center leading-1 overflow-hidden px-10 py-5 rounded-pill text-12 whitespace-nowrap')
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.jsx


var __jsx = react_default.a.createElement;




var Tag_Tag = function Tag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      iconName = _ref.iconName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "color", "colorBg", "colorBorder", "iconName", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color,
    colorBg: colorBg,
    colorBorder: colorBorder
  }),
      thRoot = _themes$theme.thRoot;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(thRoot, className)
  }), __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: color,
    name: iconName,
    width: "1em"
  }), children);
};

/***/ }),

/***/ "NXDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstallmentPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTotalPriceWithDonation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasAtLeastOnePrice; });
/* unused harmony export hasPrice */
/* unused harmony export isLongFormat */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("SYor");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kiXb");















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var MAX_LENGTH = 10;

function getCurrencySymbol(locale, currency) {
  return 0 .toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim();
}

function hasPrice(price) {
  return !!(price === null || price === void 0 ? void 0 : price.value);
}

var hasDiscount = function hasDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      initialPrice = _ref.initialPrice;
  return hasPrice(initialPrice) && hasPrice(bestPrice) && (initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.value) !== (bestPrice === null || bestPrice === void 0 ? void 0 : bestPrice.value);
};

function hasAtLeastOnePrice() {
  var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = price || {},
      initialPrice = _ref2.initialPrice,
      bestPrice = _ref2.bestPrice;

  return hasPrice(initialPrice) || hasPrice(bestPrice);
}

var isLongFormat = function isLongFormat(amount) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_LENGTH;
  return amount ? amount.toString().length > limit : false;
};

var getTotalPriceWithDonation = function getTotalPriceWithDonation(price, locale) {
  var donation = price.donation,
      total = price.total,
      totalWithoutDiscount = price.totalWithoutDiscount;

  var totalWithDonation = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(donation, 'value', 0) + lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(total, 'value', 0);

  var totalWithoutDiscountWithDonation = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(donation, 'value', 0) + lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(totalWithoutDiscount, 'value', 0);

  var currencyOptions = {
    precision: Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__["getBookingPrecision"])(locale)
  };
  return _objectSpread(_objectSpread({}, price), {}, {
    withDonation: {
      total: {
        value: totalWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithDonation, locale, price.currency, currencyOptions)
      },
      totalWithoutDiscount: {
        value: totalWithoutDiscountWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithoutDiscountWithDonation, locale, price.currency, currencyOptions)
      },
      hasFlexRates: price.hasFlexRates,
      selectedRate: price.selectedRate
    }
  });
};

var getInstallmentPrice = function getInstallmentPrice(price, locale) {
  if (!price || !price.value) {
    return '';
  }

  if (Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.displayInstalmentsPrice')) {
    var instalmentValue = Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.instalmentValue');
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.price.instalmentPrice', {
      instalmentValue: instalmentValue,
      dividedPrice: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(Math.ceil(price.value / instalmentValue), locale, price.currency, {
        precision: 0
      })
    });
  }

  return price.formattedValue;
};


/***/ }),

/***/ "NdXQ":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("kn3Q");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),

/***/ "O034":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return priceOfStaySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return priceOfStayArgsSelector; });
/* unused harmony export proposalsSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return priceOfStayIsLoadingSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shouldDisplayAlternativePriceTitleSelector; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _booking_proposals_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UIAR");
/* harmony import */ var _calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("05PS");
/* harmony import */ var _priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("l1aQ");
/* harmony import */ var _trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("RBO1");





var priceOfStaySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(_priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__[/* priceRemoteSelector */ "a"], function (_ref) {
  var data = _ref.priceOfStay.data;
  return data;
});
var priceOfStayArgsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(_priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__[/* priceRemoteSelector */ "a"], function (_ref2) {
  var priceOfStayArgs = _ref2.priceOfStay.priceOfStayArgs;
  return priceOfStayArgs;
});
var proposalsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(priceOfStaySelector, function (_ref3) {
  var proposals = _ref3.proposals;
  return proposals || {};
});
var priceOfStayIsLoadingSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_2__[/* getCalendarLoading */ "e"], _priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__[/* priceRemoteSelector */ "a"], _trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_4__[/* getDepartureDate */ "b"], _calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_2__[/* getBlockInputDepartureDate */ "b"], _trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_4__[/* getTripDuration */ "c"], function (calendarIsLoading, _ref4, departureDate, blockInputDepartureDate, duration) {
  var _ref4$priceOfStay = _ref4.priceOfStay,
      priceOfStayIsLoading = _ref4$priceOfStay.isLoading,
      lastRequestId = _ref4$priceOfStay.lastRequestId;
  return calendarIsLoading || (lastRequestId !== -1 || !blockInputDepartureDate && !!departureDate && !!duration) && priceOfStayIsLoading;
});
var shouldDisplayAlternativePriceTitleSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(_priceRemote_selector__WEBPACK_IMPORTED_MODULE_3__[/* priceRemoteSelector */ "a"], function (_ref5) {
  var _data$gap;

  var data = _ref5.priceOfStay.data;
  var gap = (_data$gap = data === null || data === void 0 ? void 0 : data.gap) !== null && _data$gap !== void 0 ? _data$gap : 0;
  return gap >= _booking_proposals_constants__WEBPACK_IMPORTED_MODULE_1__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "y"] && gap < _booking_proposals_constants__WEBPACK_IMPORTED_MODULE_1__[/* PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD */ "w"];
});

/***/ }),

/***/ "OBn4":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("vxC8"),
    root = __webpack_require__("IBsm");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "OhDV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = sortByKeyOrder;

function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    if (err.path.indexOf(key) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(fields) {
  var keys = Object.keys(fields);
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

module.exports = exports["default"];

/***/ }),

/***/ "Ohju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TemplateString; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4mDm");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Rm1S");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("3bBZ");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

var TEMPLATE_REGEXP = /{\w+}/g;

function escapeCurlyBrackets(string) {
  return (string.match(/\w+/) || [''])[0];
}

function generateTemplateNodes(_ref) {
  var staticClassName = _ref.staticClassName,
      _ref$template = _ref.template,
      template = _ref$template === void 0 ? '' : _ref$template,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values,
      _ref$valuesClassName = _ref.valuesClassName,
      valuesClassName = _ref$valuesClassName === void 0 ? {} : _ref$valuesClassName;
  var templateWithoutVariables = template.split(TEMPLATE_REGEXP) || [];
  var templateVariables = template.match(TEMPLATE_REGEXP) || [];
  return templateWithoutVariables.reduce(function (templateNodes, staticValue, index, array) {
    if (index === array.length - 1) {
      return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
        className: staticClassName,
        key: staticValue
      }, staticValue) : staticValue]);
    }

    var variableName = escapeCurlyBrackets(templateVariables[index]);
    return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
      className: staticClassName,
      key: staticValue
    }, staticValue) : staticValue, encapsulateWithClassName(values[variableName], variableName, valuesClassName[variableName])]);
  }, []);
}

function encapsulateWithClassName() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var keyName = arguments.length > 1 ? arguments[1] : undefined;
  var className = arguments.length > 2 ? arguments[2] : undefined;
  var v = value ? value.toString() : '';
  return className && v ? __jsx("span", {
    key: keyName,
    className: className
  }, v) : v;
}

var TemplateString = function TemplateString(_ref2) {
  var className = _ref2.className,
      dataTestId = _ref2.dataTestId,
      staticClassName = _ref2.staticClassName,
      _ref2$template = _ref2.template,
      template = _ref2$template === void 0 ? '' : _ref2$template,
      _ref2$values = _ref2.values,
      values = _ref2$values === void 0 ? {} : _ref2$values,
      valuesClassName = _ref2.valuesClassName;
  return template ? __jsx("span", {
    className: className,
    "data-testid": dataTestId
  }, generateTemplateNodes({
    staticClassName: staticClassName,
    template: template,
    values: values,
    valuesClassName: valuesClassName
  })) : null;
};

/***/ }),

/***/ "PFCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPARTURE_CITY; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cvSI");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _constants__WEBPACK_IMPORTED_MODULE_0__["n"]; });


var DEFAULT_DEPARTURE_CITY = 'NO';

/***/ }),

/***/ "PFSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHO_EVENT; });
var OPEN_CRITERIA_WHO_EVENT = 'openCriteriaWho';

/***/ }),

/***/ "PhFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasTooManyPax; });
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_utils_common_validator_CommonValidators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cjjV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sW3P");




var maxAge = _components_utils_common_validator_CommonValidators__WEBPACK_IMPORTED_MODULE_2__[/* maxAge */ "c"],
    minAge = _components_utils_common_validator_CommonValidators__WEBPACK_IMPORTED_MODULE_2__[/* minAge */ "d"],
    date = _components_utils_common_validator_CommonValidators__WEBPACK_IMPORTED_MODULE_2__[/* date */ "b"];
var API_DATE_FORMAT = 'YYYYMMDD';
function hasTooManyPax(adults, children, isSeller) {
  if (isSeller) {
    return false;
  }

  return adults + children > _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_3__[/* MAX_PAX */ "K"];
}

function getBirthDayErrorMessage(params) {
  var departureDate = params.departureDate,
      birthday = params.birthday,
      dateFormat = params.dateFormat,
      adultAge = params.adultAge,
      childAge = params.childAge,
      birthdayFormatErrorMessage = params.birthdayFormatErrorMessage,
      adultAgeErrorMessage = params.adultAgeErrorMessage,
      minAgeErrorMessage = params.minAgeErrorMessage;
  var onDate = departureDate ? String(departureDate) : '';
  var nowDate = moment__WEBPACK_IMPORTED_MODULE_1___default()().format(API_DATE_FORMAT);
  var adultAgeValidator = maxAge({
    ageRequired: +adultAge,
    birthdayFormat: dateFormat,
    onDate: nowDate,
    onDateFormat: API_DATE_FORMAT
  });
  var maxAgeValidator = maxAge({
    ageRequired: +adultAge,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var minAgeValidator = minAge({
    ageRequired: +childAge,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var isChildBorn = minAge({
    ageRequired: 0,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var dateValidator = date(dateFormat);

  if (!dateValidator.isValid(birthday) || !adultAgeValidator.isValid(birthday)) {
    return birthdayFormatErrorMessage;
  }

  if (!isChildBorn.isValid(birthday)) {
    return birthdayFormatErrorMessage;
  }

  if (!maxAgeValidator.isValid(birthday)) {
    return adultAgeErrorMessage;
  }

  if (!minAgeValidator.isValid(birthday)) {
    return minAgeErrorMessage;
  }

  return '';
}

function checkFormErrors(params) {
  var _params$adults = params.adults,
      adults = _params$adults === void 0 ? 2 : _params$adults,
      _params$children = params.children,
      children = _params$children === void 0 ? 0 : _params$children,
      _params$departureDate = params.departureDate,
      departureDate = _params$departureDate === void 0 ? '' : _params$departureDate,
      _params$birthdays = params.birthdays,
      birthdays = _params$birthdays === void 0 ? [] : _params$birthdays,
      dateFormat = params.dateFormat,
      adultAge = params.adultAge,
      _params$childAge = params.childAge,
      childAge = _params$childAge === void 0 ? 0 : _params$childAge,
      birthdayFormatErrorMessage = params.birthdayFormatErrorMessage,
      adultAgeErrorMessage = params.adultAgeErrorMessage,
      minAgeErrorMessage = params.minAgeErrorMessage,
      isSeller = params.isSeller;
  var birthdaysErrorMessage = birthdays.reduce(function (errorMessage, birthday) {
    return errorMessage || getBirthDayErrorMessage({
      dateFormat: dateFormat,
      departureDate: departureDate,
      adultAge: adultAge,
      childAge: childAge,
      birthday: birthday,
      birthdayFormatErrorMessage: birthdayFormatErrorMessage,
      adultAgeErrorMessage: adultAgeErrorMessage,
      minAgeErrorMessage: minAgeErrorMessage
    });
  }, null);
  var birthdaysNotValid = birthdays.length !== children || !!birthdaysErrorMessage;
  return {
    maxPax: hasTooManyPax(+adults, +children, isSeller),
    departureDate: !departureDate,
    birthdays: birthdaysNotValid,
    birthdaysErrorMessage: birthdaysErrorMessage || birthdaysNotValid && birthdayFormatErrorMessage || ''
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  checkFormErrors: checkFormErrors
});

/***/ }),

/***/ "PuIx":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("MzY2"),
    createAssigner = __webpack_require__("wpQC");

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ "Q8Qh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);

var themes = function themes(_ref) {
  var _ref$hasArrow = _ref.hasArrow,
      hasArrow = _ref$hasArrow === void 0 ? true : _ref$hasArrow;
  return {
    "default": {
      thBody: classnames__WEBPACK_IMPORTED_MODULE_0___default()('bg-white border-1 border-lightGrey mt-15 p-10 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-grey': hasArrow
      })
    },
    hollow: {
      thBody: classnames__WEBPACK_IMPORTED_MODULE_0___default()('bg-white border-1 border-lightGrey rounded-12 shadow-lg', {
        'arrow-up arrow-white arrow-bg arrow-bg-lightGrey': hasArrow
      })
    }
  };
};

/***/ }),

/***/ "QkNd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePriceOfStay; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("uDfI");
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Ub5k");
/* harmony import */ var _use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ngAq");
/* harmony import */ var _client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("05PS");
/* harmony import */ var _client_store_price_remote_price_of_stay_priceOfStay_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("cDU8");
/* harmony import */ var _client_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("RBO1");
/* harmony import */ var _client_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Jsmy");
/* harmony import */ var _client_store_price_remote_price_of_stay_priceOfStay_helper__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fuxG");
/* harmony import */ var _client_components_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("1JJ2");
/* harmony import */ var _client_store_price_remote_price_of_stay_priceOfStay_selector__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("O034");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("L7OA");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}














function usePriceOfStay(productId, departureCity) {
  var appContext = Object(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__[/* useAppContext */ "c"])();
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useDispatch */ "d"])();

  var _useResponsive = Object(_client_components_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_18__[/* useResponsive */ "b"])(),
      isAppMounted = _useResponsive.isAppMounted;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_8__["useRouter"])(),
      offerName = _useRouter.query.offer;

  var adults = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getAdults */ "a"]);
  var blockInputDepartureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__[/* getBlockInputDepartureDate */ "b"]);
  var calendarIsLoading = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__[/* getCalendarLoading */ "e"]);
  var calendarDepartureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__[/* getCalendarDepartureCity */ "d"]);
  var calendarProductId = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_13__[/* getCalendarProductId */ "f"]);
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_15__[/* getDepartureDate */ "b"]);
  var duration = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_15__[/* getTripDuration */ "c"]);
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_16__[/* getKids */ "c"]);
  var priceOfStayArgs = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_price_remote_price_of_stay_priceOfStay_selector__WEBPACK_IMPORTED_MODULE_19__[/* priceOfStayArgsSelector */ "a"]);
  var priceOfStayIsLoading = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(_client_store_price_remote_price_of_stay_priceOfStay_selector__WEBPACK_IMPORTED_MODULE_19__[/* priceOfStayIsLoadingSelector */ "b"]);

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_10__[/* useSelector */ "e"])(function (state) {
    return {
      priceOfStay: Object(_client_store_price_remote_price_of_stay_priceOfStay_selector__WEBPACK_IMPORTED_MODULE_19__[/* priceOfStaySelector */ "c"])(state),
      priceOfStayError: state.priceRemote.priceOfStay.error,
      priceTicketIsLoading: state.priceTicket.isLoading
    };
  }),
      priceOfStay = _useSelector.priceOfStay,
      priceOfStayError = _useSelector.priceOfStayError,
      priceTicketIsLoading = _useSelector.priceTicketIsLoading;

  var calendarSynchronized = calendarDepartureCity === departureCity && calendarProductId === productId;
  var calendarIsReady = calendarSynchronized && !calendarIsLoading;
  var hasValidCriteria = !blockInputDepartureDate && !!departureDate && !!duration;
  var withCustomCriteria = hasValidCriteria && calendarIsReady;

  var searchCriteria = _objectSpread(_objectSpread(_objectSpread({
    productId: productId,
    departureDate: withCustomCriteria ? departureDate : null,
    departureCity: departureCity,
    duration: duration
  }, kids && withCustomCriteria ? {
    kids: kids
  } : null), adults && withCustomCriteria ? {
    adults: adults
  } : null), {}, {
    offerName: offerName
  }); // Fixme: refactor kids and adults reducers so that their state does not change unnecessarily


  var debouncedSearchCriteria = Object(_use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_12__[/* useDebounce */ "a"])([departureCity, withCustomCriteria ? departureDate : null, duration, JSON.stringify(withCustomCriteria ? kids : null), JSON.stringify(withCustomCriteria ? adults : null), productId], 500);
  Object(react__WEBPACK_IMPORTED_MODULE_9__["useEffect"])(function () {
    if (withCustomCriteria && departureCity) {
      dispatch(Object(_client_store_price_remote_price_of_stay_priceOfStay_actions__WEBPACK_IMPORTED_MODULE_14__[/* getPriceOfStay */ "a"])(appContext, searchCriteria));
    }
  }, debouncedSearchCriteria);
  var searchCriteriaNotSynchronized = withCustomCriteria && JSON.stringify(priceOfStayArgs) !== JSON.stringify(Object(_client_store_price_remote_price_of_stay_priceOfStay_helper__WEBPACK_IMPORTED_MODULE_17__[/* getPriceOfStayArgs */ "b"])(searchCriteria));
  var isLoading = !isAppMounted || !calendarIsReady || searchCriteriaNotSynchronized || Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_20__[/* isFeatureFlipped */ "a"])(appContext)('remoteBasePriceDisplay') && priceTicketIsLoading || priceOfStayIsLoading;
  var hasValidPriceTicketCriteria = departureCity && productId;
  var shouldDisplayPriceTicket = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_20__[/* isFeatureFlipped */ "a"])(appContext)('remoteBasePriceDisplay');
  var shouldDisplaySpinnerForPriceTicket = shouldDisplayPriceTicket && hasValidPriceTicketCriteria && (!calendarSynchronized || priceTicketIsLoading);
  var shouldDisplaySpinnerForPriceOfStay = !shouldDisplayPriceTicket && hasValidCriteria && (!calendarSynchronized || priceOfStayIsLoading);
  var shouldDisplaySpinner = searchCriteriaNotSynchronized || shouldDisplaySpinnerForPriceTicket || shouldDisplaySpinnerForPriceOfStay;
  return {
    hasValidCriteria: hasValidCriteria,
    isLoading: isLoading,
    priceOfStay: priceOfStay,
    priceOfStayError: priceOfStayError,
    shouldDisplaySpinner: shouldDisplaySpinner
  };
}

/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getArrivalDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref5) {
  var arrivalDate = _ref5.arrivalDate;
  return arrivalDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinEmail = _ref6.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinSms = _ref7.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinMail = _ref8.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinPhone = _ref9.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref10) {
  var optinFosun = _ref10.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var duration = _ref11.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref12) {
  var flexibility = _ref12.flexibility;
  return flexibility;
});


/***/ }),

/***/ "RBvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRIP_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NO_DURATION; });
var TRIP_INFORMATION_SET_DURATION = 'TRIP_INFORMATION_SET_DURATION';
var DEFAULT_TRIP_DURATION = 7;
var DEFAULT_NO_DURATION = null;

/***/ }),

/***/ "Rm1S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("xluM");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("14Sl");
var anObject = __webpack_require__("glrk");
var isNullOrUndefined = __webpack_require__("cjT7");
var toLength = __webpack_require__("UMSQ");
var toString = __webpack_require__("V37c");
var requireObjectCoercible = __webpack_require__("HYAF");
var getMethod = __webpack_require__("3Eq5");
var advanceStringIndex = __webpack_require__("iqWW");
var regExpExec = __webpack_require__("FMNM");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "RqHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRICE_COLOR_CLASS_NAMES; });
/* unused harmony export mixedToMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateDiff; });
/* unused harmony export stringToDateFormatted */
/* unused harmony export momentToInt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return maxDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return minDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closedDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return firstSiblingOpenDayOfSelectedMonthFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return siblingOpenDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDisabledDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flattenPrices; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JevA");
/* harmony import */ var core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_parse_int__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("VtPb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("sW3P");
















var PRICE_COLOR_CLASS_NAMES = {
  DARK_GREY: 'text-black hocus:text-black-active',
  GREEN: 'text-green',
  GREEN_OPACITY_45: 'text-green bestPrice',
  GREY: 'text-grey hocus:text-black-active',
  ORANGE: 'text-orange',
  ORANGE_OPACITY_45: 'text-orange lastAvailability',
  WHITE: 'text-white',
  TURQUOISE: 'text-turquoise'
};
var mixedToMoment = function mixedToMoment(mixedDate) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(mixedDate);
};
var dateToInt = function dateToInt(d) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(mixedToMoment(d).format(format), 10);
};
var dateDiff = function dateDiff(day1, day2) {
  return Math.abs(moment__WEBPACK_IMPORTED_MODULE_12___default()(day2).diff(moment__WEBPACK_IMPORTED_MODULE_12___default()(day1), 'days'));
};
var stringToDateFormatted = function stringToDateFormatted(date, format) {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()(date).format(format);
};
var momentToInt = function momentToInt(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"];
  return parseInt(date.format(format), 10);
};
var maxDatepickerDate = function maxDatepickerDate() {
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_15__[/* DEPARTURE_DATE_MAX_DATE */ "t"]).toDate();
};
var minDatepickerDate = function minDatepickerDate() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return moment__WEBPACK_IMPORTED_MODULE_12___default()().add({
    days: offset
  }).toDate();
};

function daysWithoutDepartureFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver = resolver(dateToInt(day)),
        _resolver$exclusivity = _resolver.exclusivity,
        exclusivity = _resolver$exclusivity === void 0 ? false : _resolver$exclusivity,
        _resolver$noFlight = _resolver.noFlight,
        noFlight = _resolver$noFlight === void 0 ? false : _resolver$noFlight,
        _resolver$full = _resolver.full,
        full = _resolver$full === void 0 ? false : _resolver$full;

    var available = !exclusivity && !noFlight && !full;

    if (!fromDate && !toDate) {
      return !available;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && !available;
  };
}

var daysWithNoAvailabilityFactory = function daysWithNoAvailabilityFactory(resolver) {
  return function (day) {
    var data = resolver(dateToInt(day));
    return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(data) || data.noAvailability;
  };
};

var closedDaysFactory = function closedDaysFactory(resolver, fromDate, toDate, shouldAllowSelectingSiblingOpenDays) {
  return function (day) {
    var _resolver2 = resolver(dateToInt(day)),
        _resolver2$closed = _resolver2.closed,
        closed = _resolver2$closed === void 0 ? false : _resolver2$closed,
        _resolver2$siblingOpe = _resolver2.siblingOpen,
        siblingOpen = _resolver2$siblingOpe === void 0 ? false : _resolver2$siblingOpe;

    if (!fromDate && !toDate) {
      return closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && (closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  };
};
var firstSiblingOpenDayOfSelectedMonthFactory = function firstSiblingOpenDayOfSelectedMonthFactory(resolver, selectedMonth) {
  var firstSiblingOpenDayFound;
  return function (day) {
    var _resolver3;

    if (!selectedMonth) {
      return false;
    }

    var firstDayOfSelectedMonth = "".concat(selectedMonth.toString(), "01");
    var firstDayOfSelectedMonthAsDate = moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonth, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]);
    var firstDisplayedDayOfSelectedMonthAsInt = firstDayOfSelectedMonthAsDate.weekday() > 0 ? momentToInt(firstDayOfSelectedMonthAsDate.subtract(firstDayOfSelectedMonthAsDate.weekday(), 'days')) : momentToInt(firstDayOfSelectedMonthAsDate);
    var lastDisplayedDayOfSelectedMonthAsInt = momentToInt(moment__WEBPACK_IMPORTED_MODULE_12___default()(firstDayOfSelectedMonthAsDate).add(41, 'days'));
    var currentDayDateAsInt = dateToInt(day);

    if (firstSiblingOpenDayFound && firstSiblingOpenDayFound !== dateToInt(day) || currentDayDateAsInt < firstDisplayedDayOfSelectedMonthAsInt || currentDayDateAsInt > lastDisplayedDayOfSelectedMonthAsInt) {
      return false;
    }

    var hasSiblingOpen = ((_resolver3 = resolver(currentDayDateAsInt)) === null || _resolver3 === void 0 ? void 0 : _resolver3.siblingOpen) || false;

    if (hasSiblingOpen) {
      firstSiblingOpenDayFound = dateToInt(day);
    }

    return hasSiblingOpen;
  };
};
var siblingOpenDaysFactory = function siblingOpenDaysFactory(resolver) {
  return function (day) {
    var _resolver4;

    return ((_resolver4 = resolver(dateToInt(day))) === null || _resolver4 === void 0 ? void 0 : _resolver4.siblingOpen) || false;
  };
};

var unavailableReturnDaysFactory = function unavailableReturnDaysFactory(fromDate) {
  var durations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (day) {
    if (day < fromDate) {
      return false;
    }

    var duration = dateDiff(day, fromDate); // rule of max 30 days of reservation

    if (duration > 30) {
      return true;
    }

    return !!duration && !durations.includes(duration);
  };
};

function getDisabledDays(_ref) {
  var from = _ref.from,
      isSeller = _ref.isSeller,
      optionsDuration = _ref.optionsDuration,
      openingDates = _ref.openingDates,
      prices = _ref.prices,
      resolvePrice = _ref.resolvePrice,
      shouldAllowSelectingSiblingOpenDays = _ref.shouldAllowSelectingSiblingOpenDays,
      to = _ref.to;
  var disabledDays = [];
  var pricesIds = Object.keys(prices || {});
  var hasPrices = pricesIds.length > 0;
  var allClosedDays = pricesIds.filter(function (priceKey) {
    return prices && (prices[priceKey].closed || prices[priceKey].siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  }).map(function (priceKey) {
    return parseInt(priceKey, 10);
  });

  if (hasPrices) {
    var dayIsWithoutDeparture = daysWithoutDepartureFactory(resolvePrice, from, to);
    var dayIsClosed = closedDaysFactory(resolvePrice, from, to, shouldAllowSelectingSiblingOpenDays);
    var dayIsSiblingOpen = siblingOpenDaysFactory(resolvePrice);
    var dayIsWithoutData = daysWithNoAvailabilityFactory(resolvePrice);
    disabledDays.push(dayIsWithoutDeparture);
    disabledDays.push(dayIsClosed);

    if (!shouldAllowSelectingSiblingOpenDays) {
      disabledDays.push(dayIsSiblingOpen);
    }

    disabledDays.push(dayIsWithoutData);
  }

  if (from && !to) {
    var fromDay = dateToInt(from);
    var closedDaysAfterFromDay = allClosedDays.filter(function (closedDay) {
      return closedDay > fromDay;
    });
    var firstClosedDay = hasPrices && closedDaysAfterFromDay.length > 0 && Math.min.apply(null, closedDaysAfterFromDay);
    disabledDays.push({
      before: moment__WEBPACK_IMPORTED_MODULE_12___default()(from).toDate(),
      after: firstClosedDay ? moment__WEBPACK_IMPORTED_MODULE_12___default()(firstClosedDay.toString()).toDate() : moment__WEBPACK_IMPORTED_MODULE_12___default()(from).add(30, 'days').toDate()
    });
  }

  if (from && !to && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(optionsDuration) && !isSeller) {
    disabledDays.push(unavailableReturnDaysFactory(from, optionsDuration));
  }

  if (openingDates === null || openingDates === void 0 ? void 0 : openingDates.length) {
    disabledDays.push.apply(disabledDays, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_13__[/* getClosingDatesRanges */ "b"])(openingDates)));
  }

  return disabledDays;
}
function getPriceColor(_ref2) {
  var classColor = _ref2.classColor,
      from = _ref2.from,
      hasPrices = _ref2.hasPrices,
      resolvePrice = _ref2.resolvePrice,
      selectedMonth = _ref2.selectedMonth,
      to = _ref2.to;
  return function (day) {
    var dayAsInt = dateToInt(day);

    if (selectedMonth) {
      var firstDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "01"), 10);
      var lastDayOfCurrentMonth = Number.parseInt("".concat(selectedMonth, "31"), 10); // Handle dates outside current month & without prices

      var isDayBeforeSelectedMonth = Boolean(dayAsInt < firstDayOfCurrentMonth);
      var isDayAfterSelectedMonth = Boolean(dayAsInt > lastDayOfCurrentMonth);

      if (isDayBeforeSelectedMonth || !from && isDayAfterSelectedMonth || !hasPrices) {
        return classColor === PRICE_COLOR_CLASS_NAMES.GREY;
      }
    }

    if (from) {
      var fromDateAsInt = dateToInt(from);

      if (to) {
        var toDateAsInt = dateToInt(to); // Handle dates between from and to dates

        if (dayAsInt >= fromDateAsInt && dayAsInt <= toDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        }
      } else {
        if (dayAsInt === fromDateAsInt) {
          return classColor === PRICE_COLOR_CLASS_NAMES.WHITE;
        } // Handle dates before and after from date


        switch (classColor) {
          case PRICE_COLOR_CLASS_NAMES.WHITE:
            return false;

          case PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45:
          case PRICE_COLOR_CLASS_NAMES.GREY:
          case PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45:
            if (dayAsInt >= fromDateAsInt) {
              return false;
            }

            break;

          default:
            if (dayAsInt < fromDateAsInt) {
              return false;
            }

            break;
        }
      }
    } // Get the correct color based on price


    if (resolvePrice) {
      var dayWithPrice = resolvePrice(dateToInt(day)) || {
        isBestPrice: false,
        lastAvailability: false,
        price: ''
      };
      var isBestPrice = dayWithPrice.isBestPrice,
          lastAvailability = dayWithPrice.lastAvailability,
          price = dayWithPrice.price,
          siblingOpen = dayWithPrice.siblingOpen;

      if (siblingOpen) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE || classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE : classColor === PRICE_COLOR_CLASS_NAMES.TURQUOISE;
      }

      if (lastAvailability) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.ORANGE || classColor === PRICE_COLOR_CLASS_NAMES.ORANGE_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.ORANGE;
      }

      if (isBestPrice) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.GREEN || classColor === PRICE_COLOR_CLASS_NAMES.GREEN_OPACITY_45 : classColor === PRICE_COLOR_CLASS_NAMES.GREEN;
      }

      if (price) {
        return from ? classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY || classColor === PRICE_COLOR_CLASS_NAMES.GREY : classColor === PRICE_COLOR_CLASS_NAMES.DARK_GREY;
      }
    }

    return false;
  };
}
function flattenPrices(prices) {
  var pricesIds = Object.keys(prices);
  return pricesIds.map(function (priceId) {
    return prices[priceId].oldPrice;
  }).join();
}

/***/ }),

/***/ "SQLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n  fragment BookingAttendeesProfile on Profile {\n    customerId\n    gmNumber\n    civility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n    dateOfBirth\n  }\n");

/***/ }),

/***/ "SUcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductBanner; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _exclusive_collection_badge_ExclusiveCollectionBadge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7knX");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var ProductBanner = function ProductBanner(_ref) {
  var _product$destination;

  var className = _ref.className,
      product = _ref.product;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('flex flex-col items-start text-black', className)
  }, __jsx("span", {
    className: "flex-wrap font-sans font-semibold inline-flex gap-5 items-center order-last text-20",
    "data-testid": "ProductBlockHeader-name"
  }, product.name, product.isExplicitEC && __jsx(_exclusive_collection_badge_ExclusiveCollectionBadge__WEBPACK_IMPORTED_MODULE_3__[/* ExclusiveCollectionBadge */ "a"], {
    className: "md:mx-5"
  }), product.seasonTrad && __jsx("span", {
    className: "bg-turquoise font-bold leading-1 px-10 py-5 rounded-pill shrink-0 text-10 text-center text-white whitespace-nowrap"
  }, product.seasonTrad)), __jsx("span", {
    className: "font-sans font-semibold text-sienna text-14 truncate",
    "data-testid": "ProductBlockHeader-country"
  }, product === null || product === void 0 ? void 0 : (_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country));
};

/***/ }),

/***/ "SqqE":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("s+R0");

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),

/***/ "TVUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TrackingPageLoad_TrackingPageLoad; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("JTJg");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/last-visited-tracking-api/index.js
var last_visited_tracking_api = __webpack_require__("evRn");

// EXTERNAL MODULE: ./src/client/store/lead-info/leadInfo.selector.js
var leadInfo_selector = __webpack_require__("8fx4");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/client/tracking/tracking-component/TrackingComponent.jsx












function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var TrackingComponent_TrackingComponent = function TrackingComponent(_ref) {
  var children = _ref.children,
      track = _ref.track,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "track"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var leadScoring = Object(es["e" /* useSelector */])(leadInfo_selector["a" /* getLeadScore */]); // in some cases (like the NotFoundView) the siteSection's value cannot be dynamically built
  // from the pageType and attached to the pageContext,
  // so we need to declare it in the props directly but this should be avoided

  var siteSection = props.siteSection || pageContext.siteSection;
  Object(react["useEffect"])(function () {
    Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageContext.pageType, {
      // $FlowFixMe
      id: props.resortCode,
      be: false,
      timestamp: Date.now()
    });
  }, [props.pageName]);
  Object(react["useEffect"])(function () {
    // pageId is not actually needed here, since the categoryGA is only used for events
    // not for page loading (the analytics team doesn't care), but it makes our API more
    // consistent
    Object(tracking_api["b" /* setDataLayer */])(_objectSpread(_objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      siteSection: siteSection
    }, siteSection && siteSection.includes(constants["p" /* PLE */]) ? {
      BE_customerStatus: appContext.customerStatus
    } : undefined), leadScoring ? {
      leadScoring: leadScoring
    } : null), appContext, pageContext.pageId);

    if (track) {
      track();
    }

    js_cookie_default.a.remove(constants["K" /* VOUCHER_DISCOUNT */]);
    js_cookie_default.a.remove(constants["J" /* VOUCHER_CODE */]);
  }, [props.pageName]);
  return children !== null && children !== void 0 ? children : null;
};

/* harmony default export */ var tracking_component_TrackingComponent = (TrackingComponent_TrackingComponent);
// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// CONCATENATED MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx











var __jsx = react_default.a.createElement;

function TrackingPageLoad_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function TrackingPageLoad_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TrackingPageLoad_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TrackingPageLoad_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var TrackingPageLoad_TrackingPageLoad = function TrackingPageLoad(props) {
  var _useRouter = Object(router["useRouter"])(),
      trackingPageLoadAppendSuffix = _useRouter.query.trackingPageLoadAppendSuffix;

  var profile = Object(es["e" /* useSelector */])(userInfo_selectors["a" /* userInfoSelector */]);

  function getTrackingProps() {
    var _profile$loyaltyProgr;

    var baseProps = TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread({}, props.trackingKey ?
    /**
     * We need to omit ski data because in case of 2 bookings from the same session,
     * when the first one has ski equipments and second one has none,
     * the second one get wrong ski data from locale storage
     * In case of new ski data exist, it will be added from props anyway
     */
    omit_default()(Object(tracking_storage_api["b" /* get */])(props.trackingKey), 'skiEquipment', 'skiingEquipment', 'snowboardingEquipment', 'hikingEquipment') : {}), {}, {
      event: constants["I" /* VIRTUAL_PAGE_LOAD */],
      fidelityStatus: (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || ''
    }, omit_default()(props, 'children', 'location', 'history', 'match', 'trackingKey'));

    if (trackingPageLoadAppendSuffix) {
      baseProps = TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread({}, baseProps), {}, {
        pageName: "".concat(baseProps.pageName, "_").concat(trackingPageLoadAppendSuffix)
      });
    }

    if (props.pageName === constants["b" /* BE_OPTION_CONFIRMATION */]) {
      return omit_default()(baseProps, ['upsellExcursion', 'upsellRevenue', 'donation', 'paymentDeposit', 'paymentMethod', 'paymentPlan', 'paymentStatus', 'paymentType', 'donation']);
    }

    return baseProps;
  }

  var trackingProps = getTrackingProps();
  react_default.a.useEffect(function () {
    if (props.event) {
      Object(tracking_storage_api["c" /* set */])(trackingProps);
    }
  }, [props.event]);
  return __jsx(tracking_component_TrackingComponent, Object(esm_extends["a" /* default */])({}, trackingProps, {
    track: props.track
  }));
};

/***/ }),

/***/ "TYzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* unused harmony export CriteriaDisplayContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useCriteriaDisplayContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaDisplayProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("3KgV");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}


var ACTIONS = Object.freeze({
  CLOSE_CRITERIA: 'CLOSE_CRITERIA',
  OPEN_CRITERIA: 'OPEN_CRITERIA',
  OPEN_NEXT_CRITERIA: 'OPEN_NEXT_CRITERIA'
});
var initialState = {
  criteriaWhenIsOpen: false,
  criteriaWhoIsOpen: false,
  criteriaTransportIsOpen: false
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  switch (action.type) {
    case ACTIONS.OPEN_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), true));

    case ACTIONS.CLOSE_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), false));

    case ACTIONS.OPEN_NEXT_CRITERIA:
      var _action$payload = action.payload,
          currentCriteria = _action$payload.currentCriteria,
          criteriaContext = _action$payload.criteriaContext;

      if (currentCriteria === 'criteriaTransport') {
        return state;
      }

      if (currentCriteria === 'criteriaWho' && !criteriaContext.criteriaTransportIsSet) {
        return _objectSpread(_objectSpread({}, state), {}, {
          criteriaTransportIsOpen: true
        });
      }

      if (currentCriteria === 'criteriaWhen') {
        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      if (currentCriteria === 'criteriaQuery') {
        if (!criteriaContext.criteriaWhenIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhenIsOpen: true
          });
        }

        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      return state;

    default:
      return state;
  }
};

var CriteriaDisplayContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_9__["createContext"])([initialState, function () {}]);
var useCriteriaDisplayContext = function useCriteriaDisplayContext() {
  return Object(react__WEBPACK_IMPORTED_MODULE_9__["useContext"])(CriteriaDisplayContext);
};
var CriteriaDisplayProvider = function CriteriaDisplayProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_9__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var reducer = Object(react__WEBPACK_IMPORTED_MODULE_9__["useMemo"])(function () {
    return [state, dispatch];
  }, [state, dispatch]);
  return __jsx(CriteriaDisplayContext.Provider, {
    value: reducer
  }, children);
};

/***/ }),

/***/ "U2fG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LAYER_HEADER_HEIGHT; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Layer; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("oVuX");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("SYor");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 8 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/context/ToastContext.js
var ToastContext = __webpack_require__("waz2");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.themes.js
var themes = function themes(_ref) {
  var isActive = _ref.isActive,
      hasIcon = _ref.hasIcon;
  return {
    "default": {
      thRoot: "cursor-pointer flex flex-col sm:flex-row items-center p-5 rounded-4 text-12 text-black transition-colors duration-250 ease-in".concat(isActive ? ' bg-saffron hocus:bg-saffron-active' : ' hocus:text-black-active'),
      thIcon: 'm-5 shrink-0',
      thIconWidth: '1.25rem',
      thLabel: hasIcon ? 'sr-only' : ''
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.jsx

var __jsx = react_default.a.createElement;




var LayerHeaderButton_LayerHeaderButton = function LayerHeaderButton(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      iconClassName = _ref.iconClassName,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      label = _ref.label,
      onClick = _ref.onClick,
      tabIndex = _ref.tabIndex,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!label && !iconName) {
    return null;
  }

  var hasIcon = !!iconName;
  var _themes$theme = themes({
    isActive: isActive,
    hasIcon: hasIcon
  })[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  return __jsx("button", Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    className: classnames_default()(thRoot, className),
    "data-testid": dataTestId,
    onClick: onClick
  }, tabIndex === -1 ? {
    tabIndex: tabIndex
  } : null, {
    type: "button"
  }), !!iconName && __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(thIcon, iconClassName),
    hasRtl: true,
    name: iconName,
    width: thIconWidth
  }), !!label && __jsx("span", {
    className: thLabel
  }, label));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.themes.js
var LayerHeader_themes_themes = {
  "default": {
    thRoot: 'bg-white border-b-1 fixed overflow-hidden px-20 transition-heights duration-250 ease-in w-full z-3',
    thInner: 'flex h-full items-center w-full',
    thChild: 'w-full',
    thClose: 'leading-0 ms-auto order-1 p-10 text-black hocus:text-black-active transition-color',
    thCloseIconWidth: '1rem',
    thCloseLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.jsx

var LayerHeader_jsx = react_default.a.createElement;






var LayerHeader_LayerHeader = function LayerHeader(_ref) {
  var buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      hasContainer = _ref.hasContainer,
      height = _ref.height,
      onClose = _ref.onClose,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var layerButtonRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    layerButtonRef.current && layerButtonRef.current.focus();
  }, []);
  var _themes$theme = LayerHeader_themes_themes[theme],
      thChild = _themes$theme.thChild,
      thClose = _themes$theme.thClose,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thCloseLabel = _themes$theme.thCloseLabel,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  return LayerHeader_jsx("header", {
    className: classnames_default()(thRoot, className),
    style: {
      height: height,
      maxHeight: height
    }
  }, LayerHeader_jsx("div", {
    className: classnames_default()(thInner, {
      'm-auto max-w-site w-full': hasContainer
    }),
    "data-testid": "LayerHeader-body"
  }, LayerHeader_jsx("button", {
    className: thClose,
    "data-testid": "Layer-close",
    onClick: onClose,
    ref: layerButtonRef,
    type: "button"
  }, !!closeLabel && LayerHeader_jsx("span", {
    className: thCloseLabel
  }, closeLabel), LayerHeader_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    dataTestId: "layer-header-button-left"
  }, buttonLeft, {
    theme: theme
  })), !!react["Children"].count(children) && LayerHeader_jsx("div", {
    className: thChild
  }, children), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    dataTestId: "layer-header-button-right"
  }, buttonRight, {
    theme: theme
  }))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/Layer.jsx







var Layer_jsx = react_default.a.createElement;









var LAYER_HEADER_HEIGHT = 60;

var onScroll = throttle_default()(function () {
  Object(lib["forceCheck"])();
}, 250);

var Layer_LayerComponent = function LayerComponent(_ref, layerRef) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? colors["a" /* COLORS */].WHITE : _ref$bgColor,
      buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      customHeader = _ref.customHeader,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'Layer' : _ref$dataTestId,
      _ref$enterAnimation = _ref.enterAnimation,
      enterAnimation = _ref$enterAnimation === void 0 ? 'ltr:animate-slideInRight rtl:animate-slideInLeft' : _ref$enterAnimation,
      _ref$externalFocusTra = _ref.externalFocusTrapRefs,
      externalFocusTrapRefs = _ref$externalFocusTra === void 0 ? [] : _ref$externalFocusTra,
      hasAnimateEnter = _ref.hasAnimateEnter,
      hasContainer = _ref.hasContainer,
      hasContainerHeader = _ref.hasContainerHeader,
      hasNoFocusTrap = _ref.hasNoFocusTrap,
      header = _ref.header,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react["useContext"])(ToastContext["a" /* ToastContext */]),
      ref = _useContext.ref;

  var layerBody = Object(react["useRef"])(null);
  Object(react["useImperativeHandle"])(layerRef, function () {
    return layerBody.current;
  }, [layerBody]);
  Object(react["useEffect"])(function () {
    var _layerBody$current;

    (_layerBody$current = layerBody.current) === null || _layerBody$current === void 0 ? void 0 : _layerBody$current.addEventListener('scroll', onScroll);
    return function () {
      var _layerBody$current2;

      (_layerBody$current2 = layerBody.current) === null || _layerBody$current2 === void 0 ? void 0 : _layerBody$current2.removeEventListener('scroll', onScroll);
    };
  }, []);

  if (!react["Children"].count(children)) {
    return null;
  }

  var hasHeader = buttonLeft || buttonRight || header;

  var getStyle = function getStyle() {
    return hasHeader || !hasHeader && customHeader ? {
      paddingTop: customHeader ? customHeader.height : LAYER_HEADER_HEIGHT
    } : {};
  };

  var shards = ref ? [ref].concat(Object(toConsumableArray["a" /* default */])(externalFocusTrapRefs)) : externalFocusTrapRefs;
  return Layer_jsx(Portal["a" /* default */], {
    name: portalName
  }, Layer_jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: !hasNoFocusTrap,
    onEscapeKey: onClose,
    shards: shards.filter(Boolean)
  }, Layer_jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: true
  }, Layer_jsx("aside", {
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, Layer_jsx("div", {
    className: classnames_default()("animation-duration-500 bg-".concat(bgColor), 'fixed inset-0 w-full', Object(defineProperty["a" /* default */])({}, enterAnimation, hasAnimateEnter), className),
    "data-testid": dataTestId,
    role: "document"
  }, hasHeader && Layer_jsx(LayerHeader_LayerHeader, {
    buttonLeft: buttonLeft,
    buttonRight: buttonRight,
    closeLabel: [closeLabel, ariaLabel].join(' ').trim(),
    hasContainer: hasContainerHeader,
    height: LAYER_HEADER_HEIGHT,
    onClose: onClose,
    theme: theme
  }, header), !hasHeader && customHeader && customHeader.content, Layer_jsx("div", {
    className: classnames_default()('h-full scroll-y duration-250 ease-in transition-all z-0', {
      'px-20': hasContainer
    }),
    "data-testid": "Layer-body",
    ref: layerBody,
    style: getStyle()
  }, Layer_jsx("div", {
    className: classnames_default()('h-full min-h-full', {
      'mx-auto max-w-site w-full': hasContainer
    }),
    "data-testid": "Layer-content"
  }, children)))))));
}; // $FlowFixMe


var Layer = /*#__PURE__*/Object(react["forwardRef"])(Layer_LayerComponent);

/***/ }),

/***/ "U6GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDown; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SuFq");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("05v4");
/* harmony import */ var _DropDown_themes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Q8Qh");











var __jsx = react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





var DropDown = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(DropDown, _Component);

  var _super = _createSuper(DropDown);

  function DropDown(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, DropDown);

    _this = _super.call(this, props);

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "rootRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "contentRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_11__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "expand", function () {
      _this.setState({
        isExpanded: true
      }, _this.toggleEventListeners);
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "collapse", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      if (!_this.props.unmountsOnClose) {
        _this.setState({
          isExpanded: false
        }, _this.toggleEventListeners);
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onKeyDown", function (e) {
      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__[/* ESCAPE */ "g"]) {
        _this.collapse();
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onClickOutside", function (e) {
      if (!_this.contentRef || // $FlowFixMe
      _this.contentRef.current.contains(e.target) || // $FlowFixMe
      _this.rootRef.current.contains(e.target) || // $FlowFixMe
      lodash_get__WEBPACK_IMPORTED_MODULE_10___default()(_this.props, 'rootRef.current') && _this.props.rootRef.current.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      _this.collapse();
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }, _this.toggleEventListeners);
    });

    _this.state = {
      isExpanded: props.isExpanded || false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isExpanded) {
        this.removeEventListeners();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isExpanded !== this.props.isExpanded) {
        this.setState({
          isExpanded: nextProps.isExpanded
        }, this.toggleEventListeners);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      if (true) {
        document.addEventListener('mouseup', this.onClickOutside, false);
        document.addEventListener('touchstart', this.onClickOutside, false);
        document.addEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (true) {
        document.removeEventListener('mouseup', this.onClickOutside, false);
        document.removeEventListener('touchstart', this.onClickOutside, false);
        document.removeEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "toggleEventListeners",
    value: function toggleEventListeners() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      } else {
        this.removeEventListeners();
      }
    } // TODO: cleanup !!
    // eslint-disable-next-line react/no-unused-class-component-methods

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          contentStyle = _this$props.contentStyle,
          contentClassName = _this$props.contentClassName,
          hasArrow = _this$props.hasArrow,
          hasCloseOnClick = _this$props.hasCloseOnClick,
          relative = _this$props.relative,
          noLayout = _this$props.noLayout,
          renderTrigger = _this$props.renderTrigger,
          theme = _this$props.theme;
      var thBody = Object(_DropDown_themes__WEBPACK_IMPORTED_MODULE_14__[/* themes */ "a"])({
        hasArrow: hasArrow
      })[theme].thBody;
      return __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()('inline-block', {
          relative: relative
        }, className),
        ref: this.rootRef
      }, renderTrigger && renderTrigger(this.toggle, this.state.isExpanded), this.state.isExpanded && __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_12___default()({
          'absolute left-1/2 min-w-full w-full transform -translate-x-1/2 ': !noLayout
        }, contentClassName, thBody),
        "data-testid": "DropDown-body",
        onClick: hasCloseOnClick ? this.collapse : null,
        ref: this.contentRef,
        style: contentStyle
      }, children(this.toggle, this.state.isExpanded)));
    }
  }]);

  return DropDown;
}(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(DropDown, "defaultProps", {
  hasArrow: true,
  isExpanded: false,
  relative: true,
  noLayout: false,
  theme: 'default',
  unmountsOnClose: false
});

/***/ }),

/***/ "U7t3":
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),

/***/ "UIAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ACCOMMODATION_FROM_ALTERNATIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ACCOMMODATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_TRANSFER_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return UPDATE_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_PROPOSALS; });
/* unused harmony export LOAD_PROPOSAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return IS_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_PROPOSALS_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_SELECTED_PROPOSAL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REMOVE_TRANSFER_FROM_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PATCH_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SAVE_CUSTOMER_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UPDATE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PREPARE_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DISPLAY_TOAST_ON_CONTEXT_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_PROPOSALS_FROM_EDIT_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SAVE_DONATION_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTOSAVE; });
/* unused harmony export SET_PROMO_CODE_FAILURE_STATUS */
/* unused harmony export SET_PROMO_CODE_SUCCESS_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return UPDATE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SWITCH_PROPOSALS_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return INSURANCE_DELETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return INSURANCE_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return INIT_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return TOGGLE_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PROPOSAL_REFRESH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EDIT_HOUSEHOLDS; });
var ADD_ACCOMMODATION = 'ADD_ACCOMMODATION';
var ADD_ACCOMMODATION_FROM_ALTERNATIVES = 'ADD_ACCOMMODATION_FROM_ALTERNATIVES';
var ADD_ACCOMMODATION_ERROR = 'ADD_ACCOMMODATION_ERROR';
var ADD_TRANSFER_TO_PROPOSALS = 'ADD_TRANSFER_TO_PROPOSALS';
var ADD_TRANSPORT = 'ADD_TRANSPORT';
var UPDATE_ATTENDEES = 'UPDATE_ATTENDEES';
var CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
var LOAD_PROPOSAL = 'LOAD_PROPOSAL';
var IS_BOOKING = 'IS_BOOKING';
var FETCH_PROPOSALS = 'FETCH_PROPOSALS';
var FETCH_PROPOSALS_BY_ID = 'FETCH_PROPOSALS_BY_ID';
var FETCH_SELECTED_PROPOSAL_PAYMENT = 'FETCH_SELECTED_PROPOSAL_PAYMENT';
var REMOVE_TRANSFER_FROM_PROPOSALS = 'REMOVE_TRANSFER_FROM_PROPOSALS';
var SET_PROPOSALS = 'SET_PROPOSALS';
var PATCH_PROPOSAL = 'PATCH_PROPOSAL';
var SAVE_CUSTOMER_PROPOSAL = 'SAVE_CUSTOMER_PROPOSAL';
var SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID = 'SAVE_CUSTOMER_PROPOSAL_OPPORTUNITYID';
var UPDATE_INSURANCES = 'UPDATE_INSURANCES';
var DELETE_INSURANCES = 'DELETE_INSURANCES';
var PREPARE_BE = 'PREPARE_BE';
var DISPLAY_TOAST_ON_CONTEXT_SHARE = 'DISPLAY_TOAST_ON_CONTEXT_SHARE';
var FETCH_PROPOSALS_FROM_EDIT_CRITERIA = 'FETCH_PROPOSALS_FROM_EDIT_CRITERIA';
var SAVE_DONATION_TO_PROPOSALS = 'SAVE_DONATION_TO_PROPOSALS';
var SET_PROMO_CODE = 'SET_PROMO_CODE';
var AUTOSAVE = 'AUTOSAVE';
var SET_PROMO_CODE_FAILURE_STATUS = 'failure';
var SET_PROMO_CODE_SUCCESS_STATUS = 'success';
var UPDATE_SERVICES = 'UPDATE_SERVICES';
var ADD_SERVICE = 'ADD_SERVICE';
var DELETE_SERVICE = 'DELETE_SERVICE';
var SWITCH_PROPOSALS_OFFERS = 'SWITCH_PROPOSALS_OFFERS';
var PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD = 30;
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD = 30;
var INSURANCE_DELETED = 'INSURANCE_DELETED';
var INSURANCE_ADDED = 'INSURANCE_ADDED';
var INIT_INSURANCES = 'INIT_INSURANCES';
var TOGGLE_TERMS = 'TOGGLE_TERMS';
var PROPOSAL_REFRESH = 'PROPOSAL_REFRESH';
var EDIT_HOUSEHOLDS = 'EDIT_HOUSEHOLDS';

/***/ }),

/***/ "V5RX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node: true */


function makeArrayFrom(obj) {
  return Array.prototype.slice.apply(obj);
}

var
  PENDING = "pending",
  RESOLVED = "resolved",
  REJECTED = "rejected";

function SynchronousPromise(handler) {
  this.status = PENDING;
  this._continuations = [];
  this._parent = null;
  this._paused = false;
  if (handler) {
    handler.call(
      this,
      this._continueWith.bind(this),
      this._failWith.bind(this)
    );
  }
}

function looksLikeAPromise(obj) {
  return obj && typeof (obj.then) === "function";
}

function passThrough(value) {
  return value;
}

SynchronousPromise.prototype = {
  then: function (nextFn, catchFn) {
    var next = SynchronousPromise.unresolved()._setParent(this);
    if (this._isRejected()) {
      if (this._paused) {
        this._continuations.push({
          promise: next,
          nextFn: nextFn,
          catchFn: catchFn
        });
        return next;
      }
      if (catchFn) {
        try {
          var catchResult = catchFn(this._error);
          if (looksLikeAPromise(catchResult)) {
            this._chainPromiseData(catchResult, next);
            return next;
          } else {
            return SynchronousPromise.resolve(catchResult)._setParent(this);
          }
        } catch (e) {
          return SynchronousPromise.reject(e)._setParent(this);
        }
      }
      return SynchronousPromise.reject(this._error)._setParent(this);
    }
    this._continuations.push({
      promise: next,
      nextFn: nextFn,
      catchFn: catchFn
    });
    this._runResolutions();
    return next;
  },
  catch: function (handler) {
    if (this._isResolved()) {
      return SynchronousPromise.resolve(this._data)._setParent(this);
    }
    var next = SynchronousPromise.unresolved()._setParent(this);
    this._continuations.push({
      promise: next,
      catchFn: handler
    });
    this._runRejections();
    return next;
  },
  finally: function (callback) {
    var ran = false;

    function runFinally(result, err) {
      if (!ran) {
        ran = true;
        if (!callback) {
          callback = passThrough;
        }
        var callbackResult = callback(result);
        if (looksLikeAPromise(callbackResult)) {
          return callbackResult.then(function () {
            if (err) {
              throw err;
            }
            return result;
          });
        } else {
          return result;
        }
      }
    }

    return this
      .then(function (result) {
        return runFinally(result);
      })
      .catch(function (err) {
        return runFinally(null, err);
      });
  },
  pause: function () {
    this._paused = true;
    return this;
  },
  resume: function () {
    var firstPaused = this._findFirstPaused();
    if (firstPaused) {
      firstPaused._paused = false;
      firstPaused._runResolutions();
      firstPaused._runRejections();
    }
    return this;
  },
  _findAncestry: function () {
    return this._continuations.reduce(function (acc, cur) {
      if (cur.promise) {
        var node = {
          promise: cur.promise,
          children: cur.promise._findAncestry()
        };
        acc.push(node);
      }
      return acc;
    }, []);
  },
  _setParent: function (parent) {
    if (this._parent) {
      throw new Error("parent already set");
    }
    this._parent = parent;
    return this;
  },
  _continueWith: function (data) {
    var firstPending = this._findFirstPending();
    if (firstPending) {
      firstPending._data = data;
      firstPending._setResolved();
    }
  },
  _findFirstPending: function () {
    return this._findFirstAncestor(function (test) {
      return test._isPending && test._isPending();
    });
  },
  _findFirstPaused: function () {
    return this._findFirstAncestor(function (test) {
      return test._paused;
    });
  },
  _findFirstAncestor: function (matching) {
    var test = this;
    var result;
    while (test) {
      if (matching(test)) {
        result = test;
      }
      test = test._parent;
    }
    return result;
  },
  _failWith: function (error) {
    var firstRejected = this._findFirstPending();
    if (firstRejected) {
      firstRejected._error = error;
      firstRejected._setRejected();
    }
  },
  _takeContinuations: function () {
    return this._continuations.splice(0, this._continuations.length);
  },
  _runRejections: function () {
    if (this._paused || !this._isRejected()) {
      return;
    }
    var
      error = this._error,
      continuations = this._takeContinuations(),
      self = this;
    continuations.forEach(function (cont) {
      if (cont.catchFn) {
        try {
          var catchResult = cont.catchFn(error);
          self._handleUserFunctionResult(catchResult, cont.promise);
        } catch (e) {
          cont.promise.reject(e);
        }
      } else {
        cont.promise.reject(error);
      }
    });
  },
  _runResolutions: function () {
    if (this._paused || !this._isResolved() || this._isPending()) {
      return;
    }
    var continuations = this._takeContinuations();
    var data = this._data;
    var self = this;
    continuations.forEach(function (cont) {
      if (cont.nextFn) {
        try {
          var result = cont.nextFn(data);
          self._handleUserFunctionResult(result, cont.promise);
        } catch (e) {
          self._handleResolutionError(e, cont);
        }
      } else if (cont.promise) {
        cont.promise.resolve(data);
      }
    });
    if (looksLikeAPromise(this._data)) {
      return this._handleWhenResolvedDataIsPromise(this._data);
    }
  },
  _handleResolutionError: function (e, continuation) {
    this._setRejected();
    if (continuation.catchFn) {
      try {
        continuation.catchFn(e);
        return;
      } catch (e2) {
        e = e2;
      }
    }
    if (continuation.promise) {
      continuation.promise.reject(e);
    }
  },
  _handleWhenResolvedDataIsPromise: function (data) {
    var self = this;
    return data.then(function (result) {
      self._data = result;
      self._runResolutions();
    }).catch(function (error) {
      self._error = error;
      self._setRejected();
      self._runRejections();
    });
  },
  _handleUserFunctionResult: function (data, nextSynchronousPromise) {
    if (looksLikeAPromise(data)) {
      this._chainPromiseData(data, nextSynchronousPromise);
    } else {
      nextSynchronousPromise.resolve(data);
    }
  },
  _chainPromiseData: function (promiseData, nextSynchronousPromise) {
    promiseData.then(function (newData) {
      nextSynchronousPromise.resolve(newData);
    }).catch(function (newError) {
      nextSynchronousPromise.reject(newError);
    });
  },
  _setResolved: function () {
    this.status = RESOLVED;
    if (!this._paused) {
      this._runResolutions();
    }
  },
  _setRejected: function () {
    this.status = REJECTED;
    if (!this._paused) {
      this._runRejections();
    }
  },
  _isPending: function () {
    return this.status === PENDING;
  },
  _isResolved: function () {
    return this.status === RESOLVED;
  },
  _isRejected: function () {
    return this.status === REJECTED;
  }
};

SynchronousPromise.resolve = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    if (looksLikeAPromise(result)) {
      result.then(function (newResult) {
        resolve(newResult);
      }).catch(function (error) {
        reject(error);
      });
    } else {
      resolve(result);
    }
  });
};

SynchronousPromise.reject = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    reject(result);
  });
};

SynchronousPromise.unresolved = function () {
  return new SynchronousPromise(function (resolve, reject) {
    this.resolve = resolve;
    this.reject = reject;
  });
};

SynchronousPromise.all = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allData = [],
      numResolved = 0,
      doResolve = function () {
        if (numResolved === args.length) {
          resolve(allData);
        }
      },
      rejected = false,
      doReject = function (err) {
        if (rejected) {
          return;
        }
        rejected = true;
        reject(err);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = thisResult;
        numResolved += 1;
        doResolve();
      }).catch(function (err) {
        doReject(err);
      });
    });
  });
};

function createAggregateErrorFrom(errors) {
  /* jshint ignore:start */
  if (typeof window !== "undefined" && "AggregateError" in window) {
    return new window.AggregateError(errors);
  }
  /* jshint ignore:end */

  return { errors: errors };
}

SynchronousPromise.any = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.reject(createAggregateErrorFrom([]));
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allErrors = [],
      numRejected = 0,
      doReject = function () {
        if (numRejected === args.length) {
          reject(createAggregateErrorFrom(allErrors));
        }
      },
      resolved = false,
      doResolve = function (result) {
        if (resolved) {
          return;
        }
        resolved = true;
        resolve(result);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        doResolve(thisResult);
      }).catch(function (err) {
        allErrors[idx] = err;
        numRejected += 1;
        doReject();
      });
    });
  });
};

SynchronousPromise.allSettled = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve) {
    var
      allData = [],
      numSettled = 0,
      doSettled = function () {
        numSettled += 1;
        if (numSettled === args.length) {
          resolve(allData);
        }
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = {
          status: "fulfilled",
          value: thisResult
        };
        doSettled();
      }).catch(function (err) {
        allData[idx] = {
          status: "rejected",
          reason: err
        };
        doSettled();
      });
    });
  });
};

/* jshint ignore:start */
if (Promise === SynchronousPromise) {
  throw new Error("Please use SynchronousPromise.installGlobally() to install globally");
}
var RealPromise = Promise;
SynchronousPromise.installGlobally = function (__awaiter) {
  if (Promise === SynchronousPromise) {
    return __awaiter;
  }
  var result = patchAwaiterIfRequired(__awaiter);
  Promise = SynchronousPromise;
  return result;
};

SynchronousPromise.uninstallGlobally = function () {
  if (Promise === SynchronousPromise) {
    Promise = RealPromise;
  }
};

function patchAwaiterIfRequired(__awaiter) {
  if (typeof (__awaiter) === "undefined" || __awaiter.__patched) {
    return __awaiter;
  }
  var originalAwaiter = __awaiter;
  __awaiter = function () {
    var Promise = RealPromise;
    originalAwaiter.apply(this, makeArrayFrom(arguments));
  };
  __awaiter.__patched = true;
  return __awaiter;
}

/* jshint ignore:end */

module.exports = {
  SynchronousPromise: SynchronousPromise
};


/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js


var variants = {
  diamond: {
    root: ' transform rotate-45',
    item: ' transform -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$colorBg,
        _ref$colorBorder = _ref.colorBorder,
        colorBorder = _ref$colorBorder === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$colorBorder,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
        hasShadow = _ref.hasShadow,
        relative = _ref.relative,
        variant = _ref.variant;
    return {
      thRoot: "bg-".concat(colorBg, " border-").concat(colorBorder, " text-").concat(color, " border-2 flex-none inline-flex items-center justify-center leading-0 overflow-hidden ").concat(relative ? 'relative' : '', " ").concat(hasShadow ? 'shadow' : '').concat(variant ? variants[variant].root : ''),
      thImage: "absolute inset-0 ".concat(variant ? variants[variant].item : ''),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-center ".concat(variant ? variants[variant].item : ''),
      thLabelStyle: {
        fontSize: '1em'
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx
var __jsx = react_default.a.createElement;





var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      color = _ref.color,
      hasShadow = _ref.hasShadow,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      imageSrc = _ref.imageSrc,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 50 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$relative = _ref.relative,
      relative = _ref$relative === void 0 ? true : _ref$relative,
      variant = _ref.variant;

  if (!iconName && !imageSrc && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    colorBg: colorBg,
    colorBorder: colorBorder,
    color: color,
    hasShadow: hasShadow,
    relative: relative,
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thImage = _themes$theme.thImage,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thRoot = _themes$theme.thRoot;

  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  return __jsx("span", {
    className: classnames_default()(thRoot, className),
    style: styles
  }, !!imageSrc && __jsx("span", {
    className: thImage
  }, __jsx(Image["b" /* default */], {
    altMsg: alt,
    imageUrl: imageSrc,
    dimensions: imageSize
  })), !!iconName && __jsx("span", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("span", {
    className: thLabel,
    style: thLabelStyle
  }, label));
};

/***/ }),

/***/ "VNI2":
/***/ (function(module, exports) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),

/***/ "VO7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setAdultsNumber; });
/* unused harmony export updateAdult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAttendees; });
/* unused harmony export setAdults */
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ORYz");



function setAdultsNumber(adultsNumber) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_ADULTS_NUMBER */ "e"], {
    adultsNumber: adultsNumber
  });
}

function updateAdult(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_ADULT */ "f"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}

function setAttendees(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ATTENDEES */ "d"], payload);
}

function setAdults(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ADULTS */ "c"], payload);
}



/***/ }),

/***/ "VO9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Notification_Notification; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// CONCATENATED MODULE: ./src/client/components/frameworks/notification/Notification.themes.js


var themes = {
  "default": function _default(_ref) {
    var color = _ref.color,
        colorBg = _ref.colorBg;
    return {
      thRoot: classnames_default()("bg-".concat(colorBg, " border-1 border-current flex isolate items-start p-10 relative rounded-12 text-").concat(color)),
      thInner: 'flex flex-col flex-1 sm:items-center sm:flex-row',
      thIcon: 'pt-5 pe-10',
      thMessage: 'sm:flex-1 p-10',
      thTitle: 'font-bold font-sans text-14 text-current',
      thText: 'font-sans text-14',
      thTextTheme: 'text-sans-n1',
      thSlot: 'max-w-full overflow-hidden p-10',
      thCloseButton: 'absolute p-10 end-0 top-0 z-1',
      thCloseButtonLabel: 'sr-only'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/notification/Notification.jsx


var __jsx = react_default.a.createElement;







var Notification_Notification = function Notification(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref$color,
      _ref$colorBg = _ref.colorBg,
      colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].WHITE : _ref$colorBg,
      hasClose = _ref.hasClose,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? icons["a" /* ICONS */].LIGHTBULB : _ref$iconName,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? '1.875rem' : _ref$iconWidth,
      id = _ref.id,
      onClose = _ref.onClose,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "closeLabel", "color", "colorBg", "hasClose", "iconName", "iconWidth", "id", "onClose", "text", "theme", "title"]);

  if (!title && !text && !react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color,
    colorBg: colorBg
  }),
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thIcon = _themes$theme.thIcon,
      thInner = _themes$theme.thInner,
      thMessage = _themes$theme.thMessage,
      thRoot = _themes$theme.thRoot,
      thSlot = _themes$theme.thSlot,
      thText = _themes$theme.thText,
      thTextTheme = _themes$theme.thTextTheme,
      thTitle = _themes$theme.thTitle;

  return __jsx("div", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(thRoot, className),
    id: id
  }), !!iconName && __jsx("div", {
    className: classnames_default()('leading-0', thIcon)
  }, __jsx(Icon["a" /* Icon */], {
    name: iconName,
    width: iconWidth
  })), __jsx("div", {
    className: thInner
  }, (text || title) && __jsx("div", {
    className: thMessage
  }, !!title && !text && __jsx("p", {
    className: classnames_default()('m-0', thTitle)
  }, title), !!title && !!text && __jsx("h3", {
    className: classnames_default()(thTitle)
  }, title), __jsx(Text["a" /* Text */], {
    className: thText,
    text: text,
    theme: thTextTheme
  })), react["Children"].count(children) > 0 && __jsx("div", {
    className: thSlot
  }, children)), hasClose && __jsx("button", {
    className: classnames_default()('leading-0', thCloseButton),
    onClick: onClose,
    type: "button"
  }, !!closeLabel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
};

/***/ }),

/***/ "VQ9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useBlockInputDepartureDate; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("uDfI");
/* harmony import */ var _client_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rueY");
/* harmony import */ var _client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("05PS");




function useBlockInputDepartureDate() {
  var checkIfDepartureDateIsBookable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var departureDateIsBookable = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__[/* getDepartureDateBookable */ "j"]);
  var blockInputDepartureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__[/* getBlockInputDepartureDate */ "b"]);
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useDispatch */ "d"])();

  var setBlockInputDepartureDate = function setBlockInputDepartureDate(value) {
    if (value !== blockInputDepartureDate) {
      dispatch(Object(_client_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_2__[/* setCalendarBlockInputDepartureDate */ "f"])(value));
    }
  };

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (departureDateIsBookable) {
      setBlockInputDepartureDate(false);
    }
  }, [departureDateIsBookable]);
  return {
    blockInputDepartureDate: checkIfDepartureDateIsBookable && blockInputDepartureDate,
    departureDateIsBookable: departureDateIsBookable,
    setBlockInputDepartureDate: setBlockInputDepartureDate
  };
}

/***/ }),

/***/ "Vk6K":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("Syyo"),
    copyArray = __webpack_require__("QT01"),
    getTag = __webpack_require__("kkM+"),
    isArrayLike = __webpack_require__("9y2L"),
    isString = __webpack_require__("nDih"),
    iteratorToArray = __webpack_require__("U7t3"),
    mapToArray = __webpack_require__("aURW"),
    setToArray = __webpack_require__("XlL0"),
    stringToArray = __webpack_require__("f2p0"),
    values = __webpack_require__("0iyY");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPricesByDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClosingDatesRanges; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ToJy");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ldK3");














var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n              siblingId\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true, isCalendarCase: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n                offerId\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_CALENDAR */ "dd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit;
  var bookableDatesQueryArs = {
    productId: productId,
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_BOOKABLE_DATES */ "cd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_7___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_7___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__[/* getSpecificQueryParam */ "l"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__[/* QUERY_DEPARTURE_DATE */ "g"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_7___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer,
              siblingId = _ref6.siblingId;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2, _priceConfig$termsAnd5;

            var available = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_OPEN */ "g"];
            var closed = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_CLOSED */ "a"];
            var exclusivity = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_EXCLUSIVITY */ "b"];
            var full = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_FULL */ "c"];
            var lastAvailability = offer === 'urgentisation';
            var noAvailability = availability === '';
            var noDeparture = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_DEPARTURE */ "e"];
            var noFlight = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_FLIGHT */ "f"];
            var siblingOpen = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_SUMMER */ "h"] || availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_WINTER */ "i"];
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              rate: priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd5 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd5 === void 0 ? void 0 : _priceConfig$termsAnd5.offerId,
              siblingId: siblingId,
              siblingOpen: siblingOpen,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}
var getClosingDatesRanges = function getClosingDatesRanges(openingDatesRanges) {
  return openingDatesRanges.sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  }).map(function (openingDate, index, openingDates) {
    var _openingDates;

    return {
      after: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "j"])(openingDate.closing).toDate(),
      before: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "j"])(((_openingDates = openingDates[index + 1]) === null || _openingDates === void 0 ? void 0 : _openingDates.opening) || openingDates[0].opening).toDate()
    };
  });
};

/***/ }),

/***/ "W+NJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputButton_InputButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var InputButton_themes_defaultTheme = function defaultTheme(_ref) {
  var isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled;
  var hasDefaultStyle = !isActive && !isFilled && !isDisabled;
  var hasFilledStyle = isFilled && !isDisabled;
  var hasActiveStyle = isActive && !isDisabled && !isFilled;
  return {
    thRoot: classnames_default()('border flex items-center leading-normal rounded-pill text-14 text-black transition-all duration-250 ease-in w-full', {
      'border-lightGrey hocus:border-black': hasDefaultStyle,
      'border-black': hasActiveStyle,
      'border-success text-black': hasFilledStyle,
      'border-grey bg-pearl cursor-not-allowed text-grey': isDisabled
    }),
    thButton: 'flex gap-10 items-center flex-1 h-48 px-20 py-10',
    thIcon: classnames_default()('flex-none shrink-0', {
      'text-success': isFilled
    }),
    thIconSize: '1.25em',
    thChildren: 'flex-1 text-initial',
    thBadgeColor: colors["a" /* COLORS */].SAFFRON,
    thBadgeColorText: colors["a" /* COLORS */].BLACK,
    thIconRight: 'leading-0 pe-20 py-10 shrink-0',
    thSpinner: 'shrink-0',
    thSpinnerColor: 'current',
    thIconCaret: 'transition-all duration-250 ease-in',
    thClear: 'leading-0 pe-20 py-10 shrink-0',
    thClearSize: '0.625rem',
    thSwitchButton: 'leading-0 pe-20 py-10 shrink-0',
    thSwitch: classnames_default()('bg-current border-current flex leading-0 overflow-hidden rounded-pill duration-250 ease-in transition-all', {
      'text-lightGrey': !isFilled,
      'text-success': isFilled
    }),
    thSwitchStyle: {
      width: 'calc(40rem / 16)',
      height: 'calc(24rem / 16)',
      padding: 'calc(2rem / 16)'
    },
    thSwitchToggler: classnames_default()('bg-white flex font-bold items-center justify-center leading-0 rounded-pill text-center text-10 shadow', {
      'text-lightGrey': !isFilled,
      'text-success transform ltr:translate-x-[16px] rtl:-translate-x-[16px]': isFilled
    }),
    thSwitchTogglerStyle: {
      width: 'calc(20rem / 16)',
      height: 'calc(20rem / 16)'
    }
  };
};

var themes = function themes(props) {
  var d = InputButton_themes_defaultTheme(props);
  return {
    "default": d,
    remote: _objectSpread(_objectSpread({}, d), {}, {
      thButton: 'flex gap-5 items-center justify-center flex-1 h-48 p-10',
      thChildren: 'text-initial',
      thBadge: 'hidden',
      thClear: 'hidden',
      thIconRight: 'hidden',
      thSwitchButton: 'hidden'
    })
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx
var __jsx = react_default.a.createElement;

/* eslint-disable react/jsx-no-useless-fragment */







var InputButton_InputButton = function InputButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      badgeCount = _ref.badgeCount,
      _ref$badgeSize = _ref.badgeSize,
      badgeSize = _ref$badgeSize === void 0 ? 24 : _ref$badgeSize,
      _ref$hasSwitch = _ref.hasSwitch,
      hasSwitch = _ref$hasSwitch === void 0 ? false : _ref$hasSwitch,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var _themes$theme = themes({
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isLoading: isLoading
  })[theme],
      thBadge = _themes$theme.thBadge,
      thBadgeColor = _themes$theme.thBadgeColor,
      thBadgeColorText = _themes$theme.thBadgeColorText,
      thButton = _themes$theme.thButton,
      thChildren = _themes$theme.thChildren,
      thClear = _themes$theme.thClear,
      thClearSize = _themes$theme.thClearSize,
      thIcon = _themes$theme.thIcon,
      thIconRight = _themes$theme.thIconRight,
      thIconCaret = _themes$theme.thIconCaret,
      thIconSize = _themes$theme.thIconSize,
      thSpinner = _themes$theme.thSpinner,
      thRoot = _themes$theme.thRoot,
      thSpinnerColor = _themes$theme.thSpinnerColor,
      thSwitch = _themes$theme.thSwitch,
      thSwitchButton = _themes$theme.thSwitchButton,
      thSwitchStyle = _themes$theme.thSwitchStyle,
      thSwitchToggler = _themes$theme.thSwitchToggler,
      thSwitchTogglerStyle = _themes$theme.thSwitchTogglerStyle;

  if (!iconName && !children) {
    return null;
  }

  var hasClear = onClear && isFilled && !isLoading && !isDisabled;
  return __jsx("div", {
    className: classnames_default()(thRoot, className)
  }, __jsx("button", {
    className: thButton,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: onClick,
    title: title,
    type: "button"
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    color: "none",
    name: iconName,
    width: thIconSize
  }), __jsx("span", {
    className: thChildren
  }, children), !!badgeCount && __jsx(Badge["a" /* Badge */], {
    className: thBadge,
    color: thBadgeColorText,
    colorBg: thBadgeColor,
    colorBorder: thBadgeColor,
    label: __jsx("span", {
      className: "-me-1 mt-1"
    }, badgeCount),
    size: badgeSize,
    variant: "pill"
  })), !hasSwitch && __jsx(react["Fragment"], null, hasClear ? __jsx("button", {
    "data-testid": "InputButtonClear",
    className: thClear,
    disabled: isDisabled,
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearSize
  })) : __jsx("button", {
    className: thIconRight,
    onClick: onClick,
    type: "button"
  }, isLoading ? __jsx(Spinner["a" /* Spinner */], {
    className: thSpinner,
    color: thSpinnerColor,
    size: "small"
  }) : __jsx(Icon["a" /* Icon */], {
    className: thIconCaret,
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: "0.625rem"
  }))), hasSwitch && __jsx("button", {
    className: thSwitchButton,
    "data-testid": "InputButtonClear",
    onClick: hasClear ? onClear : onClick,
    type: "button"
  }, __jsx("span", {
    className: thSwitch,
    style: thSwitchStyle
  }, __jsx("span", {
    "aria-hidden": true,
    className: thSwitchToggler,
    style: thSwitchTogglerStyle
  }, __jsx(Icon["a" /* Icon */], {
    name: isFilled ? icons["a" /* ICONS */].ON : icons["a" /* ICONS */].OFF,
    width: "calc(8rem / 16)"
  })))));
};

/***/ }),

/***/ "WGoB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttendeesSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTravelSectionSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pluralizeLabel; });
/* unused harmony export prefixWithPlusIfPositive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalizeName; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");





function pluralizeLabel(singularLabel, pluralLabel, value) {
  return value > 1 ? pluralLabel : singularLabel;
}

function prefixWithPlusIfPositive(value, label) {
  return value >= 0 ? "+".concat(label) : label;
}

function capitalizeName(text) {
  return (text || '').toLowerCase().replace(/(?:^|[-\s.'&])\S/g, function (a) {
    return a.toUpperCase();
  });
}

var getAttendeesSummary = function getAttendeesSummary(_ref) {
  var adultsCount = _ref.adultsCount,
      kidsCount = _ref.kidsCount;
  return "".concat(adultsCount, " ").concat(pluralizeLabel(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.adult'), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.adults'), adultsCount), " ").concat(kidsCount > 0 ? " - ".concat(kidsCount, " ").concat(pluralizeLabel(Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.child'), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.common.children'), kidsCount)) : '');
};
var getTravelSectionSummary = function getTravelSectionSummary(_ref2) {
  var travelSection = _ref2.travelSection;
  return "".concat(travelSection.label.toLowerCase(), " (").concat(travelSection.id.toUpperCase(), ")");
};


/***/ }),

/***/ "WeO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAttendeeNamePlaceholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNumberOfAdultsAndChildren; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var getAttendeeNamePlaceholder = function getAttendeeNamePlaceholder(attendee, isKid, isMain) {
  var firstName = attendee.firstName,
      lastName = attendee.lastName,
      civility = attendee.civility;
  var attendeeLabel = isKid ? Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.participants.otherKidsInfosHeader.title') : Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.participants.otherAdultsInfosHeader.title');

  if (isMain) {
    attendeeLabel = Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.participants.personnalInfosHeader.title');
  }

  if (firstName && lastName && civility) {
    attendeeLabel = "".concat(civility, " ").concat(firstName, " ").concat(lastName);
  }

  return attendeeLabel;
};
var getNumberOfAdultsAndChildren = function getNumberOfAdultsAndChildren(quantityOfChildren, quantityOfAdults) {
  if (quantityOfChildren === 0) {
    return "".concat(quantityOfAdults, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.adults'));
  }

  if (quantityOfChildren === 1) {
    return "".concat(quantityOfAdults, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.adults'), " - ").concat(quantityOfChildren, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.child'));
  }

  if (quantityOfChildren > 1) {
    return "".concat(quantityOfAdults, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.adults'), " - ").concat(quantityOfChildren, " ").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.common.children'));
  }
};

/***/ }),

/***/ "XTOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_Product; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("Rfxz");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// CONCATENATED MODULE: ./src/client/components/widgets/offer-discount/OfferDiscount.jsx
var __jsx = react_default.a.createElement;



var OfferDiscount_OfferDiscount = function OfferDiscount(_ref) {
  var _discount$amount;

  var className = _ref.className,
      discount = _ref.discount,
      i18n = _ref.i18n;
  var offerName = (discount === null || discount === void 0 ? void 0 : discount.offerName) || (i18n === null || i18n === void 0 ? void 0 : i18n.defaultLabel) || '';
  var backgroundColor = (discount === null || discount === void 0 ? void 0 : discount.offerColor) || (i18n === null || i18n === void 0 ? void 0 : i18n.defaultColor) || null;
  return (discount === null || discount === void 0 ? void 0 : (_discount$amount = discount.amount) === null || _discount$amount === void 0 ? void 0 : _discount$amount.value) ? __jsx(Tag["a" /* Tag */], {
    className: className,
    color: colors["a" /* COLORS */].WHITE,
    style: {
      backgroundColor: backgroundColor
    }
  }, offerName) : null;
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-comparison/ProductComparison.jsx

var ProductComparison_jsx = react_default.a.createElement;





var ProductComparison_ProductComparison = function ProductComparison(_ref) {
  var className = _ref.className,
      eligibilityLabel = _ref.eligibilityLabel,
      isEligible = _ref.isEligible,
      label = _ref.label,
      onComparisonClick = _ref.onComparisonClick,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? product_utils["b" /* IS_ENABLED */] : _ref$status;

  if (!isEligible) {
    return ProductComparison_jsx("div", {
      className: "absolute bg-white/60 flex font-bold inset-0 items-center justify-center p-20 rounded-12 text-14 text-center z-1"
    }, eligibilityLabel);
  }

  var isSelectable = status !== product_utils["a" /* IS_DISABLED */];
  var isSelected = status === product_utils["c" /* IS_SELECTED */];
  var buttonProps = isSelectable ? {
    onClick: onComparisonClick,
    type: 'button',
    title: label
  } : null;
  var TagName = isSelectable ? 'button' : 'div';
  return ProductComparison_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()('absolute bg-darkGrey/40 flex h-full inset-0 items-center justify-center p-20 rounded-12 text-white w-full z-1', className)
  }, buttonProps), isSelectable && ProductComparison_jsx("span", {
    className: classnames_default()('aspect-square border-2 leading-0 p-10 rounded-full transition-colors duration-250 ease-in', {
      'bg-transparent border-white': !isSelected,
      'bg-saffron border-saffron text-black': isSelected
    })
  }, ProductComparison_jsx(Icon["a" /* Icon */], {
    name: isSelected ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-thumbnail/ProductThumbnail.jsx
var ProductThumbnail = __webpack_require__("Z+2E");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/Availability.jsx
var Availability_jsx = react_default.a.createElement;




var computeAvailabilityStatus = function computeAvailabilityStatus(_ref) {
  var availability = _ref.availability,
      remainingStock = _ref.remainingStock;

  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
};

var Availability_Availability = function Availability(_ref2) {
  var availability = _ref2.availability,
      config = _ref2.config,
      remainingStock = _ref2.remainingStock;
  var availabilityStatus = computeAvailabilityStatus({
    availability: availability,
    remainingStock: remainingStock
  });

  var _ref3 = config[availabilityStatus] || {},
      color = _ref3.color,
      icon = _ref3.icon,
      label = _ref3.label;

  return label ? Availability_jsx("span", {
    className: "flex flex-none shrink gap-5 items-center text-".concat(color, " text-end")
  }, icon && Availability_jsx(Icon["a" /* Icon */], {
    name: icon,
    width: "0.8rem"
  }), Object(dist["messageFormat"])(label).format({
    count: remainingStock
  })) : null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/AvailabilityAge.jsx
var AvailabilityAge_jsx = react_default.a.createElement;



var shouldShowAgeInMonth = function shouldShowAgeInMonth(ageInNumberOfMonths) {
  return ageInNumberOfMonths <= 23;
};

var shouldShowAgeInYearsRange = function shouldShowAgeInYearsRange(ageMin, ageMax) {
  return !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));
};

var AvailabilityAge_AvailabilityAge = function AvailabilityAge(_ref) {
  var ageMax = _ref.ageMax,
      ageMin = _ref.ageMin,
      childcareLabel = _ref.childcareLabel,
      monthsLabel = _ref.monthsLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var message = '';

  if (shouldShowAgeInMonth(ageMax)) {
    message = Object(dist["messageFormat"])(monthsLabel).format({
      min: ageMin,
      max: ageMax
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = Object(dist["messageFormat"])(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12)
    });
  } else {
    // Shows a single year age
    message = Object(dist["messageFormat"])(yearLabel).format({
      fixed: Math.floor(ageMin / 12)
    });
  }

  return AvailabilityAge_jsx(react["Fragment"], null, "".concat(childcareLabel, " "), AvailabilityAge_jsx("span", {
    className: "font-normal whitespace-nowrap"
  }, "(", message, ")"));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/productChildcareAvailabilities.jsx

var productChildcareAvailabilities_jsx = react_default.a.createElement;







var productChildcareAvailabilities_ProductChildcareAvailabilities = function ProductChildcareAvailabilities(_ref) {
  var availableLabel = _ref.availableLabel,
      childcareLabel = _ref.childcareLabel,
      items = _ref.items,
      monthsLabel = _ref.monthsLabel,
      remainingLabel = _ref.remainingLabel,
      unavailableLabel = _ref.unavailableLabel,
      unknownLabel = _ref.unknownLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var renderConfig = {
    available: {
      color: colors["a" /* COLORS */].GREEN,
      icon: icons["a" /* ICONS */].CHECK,
      label: availableLabel
    },
    remaining: {
      color: colors["a" /* COLORS */].ORANGE,
      icon: icons["a" /* ICONS */].WARNING,
      label: remainingLabel
    },
    unavailable: {
      color: colors["a" /* COLORS */].RED,
      icon: icons["a" /* ICONS */].CROSS,
      label: unavailableLabel
    },
    unknown: {
      color: colors["a" /* COLORS */].MEDIUM_GREY,
      label: unknownLabel
    }
  };
  return productChildcareAvailabilities_jsx(react["Fragment"], null, items.map(function (_ref2) {
    var ageMax = _ref2.ageMax,
        ageMin = _ref2.ageMin,
        availability = _ref2.availability,
        id = _ref2.id,
        isIncluded = _ref2.isIncluded,
        remainingStock = _ref2.remainingStock;
    return productChildcareAvailabilities_jsx("p", {
      key: id,
      className: "flex font-bold items-start justify-between mt-10 text-14 text-black"
    }, productChildcareAvailabilities_jsx("span", {
      className: "flex-1"
    }, productChildcareAvailabilities_jsx(AvailabilityAge_AvailabilityAge, {
      ageMax: ageMax,
      ageMin: ageMin,
      childcareLabel: childcareLabel,
      monthsLabel: monthsLabel,
      yearLabel: yearLabel,
      yearsLabel: yearsLabel
    }), productChildcareAvailabilities_jsx("span", {
      className: classnames_default()('font-brand font-normal me-5 text-12', {
        'text-black': isIncluded,
        'text-sienna': !isIncluded
      })
    }, isIncluded ? Object(src_i18n["h" /* t */])('common.included') : Object(src_i18n["h" /* t */])('common.onDemand'))), productChildcareAvailabilities_jsx(Availability_Availability, {
      availability: availability,
      config: renderConfig,
      remainingStock: remainingStock
    }));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.jsx
















var Product_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var Product_Product = function Product(_ref) {
  var _flag$price, _flag$price$bestPrice, _flag$price2, _flag$price2$bestPric, _minAuthorizedAge$val;

  var childcare = _ref.childcare,
      childcareIncluded = _ref.childcareIncluded,
      className = _ref.className,
      _ref$cmtaLinks = _ref.cmtaLinks,
      cmtaLinks = _ref$cmtaLinks === void 0 ? {} : _ref$cmtaLinks,
      comfort = _ref.comfort,
      comparison = _ref.comparison,
      departureDateOn = _ref.departureDateOn,
      _ref$flag = _ref.flag,
      flag = _ref$flag === void 0 ? {} : _ref$flag,
      hasComparison = _ref.hasComparison,
      hasDiscount = _ref.hasDiscount,
      _ref$hasFadeIn = _ref.hasFadeIn,
      hasFadeIn = _ref$hasFadeIn === void 0 ? true : _ref$hasFadeIn,
      hasLazyLoading = _ref.hasLazyLoading,
      header = _ref.header,
      id = _ref.id,
      index = _ref.index,
      _ref$isCompact = _ref.isCompact,
      isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids,
      lineName = _ref.lineName,
      _ref$minAuthorizedAge = _ref.minAuthorizedAge,
      minAuthorizedAge = _ref$minAuthorizedAge === void 0 ? {} : _ref$minAuthorizedAge,
      offer = _ref.offer,
      offerDiscount = _ref.offerDiscount,
      onClick = _ref.onClick,
      onComparisonClick = _ref.onComparisonClick,
      ratioDisplay = _ref.ratioDisplay,
      thumbnail = _ref.thumbnail,
      url = _ref.url;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isGsa = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('isGsa');
  var router = Object(next_router["useRouter"])();

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var track = Object(useTracking["a" /* useTracking */])({});
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: typeof comfort === 'number' ? comfort : '',
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price = flag.price) === null || _flag$price === void 0 ? void 0 : (_flag$price$bestPrice = _flag$price.bestPrice) === null || _flag$price$bestPrice === void 0 ? void 0 : _flag$price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(camelCase_default()(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var clickIconBubbleTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: "".concat(id, "_infoIcon"),
    resortCode: id,
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price2 = flag.price) === null || _flag$price2 === void 0 ? void 0 : (_flag$price2$bestPric = _flag$price2.bestPrice) === null || _flag$price2$bestPric === void 0 ? void 0 : _flag$price2$bestPric.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(camelCase_default()(lineName)) : siteSection,
    thumbnailPosition: index + 1,
    siteSection: siteSection
  } : null;
  var linkShouldBeDisabled = isLinkDisabled || hasComparison || isGsa;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    router.push(newHistoryState.toString());
  };

  var minAuthorizedAgeMessage = (minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) === 0 ? Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcareFrom0') : Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcare', {
    min_authorized_age_in_months: Math.floor(((_minAuthorizedAge$val = minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) !== null && _minAuthorizedAge$val !== void 0 ? _minAuthorizedAge$val : 0) / 12)
  });
  var childcareBirthdateAlert = (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && childcare && isEmpty_default()(childcare.items) && !childcareIncluded;
  var noChildcareAlert = kids && kids.length > 0 && kids.some(function (kid) {
    return !kid.birthdate;
  }) && childcareIncluded;
  return Product_jsx("article", {
    className: classnames_default()('isolate relative', {
      'animate-fadeIn animation-duration-750': hasFadeIn
    }, className),
    onClick: onClick
  }, Product_jsx("div", {
    className: classnames_default()('isolate relative', {
      'flex gap-10': isCompact
    })
  }, Product_jsx("div", {
    className: classnames_default()('relative', {
      'w-1/2 shrink-0': isCompact
    }),
    "data-testid": "Product-Header-Wrapper"
  }, hasComparison && Product_jsx(ProductComparison_ProductComparison, Object(esm_extends["a" /* default */])({}, comparison, {
    onComparisonClick: onComparisonClick
  })), !!departureDateOn && Product_jsx(Tag["a" /* Tag */], {
    className: "absolute start-0 mx-10 -translate-y-1/2 z-2",
    color: colors["a" /* COLORS */].SIENNA,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].SIENNA,
    "data-testid": "Product-departure"
  }, departureDateOn), hasDiscount && Product_jsx(OfferDiscount_OfferDiscount, {
    className: "absolute end-0 mx-10 -translate-y-1/2 z-2",
    discount: offerDiscount === null || offerDiscount === void 0 ? void 0 : offerDiscount.discount,
    i18n: offerDiscount === null || offerDiscount === void 0 ? void 0 : offerDiscount.i18n
  }), Product_jsx(ProductThumbnail["a" /* ProductThumbnail */], Object(esm_extends["a" /* default */])({}, thumbnail, {
    className: "overflow-hidden rounded-12",
    hasLazyLoading: hasLazyLoading,
    isLinkDisabled: true,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratioDisplay: ratioDisplay
  }))), Product_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    className: classnames_default()({
      'overflow-hidden': isCompact,
      'mt-10': !isCompact
    }),
    isLinkDisabled: linkShouldBeDisabled,
    link: appContext.isCmta && id && Object(Product_utils["e" /* localeHasCmtaLinks */])(cmtaLinks) ? Object(Product_utils["a" /* generateCmtaLinkProp */])(id, cmtaLinks) : Object(Product_utils["b" /* generateLinkProp */])(url, offer),
    onClick: function onClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    }
  }))), !isEmpty_default()(flag) && Product_jsx(ProductFlag["a" /* ProductFlag */], Object(esm_extends["a" /* default */])({}, flag, {
    isLinkDisabled: linkShouldBeDisabled,
    onClick: goOnResort,
    onCtaClick: function onCtaClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_discoverResort")
        }));
      }
    },
    onEmptyPriceClick: function onEmptyPriceClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    },
    onPriceClick: function onPriceClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_bestPrice")
        }));
      }
    },
    onIconBubbleClick: function onIconBubbleClick() {
      if (Object(src_i18n["d" /* getKeyValue */])('price.displayIconBubble')) {
        track(_objectSpread(_objectSpread({}, clickIconBubbleTrackingData), {}, {
          labelGA: "".concat(id, "_infoIcon")
        }));
      }
    },
    price: flag.price
  })), childcareBirthdateAlert && Product_jsx("div", {
    className: "border-1 border-lightGrey flex gap-5 mt-5 p-10 rounded-12 text-12"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "mt-1 shrink-0",
    color: colors["a" /* COLORS */].RED,
    name: icons["a" /* ICONS */].WARNING,
    width: "1rem"
  }), minAuthorizedAgeMessage), noChildcareAlert && Product_jsx("button", {
    className: "bg-sand hocus:bg-sand-active cursor-pointer flex font-bold gap-5 leading-1 mt-5 p-10 rounded-12 text-12 text-initial text-black transition-colors duration-250 ease-in",
    onClick: function onClick() {
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="CriteriaWho"]', 600);
    },
    type: "button"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "mt-1 shrink-0",
    name: icons["a" /* ICONS */].KIDS,
    width: "1rem"
  }), Object(src_i18n["h" /* t */])('faceting.availabilities.enterBirthdate')), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.childcare') && childcare && !isEmpty_default()(childcare.items) && Product_jsx(productChildcareAvailabilities_ProductChildcareAvailabilities, childcare));
};

/***/ }),

/***/ "XiOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaContextProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var initialState = {
  criteriaWhenIsSet: false,
  criteriaWhoIsSet: false,
  criteriaTransportIsSet: false,
  defaultValueForCalendar: null,
  isJoyview: false,
  layerButtonLabel: '',
  layerHeader: '',
  trackingActionName: '',
  setFacetHasSeeMore: function setFacetHasSeeMore() {},
  displayActivityFilter: true,
  displayChildcareFilter: true,
  displayDestinationFilter: true,
  displaySeasonFilter: true,
  displayTypeOfStayFilter: true,
  displayFlightDurationFilter: true
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  return _objectSpread(_objectSpread({}, state), action);
};

var CriteriaContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_8__["createContext"])([initialState, function () {}]);
var CriteriaContextProvider = function CriteriaContextProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_8__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var reducer = Object(react__WEBPACK_IMPORTED_MODULE_8__["useMemo"])(function () {
    return [state, dispatch];
  }, [state, dispatch]);
  return __jsx(CriteriaContext.Provider, {
    value: reducer
  }, children);
};

/***/ }),

/***/ "XpIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LEGAL_INFO_WEBTHEO_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LEGAL_INFO_NDC_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LEGAL_INFO_THEO_ID; });
/* unused harmony export LEGAL_INFO_SMS_ID */
/* unused harmony export LEGAL_INFO_EMAIL_ID */
/* unused harmony export LEGAL_INFO_MAIL_ID */
/* unused harmony export LEGAL_INFO_FOSUN_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEGAL_INFO_CGV_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEALTH_REGULATION; });
var LEGAL_INFO_WEBTHEO_ID = 'WEBTHEO';
var LEGAL_INFO_NDC_ID = 'NDC';
var LEGAL_INFO_THEO_ID = 'THEO';
var LEGAL_INFO_SMS_ID = 'SMS_OPTIN';
var LEGAL_INFO_EMAIL_ID = 'EMAIL_OPTIN';
var LEGAL_INFO_MAIL_ID = 'MAIL_OPTIN';
var LEGAL_INFO_FOSUN_ID = 'FOSUN_PARTNERS';
var LEGAL_INFO_CGV_ID = 'CGV';
var HEALTH_REGULATION = 'HEALTH_REGULATION';

/***/ }),

/***/ "Xzib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PopOver_PopOver; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-large arrow-white bg-white after:drop-shadow-md mb-20 rounded-2 shadow-md',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  infoBanner: {
    thTrigger: 'w-full',
    thContainer: 'absolute top-full animate-fadeIn animation-duration-500 mt-5 rounded-2',
    thContent: ' arrow-white bg-white',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.875rem'
  },
  priceOfStayTooltip: {
    thTrigger: 'w-full',
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md mb-20 rounded-2',
    thCloseButton: 'absolute p-5 end-0 text-mediumGrey',
    thCloseIconWidth: '0.625rem'
  },
  fancy: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-5',
    thContent: 'arrow-bg arrow-bg-black arrow-downLeft arrow-large arrow-white bg-white border-1 border-black after:drop-shadow-md mb-20 rounded-12 shadow-md',
    thCloseButton: 'absolute leading-0 p-10 end-0 top-0 text-grey',
    thCloseIconWidth: '0.625rem'
  },
  favorite: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-end',
    thContent: 'arrow-downRight arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  'favorite-centered': {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0 -mb-40 flex justify-center',
    thContent: 'arrow-down arrow-white bg-white after:drop-shadow-md text-12 mb-10 text-center rounded-2',
    thCloseButton: 'absolute leading-none p-10 end-0 top-0 text-black',
    thCloseIconWidth: '0.625rem'
  },
  typesOfStaySearchFilter: {
    thContainer: 'absolute bottom-full animate-fadeIn animation-duration-500 -mb-5 w-screen',
    thContent: 'flex w-full leading-1',
    thCloseButton: '',
    thTrigger: 'leading-0',
    thCloseIconWidth: ''
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx

var __jsx = react_default.a.createElement;









var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
      containerStyle = _ref.containerStyle,
      content = _ref.content,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
      _ref$isInitiallyVisib = _ref.isInitiallyVisible,
      isInitiallyVisible = _ref$isInitiallyVisib === void 0 ? false : _ref$isInitiallyVisib,
      _ref$isModalOnly = _ref.isModalOnly,
      isModalOnly = _ref$isModalOnly === void 0 ? false : _ref$isModalOnly,
      _onClick = _ref.onClick,
      onRender = _ref.onRender,
      onTimeout = _ref.onTimeout,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      timeoutInMs = _ref.timeoutInMs,
      triggerOnHover = _ref.triggerOnHover;

  var _useState = Object(react["useState"])(isInitiallyVisible),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  Object(react["useEffect"])(function () {
    onRender && onRender();

    if (timeoutInMs && timeoutInMs > 0) {
      setTimeout(function () {
        setIsVisible(false);
        onTimeout && onTimeout();
      }, timeoutInMs);
    }

    return function () {
      onTimeout && onTimeout();
    };
  }, []);
  var shouldTriggerOnHover = triggerOnHover && isDesktop;
  Object(react["useEffect"])(function () {
    var timeoutId;

    if (shouldTriggerOnHover && isVisible && _onClick) {
      timeoutId = setTimeout(_onClick, 300);
      return function () {
        clearTimeout(timeoutId);
      };
    }
  }, [isVisible, shouldTriggerOnHover]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTrigger = _themes$theme.thTrigger,
      thContainer = _themes$theme.thContainer,
      thContent = _themes$theme.thContent,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseIconWidth = _themes$theme.thCloseIconWidth;
  return __jsx("div", Object(esm_extends["a" /* default */])({
    className: classnames_default()('isolate relative', className)
  }, shouldTriggerOnHover && {
    onMouseEnter: function onMouseEnter(e) {
      setIsVisible(true);

      if (!shouldTriggerOnHover) {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      }
    },
    onMouseLeave: function onMouseLeave() {
      setIsVisible(false);
    }
  }), __jsx("button", {
    className: thTrigger,
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();

      if (!timeoutInMs) {
        setIsVisible(!isVisible);
      }

      if (!isVisible && !shouldTriggerOnHover && _onClick) {
        _onClick(e);
      }
    },
    type: "button"
  }, children), isVisible && (isDesktop && !isModalOnly ? __jsx(ClickOutside["a" /* ClickOutside */], Object(esm_extends["a" /* default */])({
    className: classnames_default()(thContainer, containerClassName),
    onClick: function onClick() {
      setIsVisible(false);
    }
  }, containerStyle ? {
    style: containerStyle
  } : {}), __jsx("div", {
    className: classnames_default()(thContent, contentClassName)
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    onClick: function onClick() {
      return setIsVisible(false);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), content)) : __jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};

/***/ }),

/***/ "Y3fD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__("ERkP");
var factory = __webpack_require__("ttFy");

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ "YGK4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("HFnK");


/***/ }),

/***/ "YRNe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AlternativeProposals_AlternativeProposals; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsUtils.js
var AlternativeProposalsUtils = __webpack_require__("/nu6");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionHeader.jsx

var __jsx = react_default.a.createElement;










var AlternativeDateSuggestionHeader_AlternativeDateSuggestionHeader = function AlternativeDateSuggestionHeader(_ref) {
  var arrivalDate = _ref.arrivalDate,
      className = _ref.className,
      duration = _ref.duration,
      resort = _ref.resort;
  var getFormattedDateTitle = Object(dateUtils["a" /* formatDate */])('DD/MM');
  var departureDate = Object(AlternativeProposalsUtils["a" /* getDepartureDate */])({
    date: arrivalDate,
    duration: duration,
    format: apiDate["a" /* API_DATE_FORMAT */],
    unit: 'days'
  });
  return __jsx("h2", {
    className: classnames_default()('flex font-brand gap-10 items-start leading-tight text-24 md:text-28 lg:text-32 text-black', className),
    "data-testid": "AlternativeDate"
  }, __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: colors["a" /* COLORS */].ORANGE,
    hasRtl: true,
    name: icons["a" /* ICONS */].WARNING,
    width: "2em"
  }), __jsx("span", null, __jsx(TemplateString["a" /* TemplateString */], {
    className: "block",
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.noAvailabilityOnCriterionLabel') // $FlowFixMe
    ,
    values: {
      resortName: resort.name
    }
  }), __jsx(TemplateString["a" /* TemplateString */], {
    className: "block text-orange",
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.notAvailableDates') // $FlowFixMe
    ,
    values: {
      arrivalDate: getFormattedDateTitle(arrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDateTitle(departureDate, 'YYYYMMDD') || ''
    }
  })));
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("4mDm");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("3bBZ");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/components/widgets/package/price/DateSummary.jsx



var DateSummary_jsx = react_default.a.createElement;







var DateSummary_DateSummary = function DateSummary(_ref) {
  var className = _ref.className,
      template = _ref.template,
      values = _ref.values;
  return DateSummary_jsx("p", {
    className: classnames_default()('flex items-center gap-10 text-14', className),
    "data-testid": booking_constants["l" /* CRITERIA_SELECTORS */].DEPARTURE
  }, DateSummary_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: colors["a" /* COLORS */].SIENNA,
    hasRtl: true,
    name: icons["a" /* ICONS */].DATE,
    width: "1.875rem"
  }), DateSummary_jsx(TemplateString["a" /* TemplateString */], {
    template: template // $FlowFixMe
    ,
    values: values,
    valuesClassName: {
      arrivalDate: 'font-bold text-sienna',
      departureDate: 'font-bold text-sienna'
    }
  }));
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("4Brf");

// CONCATENATED MODULE: ./src/client/components/frameworks/flipper/Flipper.jsx


var Flipper_jsx = react_default.a.createElement;

var Flipper_Flipper = function Flipper(_ref) {
  var description = _ref.description,
      value = _ref.value;

  var _useState = Object(react["useState"])(value),
      oldValue = _useState[0],
      setOldValue = _useState[1];

  var _useState2 = Object(react["useState"])(value),
      latestValue = _useState2[0],
      setLatestValue = _useState2[1];

  var _useState3 = Object(react["useState"])(''),
      transition = _useState3[0],
      setTransition = _useState3[1];

  Object(react["useEffect"])(function () {
    setOldValue(latestValue);
    setLatestValue(value);

    if (value !== latestValue) {
      setTransition('animate-flipperLeave');
    }
  }, [value]);
  return Flipper_jsx("span", {
    "data-testid": value,
    className: "isolate relative"
  }, !!description && Flipper_jsx("span", {
    className: "sr-only",
    "data-testid": "srOnly"
  }, description), Flipper_jsx("span", {
    className: "text-center block ".concat(transition),
    "data-testid": "Flipper-value",
    key: transition,
    onAnimationEnd: function onAnimationEnd(event) {
      switch (event.animationName) {
        case 'animate-flipperLeave':
          setTransition('animate-flipperEnter');
          break;

        case 'animate-flipperEnter':
          setTransition('animate-flipperEnter');
          break;

        default:
          break;
      }
    }
  }, transition === 'animate-flipperLeave' ? oldValue : latestValue));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeSuggestionCriteria.jsx
var AlternativeSuggestionCriteria_jsx = react_default.a.createElement;







var AlternativeSuggestionCriteria_AlternativeSuggestionCriteria = function AlternativeSuggestionCriteria(_ref) {
  var buttonLabel = _ref.buttonLabel,
      className = _ref.className,
      onSubmit = _ref.onSubmit,
      suggestion = _ref.suggestion,
      title = _ref.title;
  var getFormattedDate = Object(dateUtils["a" /* formatDate */])('D MMMM YYYY');
  return AlternativeSuggestionCriteria_jsx("div", {
    className: className,
    "data-testid": "AlternativeDateSuggestionCriteria"
  }, title && AlternativeSuggestionCriteria_jsx("p", {
    className: "mb-5 text-16 text-black"
  }, title), AlternativeSuggestionCriteria_jsx(Capsule["a" /* Capsule */], {
    contentClassName: "flex flex-col gap-10 p-20"
  }, AlternativeSuggestionCriteria_jsx(DateSummary_DateSummary, {
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.fromTo'),
    values: {
      arrivalDate: getFormattedDate(suggestion.resortArrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDate(suggestion.resortDepartureDate, 'YYYYMMDD') || ''
    }
  }), AlternativeSuggestionCriteria_jsx("div", {
    className: "flex font-bold gap-10 items-center justify-center text-sienna"
  }, AlternativeSuggestionCriteria_jsx(Flipper_Flipper, {
    value: suggestion.price.total
  }), AlternativeSuggestionCriteria_jsx(Flipper_Flipper, {
    value: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.totalPrice')
  })), AlternativeSuggestionCriteria_jsx(Button["a" /* Button */], {
    className: "w-full",
    dataTestId: "AlternativeProposalsModalButton",
    onClick: function onClick() {
      return onSubmit(suggestion.resortArrivalDate);
    }
  }, buttonLabel)));
};
// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionImmersive.jsx

var AlternativeDateSuggestionImmersive_jsx = react_default.a.createElement;







var DIMENSIONS = {
  h: 408,
  w: 734
};
var AlternativeDateSuggestionImmersive_AlternativeDateSuggestionImmersive = function AlternativeDateSuggestionImmersive(_ref) {
  var className = _ref.className,
      onClose = _ref.onClose,
      resort = _ref.resort;
  var trackClick = Object(useTracking["a" /* useTracking */])({
    actionGA: 'checkPricesKO',
    categoryGA: 'search'
  });
  return AlternativeDateSuggestionImmersive_jsx("div", {
    className: classnames_default()('w-full', className)
  }, AlternativeDateSuggestionImmersive_jsx("div", {
    className: "overflow-hidden rounded-12"
  }, AlternativeDateSuggestionImmersive_jsx(Image["a" /* Image */], {
    altMsg: resort.name,
    dimensions: DIMENSIONS,
    hasLazyLoading: false,
    imageUrl: resort.image
  })), !!onClose && AlternativeDateSuggestionImmersive_jsx("button", {
    className: "flex font-sans gap-5 items-center mt-20 text-16 text-sienna",
    onClick: function onClick() {
      onClose && onClose();
      trackClick({
        labelGA: 'backResortPage'
      });
    },
    type: "button"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.doNotCheckPriceLabel'), AlternativeDateSuggestionImmersive_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_RIGHT
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-suggestions/AlternativeSuggestions.jsx
var AlternativeSuggestions_jsx = react_default.a.createElement;







var AlternativeSuggestions_AlternativeSuggestions = function AlternativeSuggestions(_ref) {
  var children = _ref.children,
      className = _ref.className,
      immersiveResort = _ref.immersiveResort,
      onClose = _ref.onClose,
      title = _ref.title;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return AlternativeSuggestions_jsx("div", {
    className: classnames_default()(className)
  }, AlternativeSuggestions_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n1"
  }, title), AlternativeSuggestions_jsx("div", {
    className: "flex gap-20"
  }, isTablet ? AlternativeSuggestions_jsx("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 gap-20"
  }, children) : AlternativeSuggestions_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    className: "-mx-20",
    forwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  }, AlternativeSuggestions_jsx("div", {
    className: "flex gap-10 px-20"
  }, children)), immersiveResort && AlternativeSuggestions_jsx(AlternativeDateSuggestionImmersive_AlternativeDateSuggestionImmersive, {
    onClose: onClose,
    resort: immersiveResort
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeDurationSuggestions.jsx









var AlternativeDurationSuggestions_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var AlternativeDurationSuggestions_AlternativeDurationSuggestions = function AlternativeDurationSuggestions(_ref) {
  var durations = _ref.durations,
      onSelectNewDuration = _ref.onSelectNewDuration,
      trackingData = _ref.trackingData;
  return AlternativeDurationSuggestions_jsx(AlternativeSuggestions_AlternativeSuggestions, {
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.durationsLabel')
  }, durations.map(function (suggestion) {
    var duration = suggestion.data.duration;
    var multi = durations.length > 1;
    return AlternativeDurationSuggestions_jsx(AlternativeSuggestionCriteria_AlternativeSuggestionCriteria, {
      buttonLabel: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.checkPriceLabelDuration'),
      className: classnames_default()({
        'flex-none last:scroll-x-ghost-m-20 last:scroll-x-ghost-m w-[280px] sm:w-auto': multi,
        'flex-1': !multi
      }),
      key: duration,
      onSubmit: function onSubmit() {
        onSelectNewDuration({
          proposalIds: suggestion.ids,
          duration: duration
        });
        trackingData('duration_check');
      },
      suggestion: _objectSpread(_objectSpread({}, suggestion.data), {}, {
        price: {
          total: suggestion.data.price.total.formattedValue
        }
      }),
      title: AlternativeDurationSuggestions_jsx(react["Fragment"], null, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.durationLabel'), ' ', AlternativeDurationSuggestions_jsx("span", {
        className: "font-bold text-18 text-sienna"
      }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.durationsSuggestions', {
        duration: duration
      })))
    });
  }));
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("+2oP");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/AlternativePrice.themes.js
var themes = {
  "default": {
    thRoot: 'w-full bg-white border-1 rounded-4 shadow-sm relative',
    thHeightStyle: {
      minHeight: '3.125rem'
    },
    thButton: 'flex flex-1 border-1 leading-0 overflow-hidden rounded-4 text-14 bg-saffron border-saffron text-white items-center text-current text-initial lg:me-10 justify-center md:justify-between',
    thClear: 'px-10 shrink-0 text-current',
    thClearSize: '0.625rem',
    thIcon: 'shrink-0 mx-10',
    thLabel: 'flex-1 mx-10 overflow-hidden flex items-center whitespace-nowrap',
    thSubmitButton: 'bg-success cursor-pointer font-bold flex justify-center items-center leading-0 rounded-4 text-14 text-white mt-15 lg:mt-0 lg:flex-1 w-full lg:w-auto'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/constants.js
var ALL_INCLUSIVE_SERVICE_LIST_DESKTOP_OVERFLOW_THRESHOLD = 4;
var ALL_INCLUSIVE_SERVICE_LIST_MOBILE_OVERFLOW_THRESHOLD = 2;
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/constants.js
var criteria_transport_constants = __webpack_require__("MX/n");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/constants.js
var criteria_when_constants = __webpack_require__("393O");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/constants.js
var criteria_who_constants = __webpack_require__("PFSw");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var store_booking_constants = __webpack_require__("2N/j");

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price-criteria-button/AlternativePriceCriteriaButton.jsx
var AlternativePriceCriteriaButton_jsx = react_default.a.createElement;




var AlternativePriceCriteriaButton_AlternativePriceCriteriaButton = function AlternativePriceCriteriaButton(_ref) {
  var children = _ref.children,
      iconName = _ref.iconName,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thButton = _themes$theme.thButton,
      thHeightStyle = _themes$theme.thHeightStyle,
      thIcon = _themes$theme.thIcon,
      thLabel = _themes$theme.thLabel;
  return AlternativePriceCriteriaButton_jsx("button", {
    className: thButton,
    onClick: onClick,
    style: thHeightStyle,
    type: "button"
  }, AlternativePriceCriteriaButton_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: "1em"
  }), AlternativePriceCriteriaButton_jsx("span", {
    className: classnames_default()(thLabel),
    style: thHeightStyle
  }, children));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product-banner/ProductBanner.jsx
var ProductBanner = __webpack_require__("SUcU");

// EXTERNAL MODULE: ./src/client/components/widgets/product-services/product-service/ProductService.jsx
var ProductService = __webpack_require__("9OZL");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/AlternativePrice.jsx





var AlternativePrice_jsx = react_default.a.createElement;
























var AlternativePrice_AlternativePrice = function AlternativePrice(_ref) {
  var bookingEngineEntryPoint = _ref.bookingEngineEntryPoint,
      continueToBookingEngine = _ref.continueToBookingEngine,
      departureCities = _ref.departureCities,
      hasOtherProposals = _ref.hasOtherProposals,
      onModify = _ref.onModify,
      proposals = _ref.proposals,
      resort = _ref.resort,
      _ref$searchCriteria = _ref.searchCriteria,
      adultsCount = _ref$searchCriteria.adultsCount,
      arrivalDate = _ref$searchCriteria.arrivalDate,
      departureCity = _ref$searchCriteria.departureCity,
      duration = _ref$searchCriteria.duration,
      kidsCount = _ref$searchCriteria.kidsCount,
      seeOtherProposalsCallback = _ref.seeOtherProposalsCallback,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])();
  var _proposals$ = proposals[0],
      price = _proposals$.price,
      allInclusiveServices = _proposals$.allInclusiveServices;

  if (!price) {
    return null;
  }

  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thSubmitButton = _themes$theme.thSubmitButton;
  var noTransport = departureCity === departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  var openCriteriaWhenEvent = document.createEvent('Event');
  openCriteriaWhenEvent.initEvent(criteria_when_constants["a" /* OPEN_CRITERIA_WHEN_EVENT */], true, true);
  var openCriteriaWhoEvent = document.createEvent('Event');
  openCriteriaWhoEvent.initEvent(criteria_who_constants["a" /* OPEN_CRITERIA_WHO_EVENT */], true, true);
  var openCriteriaTransportEvent = document.createEvent('Event');
  openCriteriaTransportEvent.initEvent(criteria_transport_constants["a" /* OPEN_CRITERIA_TRANSPORT_EVENT */], true, true);

  var criteriaClickHandlerFactory = function criteriaClickHandlerFactory(event) {
    return function () {
      if (onModify) {
        onModify();
      }

      if (bookingEngineEntryPoint === store_booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE) {
        setTimeout(function () {
          document.dispatchEvent(event);
        }, 200);
      }
    };
  };

  var firstDay = moment_default()(arrivalDate);
  var city = departureCities.find(function (d) {
    return departureCity === d.value;
  });
  var bestPrice = price.bestPrice,
      total = price.total;
  var overflowThreshold = isDesktop ? ALL_INCLUSIVE_SERVICE_LIST_DESKTOP_OVERFLOW_THRESHOLD : ALL_INCLUSIVE_SERVICE_LIST_MOBILE_OVERFLOW_THRESHOLD;
  return AlternativePrice_jsx(react["Fragment"], null, hasOtherProposals && AlternativePrice_jsx(Button["a" /* Button */], {
    className: "lg:mt-30",
    color: isDesktop ? colors["a" /* COLORS */].WHITE : colors["a" /* COLORS */].SAFFRON,
    colorBg: isDesktop ? colors["a" /* COLORS */].SAFFRON : colors["a" /* COLORS */].LIGHT_GREY,
    colorBorder: isDesktop ? colors["a" /* COLORS */].SAFFRON : colors["a" /* COLORS */].LIGHT_GREY,
    onClick: function onClick() {
      track({
        actionGA: 'checkPriceKO',
        categoryGA: 'resort',
        labelGA: 'seeOtherProposals'
      });
      seeOtherProposalsCallback();
    }
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.seeOtherProposalsButton')), AlternativePrice_jsx("div", {
    className: classnames_default()(thRoot)
  }, AlternativePrice_jsx("div", {
    className: "p-10 flex flex-col items-center"
  }, AlternativePrice_jsx("div", {
    className: "flex justify-between w-full"
  }, AlternativePrice_jsx(ProductBanner["a" /* ProductBanner */], {
    product: resort
  }), AlternativePrice_jsx("div", {
    className: "text-center w-full lg:w-auto lg:text-right lg:flex lg:items-center"
  }, AlternativePrice_jsx("div", {
    className: "hidden lg:flex gap-10 lg:items-center"
  }, AlternativePrice_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].SAFFRON,
    name: icons["a" /* ICONS */].ALL_INCLUSIVE,
    width: "1.5rem"
  }), AlternativePrice_jsx("div", {
    className: "font-brand text-16 text-saffron"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.allInclusive'))), AlternativePrice_jsx(Price["a" /* Price */], {
    bestPrice: bestPrice,
    className: "inline-flex",
    hasInitialPrice: true,
    hasInstalment: false,
    initialPrice: total,
    unit: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.totalPrice')
  }))), AlternativePrice_jsx("div", {
    className: "flex mt-10 w-full flex-between flex-wrap lg:flex-nowrap"
  }, AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: icons["a" /* ICONS */].DATE,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaWhenEvent) : undefined
  }, "".concat(firstDay.format('DD MMM'), " - ").concat(firstDay.add(duration, 'd').format('DD MMM'))), AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: icons["a" /* ICONS */].PEOPLE_DOUBLE,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaWhoEvent) : undefined
  }, Object(labelUtils["b" /* getAttendeesSummary */])({
    adultsCount: adultsCount,
    kidsCount: kidsCount
  })), AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: noTransport ? icons["a" /* ICONS */].NO_TRANSPORT : icons["a" /* ICONS */].TRANSPORT,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaTransportEvent) : undefined
  }, city ? city.name : ''), AlternativePrice_jsx(Button["a" /* Button */], {
    className: thSubmitButton,
    onClick: function onClick() {
      track({
        actionGA: 'checkPriceKO',
        categoryGA: 'resort',
        labelGA: 'rate_check'
      });
      continueToBookingEngine();
    },
    style: {
      minWidth: 80,
      width: isDesktop ? 250 : '100%'
    },
    type: "submit"
  }, Object(src_i18n["h" /* t */])('common.continue'))), onModify && AlternativePrice_jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].SAFFRON,
    colorBg: colors["a" /* COLORS */].TRANSPARENT,
    colorBorder: colors["a" /* COLORS */].SAFFRON,
    iconLeft: {
      name: icons["a" /* ICONS */].PEN
    },
    onClick: function onClick() {
      track({
        actionGA: 'checkPriceKO',
        categoryGA: 'resort',
        labelGA: 'rate_modify'
      });
      onModify();
    }
  }, Object(src_i18n["h" /* t */])('common.modify')), AlternativePrice_jsx("div", {
    className: "w-full px-25"
  }, AlternativePrice_jsx("div", {
    className: "flex flex-wrap"
  }, allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.slice(0, overflowThreshold).map(function (service) {
    return AlternativePrice_jsx(ProductService["a" /* ProductService */], {
      service: service,
      className: "w-full lg:w-1/2",
      key: service.label
    });
  })), (allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length) > overflowThreshold && AlternativePrice_jsx(react["Fragment"], null, AlternativePrice_jsx(lib["Collapse"], {
    isOpened: isDetailOpened
  }, AlternativePrice_jsx("div", {
    className: "flex flex-wra"
  }, allInclusiveServices.slice(overflowThreshold, allInclusiveServices.length).map(function (service) {
    return AlternativePrice_jsx(ProductService["a" /* ProductService */], {
      service: service,
      className: "w-full lg:w-1/2",
      key: service.label
    });
  }))), !isDetailOpened ? AlternativePrice_jsx("div", {
    className: " w-full"
  }) : null))), (allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length) > overflowThreshold && AlternativePrice_jsx("div", {
    className: "flex items-center justify-center absolute left-1/2 transform -translate-x-1/2"
  }, AlternativePrice_jsx(StripButton["a" /* StripButton */], {
    className: "font-bold text-center text-saffron text-12 underline",
    height: 30,
    onClick: function onClick() {
      return setIsDetailOpened(!isDetailOpened);
    },
    orientation: "bottom"
  }, AlternativePrice_jsx("div", {
    className: "flex gap-10 items-center text-14"
  }, !isDetailOpened ? Object(src_i18n["h" /* t */])('priceRemote.openAllInclusiveDetails') : Object(src_i18n["h" /* t */])('priceRemote.closeAllInclusiveDetails'), AlternativePrice_jsx(Icon["a" /* Icon */], {
    className: "text-saffron transition-transform",
    name: icons["a" /* ICONS */].ARROW_DOWN,
    rotation: isDetailOpened ? 180 : 0,
    width: "0.625rem"
  }))))));
};
// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price-title/AlternativePriceTitle.jsx
var AlternativePriceTitle_jsx = react_default.a.createElement;







var AlternativePriceTitle_AlternativePriceTitle = function AlternativePriceTitle(_ref) {
  var className = _ref.className,
      price = _ref.proposal.price,
      title = _ref.title;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  if (!price) {
    return null;
  }

  return AlternativePriceTitle_jsx("h2", {
    className: classnames_default()('flex font-bold gap-10 items-center leading-tight text-24 md:text-28 lg:text-32 text-orange', className)
  }, Object(sellerUtils["f" /* isSeller */])(appContext) && price.gap >= 30 || price.gap < 30 ? AlternativePriceTitle_jsx(react["Fragment"], null, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "1em"
  }), title) : AlternativePriceTitle_jsx(react["Fragment"], null, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "4rem"
  }), Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCenterAdvise'), AlternativePriceTitle_jsx("span", {
    className: "flex gap-5 items-center text-18"
  }, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    hasRtl: true,
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "4rem"
  }), AlternativePriceTitle_jsx("span", null, AlternativePriceTitle_jsx("span", null, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.pleaseCallLabel')), ' ', Object(src_i18n["h" /* t */])('travelAdvisor.phoneNumber'), ' ', AlternativePriceTitle_jsx("span", {
    className: "text-16 text-black"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCost'))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-proposal-header/AlternativeProposalHeader.jsx
var AlternativeProposalHeader_jsx = react_default.a.createElement;





var AlternativeProposalHeader_AlternativeProposalHeader = function AlternativeProposalHeader(_ref) {
  var className = _ref.className,
      proposal = _ref.proposal,
      title = _ref.title;
  return proposal ? AlternativeProposalHeader_jsx(AlternativePriceTitle_AlternativePriceTitle, {
    className: className,
    proposal: proposal,
    title: title
  }) : AlternativeProposalHeader_jsx("h2", {
    className: classnames_default()('flex font-brand gap-10 items-start leading-tight text-24 md:text-28 lg:text-32 text-orange', className)
  }, AlternativeProposalHeader_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    hasRtl: true,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "1em"
  }), title);
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestion.jsx


var AlternativeDateSuggestion_jsx = react_default.a.createElement;




var AlternativeDateSuggestion_AlternativeDateSuggestion = function AlternativeDateSuggestion(_ref) {
  var className = _ref.className,
      dates = _ref.dates,
      onClose = _ref.onClose,
      _onSubmit = _ref.onSubmit,
      resort = _ref.resort,
      trackingData = _ref.trackingData;
  return AlternativeDateSuggestion_jsx(AlternativeSuggestions_AlternativeSuggestions, {
    className: className,
    immersiveResort: resort,
    onClose: onClose,
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.weSuggestLabel', {
      resortName: resort.name
    })
  }, dates.map(function (suggestion) {
    return AlternativeDateSuggestion_jsx(AlternativeSuggestionCriteria_AlternativeSuggestionCriteria, {
      buttonLabel: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.checkPriceLabel'),
      key: suggestion.dateOffset,
      onSubmit: function onSubmit(newArrivalDate) {
        _onSubmit(newArrivalDate);

        trackingData('date_check');
      },
      suggestion: suggestion
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsSeparatorDashed.jsx
var AlternativeProposalsSeparatorDashed_jsx = react_default.a.createElement;



var AlternativeProposalsSeparatorDashed = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return AlternativeProposalsSeparatorDashed_jsx("div", {
    className: classnames_default()('flex justify-center isolate relative w-full', props.className),
    "data-testid": "AlternativeProposalsSeparatorDashed",
    ref: ref
  }, AlternativeProposalsSeparatorDashed_jsx("hr", {
    className: "absolute block border-0 border-t-1 border-dashed border-grey h-1 m-0 p-0 top-1/2 w-full"
  }), AlternativeProposalsSeparatorDashed_jsx("p", {
    className: "bg-white font-bold px-25 py-10 text-24 text-black z-1"
  }, Object(src_i18n["h" /* t */])('booking.common.or')));
});
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 5 modules
var Product = __webpack_require__("XTOr");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResortThumbnail.jsx



var AlternativeResortThumbnail_jsx = react_default.a.createElement;









var AlternativeResortThumbnail_AlternativeResortThumbnail = function AlternativeResortThumbnail(_ref) {
  var _ref$categoryGA = _ref.categoryGA,
      categoryGA = _ref$categoryGA === void 0 ? 'resort' : _ref$categoryGA,
      className = _ref.className,
      onClick = _ref.onClick,
      scrollToBookingEngineEntryPoint = _ref.scrollToBookingEngineEntryPoint,
      suggestion = _ref.suggestion;
  var router = Object(next_router["useRouter"])();
  var trackClick = Object(useTracking["a" /* useTracking */])({
    actionGA: 'checkPricesKO',
    categoryGA: categoryGA
  });

  var handleClick = function handleClick() {
    var _suggestion$resort = suggestion.resort,
        id = _suggestion$resort.id,
        name = _suggestion$resort.name,
        href = _suggestion$resort.href;
    var url = "".concat(href, "?").concat(URI_default.a.buildQuery(omit_default()(router.query, ['dynamicPage'])));
    onClick ? onClick(id, name) : router.push(url).then(function () {
      if (scrollToBookingEngineEntryPoint) {
        scrollToBookingEngineEntryPoint();
      }
    });
  };

  return AlternativeResortThumbnail_jsx("div", {
    className: className,
    "data-testid": "AlternativeResortThumbnail"
  }, AlternativeResortThumbnail_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({}, Object(product_utils["d" /* createPropsForProduct */])(suggestion.resort), {
    hasLazyLoading: false // Allows to avoid to launch the tracking on the arrows of the slider
    ,
    onClick: function onClick(e) {
      if (e.target instanceof HTMLImageElement) {
        handleClick();
        trackClick({
          labelGA: 'resort_checkThumbnail'
        });
      }
    }
  })), AlternativeResortThumbnail_jsx(Button["a" /* Button */], {
    className: "mt-20 w-full",
    dataTestId: "AlernativeResortThumbnailButton",
    onClick: function onClick() {
      handleClick();
      trackClick({
        actionGA: 'checkPricesKO',
        categoryGA: 'resort',
        labelGA: 'resort_check'
      });
    }
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.checkPriceLabelResort')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/price/AttendeesSummary.jsx
var AttendeesSummary_jsx = react_default.a.createElement;








var AttendeesSummary_AttendeesSummary = function AttendeesSummary(_ref) {
  var adults = _ref.adults,
      className = _ref.className,
      kids = _ref.kids;
  return AttendeesSummary_jsx("div", {
    className: classnames_default()('flex items-center gap-10 text-14', className),
    "data-testid": booking_constants["l" /* CRITERIA_SELECTORS */].ATTENDEES
  }, AttendeesSummary_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: colors["a" /* COLORS */].SIENNA,
    hasRtl: true,
    name: icons["a" /* ICONS */].PEOPLE_DOUBLE,
    width: "1.875rem"
  }), AttendeesSummary_jsx("div", null, AttendeesSummary_jsx("p", {
    "data-testid": "PackagePriceSummary-guestsItem",
    key: "adults"
  }, AttendeesSummary_jsx("span", {
    className: "font-bold text-sienna"
  }, adults), " ".concat(Object(labelUtils["d" /* pluralizeLabel */])(Object(src_i18n["h" /* t */])('booking.common.adult'), Object(src_i18n["h" /* t */])('booking.common.adults'), adults))), kids > 0 && AttendeesSummary_jsx("p", {
    "data-testid": "PackagePriceSummary-guestsItem",
    key: "children"
  }, AttendeesSummary_jsx("span", {
    className: "font-bold text-sienna"
  }, kids), " ".concat(Object(labelUtils["d" /* pluralizeLabel */])(Object(src_i18n["h" /* t */])('booking.common.child'), Object(src_i18n["h" /* t */])('booking.common.children'), kids)))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/package/price/TransportSummary.jsx
var TransportSummary_jsx = react_default.a.createElement;







var TransportSummary_TransportSummary = function TransportSummary(_ref) {
  var className = _ref.className,
      departure = _ref.departure,
      transportIcon = _ref.transportIcon;
  var noTransportIcon = icons["a" /* ICONS */].NO_TRANSPORT;
  return TransportSummary_jsx("div", {
    className: classnames_default()('flex items-center gap-10 text-14', className),
    "data-testid": booking_constants["l" /* CRITERIA_SELECTORS */].TRANSPORT
  }, TransportSummary_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: colors["a" /* COLORS */].SIENNA,
    hasRtl: true,
    name: departure ? transportIcon : noTransportIcon,
    width: "1.875rem"
  }), departure ? TransportSummary_jsx(react["Fragment"], null, Object(src_i18n["h" /* t */])('common.transport.from'), " ", TransportSummary_jsx("span", {
    className: "font-bold text-sienna"
  }, departure)) : Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.noTransport'));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResortCriteria.jsx
var AlternativeResortCriteria_jsx = react_default.a.createElement;











var AlternativeResortCriteria_AlternativeResortCriteria = function AlternativeResortCriteria(_ref) {
  var adultsNumber = _ref.adultsNumber,
      arrivalDate = _ref.arrivalDate,
      className = _ref.className,
      departureCity = _ref.departureCity,
      duration = _ref.duration,
      kidsNumber = _ref.kidsNumber;
  var getFormattedDate = Object(dateUtils["a" /* formatDate */])('D MMMM YYYY');
  var departureDate = Object(AlternativeProposalsUtils["a" /* getDepartureDate */])({
    date: arrivalDate,
    duration: duration,
    format: apiDate["a" /* API_DATE_FORMAT */],
    unit: 'days'
  });
  return AlternativeResortCriteria_jsx(Capsule["a" /* Capsule */], {
    className: className,
    contentClassName: "flex flex-col gap-10 p-20",
    dataTestId: "AlternativeResortCriteria"
  }, AlternativeResortCriteria_jsx(DateSummary_DateSummary, {
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.fromTo'),
    values: {
      arrivalDate: getFormattedDate(arrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDate(departureDate, 'YYYYMMDD') || ''
    }
  }), AlternativeResortCriteria_jsx(AttendeesSummary_AttendeesSummary, {
    adults: adultsNumber,
    kids: kidsNumber
  }), AlternativeResortCriteria_jsx(TransportSummary_TransportSummary, {
    departure: departureCity !== 'NO' ? departureCity : null,
    transportIcon: icons["a" /* ICONS */].TRANSPORT
  }), AlternativeResortCriteria_jsx("p", {
    className: "flex font-bold gap-5 items-start text-12 text-orange"
  }, AlternativeResortCriteria_jsx(Icon["a" /* Icon */], {
    className: "shrink-0 translate-y-[0.2em]",
    name: icons["a" /* ICONS */].WARNING,
    width: "1em"
  }), Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.resortCounterProposalTransportReassurance')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResort.jsx

var AlternativeResort_jsx = react_default.a.createElement;







var AlternativeResort_AlternativeResort = function AlternativeResort(_ref) {
  var adultsNumber = _ref.adultsNumber,
      arrivalDate = _ref.arrivalDate,
      _ref$categoryGA = _ref.categoryGA,
      categoryGA = _ref$categoryGA === void 0 ? 'resort' : _ref$categoryGA,
      departureCity = _ref.departureCity,
      duration = _ref.duration,
      i18n = _ref.i18n,
      kidsNumber = _ref.kidsNumber,
      suggestions = _ref.suggestions,
      selectResortHandler = _ref.selectResortHandler,
      scrollToBookingEngineEntryPoint = _ref.scrollToBookingEngineEntryPoint;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return AlternativeResort_jsx("div", {
    "data-testid": "AlternativeResort"
  }, AlternativeResort_jsx(Title["a" /* Title */], {
    className: "mb-20",
    theme: "title-brand-n1"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.resortCounterProposalTitle')), AlternativeResort_jsx("div", {
    className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-20"
  }, AlternativeResort_jsx(AlternativeResortCriteria_AlternativeResortCriteria, {
    adultsNumber: adultsNumber,
    arrivalDate: arrivalDate,
    className: "flex-1",
    departureCity: departureCity,
    duration: duration,
    i18n: i18n,
    kidsNumber: kidsNumber
  }), isTablet ? AlternativeResort_jsx(react["Fragment"], null, suggestions.map(function (suggestion) {
    return AlternativeResort_jsx(AlternativeResortThumbnail_AlternativeResortThumbnail, {
      categoryGA: categoryGA,
      key: suggestion.resort.id,
      onClick: selectResortHandler,
      scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint,
      suggestion: suggestion
    });
  })) : AlternativeResort_jsx(Scrollable["a" /* Scrollable */], {
    className: "-mx-20",
    backwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    forwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  }, AlternativeResort_jsx("div", {
    className: "flex gap-10 px-20"
  }, suggestions.map(function (suggestion) {
    return AlternativeResort_jsx(AlternativeResortThumbnail_AlternativeResortThumbnail, {
      categoryGA: categoryGA,
      className: "flex-none last:scroll-x-ghost-m-20 last:scroll-x-ghost-m w-[280px]",
      key: suggestion.resort.id,
      onClick: selectResortHandler,
      scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint,
      suggestion: suggestion
    });
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposals.jsx
var AlternativeProposals_jsx = react_default.a.createElement;
















var AlternativeProposals_AlternativeProposals = function AlternativeProposals(_ref) {
  var _proposal$price, _proposal$price2;

  var bookingEngineEntryPoint = _ref.bookingEngineEntryPoint,
      _ref$disableAlternati = _ref.disableAlternativePrice,
      disableAlternativePrice = _ref$disableAlternati === void 0 ? false : _ref$disableAlternati,
      goToBookingEngine = _ref.goToBookingEngine,
      i18n = _ref.i18n,
      onClose = _ref.onClose,
      onSelectNewDuration = _ref.onSelectNewDuration,
      onSubmit = _ref.onSubmit,
      proposals = _ref.proposals,
      resort = _ref.resort,
      scrollToBookingEngineEntryPoint = _ref.scrollToBookingEngineEntryPoint,
      _ref$searchCriteria = _ref.searchCriteria,
      adultsCount = _ref$searchCriteria.adultsCount,
      arrivalDate = _ref$searchCriteria.arrivalDate,
      departureCity = _ref$searchCriteria.departureCity,
      duration = _ref$searchCriteria.duration,
      kidsCount = _ref$searchCriteria.kidsCount,
      searchCriteria = _ref.searchCriteria,
      selectResortHandler = _ref.selectResortHandler,
      _ref$suggestions = _ref.suggestions,
      dates = _ref$suggestions.dates,
      resorts = _ref$suggestions.resorts,
      durations = _ref$suggestions.durations;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'checkPricesKO',
    categoryGA: 'search'
  });
  var separatorComponent = Object(react["useRef"])(null);
  var proposal = proposals[0];
  var shouldDisplayAlternativePriceCriteria = !disableAlternativePrice && (proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : _proposal$price.gap) > constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */] && (appContext.isSeller || proposal.price.gap < constants["x" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */]);
  var shouldDisplayAlternativePriceTitle = !disableAlternativePrice && (proposal === null || proposal === void 0 ? void 0 : (_proposal$price2 = proposal.price) === null || _proposal$price2 === void 0 ? void 0 : _proposal$price2.gap) > constants["y" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];

  var seeOtherProposalsCallback = function seeOtherProposalsCallback() {
    if (separatorComponent.current) {
      separatorComponent.current.scrollIntoView();
    }
  };

  var atLeastOneDateCounterProposal = dates.length > 0;
  var atLeastOneResortCounterProposal = resorts.length > 0;
  var atLeastOneDurationCounterProposal = durations.length > 0;
  var hasSuggestions = atLeastOneDateCounterProposal || atLeastOneResortCounterProposal || atLeastOneDurationCounterProposal;

  var trackingData = function trackingData(labelGA) {
    track({
      labelGA: labelGA
    });
  };

  return AlternativeProposals_jsx("div", {
    "data-testid": "AlternativeProposalsModal"
  }, shouldDisplayAlternativePriceTitle && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeProposalHeader_AlternativeProposalHeader, {
    proposal: proposal,
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.rateCounterProposalTitle')
  })), shouldDisplayAlternativePriceCriteria && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativePrice_AlternativePrice, {
    bookingEngineEntryPoint: bookingEngineEntryPoint // $FlowFixMe
    ,
    continueToBookingEngine: goToBookingEngine,
    departureCities: i18n.bookingCriteria.departureCities,
    hasOtherProposals: hasSuggestions,
    onModify: onClose ? function () {
      onClose();

      if (scrollToBookingEngineEntryPoint) {
        scrollToBookingEngineEntryPoint();
      }
    } : undefined,
    proposals: proposals,
    resort: resort,
    searchCriteria: searchCriteria,
    seeOtherProposalsCallback: seeOtherProposalsCallback
  })), hasSuggestions && shouldDisplayAlternativePriceCriteria && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, {
    ref: separatorComponent
  }), hasSuggestions && !shouldDisplayAlternativePriceTitle && !disableAlternativePrice ? AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeDateSuggestionHeader_AlternativeDateSuggestionHeader, {
    arrivalDate: arrivalDate,
    duration: duration,
    resort: resort
  })) : AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], null, AlternativeProposals_jsx(AlternativeProposalHeader_AlternativeProposalHeader, {
    className: "my-40",
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.otherProposals')
  })), atLeastOneDateCounterProposal && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeDateSuggestion_AlternativeDateSuggestion, {
    dates: dates,
    onClose: onClose,
    onSubmit: onSubmit,
    resort: resort,
    trackingData: trackingData
  })), atLeastOneDateCounterProposal && (atLeastOneDurationCounterProposal || atLeastOneResortCounterProposal) && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, null), atLeastOneDurationCounterProposal && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeDurationSuggestions_AlternativeDurationSuggestions, {
    durations: durations,
    onSelectNewDuration: onSelectNewDuration,
    trackingData: trackingData
  })), atLeastOneDurationCounterProposal && atLeastOneResortCounterProposal && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, null), atLeastOneResortCounterProposal && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "my-40"
  }, AlternativeProposals_jsx(AlternativeResort_AlternativeResort, {
    adultsNumber: adultsCount,
    arrivalDate: arrivalDate,
    departureCity: departureCity,
    duration: duration,
    i18n: i18n,
    kidsNumber: kidsCount,
    scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint,
    selectResortHandler: selectResortHandler,
    suggestions: resorts
  })), !appContext.isCmta && AlternativeProposals_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "border-t-1 border-grey mt-40"
  }, AlternativeProposals_jsx("div", {
    className: "flex font-bold gap-5 items-center justify-center py-20 text-18 text-black"
  }, AlternativeProposals_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: colors["a" /* COLORS */].GREEN,
    hasRtl: true,
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "3em"
  }), AlternativeProposals_jsx("p", null, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.contactCallCenter'), ' ', AlternativeProposals_jsx("span", {
    className: "text-green"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCenterNumber')), ' ', AlternativeProposals_jsx("span", {
    className: "font-normal text-12"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCost'))))));
};

/***/ }),

/***/ "YZTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP; });
/* unused harmony export ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_LAYER_HEADER__CA__ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ID_LAYER_HEADER__CA__CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ID_LAYER_HEADER__CA__ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ID_LAYER_HEADER__CA__INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ID_LAYER_HEADER__CA__MORE_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ID_LAYER_HEADER__CA__PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ID_LAYER_HEADER__CA__RENTALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ID_LAYER_HEADER__CA__STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ID_LAYER_HEADER__CA__TRANSFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ID_LAYER_HEADER__CA__VOUCHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ID_MODAL_HEADER__BE__OPTION; });
/* unused harmony export ID_MODAL_HEADER__BE__CXO_OPTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ID_MODAL_HEADER__BE__PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ID_MODAL_HEADER__BE__SHARE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ID_MODAL_HEADER__BE__MISMATCH_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ID_MODAL_HEADER__PLE__LOGIN; });
/* unused harmony export ID_MODAL_HEADER__BE__CUSTOMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ID_MODAL_HEADER__EASY_ARRIVAL_INFO; });
/* unused harmony export ID_MODAL_HEADER__BE__HOUSEHOLD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ID_MODAL_HEADER__PLE__NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ID_MODAL_HEADER__FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ID_MODAL_HEADER__BE_REFRESH_PROPOSAL; });
// Layers header IDs
var ID_LAYER_HEADER__BE__ACCOMMODATIONS = 'AccommodationsLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_FILTERS_MOBILE = 'TransportsFiltersMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
var ID_LAYER_HEADER__CA__ACTIVITIES = 'ActivitiesLayerHeaderId';
var ID_LAYER_HEADER__CA__CHILDCARES = 'ChildcaresLayerHeaderId';
var ID_LAYER_HEADER__CA__ESF = 'ESFLayerHeaderId';
var ID_LAYER_HEADER__CA__INSURANCES = 'InsurancesLayerHeaderId';
var ID_LAYER_HEADER__CA__MORE_ROOMS = 'MoreRoomsLayerHeaderId';
var ID_LAYER_HEADER__CA__PACKAGES = 'PackagesLayerHeaderId';
var ID_LAYER_HEADER__CA__RENTALS = 'RentalsLayerHeaderId';
var ID_LAYER_HEADER__CA__STAFF = 'StaffLayerHeaderId';
var ID_LAYER_HEADER__CA__TRANSFERS = 'TransfersLayerHeaderId';
var ID_LAYER_HEADER__CA__VOUCHERS = 'VouchersLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId'; // Modals header IDs

var ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
var ID_MODAL_HEADER__BE__CXO_OPTION = 'CxoOptionModalHeaderId';
var ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION = 'SaveCriteriaConfirmationModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
var ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
var ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
var ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
var ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
var ID_MODAL_HEADER__EASY_ARRIVAL_INFO = 'EasyArrivalModalHeaderId';
var ID_MODAL_HEADER__BE__HOUSEHOLD = 'ParticipantsHouseholdModalHeaderId';
var ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
var ID_MODAL_HEADER__FILTERS = 'FiltersModalHeaderId';
var ID_MODAL_HEADER__BE_REFRESH_PROPOSAL = 'RefreshProposalModalHeaderId';

/***/ }),

/***/ "Z+2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductThumbnail; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("mRH6");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cxan");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("DQFb");
/* harmony import */ var _frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("N5WC");



var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;








var OPENING_STATUS = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["constants"].OPENING_STATUS;
var ProductThumbnail = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["memo"])(function ProductThumbnail(_ref) {
  var _ref$bottomTags = _ref.bottomTags,
      bottomTags = _ref$bottomTags === void 0 ? [] : _ref$bottomTags,
      className = _ref.className,
      closedLabel = _ref.closedLabel,
      hasLazyLoading = _ref.hasLazyLoading,
      isLinkDisabled = _ref.isLinkDisabled,
      isSliderDisabled = _ref.isSliderDisabled,
      _ref$isTagsDisabled = _ref.isTagsDisabled,
      isTagsDisabled = _ref$isTagsDisabled === void 0 ? false : _ref$isTagsDisabled,
      link = _ref.link,
      nextLabel = _ref.nextLabel,
      openingStatus = _ref.openingStatus,
      _ref$pictures = _ref.pictures,
      pictures = _ref$pictures === void 0 ? [] : _ref$pictures,
      previousLabel = _ref.previousLabel,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 / 3 : _ref$ratioDisplay,
      _ref$topTags = _ref.topTags,
      topTags = _ref$topTags === void 0 ? [] : _ref$topTags;
  var TagName = isLinkDisabled ? 'div' : _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"];
  var defaultPicture = pictures[0] || {};
  return __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('block relative', className)
  }, isLinkDisabled ? null : link), !isSliderDisabled && pictures.length > 1 && openingStatus !== OPENING_STATUS.CLOSED ? __jsx(_frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_9__[/* ImageSlideShow */ "a"], {
    hasLazyLoading: true,
    itemClassName: "isolate overflow-hidden rounded-12 will-change-transform",
    media: pictures,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "c"].XL,
    ratioDisplay: ratioDisplay
  }) : __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* Image */ "a"], {
    altMsg: defaultPicture.alt,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    groupKey: "thumbnails",
    ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "c"].XL,
    ratioDisplay: ratioDisplay,
    hasLazyLoading: hasLazyLoading
  }), !!(topTags === null || topTags === void 0 ? void 0 : topTags.length) && !isTagsDisabled && __jsx("div", {
    className: "absolute flex gap-5 justify-end p-10 top-0 w-full",
    "data-testid": "ProductThumbnail-topTags"
  }, topTags.map(function (tag) {
    return __jsx(_frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__[/* Tag */ "a"], {
      color: tag.color,
      colorBg: tag.colorBg,
      iconName: tag.iconName,
      "data-testid": tag.dataTestId,
      key: tag.dataTestId || tag.label,
      style: tag.style
    }, tag.label);
  })), openingStatus === OPENING_STATUS.CLOSED && __jsx("div", {
    className: "absolute bg-black/60 font-bold inline-flex items-center justify-center overflow-hidden inset-0 rounded-12 text-20 text-white uppercase z-1",
    "data-testid": "ProductThumbnail-closed"
  }, closedLabel), !!(bottomTags === null || bottomTags === void 0 ? void 0 : bottomTags.length) && !isTagsDisabled && __jsx("div", {
    className: "absolute bottom-0 flex gap-5 justify-start p-10 w-full",
    "data-testid": "ProductThumbnail-bottomTags"
  }, bottomTags.map(function (tag) {
    return __jsx(_frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__[/* Tag */ "a"], {
      color: tag.color,
      colorBg: tag.colorBg,
      iconName: tag.iconName,
      "data-testid": tag.dataTestId,
      key: tag.label,
      style: tag.style
    }, tag.label);
  })));
});

/***/ }),

/***/ "ZHrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ ContactInfoUtils_getOptinsInfos; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ ContactInfoUtils_getInitialFormValues; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getSchemaValidators; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ ContactInfoUtils_getValidators; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ ContactInfoUtils_getTravelDocumentsValidators; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ ContactInfoUtils_getLegalAgreementValidator; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ ContactInfoUtils_getAdultCivilities; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ ContactInfoUtils_getHeaderContactInfoTitle; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ ContactInfoUtils_findDuplicateAttendees; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* binding */ ContactInfoUtils_trackAttendeesFormError; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ ContactInfoUtils_isChildWillBeAdultByArrivalDate; });
__webpack_require__.d(__webpack_exports__, "w", function() { return /* binding */ ContactInfoUtils_travelCompanionMapper; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ createId; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ ContactInfoUtils_filterSearchedChildren; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ findAlphabetIndex; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ setTravelCompanionBlockFormErrors; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getTravelCompanionInfos; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ ContactInfoUtils_setTravelCompanionField; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ submitOption; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ submitOptionFromProposal; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ renderErrorUpdatingAttendees; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getAllAttendeesIds; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ ContactInfoUtils_shouldHideField; });

// UNUSED EXPORTS: getSalesmanIdValidator, tripInformationToAttendeesList, getNextCharacter, getChildrenToAdultsTransferList, compareById, compareByBirthdate, getSortedTravelCompanionList, getFieldErrors, getCNILLegalMessage, getLegalInformation, getLegalInputInformation, shouldDisplayLegalInformation, getDocumentsFields, getHouseholdsAttendees

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("4mDm");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("E9XD");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("Rfxz");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("ToJy");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("qePV");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("T63A");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("B6y2");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("TWNs");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("JTJg");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("Rm1S");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("EnZy");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("SYor");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("3bBZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isObject.js
var isObject = __webpack_require__("tQYX");
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/flatten.js
var flatten = __webpack_require__("1xil");
var flatten_default = /*#__PURE__*/__webpack_require__.n(flatten);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js + 1 modules
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/utils/legal-information/legalInformationIds.constants.js
var legalInformationIds_constants = __webpack_require__("y5Lu");

// EXTERNAL MODULE: ./src/utils/booking-process/constants.js
var booking_process_constants = __webpack_require__("XpIN");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/option-validity/constants.js
var option_validity_constants = __webpack_require__("l/UU");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("UxlC");

// CONCATENATED MODULE: ./src/client/components/widgets/participants/utils.js








var STRICT_REGEX = /[.-]/g;
var NON_STRICT_REGEX = /[^\d]/g;
var REJECT_CPF_LIST = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
function digitsVerifier(numbers) {
  var numberList = numbers.split('').map(function (number) {
    return parseInt(number, 10);
  });
  var modulo = numberList.length + 1;
  var multiplied = numberList.map(function (number, index) {
    return number * (modulo - index);
  });
  var mod = multiplied.reduce(function (buffer, number) {
    return buffer + number;
  }) % 11;
  return mod < 2 ? 0 : 11 - mod;
}
function isValidCPF(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var stripped = strip(cpf, isStrict); // CPF must be defined

  if (!stripped) {
    return false;
  } // CPF must have 11 chars


  if (stripped.length !== 11) {
    return false;
  }

  if (REJECT_CPF_LIST.includes(stripped)) {
    return false;
  }

  var numbers = stripped.substr(0, 9);
  numbers += digitsVerifier(numbers);
  numbers += digitsVerifier(numbers);
  return numbers.substr(-2) === stripped.substr(-2);
}
function strip(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var regex = isStrict ? STRICT_REGEX : NON_STRICT_REGEX;
  return (cpf || '').toString().replace(regex, '');
}
// EXTERNAL MODULE: ./src/utils/locale/constants.js
var locale_constants = __webpack_require__("qFX+");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/contact-info-form/identityNumberValidator.reducer.js









var identityNumberRule = lib["string"]().matches(/[a-zA-Z0-9]{6,}/, {
  excludeEmptyString: true
}, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).transform(function (__, initialValue) {
  return initialValue ? initialValue.replace(/ /g, '') : initialValue;
}).max(30);
var fiscalCodeRule = lib["string"]().matches(/[a-zA-Z0-9]{16,}/, {
  excludeEmptyString: true
}, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).transform(function (__, initialValue) {
  return initialValue ? initialValue.replace(/ /g, '') : initialValue;
}).max(30);
var identityNumberValidator_reducer_identityNumberValidatorReducer = function identityNumberValidatorReducer(locale, attendeeSchema) {
  var _attendeeSchema$find;

  var isIdentityNumberRequired = !!(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : (_attendeeSchema$find = attendeeSchema.find(function (_ref) {
    var name = _ref.name;
    return name === 'identity_number';
  })) === null || _attendeeSchema$find === void 0 ? void 0 : _attendeeSchema$find.required);
  var brazilCpfRule = lib["string"]().test('is-brazil-cpf-rule-valid', Object(i18n["h" /* t */])('booking.participants.errorMessage.identityNumber'), function (value) {
    var trimValue = value ? value.trim() : '';

    if (!isIdentityNumberRequired) {
      // field isn't required: check cpf validity is has truthy value or return true
      return trimValue ? isValidCPF(value) : true;
    } // field is required: return cpf validity if has truthy value or return false


    var invalidCpfFormat = value.length < 11 || value.length > 14 || !isValidCPF(value);
    return trimValue && !invalidCpfFormat;
  });

  switch (locale) {
    case locale_constants["a" /* LOCALES */].PT_BR:
      return brazilCpfRule;

    case locale_constants["a" /* LOCALES */].IT_IT:
      return fiscalCodeRule;

    default:
      return identityNumberRule;
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js








































function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




















 // removing mergeSchemas method cause it does not have expected behavior.
// https://github.com/jquense/yup#schemaconcatschema-schema-schema -> doc explaning that is does not merge content but override previous schema.
// https://github.com/jquense/yup/issues/1535 -> issue explaining that it does not merge content but override previous schema.
// Using yup.addMethods that allows us to add custom methods to Yup when needed so it's possible to chain schemas in prefered order.

function getCNILLegalMessage() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cnilLegalMessage = legalMessages.find(function (legalMessage) {
    return legalMessage.id === contact_info_constants["b" /* CNIL_LEGAL_MESSAGE_ID */];
  });
  return cnilLegalMessage && pick_default()(cnilLegalMessage, ['label', 'description', 'required']);
}

function getLegalInputInformation() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  var type = arguments.length > 2 ? arguments[2] : undefined;
  return legalMessages.find(function (legalMessage) {
    return legalMessage.id === id && (type && legalMessage.type ? legalMessage.type === type : true);
  });
}

function getLegalInformation(beLegalInfos) {
  return function (id) {
    return (beLegalInfos || []).find(function (legalInfo) {
      return legalInfo.id === id;
    });
  };
}

var ContactInfoUtils_getOptinsInfos = function getOptinsInfos(bookingProcess) {
  var getLegalInfo = getLegalInformation(bookingProcess);
  return {
    email: getLegalInfo(legalInformationIds_constants["c" /* EMAIL_OPTIN */]),
    sms: getLegalInfo(legalInformationIds_constants["k" /* SMS_OPTIN */]),
    mail: getLegalInfo(legalInformationIds_constants["g" /* MAIL_OPTIN */]),
    fosun: getLegalInfo(legalInformationIds_constants["d" /* FOSUN_PARTNERS */]),
    phone: getLegalInfo(legalInformationIds_constants["i" /* PHONE_OPTIN */]),
    clubmedPlus: getLegalInfo(legalInformationIds_constants["a" /* CLUBMED_PLUS */]),
    theo: getLegalInfo(booking_process_constants["d" /* LEGAL_INFO_THEO_ID */]),
    webTheo: getLegalInfo(booking_process_constants["e" /* LEGAL_INFO_WEBTHEO_ID */]),
    ndc: getLegalInfo(booking_process_constants["c" /* LEGAL_INFO_NDC_ID */])
  };
};

function shouldDisplayLegalInformation(beLegalInfos) {
  var getLegalInfo = getLegalInformation(beLegalInfos);
  return function (id) {
    return !!getLegalInfo(id);
  };
}

function _getOptionSubmissionRequest(params, hasSaveOption, isChequeOrTransferPaymentLabel) {
  return "\n    mutation {\n      bookings(\n        proposalId: \"".concat(params.proposalId, "\"\n        ").concat(hasSaveOption || isChequeOrTransferPaymentLabel ? 'bookingStatus: OPTION' : 'bookingStatus: PENDING_PAYMENT', "\n        ").concat(params.bookingIdForRenewal ? "bookingIdForRenewal: \"".concat(params.bookingIdForRenewal, "\"") : '', "\n      ) {\n        bookingId\n        expirationDateTime\n        isReliable\n      }\n    }");
}

function submitOptionFromProposal(_ref) {
  var appContext = _ref.appContext,
      bookingIdForRenewal = _ref.bookingIdForRenewal,
      hasNoRedirection = _ref.hasNoRedirection,
      hasSaveOption = _ref.hasSaveOption,
      productId = _ref.productId,
      router = _ref.router,
      selectedProposalId = _ref.selectedProposalId,
      withfutureTravelCredits = _ref.withfutureTravelCredits;
  return function (proposalId) {
    var redirectTo = redirectUtils["a" /* default */].redirectToUri(router);
    var params = {
      bookingIdForRenewal: bookingIdForRenewal,
      proposalId: proposalId
    };
    var paymentMethodLabel = js_cookie_default.a.get(PaymentInfo_const["l" /* PAYMENT_METHOD_LABEL */]);
    var isChequeOrTransferPaymentLabel = paymentMethodLabel === PaymentInfo_const["k" /* PAYMENT_METHOD_CATEGORY */].DIRECT_DEBIT || paymentMethodLabel === PaymentInfo_const["k" /* PAYMENT_METHOD_CATEGORY */].BANK_TRANSFER;

    var query = _getOptionSubmissionRequest(params, hasSaveOption, isChequeOrTransferPaymentLabel);

    var handleSuccess = function handleSuccess(response) {
      var _response$bookings, _response$bookings2, _response$bookings3, _response$bookings4;

      var queryParams = _objectSpread({
        bi: (response === null || response === void 0 ? void 0 : (_response$bookings = response.bookings) === null || _response$bookings === void 0 ? void 0 : _response$bookings.bookingId) || '',
        expirationTime: (response === null || response === void 0 ? void 0 : (_response$bookings2 = response.bookings) === null || _response$bookings2 === void 0 ? void 0 : _response$bookings2.expirationDateTime) || '',
        isReliable: response === null || response === void 0 ? void 0 : (_response$bookings3 = response.bookings) === null || _response$bookings3 === void 0 ? void 0 : _response$bookings3.isReliable,
        selectedProposalId: selectedProposalId,
        productId: productId
      }, hasSaveOption && {
        hasSaveOption: hasSaveOption
      });

      if (withfutureTravelCredits) {
        queryParams.futureTravelCreditOption = true;
      }

      !hasNoRedirection && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmation', {
        status: statusCode_constants["a" /* STATUS_CODE_200 */]
      }, queryParams))();
      return {
        isRedirectionPerfomed: false,
        reason: null,
        bookingId: response === null || response === void 0 ? void 0 : (_response$bookings4 = response.bookings) === null || _response$bookings4 === void 0 ? void 0 : _response$bookings4.bookingId
      };
    };

    var handleError = function handleError(error) {
      var status = get_default()(error, 'errors[0].responseBody.status_code', statusCode_constants["b" /* STATUS_CODE_400 */]);

      var errorCode = get_default()(error, 'errors[0].responseBody.errors[0].error_code', 'BOOKING_UNAVAILABLE');

      var errorDescription = get_default()(error, 'errors[0].responseBody.errors[0].error_description');

      var isBookingInSameTimeOfProposalError = hasSaveOption && errorCode === option_validity_constants["a" /* BOOKING_ALREADY_EXISTS */];
      !hasNoRedirection && !isBookingInSameTimeOfProposalError && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmationError', {
        status: status,
        error_code: errorCode,
        error_description: errorDescription
      }, {
        selectedProposalId: selectedProposalId,
        productId: productId
      }))();
      return {
        isRedirectionPerfomed: false,
        reason: isBookingInSameTimeOfProposalError ? option_validity_constants["a" /* BOOKING_ALREADY_EXISTS */] : null,
        bookingId: null,
        response: null
      };
    };

    return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
      requestName: requestDictionary["Xc" /* PROPOSAL_UPDATE */]
    }).then(handleSuccess)["catch"](handleError);
  };
}

function submitOption(_ref2) {
  var appContext = _ref2.appContext,
      router = _ref2.router,
      hasSaveOption = _ref2.hasSaveOption,
      withfutureTravelCredits = _ref2.withfutureTravelCredits;
  var _router$query = router.query,
      selectedProposalId = _router$query.selectedProposalId,
      productId = _router$query.product;
  return submitOptionFromProposal({
    appContext: appContext,
    selectedProposalId: selectedProposalId,
    productId: productId,
    hasSaveOption: hasSaveOption,
    router: router,
    withfutureTravelCredits: withfutureTravelCredits
  });
}

function renderErrorUpdatingAttendees(_ref3) {
  var errors = _ref3.errors,
      statusCode = _ref3.statusCode;

  if (statusCode && (statusCode === statusCode_constants["f" /* STATUS_CODE_500 */] || statusCode === statusCode_constants["c" /* STATUS_CODE_401 */])) {
    return Object(i18n["h" /* t */])('booking.form.errors.technicalErrorParticipants');
  }

  if (errors === null || errors === void 0 ? void 0 : errors.length) {
    var _errors$;

    var errorCode = errors === null || errors === void 0 ? void 0 : (_errors$ = errors[0]) === null || _errors$ === void 0 ? void 0 : _errors$.errorCode;
    var cmsErrorKey = "booking.participants.errorMessage.".concat(errorCode);

    if (errorCode && cmsErrorKey !== Object(i18n["h" /* t */])(cmsErrorKey)) {
      return Object(i18n["h" /* t */])(cmsErrorKey);
    }
  }

  return Object(i18n["h" /* t */])('booking.form.errorLabel');
}

var getAttendeeId = function getAttendeeId(_ref4) {
  var neolid = _ref4.neolid;
  return neolid;
};

var getAllAttendeesIds = function getAllAttendeesIds(_ref5) {
  var adults = _ref5.adults,
      kids = _ref5.kids;
  var allAttendeesIds = {};

  if (adults.length > 0) {
    allAttendeesIds.adultsAttendeesIds = adults.map(getAttendeeId).filter(Boolean);
  }

  if (kids && kids.length > 0) {
    allAttendeesIds.kidsAttendeesIds = kids.map(getAttendeeId).filter(Boolean);
  }

  return allAttendeesIds;
};

var ContactInfoUtils_getInitialFormValues = function getInitialFormValues(_ref6) {
  var bookingProcess = _ref6.bookingProcess,
      adultCivilityDefaultValue = _ref6.adultCivilityDefaultValue,
      childCivilityDeefaultValue = _ref6.childCivilityDeefaultValue,
      attendees = _ref6.attendees,
      connectedUserInfo = _ref6.connectedUserInfo,
      hasAddress = _ref6.hasAddress,
      locale = _ref6.locale,
      getAttendeeSchema = _ref6.getAttendeeSchema,
      displayParticipantsSelectInput = _ref6.displayParticipantsSelectInput,
      _ref6$preCheckedOptin = _ref6.preCheckedOptins,
      preCheckedOptins = _ref6$preCheckedOptin === void 0 ? {} : _ref6$preCheckedOptin;
  var optins = ContactInfoUtils_getOptinsInfos(bookingProcess); // The opt-ins show are configurable from the CMS, but we also don't show them for identified
  // users who already checked them

  var getOptinValue = function getOptinValue(optin, optinName, userInfo) {
    var _preCheckedOptins$opt;

    if (!optin) {
      return;
    } // in case of a connected user return undefined to not show it if already checked


    if (connectedUserInfo[optinName] === true) {
      return undefined;
    }

    if (userInfo[optinName] !== undefined) {
      return userInfo[optinName];
    }

    return Boolean((_preCheckedOptins$opt = preCheckedOptins[optinName]) !== null && _preCheckedOptins$opt !== void 0 ? _preCheckedOptins$opt : optin.preChecked);
  };

  var defaultCountryCode = locale.split('-')[1];

  var getDocumentInfo = function getDocumentInfo(documents, documentType, type, attendeeSchema) {
    var document = documents === null || documents === void 0 ? void 0 : documents[documentType];

    var getFieldDefaultValue = function getFieldDefaultValue(value, field) {
      var defaultValue = {}; // should only initialize these values if they exist in the schema V1

      if (attendeeSchema === null || attendeeSchema === void 0 ? void 0 : attendeeSchema.find(function (schema) {
        return (schema === null || schema === void 0 ? void 0 : schema.name) === "".concat(documentType, "_").concat(field);
      })) {
        defaultValue[field] = value || defaultCountryCode;
      }

      return defaultValue;
    };

    var getFieldDefaulDate = function getFieldDefaulDate(value, field) {
      if (value && (attendeeSchema === null || attendeeSchema === void 0 ? void 0 : attendeeSchema.find(function (schema) {
        return (schema === null || schema === void 0 ? void 0 : schema.name) === "".concat(documentType, "_").concat(field);
      }))) {
        return Object(apiDate["e" /* apiDateToTimestamp */])(value);
      }

      return value;
    };

    var issuingDate = getFieldDefaulDate(document === null || document === void 0 ? void 0 : document.issuingDate, 'issue_date');
    var expirationDate = getFieldDefaulDate(document === null || document === void 0 ? void 0 : document.expirationDate, 'expiration_date');

    var formattedDocument = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, document || {}), getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.nationality, 'nationality')), getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.issuingCountry, 'issuingCountry')), getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.birthCountry, 'birthCountry')), issuingDate ? {
      issuingDate: issuingDate
    } : {}), expirationDate ? {
      expirationDate: expirationDate
    } : {}); // type is to be sent in Put Attendees should be in [PASSPORT, IDCARD]


    return _objectSpread(_objectSpread({}, formattedDocument), {}, {
      type: type
    });
  };

  var kidCivilities = Object(domains_service_dist["getKidsCivilities"])(locale);

  var getBirthday = function getBirthday(birthdate) {
    return birthdate && typeof birthdate === 'number' ? birthdate : Object(apiDate["e" /* apiDateToTimestamp */])(birthdate);
  };

  var adults = attendees.adults,
      children = attendees.children;
  return {
    adults: adults.map(function (adult, index) {
      var _adult$address;

      return _objectSpread(_objectSpread(_objectSpread({}, adult), {}, {
        attendeeIndex: index,
        civility: displayParticipantsSelectInput ? '' : adult.civility || adultCivilityDefaultValue,
        document: {
          passport: getDocumentInfo(adult.document, 'passport', legalInformationIds_constants["h" /* PASSPORT */], getAttendeeSchema(!!adult.isMain, false)),
          idcard: getDocumentInfo(adult.document, 'idcard', legalInformationIds_constants["e" /* IDCARD */], getAttendeeSchema(!!adult.isMain, false))
        },
        birthdate: adult.birthdate && getBirthday(adult.birthdate),
        address: adult.isMain && hasAddress ? _objectSpread(_objectSpread({}, adult.address), {}, {
          countryCode: ((_adult$address = adult.address) === null || _adult$address === void 0 ? void 0 : _adult$address.countryCode) || defaultCountryCode
        }) : undefined
      }, adult.isMain ? {
        optinEmail: getOptinValue(optins.email, 'optinEmail', adult),
        optinSms: getOptinValue(optins.sms, 'optinSms', adult),
        optinMail: getOptinValue(optins.mail, 'optinMail', adult),
        optinFosun: getOptinValue(optins.fosun, 'optinFosun', adult),
        optinPhone: getOptinValue(optins.phone, 'optinPhone', adult),
        optinClubmedPlus: getOptinValue(optins.clubmedPlus, 'optinClubmedPlus', adult),
        legalAgreement: false,
        checkAll: false
      } : null), {}, {
        mainContactId: !adult.gmNumber && adults[0].neolid ? adults[0].neolid : '-1' // temporarily disabled: waiting for clic evolv

      });
    }),
    children: children.map(function (child, index) {
      var _connectedUserInfo$tr, _kidCivilities$, _adults$, _adults$2;

      var childTravelCompanionData = (_connectedUserInfo$tr = connectedUserInfo.travelCompanions) === null || _connectedUserInfo$tr === void 0 ? void 0 : _connectedUserInfo$tr.find(function (_ref7) {
        var birthdate = _ref7.birthdate;
        return moment_default()(child.birthdate).isSame(birthdate);
      });
      var childWithInfos = childTravelCompanionData ? {
        birthdate: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.birthdate,
        civility: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.civility,
        document: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.document,
        firstName: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.firstName,
        lastName: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.lastName,
        unicodeFirstName: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.unicodeFirstName,
        unicodeLastName: childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData.unicodeLastName
      } : {};
      return _objectSpread(_objectSpread(_objectSpread({}, child || {}), childWithInfos), {}, {
        attendeeIndex: index,
        civility: (child === null || child === void 0 ? void 0 : child.civility) || childCivilityDeefaultValue || ((_kidCivilities$ = kidCivilities[0]) === null || _kidCivilities$ === void 0 ? void 0 : _kidCivilities$.value),
        document: {
          passport: getDocumentInfo(child === null || child === void 0 ? void 0 : child.document, 'passport', legalInformationIds_constants["h" /* PASSPORT */], getAttendeeSchema(false, true)),
          idcard: getDocumentInfo(child === null || child === void 0 ? void 0 : child.document, 'idcard', legalInformationIds_constants["e" /* IDCARD */], getAttendeeSchema(false, true))
        },
        birthdate: child.birthdate && getBirthday(child.birthdate),
        mainContactId: !(child === null || child === void 0 ? void 0 : child.gmNumber) && ((_adults$ = adults[0]) === null || _adults$ === void 0 ? void 0 : _adults$.neolid) ? (_adults$2 = adults[0]) === null || _adults$2 === void 0 ? void 0 : _adults$2.neolid : '0'
      });
    })
  };
};
function getSchemaValidators(schema) {
  var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref8$withRequired = _ref8.withRequired,
      withRequired = _ref8$withRequired === void 0 ? true : _ref8$withRequired,
      _ref8$requiredMessage = _ref8.requiredMessage,
      requiredMessage = _ref8$requiredMessage === void 0 ? function (fieldValidation) {
    return Object(i18n["h" /* t */])("booking.participants.errorMessage.".concat(camelCase_default()(fieldValidation.name)));
  } : _ref8$requiredMessage,
      _ref8$messages = _ref8.messages,
      messages = _ref8$messages === void 0 ? {} : _ref8$messages,
      _ref8$isDateType = _ref8.isDateType,
      isDateType = _ref8$isDateType === void 0 ? false : _ref8$isDateType,
      _ref8$isNullable = _ref8.isNullable,
      isNullable = _ref8$isNullable === void 0 ? false : _ref8$isNullable;

  return schema === null || schema === void 0 ? void 0 : schema.reduce(function (addressValidators, fieldValidation) {
    var rule = isDateType ? lib["date"]() : lib["string"]();

    if (withRequired) {
      if (fieldValidation.required) {
        rule = rule.required(requiredMessage(fieldValidation));
      }
    }

    fieldValidation.validators.forEach(function (validator) {
      var _messages$fieldValida;

      var message = messages === null || messages === void 0 ? void 0 : (_messages$fieldValida = messages[fieldValidation.name]) === null || _messages$fieldValida === void 0 ? void 0 : _messages$fieldValida[validator.name];

      switch (validator.name) {
        case 'pattern':
          rule = rule.matches(new RegExp(validator.value), message || Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
          break;

        case 'minLength':
          rule = rule.transform(function (value) {
            return value === '' ? undefined : value;
          }, message).min(validator.value, message || Object(i18n["h" /* t */])('common.form.errors.invalidFieldTooShort', {
            minlength: validator.value
          }));
          break;

        case 'maxLength':
          rule = rule.max(validator.value, message || Object(i18n["h" /* t */])('common.form.errors.invalidFieldTooLong', {
            maxlength: validator.value
          }));
          break;

        default:
          // eslint-disable-next-line no-console
          console.error("Cannot handle rule ".concat(validator.name));
      }
    });
    return _objectSpread(_objectSpread({}, addressValidators), {}, Object(defineProperty["a" /* default */])({}, fieldValidation.name, isNullable ? rule.nullable() : rule));
  }, {});
}

var getDateSchemaByName = function getDateSchemaByName(attendeeSchema, validatorName) {
  return getSchemaValidators(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : attendeeSchema.filter(function (_ref9) {
    var name = _ref9.name;
    return name === validatorName;
  }), {
    isDateType: true
  }) || {};
};

var korean = /(\S*[\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]+\S*)/;
var japanese = /(\S*[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+|[々〆〤ヶ]+\S*)/;
var hebrew = /^[\u0590-\u05fe]+$/;
var cyrillic = /(\S*[u0400-\u04FF]+$)/;
var chinese = /(\S*[\u4e00-\u9fff]+$)/;
var thai = /(\S*[\u0E01-\u0E5B]+|[\u1980-\u19DF]+|[\u1950-\u197F]+|[\u1A20-\u1AAF]+|[\uAA80-\uAADF]+$)/;
var asciiWordRegex = /^[\x20-\xFF]+$/; // ASCII

var getNonAsciiNameValidatorByLocale = function getNonAsciiNameValidatorByLocale(locale) {
  switch (locale) {
    case 'ko-KR':
      return korean;

    case 'zh-CN':
    case 'zh-HK':
    case 'zh-TW':
      return chinese;

    case 'ja-JP':
      return japanese;

    case 'ru-RU':
    case 'uk-UA':
    case 'sr-RS':
      return cyrillic;

    case 'he-IL':
      return hebrew;

    case 'th-TH':
      return thai;

    default:
      return asciiWordRegex;
  }
};

var ContactInfoUtils_getValidators = function getValidators(_ref10) {
  var attendeeSchema = _ref10.attendeeSchema,
      addressSchema = _ref10.addressSchema,
      locale = _ref10.locale,
      arrivalDate = _ref10.arrivalDate,
      adultCivilities = _ref10.adultCivilities,
      childCivilities = _ref10.childCivilities; // Validators coming from API, to be merged with local validators

  var addressSchemaValidators = getSchemaValidators(addressSchema, {
    isNullable: true
  }) || {};
  var attendeeSchemaValidators = getSchemaValidators(attendeeSchema) || {};
  var birthdateValidator = getDateSchemaByName(attendeeSchema, 'birthdate');
  lib["addMethod"](lib["string"], 'asciiNameValidator', function () {
    return this.matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
  });
  lib["addMethod"](lib["string"], 'unicodeNameValidator', function () {
    return this.matches(getNonAsciiNameValidatorByLocale(locale), Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
  });
  var phoneRegex = Object(RegexHelper["b" /* getPhoneRegex */])(locale);
  var rawValidators = {
    adultCivilities: lib["string"]().oneOf(adultCivilities, Object(i18n["h" /* t */])('booking.participants.errorMessage.civility')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.civility')),
    childCivilities: lib["string"]().oneOf(childCivilities, Object(i18n["h" /* t */])('booking.participants.errorMessage.gender')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.gender')),
    firstName: (attendeeSchemaValidators.first_name || lib["string"]()).asciiNameValidator().matches(/^[\x20-\xFF]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(20).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.firstName')),
    lastName: (attendeeSchemaValidators.last_name || lib["string"]()).asciiNameValidator().matches(/^[\x20-\xFF]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(30).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.lastName')),
    unicodeFirstName: (attendeeSchemaValidators.unicode_first_name || lib["string"]()).unicodeNameValidator().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(100).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.unicodeFirstName')),
    unicodeLastName: (attendeeSchemaValidators.unicode_last_name || lib["string"]()).unicodeNameValidator().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).max(100).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.unicodeLastName')),
    adultBirthDate: (birthdateValidator.birthdate || lib["date"]()).transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()(arrivalDate).subtract(contact_info_constants["k" /* YEAR_OF_MAJORITY */], 'y')).min(moment_default()().subtract(contact_info_constants["e" /* MAX_AGE */], 'y')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.birthdate')),
    childBirthDate: lib["date"]().transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()()).min(moment_default()().subtract(contact_info_constants["k" /* YEAR_OF_MAJORITY */], 'y')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.birthdate')),
    email: (attendeeSchemaValidators.email || lib["string"]()).matches(RegexHelper["a" /* emailRegex */], Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.email')),
    mobile: lib["string"]().matches(phoneRegex, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')).required(Object(i18n["h" /* t */])('booking.participants.errorMessage.mobilePhone')),
    healthPassId: (attendeeSchemaValidators.health_pass_id || lib["string"]()).length(10),
    emailNotRequired: lib["string"]().email(),
    mobileNotRequired: lib["string"]().transform(function (v) {
      return !v ? undefined : v;
    }) // transform to undefined when empty string to pass the regex
    .matches(phoneRegex, Object(i18n["h" /* t */])('common.form.errors.invalidFieldFormat')),
    gmNumber: (attendeeSchemaValidators.gm_number || lib["string"]()).required()
  }; // $FlowFixMe

  return _objectSpread(_objectSpread({}, rawValidators), {}, {
    address: addressSchemaValidators
  });
};
var ContactInfoUtils_getTravelDocumentsValidators = function getTravelDocumentsValidators(_ref11) {
  var _attendeeSchema$find;

  var attendeeSchema = _ref11.attendeeSchema,
      locale = _ref11.locale,
      departureDate = _ref11.departureDate,
      arrivalDate = _ref11.arrivalDate; // Validators coming from API, to be merged with local validators

  var attendeeSchemaValidators = getSchemaValidators(attendeeSchema) || {};
  var idcardExpDateValidator = getDateSchemaByName(attendeeSchema, 'idcard_expiration_date');
  var idcardIssuingDateValidator = getDateSchemaByName(attendeeSchema, 'idcard_issue_date');
  var passportExpDateValidator = getDateSchemaByName(attendeeSchema, 'passport_expiration_date');
  var passportIssDateValidator = getDateSchemaByName(attendeeSchema, 'passport_issue_date');
  var isDocumentNumberRequired = !!(attendeeSchema === null || attendeeSchema === void 0 ? void 0 : (_attendeeSchema$find = attendeeSchema.find(function (_ref12) {
    var name = _ref12.name;
    return name === 'passport_document_number';
  })) === null || _attendeeSchema$find === void 0 ? void 0 : _attendeeSchema$find.required);
  var identityNumberGeneralRule = identityNumberValidator_reducer_identityNumberValidatorReducer(locale, attendeeSchema);
  lib["addMethod"](lib["string"], 'documentNumberRule', function () {
    return this.test('is-passport-required', Object(i18n["h" /* t */])('booking.participants.errorMessage.identityNumber'), function (value) {
      var trimmedDocNumber = value === null || value === void 0 ? void 0 : value.trim();

      if (trimmedDocNumber) {
        // typed somthing apart from white spaces
        var isValidDocNumber = Boolean(trimmedDocNumber === null || trimmedDocNumber === void 0 ? void 0 : trimmedDocNumber.match(/[a-zA-Z0-9]{6,}$/));
        return isValidDocNumber;
      }

      return !isDocumentNumberRequired;
    }).max(30);
  });
  lib["addMethod"](lib["date"], 'expirationDateRule', function () {
    return this.transform(function (value, initialValue) {
      // $FlowFixMe ugly but works
      return initialValue ? new Date(moment_default()(initialValue)) : initialValue;
    }).min(moment_default()(departureDate).add(1, 'd'));
  });
  lib["addMethod"](lib["date"], 'issuingDateRule', function () {
    return this.transform(function (value, initialValue) {
      // $FlowFixMe ugly but works
      return initialValue ? new Date(moment_default()(initialValue)) : initialValue;
    }).max(moment_default()(arrivalDate).subtract(1, 'd'));
  });
  var rawValidators = {
    idcardDocumentNumber: (attendeeSchemaValidators.idcard_document_number || lib["string"]()).nullable().documentNumberRule(),
    passportDocumentNumber: (attendeeSchemaValidators.passport_document_number || lib["string"]()).nullable().documentNumberRule(),
    idcardExpirationDate: (idcardExpDateValidator.idcard_expiration_date || lib["date"]()).nullable().expirationDateRule(),
    passportExpirationDate: (passportExpDateValidator.passport_expiration_date || lib["date"]()).nullable().expirationDateRule(),
    idcardIssueDate: (idcardIssuingDateValidator.idcard_issue_date || lib["date"]()).nullable().issuingDateRule(),
    passportIssueDate: (passportIssDateValidator.passport_issue_date || lib["date"]()).nullable().issuingDateRule(),
    idcardNationality: (attendeeSchemaValidators.idcard_nationality || lib["string"]()).nullable(),
    passportNationality: (attendeeSchemaValidators.passport_nationality || lib["string"]()).nullable(),
    idcardAuthority: (attendeeSchemaValidators.idcard_authority || lib["string"]()).nullable(),
    passportAuthority: (attendeeSchemaValidators.passport_authority || lib["string"]()).nullable(),
    idcardBirthCountry: (attendeeSchemaValidators.idcard_birth_country || lib["string"]()).nullable(),
    passportBirthCountry: attendeeSchemaValidators.passport_birth_country || lib["string"](),
    identityNumber: attendeeSchemaValidators.identity_number || identityNumberGeneralRule
  }; // $FlowFixMe

  return rawValidators;
};
var ContactInfoUtils_getLegalAgreementValidator = function getLegalAgreementValidator() {
  return lib["mixed"]().oneOf([true]).required();
};
var ContactInfoUtils_getSalesmanIdValidator = function getSalesmanIdValidator(_ref13) {
  var attendeeSchema = _ref13.attendeeSchema;
  var attendeeSchemaValidators = getSchemaValidators(attendeeSchema);
  return ((attendeeSchemaValidators === null || attendeeSchemaValidators === void 0 ? void 0 : attendeeSchemaValidators.salesman_id) || lib["string"]()).matches(RegexHelper["e" /* salesmanIDRegex */]);
};

function getDocumentsFields(bookingProcess) {
  return legalInformationIds_constants["b" /* DOCUMENT_TYPES */].reduce(function (fields, type) {
    var filteredFields = {
      type: type.toLowerCase(),
      values: bookingProcess.filter(function (field) {
        return field.type === type;
      })
    }; // returns all fields in bookingProcess or TransportBookingProcess with the current type(s)

    filteredFields.values.length > 0 && fields.push(filteredFields);
    return fields;
  }, []);
}

var ContactInfoUtils_getAdultCivilities = function getAdultCivilities(defaultCivilities, locale) {
  var adultCivilities = Object(domains_service_dist["getAdultsCivilities"])(locale);
  return isEmpty_default()(adultCivilities) ? defaultCivilities : adultCivilities;
};
var ContactInfoUtils_getHeaderContactInfoTitle = function getHeaderContactInfoTitle(_ref14) {
  var isMain = _ref14.isMain,
      isChild = _ref14.isChild,
      hasUnicodeFields = _ref14.hasUnicodeFields,
      formValues = _ref14.formValues,
      attendeeIdentifier = _ref14.attendeeIdentifier,
      attendeeIndex = _ref14.attendeeIndex,
      isValid = _ref14.isValid;

  if (hasUnicodeFields && isValid) {
    return "".concat(get_default()(formValues, "".concat(attendeeIdentifier, ".unicodeFirstName")), " ").concat(get_default()(formValues, "".concat(attendeeIdentifier, ".unicodeLastName")));
  }

  var firstName = get_default()(formValues, "".concat(attendeeIdentifier, ".firstName"));

  var lastName = get_default()(formValues, "".concat(attendeeIdentifier, ".lastName"));

  if (!!firstName && !!lastName) {
    return "".concat(firstName, " ").concat(lastName);
  }

  if (isMain) {
    return Object(i18n["h" /* t */])('booking.participants.personnalInfosHeader.title');
  }

  if (isChild) {
    return "".concat(Object(i18n["h" /* t */])('booking.participants.otherKidsInfosHeader.title'), " ").concat(attendeeIndex + 1);
  }

  return "".concat(Object(i18n["h" /* t */])('booking.participants.otherAdultsInfosHeader.title'), " ").concat(attendeeIndex);
};

var ContactInfoUtils_shouldHideField = function shouldHideField(_ref15) {
  var _connectedUserInfo$tr2;

  var formInitialValues = _ref15.formInitialValues,
      connectedUserInfo = _ref15.connectedUserInfo,
      attendeeIdentifier = _ref15.attendeeIdentifier,
      fieldName = _ref15.fieldName,
      isMain = _ref15.isMain,
      fieldNameConnectedUserOverride = _ref15.fieldNameConnectedUserOverride,
      _ref15$isChild = _ref15.isChild,
      isChild = _ref15$isChild === void 0 ? false : _ref15$isChild;
  var childTravelCompanionData = attendeeIdentifier && (connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.travelCompanions) && (connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : (_connectedUserInfo$tr2 = connectedUserInfo.travelCompanions) === null || _connectedUserInfo$tr2 === void 0 ? void 0 : _connectedUserInfo$tr2.find(function (_ref16) {
    var birthdate = _ref16.birthdate;
    return Object(apiDate["d" /* apiDateTimeToTimestamp */])(birthdate) === get_default()(formInitialValues, "".concat(attendeeIdentifier, ".birthdate"));
  })) || null;
  return connectedUserInfo && !isChild && isMain && (fieldNameConnectedUserOverride && connectedUserInfo[fieldNameConnectedUserOverride] || connectedUserInfo[fieldName]) || isChild && connectedUserInfo && (childTravelCompanionData === null || childTravelCompanionData === void 0 ? void 0 : childTravelCompanionData[fieldName]);
};

var ContactInfoUtils_findDuplicateAttendees = function findDuplicateAttendees(attendees) {
  var _Object$keys;

  var duplicates = attendees === null || attendees === void 0 ? void 0 : attendees.reduce(function (acc, attendee, index) {
    if (attendee) {
      var birthdate = attendee.birthdate,
          lastName = attendee.lastName,
          firstName = attendee.firstName;

      if (birthdate && lastName && firstName) {
        var key = "".concat(birthdate).concat(lastName).concat(firstName).toLocaleLowerCase();

        if (acc[key]) {
          acc[key].push(index);
        } else {
          acc[key] = [index];
        }
      }
    }

    return acc;
  }, {});
  (_Object$keys = Object.keys(duplicates)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.forEach(function (key) {
    var _duplicates$key;

    if ((duplicates === null || duplicates === void 0 ? void 0 : (_duplicates$key = duplicates[key]) === null || _duplicates$key === void 0 ? void 0 : _duplicates$key.length) < 2) {
      delete duplicates[key];
    }
  }); // $FlowFixMe return indexes of duplicate attendees

  return flatten_default()(Object.values(duplicates));
};

var ContactInfoUtils_generateErrorFieldsObj = function generateErrorFieldsObj(erroredFieldsArray) {
  // Initialize the result object with 'no-error' for each field
  var result = {};

  for (var i = 0; i < Object.keys(contact_info_constants["c" /* FORM_ERROR_OBJECT */]).length; i++) {
    result[i] = 'no-error';
  } // Update the result for selected fields based on the input array


  erroredFieldsArray.forEach(function (field) {
    var key = Object.keys(contact_info_constants["c" /* FORM_ERROR_OBJECT */]).find(function (k) {
      return contact_info_constants["c" /* FORM_ERROR_OBJECT */][k] === field;
    });

    if (key !== undefined) {
      result[key] = field;
    }
  });
  return [result];
};

var ContactInfoUtils_trackAttendeesFormError = function trackAttendeesFormError(trackEvent, formik) {
  var _formik$errors, _formik$errors2;

  var getFields = function getFields(errors) {
    return Object.entries(errors || {}).reduce(function (acc, _ref17) {
      var _ref18 = Object(slicedToArray["a" /* default */])(_ref17, 2),
          key = _ref18[0],
          value = _ref18[1];

      if (isObject_default()(value)) {
        return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(getFields(value)));
      }

      return [].concat(Object(toConsumableArray["a" /* default */])(acc), [key]);
    }, []).sort();
  };

  var trackFormErrors = function trackFormErrors(formName, errors) {
    trackEvent(constants["E" /* TRACK_EVENT_NAMES */].FORM_ERROR, {
      error_status: {
        form_name: formName,
        fields: ContactInfoUtils_generateErrorFieldsObj(getFields(errors))
      }
    });
  };

  var trackForms = function trackForms(prefix) {
    var forms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    forms.forEach(function (errors, i) {
      trackFormErrors("".concat(prefix, "_").concat(i + 1), errors);
    });
  };

  trackForms('adult', (_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.adults);
  trackForms('child', (_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : _formik$errors2.children);
};

var ContactInfoUtils_parseBirthdate = function parseBirthdate(birthdate) {
  if (typeof birthdate === 'string') {
    return moment_default()(birthdate).valueOf();
  }

  return birthdate;
};

var ContactInfoUtils_isChildWillBeAdultByArrivalDate = function isChildWillBeAdultByArrivalDate(childBirthdate, arrivalDate) {
  var childBirthdateValue = ContactInfoUtils_parseBirthdate(childBirthdate);
  var childAge = moment_default()().diff(childBirthdateValue, 'years');
  var childAgeByArrivalDate = moment_default()(arrivalDate).diff(childBirthdateValue, 'years');
  return childAge < 18 && childAgeByArrivalDate >= 18;
};
var ContactInfoUtils_tripInformationToAttendeesList = function tripInformationToAttendeesList(tripInformation) {
  var _tripInformation$kids;

  var attendeesList = [].concat(Object(toConsumableArray["a" /* default */])(tripInformation.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread({}, adult), {}, {
      isMain: index === 0
    });
  })), Object(toConsumableArray["a" /* default */])(((_tripInformation$kids = tripInformation.kids) === null || _tripInformation$kids === void 0 ? void 0 : _tripInformation$kids.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      isChild: true
    });
  })) || []));
  return {
    adults: attendeesList.filter(function (_ref19) {
      var isChild = _ref19.isChild;
      return !isChild;
    }),
    children: attendeesList.filter(function (_ref20) {
      var isChild = _ref20.isChild;
      return isChild;
    }),
    all: attendeesList.map(function (attendee, index) {
      return _objectSpread(_objectSpread({}, attendee), {}, {
        attendeeIndex: Number(index)
      });
    })
  };
};
var ContactInfoUtils_travelCompanionMapper = function travelCompanionMapper(_ref21) {
  var companionId = _ref21.companionId,
      civility = _ref21.civility,
      firstName = _ref21.firstName,
      lastName = _ref21.lastName,
      birthdate = _ref21.birthdate,
      document = _ref21.document,
      mobile = _ref21.mobile,
      email = _ref21.email,
      customerId = _ref21.customerId,
      mainContactId = _ref21.mainContactId,
      isSelected = _ref21.isSelected,
      isChild = _ref21.isChild,
      unicodeFirstName = _ref21.unicodeFirstName,
      unicodeLastName = _ref21.unicodeLastName;
  return _objectSpread(_objectSpread({
    companionId: companionId,
    civility: civility,
    firstName: firstName,
    lastName: lastName,
    document: document,
    mobile: mobile,
    email: email,
    customerId: customerId,
    mainContactId: mainContactId,
    unicodeFirstName: unicodeFirstName,
    unicodeLastName: unicodeLastName,
    isSelected: isSelected || false
  }, (isChild || dist["attendees"].isKid({
    birthdate: birthdate
  })) && {
    isChild: true
  }), birthdate && {
    birthdate: ContactInfoUtils_parseBirthdate(birthdate)
  });
};
var getNextCharacter = function getNextCharacter(_char) {
  return String.fromCharCode(_char.charCodeAt(0) + 1);
};
var createId = function createId(index, _char2) {
  return String.fromCharCode(_char2.charCodeAt(0) + index);
};
var ContactInfoUtils_getChildrenToAdultsTransferList = function getChildrenToAdultsTransferList(attendeesList, arrivalDate) {
  var adults = attendeesList.adults,
      children = attendeesList.children;

  var toBeAdultFilter = function toBeAdultFilter(_ref22) {
    var birthdate = _ref22.birthdate;
    return birthdate && ContactInfoUtils_isChildWillBeAdultByArrivalDate(birthdate, arrivalDate);
  };

  var indexMap = function indexMap(attendee, index) {
    return _objectSpread(_objectSpread({}, attendee), {}, {
      attendeeIndex: Number(index)
    });
  };

  var adultMapper = function adultMapper(_ref23) {
    var civility = _ref23.civility,
        firstName = _ref23.firstName,
        lastName = _ref23.lastName,
        birthdate = _ref23.birthdate,
        neolid = _ref23.neolid,
        gmNumber = _ref23.gmNumber;
    return {
      civility: civility,
      firstName: firstName,
      lastName: lastName,
      birthdate: birthdate,
      neolid: neolid,
      gmNumber: gmNumber,
      isMain: false
    };
  };

  var adultsList = [].concat(Object(toConsumableArray["a" /* default */])(adults), Object(toConsumableArray["a" /* default */])(children.filter(toBeAdultFilter).map(adultMapper))).map(function (el, index) {
    return _objectSpread(_objectSpread({}, el), {}, {
      id: createId(index, 'A')
    });
  });
  var nextId = getNextCharacter(adultsList[adultsList.length - 1].id);
  var childrenList = children.filter(function (child) {
    return !children.filter(toBeAdultFilter).includes(child);
  }).map(function (el, index) {
    return _objectSpread(_objectSpread({}, el), {}, {
      id: createId(index, nextId)
    });
  });
  return {
    adultsList: adultsList,
    childrenList: childrenList,
    allList: [].concat(Object(toConsumableArray["a" /* default */])(adultsList.map(indexMap)), Object(toConsumableArray["a" /* default */])(childrenList.map(indexMap)))
  };
};
var compareById = function compareById(a, b) {
  return a.id.localeCompare(b.id);
};
var ContactInfoUtils_compareByBirthdate = function compareByBirthdate(a, b) {
  return moment_default()(a.birthdate).valueOf() - moment_default()(b.birthdate).valueOf();
};
var ContactInfoUtils_getSortedTravelCompanionList = function getSortedTravelCompanionList() {
  var travelCompanionList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var travelCompanionListWithoutBirthdate = travelCompanionList.filter(function (_ref24) {
    var birthdate = _ref24.birthdate;
    return !birthdate;
  }).map(function (_ref25) {
    var birthdate = _ref25.birthdate,
        rest = Object(objectWithoutProperties["a" /* default */])(_ref25, ["birthdate"]);

    return _objectSpread({}, rest);
  });
  var sortedTravelCompanionList = travelCompanionList.filter(function (_ref26) {
    var birthdate = _ref26.birthdate;
    return birthdate;
  }).sort(ContactInfoUtils_compareByBirthdate);
  return [].concat(Object(toConsumableArray["a" /* default */])(travelCompanionListWithoutBirthdate), Object(toConsumableArray["a" /* default */])(sortedTravelCompanionList)).filter(function (_ref27) {
    var isMain = _ref27.isMain;
    return !isMain;
  }).map(function (travelCompanion, index) {
    return _objectSpread(_objectSpread({}, travelCompanion), {}, {
      companionId: index
    });
  }).map(ContactInfoUtils_travelCompanionMapper);
};
var ContactInfoUtils_filterSearchedChildren = function filterSearchedChildren() {
  var _uniqBy2, _allAttendees$adults;

  var travelCompanionList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allAttendees = arguments.length > 1 ? arguments[1] : undefined;
  var sortedCompanionsList = ContactInfoUtils_getSortedTravelCompanionList(travelCompanionList);
  var travelCompanionAdultList = sortedCompanionsList.filter(function (_ref28) {
    var isChild = _ref28.isChild;
    return !isChild;
  });
  var travelCompanionChildrenList = sortedCompanionsList.filter(function (_ref29) {
    var isChild = _ref29.isChild;
    return isChild;
  });
  var formattedCompanionChildrenList = (_uniqBy2 = uniqBy_default()(travelCompanionChildrenList, 'birthdate')) === null || _uniqBy2 === void 0 ? void 0 : _uniqBy2.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      birthdate: child.birthdate,
      isChild: true,
      isMain: false
    });
  });
  var selectedCompanionChildrenList = formattedCompanionChildrenList.filter(function (_ref30) {
    var isSelected = _ref30.isSelected;
    return isSelected;
  });
  var firstChildIndex = allAttendees === null || allAttendees === void 0 ? void 0 : (_allAttendees$adults = allAttendees.adults) === null || _allAttendees$adults === void 0 ? void 0 : _allAttendees$adults.length;
  var selectedChildrenIndexes = selectedCompanionChildrenList.map(function (_, i) {
    return {
      index: firstChildIndex + i,
      position: i
    };
  });
  var finalCompanionsList = [].concat(Object(toConsumableArray["a" /* default */])(travelCompanionAdultList), Object(toConsumableArray["a" /* default */])(selectedCompanionChildrenList));
  return {
    travelCompanions: finalCompanionsList,
    selectedIndexes: selectedChildrenIndexes
  };
};
var getFieldErrors = function getFieldErrors(_ref31) {
  var _errors$children, _errors$adults;

  var errors = _ref31.errors,
      index = _ref31.index,
      isChild = _ref31.isChild;
  return isChild ? errors === null || errors === void 0 ? void 0 : (_errors$children = errors.children) === null || _errors$children === void 0 ? void 0 : _errors$children[index] : errors === null || errors === void 0 ? void 0 : (_errors$adults = errors.adults) === null || _errors$adults === void 0 ? void 0 : _errors$adults[index];
};

var isLetter = function isLetter(_char3) {
  return !!((_char3 === null || _char3 === void 0 ? void 0 : _char3.length) === 1 && (_char3 === null || _char3 === void 0 ? void 0 : _char3.match(/[a-z]/i)));
};

var findAlphabetIndex = function findAlphabetIndex(_char4) {
  var base = 'a'.charCodeAt(0);
  return isLetter(_char4) ? _char4.toLowerCase().charCodeAt(0) - base : 0;
};
var setTravelCompanionBlockFormErrors = function setTravelCompanionBlockFormErrors(_ref32) {
  var _errors$children2, _errors$adults2;

  var errors = _ref32.errors,
      isChild = _ref32.isChild,
      travelCompanionIndex = _ref32.travelCompanionIndex,
      setFieldTouched = _ref32.setFieldTouched;
  var fieldErrors = isChild ? errors === null || errors === void 0 ? void 0 : (_errors$children2 = errors.children) === null || _errors$children2 === void 0 ? void 0 : _errors$children2[travelCompanionIndex] : errors === null || errors === void 0 ? void 0 : (_errors$adults2 = errors.adults) === null || _errors$adults2 === void 0 ? void 0 : _errors$adults2[travelCompanionIndex];
  var fieldErrorNames = fieldErrors ? Object.keys(fieldErrors) : [];
  fieldErrorNames.forEach(function (fieldErrorName) {
    setFieldTouched("".concat(isChild ? 'children' : 'adults', "[").concat(travelCompanionIndex, "].").concat(fieldErrorName), true);
  });
};
var getTravelCompanionInfos = function getTravelCompanionInfos(_ref33) {
  var travelCompanionSelector = _ref33.travelCompanionSelector,
      isChild = _ref33.isChild,
      parentIndex = _ref33.parentIndex;
  var travelCompanionAdultList = travelCompanionSelector.list.filter(function (travelCompanion) {
    return !travelCompanion.isChild;
  }); // $FlowFixMe

  var travelCompanionChildrenList = travelCompanionSelector.list.filter(function (travelCompanion) {
    return travelCompanion.isChild;
  });
  var travelCompanionList = isChild ? travelCompanionChildrenList : travelCompanionAdultList;
  var hasSelectedTravelCompanion = !!travelCompanionList.find(function (_ref34) {
    var isSelected = _ref34.isSelected;
    return isSelected;
  });
  var hasParentIndexInSelectedIndexes = travelCompanionSelector.selectedIndexes.some(function (indexes) {
    return indexes.index === parentIndex;
  });
  return {
    travelCompanionList: travelCompanionList,
    hasParentIndexInSelectedIndexes: hasParentIndexInSelectedIndexes,
    isDisabled: hasSelectedTravelCompanion && hasParentIndexInSelectedIndexes
  };
};
var ContactInfoUtils_setTravelCompanionField = function setTravelCompanionField(_ref35) {
  var travelCompanion = _ref35.travelCompanion,
      isChild = _ref35.isChild,
      parentIndex = _ref35.parentIndex,
      values = _ref35.values,
      setFieldValue = _ref35.setFieldValue,
      attendeeIdentifier = _ref35.attendeeIdentifier;

  var fieldObject = _objectSpread(_objectSpread({}, travelCompanion), {}, {
    // Here we create the actual id that will be in sync with number of fields we have in the form
    id: createId(parentIndex, 'A'),
    mainContactId: values.adults[0].mainContactId,
    birthdate: moment_default()(travelCompanion === null || travelCompanion === void 0 ? void 0 : travelCompanion.birthdate),
    customerId: '',
    attendeeIndex: parentIndex
  }, !isChild && {
    isMain: false
  });

  return setFieldValue(attendeeIdentifier, fieldObject);
};

var ContactInfoUtils_getHouseholdsAttendees = function getHouseholdsAttendees(householdsList) {
  var tempAttendees = [];
  householdsList.forEach(function (_ref36) {
    var adults = _ref36.adults,
        children = _ref36.children;
    var mainAdultsInCurrentHousehold = adults.filter(function (attendee) {
      return attendee === null || attendee === void 0 ? void 0 : attendee.isMain;
    }).length;

    var newAdults = Object(toConsumableArray["a" /* default */])(adults); // if the Main adult was selected else where; redefine a new main adult in the current household


    if (adults.length && mainAdultsInCurrentHousehold === 0) {
      newAdults = newAdults.map(function (adult, index) {
        return _objectSpread(_objectSpread({}, adult), {}, {
          isMain: index === 0
        });
      });
    }

    tempAttendees = [].concat(Object(toConsumableArray["a" /* default */])(tempAttendees), Object(toConsumableArray["a" /* default */])(newAdults), Object(toConsumableArray["a" /* default */])(children));
  });
  return tempAttendees.sort(function (a, b) {
    if (a.id < b.id) {
      return -1;
    }

    if (a.id > b.id) {
      return 1;
    }

    return 0;
  });
};



/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qqKu");
/* harmony import */ var _rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tuzA");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("EkOT");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;










var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      _ref$rate = _ref.rate,
      rate = _ref$rate === void 0 ? '' : _ref$rate,
      startDate = _ref.startDate,
      unit = _ref.unit;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_10__[/* usePageContext */ "b"])(),
      pageType = _usePageContext.pageType;

  var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].isMicePage(pageType);
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.buttonLabel');

  var _getRateMessagesPrope = Object(_rate_messages_RateMessages_utils__WEBPACK_IMPORTED_MODULE_9__[/* getRateMessagesProperties */ "a"])(rate),
      rateContent = _getRateMessagesPrope.rateContent,
      rateTitle = _getRateMessagesPrope.rateTitle; // Display text only in product Thumbnails popin


  var rateObject = onClick ? {
    rateContent: rateContent,
    rateTitle: rateTitle
  } : {};
  return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    className: "p-20",
    text: isMice ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionForME', {
      unit: unit
    }) : [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.roomAvailability'), rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateTitle, rateObject === null || rateObject === void 0 ? void 0 : rateObject.rateContent].join(' '),
    theme: "text-sans-n2"
  }), (isAllInclusive || isJoyview || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-lightGrey p-20"
  }, isAllInclusive && __jsx("p", {
    className: "flex flex-col sm:flex-row sm:flex-wrap gap-5 sm:items-center sm:justify-center max-w-full text-center text-black text-12"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "flex font-brand gap-5 items-center text-16 text-sienna"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].SIENNA,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.startingPrice.allInclusive'))), isJoyview && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "-mt-5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLUE_WAVE,
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CLUBMED_JOYVIEW,
    width: "10rem"
  }), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], {
    className: "mt-10",
    dataTestId: "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "ZpYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ StripButton_StripButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.themes.js

var themes = function themes(_ref) {
  var color = _ref.color,
      colorBorder = _ref.colorBorder,
      orientation = _ref.orientation;
  return {
    "default": {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse relative',
      thInner: "bg-".concat(color, " border-").concat(orientation === 'top' ? 't' : 'b', "-1 border-").concat(colorBorder, " -m").concat(orientation === 'top' ? 'x' : '', "-1 overflow-hidden px-5 p").concat(orientation === 'top' ? 't' : 'b', "-5 text-center whitespace-nowrap")
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx

var __jsx = react_default.a.createElement;





var StripButton_StripButtonSvg = function StripButtonSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      colorBorder = _ref.colorBorder,
      height = _ref.height,
      hasBottomOrientation = _ref.hasBottomOrientation;
  return __jsx("svg", {
    className: classnames_default()('fill-current', "text-".concat(color), className),
    viewBox: "0 0 15 30",
    height: height,
    style: {
      flexBasis: height / 2
    }
  }, __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    d: "M10,21H-5L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))), __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    style: {
      strokeWidth: '1px'
    },
    className: "fill-transparent stroke-current text-".concat(colorBorder),
    d: "M-5,21L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))));
};

var StripButton_StripButton = function StripButton(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
      _ref2$colorBorder = _ref2.colorBorder,
      colorBorder = _ref2$colorBorder === void 0 ? colors["a" /* COLORS */].LIGHT_GREY : _ref2$colorBorder,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? 'strip-button' : _ref2$dataTestId,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 30 : _ref2$height,
      onClick = _ref2.onClick,
      _ref2$orientation = _ref2.orientation,
      orientation = _ref2$orientation === void 0 ? 'top' : _ref2$orientation,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes({
    color: color,
    colorBorder: colorBorder,
    onClick: onClick,
    orientation: orientation
  })[theme],
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  var hasBottomOrientation = orientation === 'bottom';
  var svgProps = {
    color: color,
    colorBorder: colorBorder,
    height: height,
    hasBottomOrientation: hasBottomOrientation
  };
  var TagName = onClick ? 'button' : 'div';
  var btnProps = onClick ? {
    onClick: onClick,
    type: 'button'
  } : null;
  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(thRoot, className),
    "data-testid": dataTestId
  }, btnProps), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: classnames_default()('transform', {
      '-scale-y-1': hasBottomOrientation
    })
  }, svgProps)), __jsx("span", {
    className: thInner,
    style: {
      height: height
    }
  }, children), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: classnames_default()('transform -scale-x-1', {
      '-scale-y-1': hasBottomOrientation
    })
  }, svgProps)));
};

/***/ }),

/***/ "aURW":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "apzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfoSelector; });
var userInfoSelector = function userInfoSelector(state) {
  return state.userInfo;
};

/***/ }),

/***/ "b0q8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.resolve = resolve;
exports.reject = reject;
exports.unresolve = unresolve;
exports.unreject = unreject;
exports.isResolvedAction = isResolvedAction;
exports.isRejectedAction = isRejectedAction;
exports.isThenAction = isThenAction;
exports.default = optimistPromiseMiddleware;

var _fluxStandardAction = __webpack_require__("8soX");

function isPromise(val) {
  return val && typeof val.then === 'function';
}

var RESOLVED_NAME = '_RESOLVED',
    REJECTED_NAME = '_REJECTED';

var BEGIN = 'BEGIN';
var COMMIT = 'COMMIT';
var REVERT = 'REVERT';

function resolve(actionName) {
  return actionName + RESOLVED_NAME;
}

function reject(actionName) {
  return actionName + REJECTED_NAME;
}

function unresolve(resolvedActionName) {
  return resolvedActionName.split(RESOLVED_NAME)[0];
}

function unreject(rejectedActionName) {
  return rejectedActionName.split(REJECTED_NAME)[0];
}

function isResolvedAction(resolvedActionName) {
  return unresolve(resolvedActionName) !== resolvedActionName;
}

function isRejectedAction(rejectedActionName) {
  return unreject(rejectedActionName) !== rejectedActionName;
}

function isThenAction(thenActionName) {
  return isResolvedAction(thenActionName) || isRejectedAction(thenActionName);
}

function optimistPromiseMiddleware() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$throwOnReject = _ref.throwOnReject,
      throwOnReject = _ref$throwOnReject === undefined ? true : _ref$throwOnReject,
      _ref$resolvedName = _ref.resolvedName,
      resolvedName = _ref$resolvedName === undefined ? RESOLVED_NAME : _ref$resolvedName,
      _ref$rejectedName = _ref.rejectedName,
      rejectedName = _ref$rejectedName === undefined ? REJECTED_NAME : _ref$rejectedName;

  RESOLVED_NAME = resolvedName;
  REJECTED_NAME = rejectedName;

  var nextTransactionID = 0;
  return function (_ref2) {
    var dispatch = _ref2.dispatch;
    return function (next) {
      return function (action) {
        if (!(0, _fluxStandardAction.isFSA)(action) || !action.meta || !isPromise(action.meta.promise)) {
          return next(action);
        }

        var isOptimist = action.meta.optimist;

        var transactionID = void 0;

        if (isOptimist) {
          transactionID = nextTransactionID++;
        }

        // (1) Dispatch actionName with meta with arguments apart from promise

        // Clone original action
        var newAction = _extends({}, action, {
          meta: _extends({}, action.meta)
        });

        if (isOptimist) {
          // Adding optimistic meta
          newAction.optimist = { type: BEGIN, id: transactionID };
          delete newAction.meta.optimist;
        }

        if (Object.keys(newAction.meta).length === 1) {
          delete newAction.meta;
        } else {
          // Other arguments, delete promise and optimist only
          delete newAction.meta.promise;
        }

        var skipOptimist = action.meta.skipOptimist;

        if (!skipOptimist) {
          next(newAction);
        }

        // Create a base for the next action containing the metadata.
        var nextActionBase = {
          meta: _extends({}, newAction.meta, {
            payload: newAction.payload
          })
        };

        if (!nextActionBase.meta.payload) {
          // No payload, no need to include them in the meta.
          delete nextActionBase.meta.payload;
        }
        if (Object.keys(nextActionBase.meta).length === 0) {
          // No meta was included either, remove all meta.
          delete nextActionBase.meta;
        }

        // (2) Listen to promise and dispatch payload with new actionName
        return action.meta.promise.then(function (result) {
          var actionToDispatch = _extends({
            type: resolve(action.type),
            payload: result
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: COMMIT, id: transactionID };
          }
          dispatch(actionToDispatch);
          return result;
        }).catch(function (error) {
          var actionToDispatch = _extends({
            type: reject(action.type),
            payload: error
          }, nextActionBase);
          if (isOptimist) {
            actionToDispatch.optimist = { type: REVERT, id: transactionID };
          }
          dispatch(actionToDispatch);
          if (throwOnReject) {
            throw error;
          }
        });
      };
    };
  };
}

/***/ }),

/***/ "bMF2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAdultsWithoutMainContact */
/* unused harmony export getKidsBirthdate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFormattedKidsBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResortInitialKids; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("yyme");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("wQ38");













/* eslint-disable flowtype/no-weak-types */

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




function getAdultsWithoutMainContact(adults) {
  return (adults || []).slice(1);
}

function getKidsBirthdate(kids) {
  return (kids || []).map(function (kid) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(kid, 'birthdate');
  }).filter(Boolean) // kids may not have a birthdate
  .map(function (birthdate) {
    return moment__WEBPACK_IMPORTED_MODULE_13___default()(birthdate);
  });
}

function getFormattedKidsBirthdate(kids, dateFormat) {
  return getKidsBirthdate(kids).map(function (birthdate) {
    return moment__WEBPACK_IMPORTED_MODULE_13___default()(birthdate).format(dateFormat);
  });
}

function getResortInitialKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var initialKidsNumber = arguments.length > 1 ? arguments[1] : undefined;
  var isAdultOnlyResort = arguments.length > 2 ? arguments[2] : undefined;

  if (isAdultOnlyResort) {
    return [];
  }

  return lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(kids) && initialKidsNumber > -1 ? Array(initialKidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_14__[/* DEFAULT_KID_VALUE */ "a"])) : kids;
}



/***/ }),

/***/ "c8jO":
/***/ (function(module, exports) {

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
module.exports = _taggedTemplateLiteralLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "cDU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPriceOfStay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetPriceOfStay; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _priceOfStay_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fuxG");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("GZgf");



var getPriceOfStay = function getPriceOfStay(appContext, searchCriteria) {
  var args = Object(_priceOfStay_helper__WEBPACK_IMPORTED_MODULE_1__[/* getPriceOfStayArgs */ "b"])(searchCriteria);
  return function (dispatch, getState) {
    var _state$priceRemote$pr, _state$priceRemote, _state$priceRemote$pr2;

    var state = getState();

    if (JSON.stringify(args) === JSON.stringify((_state$priceRemote$pr = (_state$priceRemote = state.priceRemote) === null || _state$priceRemote === void 0 ? void 0 : (_state$priceRemote$pr2 = _state$priceRemote.priceOfStay) === null || _state$priceRemote$pr2 === void 0 ? void 0 : _state$priceRemote$pr2.priceOfStayArgs) !== null && _state$priceRemote$pr !== void 0 ? _state$priceRemote$pr : {})) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_OF_STAY_REQUEST_ABORT */ "c"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_OF_STAY_REQUEST */ "b"], {
      args: args
    }, {
      optimist: true,
      promise: Object(_priceOfStay_helper__WEBPACK_IMPORTED_MODULE_1__[/* fetchPriceOfStay */ "a"])(appContext, searchCriteria)
    }));
  };
};
var resetPriceOfStay = function resetPriceOfStay() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_2__[/* RESET_PRICE_OF_STAY */ "d"]);
};

/***/ }),

/***/ "cVnM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Scrollable_Scrollable; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/feature-testing/index.js + 1 modules
var feature_testing = __webpack_require__("qlAI");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/scrollable/Scrollable.themes.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}



var getNavPositionClasses = function getNavPositionClasses(navPosition) {
  switch (navPosition) {
    case 'top':
      return {
        thRoot: 'flex flex-col',
        thControlsWrapper: 'flex gap-10 justify-end mb-5 order-first w-full',
        thControls: 'flex gap-5 self-center',
        thControl: ''
      };

    case 'side':
      return {
        thRoot: 'flex flex-row justify-between',
        thInner: 'flex-1',
        thControlsWrapper: 'flex gap-10',
        thControls: 'flex gap-5 items-center justify-between pointer-events-none',
        thControl: 'mx-5',
        thControlDisabled: 'sr-only focus:not-sr-only',
        thControlLeft: 'pointer-events-auto mr-auto',
        thControlRight: 'pointer-events-auto ml-auto'
      };

    case 'center':
    default:
      return {
        thRoot: 'overflow-hidden relative',
        thControls: 'absolute flex items-center justify-between inset-0 pointer-events-none w-full z-1',
        thControl: 'mx-5',
        thControlDisabled: 'sr-only focus:not-sr-only',
        thControlLeft: 'pointer-events-auto mr-auto',
        thControlRight: 'pointer-events-auto ml-auto'
      };
  }
};

var themes = {
  "default": function _default(_ref) {
    var navPosition = _ref.navPosition;
    return _objectSpread(_objectSpread({}, getNavPositionClasses(navPosition)), {}, {
      thControlColor: colors["a" /* COLORS */].TRANSPARENT,
      thContolTheme: 'ghost',
      thControlSize: 23
    });
  },
  calendar: function calendar(_ref2) {
    var navPosition = _ref2.navPosition;
    return _objectSpread(_objectSpread({}, getNavPositionClasses(navPosition)), {}, {
      thInner: 'md:px-50',
      thControlColor: colors["a" /* COLORS */].WHITE,
      thControlSize: 46
    });
  },
  tabs: function tabs(_ref3) {
    var navPosition = _ref3.navPosition;
    return _objectSpread(_objectSpread({}, getNavPositionClasses(navPosition)), {}, {
      thControlColor: colors["a" /* COLORS */].LIGHT_SAND,
      thControlSize: 38
    });
  },
  nav: function nav() {
    return {
      thRoot: 'bg-white isolate overflow-hidden px-50 relative',
      thControls: 'absolute flex inset-0 items-center justify-between pointer-events-none w-full',
      thInner: 'border-lightGrey border-l-1 border-r-1',
      thControl: 'text-16',
      thControlLeft: 'mr-auto pointer-events-auto',
      thControlRight: 'ml-auto pointer-events-auto',
      thControlSize: 50,
      thControlColor: colors["a" /* COLORS */].TRANSPARENT,
      thContolTheme: 'ghost'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx










var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var WHEEL_DELTA_SCROLL_FACTOR = 50;
var CLICK_DELTA_SCROLL_FACTOR = 200;
var MOUSE_DELTA_SCROLL_FACTOR = 50;
var Scrollable_Scrollable = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Scrollable, _Component);

  var _super = _createSuper(Scrollable);

  function Scrollable(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Scrollable);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "scrollAreaNode", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "scrolling", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMouseWheel", function (e) {
      if (!_this.scrollAreaNode) {
        return;
      } // $FlowFixMe


      var wheelDelta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)); // $FlowFixMe

      _this.scrollAreaNode.scrollLeft -= wheelDelta * _this.props.deltaScrollFactorWheel; // Prevent page to scroll down

      if (_this.state.hasScrollLeft || _this.state.hasScrollRight) {
        e.preventDefault();
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onScroll", function () {
      var state = _this.processScroll();

      _this.setState(state);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMouseDown", function (direction) {
      return function () {
        if (!_this.scrollAreaNode) {
          return;
        }

        _this.scrolling = setInterval(function () {
          if (!_this.scrollAreaNode) {
            return;
          }

          _this.scrollAreaNode.scrollLeft += (_this.props.deltaScrollFactorMouse || MOUSE_DELTA_SCROLL_FACTOR) * direction;

          _this.onScroll();

          if (direction === -1 && !_this.state.hasScrollLeft || direction === 1 && !_this.state.hasScrollRight) {
            clearInterval(_this.scrolling);
          }
        }, 100);
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onMouseUp", function () {
      clearInterval(_this.scrolling);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClick", function (direction) {
      return function () {
        if (!_this.scrollAreaNode) {
          return;
        }

        _this.scrollAreaNode.scrollLeft += (_this.props.deltaScrollFactorClick || CLICK_DELTA_SCROLL_FACTOR) * direction;

        _this.onScroll();
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setScrollAreaRef", function (ref) {
      _this.scrollAreaNode = ref;
    });

    _this.state = {
      hasScrollLeft: false,
      hasScrollRight: false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(Scrollable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.scrollAreaNode) {
        return;
      }

      if (this.props.hasNoMouseWheelScroll) {
        this.onScroll();
        return;
      }

      if (true) {
        // $FlowFixMe
        this.scrollAreaNode.addEventListener('scroll', this.onScroll, false); // $FlowFixMe

        this.scrollAreaNode.addEventListener('mousewheel', this.onMouseWheel, false); // $FlowFixMe

        this.scrollAreaNode.addEventListener('DOMMouseScroll', this.onMouseWheel, false); // Firefox

        this.onScroll();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.initialPosition !== this.props.initialPosition) {
        this.initScrollPosition();
      }

      var _this$processScroll = this.processScroll(),
          hasScrollLeft = _this$processScroll.hasScrollLeft,
          hasScrollRight = _this$processScroll.hasScrollRight;

      if (prevState.hasScrollRight !== hasScrollRight || prevState.hasScrollLeft !== hasScrollLeft) {
        this.setState({
          hasScrollLeft: hasScrollLeft,
          hasScrollRight: hasScrollRight
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.scrollAreaNode || this.props.hasNoMouseWheelScroll) {
        return;
      }

      if (true) {
        // $FlowFixMe
        this.scrollAreaNode.removeEventListener('scroll', this.onScroll, false); // $FlowFixMe

        this.scrollAreaNode.removeEventListener('mousewheel', this.onMouseWheel, false); // $FlowFixMe

        this.scrollAreaNode.removeEventListener('DOMMouseScroll', this.onMouseWheel, false);
      }
    }
  }, {
    key: "initScrollPosition",
    value: function initScrollPosition() {
      if (!this.scrollAreaNode) {
        return;
      }

      if (this.props.elementWidth && this.props.initialPosition) {
        var normalizedPosition = this.context.isRTL ? // $FlowFixMe
        -1 * this.props.initialPosition : this.props.initialPosition; // $FlowFixMe

        this.scrollAreaNode.scrollLeft = this.props.elementWidth * normalizedPosition;
      }
    }
  }, {
    key: "processScroll",
    value: function processScroll() {
      if (!this.scrollAreaNode) {
        return {
          hasScrollLeft: false,
          hasScrollRight: false
        };
      }

      var _this$scrollAreaNode = this.scrollAreaNode,
          scrollLeft = _this$scrollAreaNode.scrollLeft,
          clientWidth = _this$scrollAreaNode.clientWidth,
          scrollWidth = _this$scrollAreaNode.scrollWidth; // $FlowFixMe

      var isRTL = document.documentElement.dir === 'rtl';
      var hasScrollRight = isRTL ? scrollLeft < 0 : scrollLeft + clientWidth < scrollWidth; // the minus 1 is here to handle scroll correctly, I don't know where it came this pixel

      var hasScrollLeft = isRTL ? scrollLeft > -(scrollWidth - clientWidth - 1) : scrollLeft > 0;
      return {
        hasScrollLeft: hasScrollLeft,
        hasScrollRight: hasScrollRight
      };
    }
  }, {
    key: "shouldDisplayControls",
    value: function shouldDisplayControls() {
      var _this$state = this.state,
          hasScrollLeft = _this$state.hasScrollLeft,
          hasScrollRight = _this$state.hasScrollRight;
      var hasControlsOnTouch = this.props.hasControlsOnTouch;
      return (hasControlsOnTouch || !Object(feature_testing["a" /* hasTouch */])()) && (hasScrollLeft || hasScrollRight);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backwardLabel = _this$props.backwardLabel,
          children = _this$props.children,
          childrenWrapperClassNames = _this$props.childrenWrapperClassNames,
          className = _this$props.className,
          controlsClassName = _this$props.controlsClassName,
          forceDisplayControls = _this$props.forceDisplayControls,
          forwardLabel = _this$props.forwardLabel,
          header = _this$props.header,
          innerClassName = _this$props.innerClassName,
          navPosition = _this$props.navPosition,
          theme = _this$props.theme;

      if (!react["Children"].count(children)) {
        return null;
      }

      var _this$state2 = this.state,
          hasScrollLeft = _this$state2.hasScrollLeft,
          hasScrollRight = _this$state2.hasScrollRight;
      var isRTL = this.context.isRTL;

      var _themes$theme = themes[theme]({
        navPosition: navPosition
      }),
          thControl = _themes$theme.thControl,
          thControlColor = _themes$theme.thControlColor,
          thControlDisabled = _themes$theme.thControlDisabled,
          thControlLeft = _themes$theme.thControlLeft,
          thControlRight = _themes$theme.thControlRight,
          thControlSize = _themes$theme.thControlSize,
          thContolTheme = _themes$theme.thContolTheme,
          thControls = _themes$theme.thControls,
          thControlsWrapper = _themes$theme.thControlsWrapper,
          thInner = _themes$theme.thInner,
          thRoot = _themes$theme.thRoot;

      var hasControls = this.shouldDisplayControls() || forceDisplayControls;

      var rightScrollBtn = __jsx(ArrowButton["a" /* ArrowButton */], {
        className: classnames_default()(thControl, thControlRight, Object(defineProperty["a" /* default */])({}, thControlDisabled, !hasScrollRight)),
        color: thControlColor,
        hasNoRtl: true,
        isDisabled: !hasScrollRight,
        key: "right",
        label: forwardLabel,
        onClick: this.onClick(1),
        onMouseDown: this.onMouseDown(1),
        onMouseUp: this.onMouseUp,
        rotation: 180,
        size: thControlSize,
        theme: thContolTheme
      });

      var leftScrollBtn = __jsx(ArrowButton["a" /* ArrowButton */], {
        className: classnames_default()(thControl, thControlLeft, Object(defineProperty["a" /* default */])({}, thControlDisabled, !hasScrollLeft)),
        color: thControlColor,
        hasNoRtl: true,
        isDisabled: !hasScrollLeft,
        key: "left",
        label: backwardLabel,
        onClick: this.onClick(-1),
        onMouseDown: this.onMouseDown(-1),
        onMouseUp: this.onMouseUp,
        size: thControlSize,
        theme: thContolTheme
      });

      var scrollButtons = isRTL ? [rightScrollBtn, leftScrollBtn] : [leftScrollBtn, rightScrollBtn];
      return __jsx("div", {
        className: classnames_default()(thRoot, className),
        "data-testid": "scrollable"
      }, __jsx("div", {
        className: classnames_default()('overflow-hidden relative', innerClassName, thInner)
      }, __jsx("div", {
        className: classnames_default()(childrenWrapperClassNames, 'scrollbar-hidden scroll-smooth scroll-x tap-highlight-color-transparent'),
        ref: this.setScrollAreaRef
      }, children)), (hasControls || !!header) && __jsx("div", {
        className: thControlsWrapper
      }, header, hasControls && __jsx("div", {
        className: classnames_default()(controlsClassName, thControls),
        "data-testid": "Scrollable-controls"
      }, scrollButtons)));
    }
  }]);

  return Scrollable;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Scrollable_Scrollable, "contextType", ResponsiveContext["a" /* ResponsiveContext */]);

Object(defineProperty["a" /* default */])(Scrollable_Scrollable, "defaultProps", {
  children: null,
  deltaScrollFactorClick: CLICK_DELTA_SCROLL_FACTOR,
  deltaScrollFactorMouse: MOUSE_DELTA_SCROLL_FACTOR,
  deltaScrollFactorWheel: WHEEL_DELTA_SCROLL_FACTOR,
  elementWidth: 82,
  forceDisplayControls: false,
  hasControlsOnTouch: false,
  hasNoMouseWheelScroll: false,
  initialPosition: null,
  navPosition: 'center',
  theme: 'default'
});

/***/ }),

/***/ "cjjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMAIL_PATTERN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GM_NUMBER_PATTERN; });
/* unused harmony export email */
/* unused harmony export firstName */
/* unused harmony export lastName */
/* unused harmony export unicodeFirstName */
/* unused harmony export unicodeLastName */
/* unused harmony export notContainsUnicode */
/* unused harmony export strictName */
/* unused harmony export ASCII */
/* unused harmony export minLength */
/* unused harmony export haveLength */
/* unused harmony export maxLength */
/* unused harmony export regexp */
/* unused harmony export enum */
/* unused harmony export phoneNumber */
/* unused harmony export mandatory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return date; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return minAge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return maxAge; });
/* unused harmony export gmNumber */
/* unused harmony export inRange */
/* unused harmony export legalAgreement */
/* unused harmony export optionalBirthdate */
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("yXV3");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("mGvo");
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9BC+");




var EMAIL_PATTERN = /^(?!.*@.*\.{2})[^\s@]+@[^\s@]+\.[^\s@.]+$/;
var GM_NUMBER_PATTERN = /^[0-9]{0,9}$/;
var UNICODE_CHAR_REGEXP = /[^\u0000-\u00ff]/;

function _regexp(reg) {
  return function (value) {
    return reg.test(value);
  };
}

function _minLength(length) {
  return function (value) {
    return value.length >= length;
  };
}

function _maxLength(length) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return value.length <= length;
  };
}

function _haveLength(length) {
  return function (value) {
    return value.length === length;
  };
}

function _enum(values) {
  return function (value) {
    return values.indexOf(value) !== -1;
  };
}

function _mandatory() {
  return function (value) {
    return !!value;
  };
}

function _checkDate(format) {
  return function (dateToCheck) {
    return !!(dateToCheck && format && moment__WEBPACK_IMPORTED_MODULE_2___default()(dateToCheck, format, true).isValid());
  };
}

function _getAge(birthday, birthdayFormat, onDate, onDateFormat) {
  var fromDate = onDate && onDateFormat ? moment__WEBPACK_IMPORTED_MODULE_2___default()(onDate, onDateFormat) : moment__WEBPACK_IMPORTED_MODULE_2___default()();
  return fromDate.diff(moment__WEBPACK_IMPORTED_MODULE_2___default()(birthday, birthdayFormat), 'years', true);
}

function _notContainsUnicode(str) {
  return !UNICODE_CHAR_REGEXP.test(str);
}

function _inRange(min, max) {
  return function (value) {
    return value >= min && value <= max;
  };
}
/* Validators */


var email = {
  name: 'email',
  isValid: _regexp(EMAIL_PATTERN)
};
var firstName = {
  name: 'firstName',
  isValid: function isValid(value) {
    return _maxLength(20)(value) && _notContainsUnicode(value);
  }
};
var lastName = {
  name: 'lastName',
  isValid: function isValid(value) {
    return _maxLength(30)(value) && _notContainsUnicode(value);
  }
};
var notContainsUnicode = {
  name: 'notContainsUnicode',
  isValid: function isValid(value) {
    return _notContainsUnicode(value);
  }
};
var unicodeFirstName = {
  name: 'unicodeFirstName',
  isValid: _maxLength(100)
};
var unicodeLastName = {
  name: 'unicodeLastName',
  isValid: _maxLength(100)
};
var strictName = {
  name: 'strictName',
  isValid: function isValid(value) {
    return _mandatory()(value) && _regexp(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/)(value);
  }
};
var ASCII = {
  name: 'ASCII',
  isValid: _regexp(/^[\x20-\xFF]+$/)
};

function minLength(length) {
  return {
    name: 'minLength',
    isValid: _minLength(length)
  };
}

function haveLength(length) {
  return {
    name: 'haveLength',
    isValid: _haveLength(length)
  };
}

function maxLength(length) {
  return {
    name: 'maxLength',
    isValid: _maxLength(length)
  };
}

function regexp(exp) {
  return {
    name: 'regexp',
    isValid: _regexp(exp)
  };
}

function enum1() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return {
    name: 'enum',
    isValid: _enum(values)
  };
}

function phoneNumber(locale) {
  var phoneRegexp = Object(_utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__[/* getPhoneRegex */ "b"])(locale);
  return {
    name: 'phoneNumber',
    isValid: _regexp(phoneRegexp)
  };
}

function mandatory() {
  return {
    name: 'mandatory',
    isValid: _mandatory()
  };
}

function date(format) {
  return {
    name: 'date',
    isValid: _checkDate(format)
  };
}

var optionalBirthdate = function optionalBirthdate(_ref) {
  var ageRequired = _ref.ageRequired,
      birthdayFormat = _ref.birthdayFormat,
      onDate = _ref.onDate,
      onDateFormat = _ref.onDateFormat;
  return {
    name: 'optionalBirthdate',
    isValid: function isValid(birthdate) {
      return !birthdate || birthdayFormat && moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate, birthdayFormat, true).isValid() && lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default()(ageRequired) && _checkDate(birthdayFormat)(birthdate) && _getAge(birthdate, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
};

function minAge(_ref2) {
  var ageRequired = _ref2.ageRequired,
      birthdayFormat = _ref2.birthdayFormat,
      onDate = _ref2.onDate,
      onDateFormat = _ref2.onDateFormat;
  return {
    name: 'minAge',
    isValid: function isValid(birthday) {
      return lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default()(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
}

function maxAge() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      ageRequired = _ref3.ageRequired,
      birthdayFormat = _ref3.birthdayFormat,
      onDate = _ref3.onDate,
      onDateFormat = _ref3.onDateFormat;

  return {
    name: 'maxAge',
    isValid: function isValid(birthday) {
      return lodash_isNumber__WEBPACK_IMPORTED_MODULE_1___default()(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) < ageRequired;
    }
  };
}

function inRange(min, max) {
  return {
    name: 'inRange',
    isValid: _inRange(min, max)
  };
}

var gmNumber = {
  name: 'gmNumber',
  isValid: function isValid(value) {
    return _regexp(GM_NUMBER_PATTERN)(value);
  }
};

function legalAgreement(required) {
  return {
    name: 'legalAgreement',
    // if legalAgreement is not required, return true to bypass validation
    isValid: function isValid(value) {
      return required ? value === true : true;
    }
  };
}



/***/ }),

/***/ "cvSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SYNC_WITH_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SEARCH_SET_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TRIP_INFORMATION_SET_DEPARTURE_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TRIP_INFORMATION_SET_DEPARTURE_DATE; });
/* unused harmony export FETCH_USER_PAST_TRIPS */
/* unused harmony export FETCH_USER_PAST_TRIPS_RESOLVED */
/* unused harmony export RESET_USER_PAST_TRIPS */
/* unused harmony export FETCH_USER_FUTURE_TRIPS */
/* unused harmony export FETCH_USER_FUTURE_TRIPS_FETCHED */
/* unused harmony export FETCH_USER_FUTURE_TRIPS_RESOLVED */
/* unused harmony export RESET_USER_FUTURE_TRIPS */
/* unused harmony export FETCH_USER_SEARCHES */
/* unused harmony export FETCH_USER_SEARCHES_RESOLVED */
/* unused harmony export SET_PARTICIPANTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CALENDAR_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_CALENDAR_TRIP_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_CALENDAR_TRIP_PRICE_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_BOOKABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_BOOKABLE_DATES_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_CHANGE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALENDAR_SET_INITIAL_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION; });
/* unused harmony export QUOTATION_FORM_UPDATE */
/* unused harmony export QUOTATION_FORM_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_TRIP_DATE_CRITERIA; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var SYNC_WITH_LOCATION = 'SYNC_WITH_LOCATION';
var SEARCH_SET_KEYWORDS = 'SEARCH_SET_KEYWORDS';
var TRIP_INFORMATION_SET_DEPARTURE_CITY = 'TRIP_INFORMATION_SET_DEPARTURE_CITY';
var TRIP_INFORMATION_SET_DEPARTURE_DATE = 'TRIP_INFORMATION_SET_DEPARTURE_DATE';
var FETCH_USER_PAST_TRIPS = 'FETCH_USER_PAST_TRIPS';
var FETCH_USER_PAST_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_PAST_TRIPS);
var RESET_USER_PAST_TRIPS = 'RESET_USER_PAST_TRIPS';
var FETCH_USER_FUTURE_TRIPS = 'FETCH_USER_FUTURE_TRIPS';
var FETCH_USER_FUTURE_TRIPS_FETCHED = 'FETCH_USER_FUTURE_TRIPS_FETCHED';
var FETCH_USER_FUTURE_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_FUTURE_TRIPS);
var RESET_USER_FUTURE_TRIPS = 'RESET_USER_FUTURE_TRIPS';
var FETCH_USER_SEARCHES = 'FETCH_USER_SEARCHES';
var FETCH_USER_SEARCHES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_SEARCHES);
var SET_PARTICIPANTS = 'SET_PARTICIPANTS';
var FETCH_CALENDAR = 'FETCH_CALENDAR';
var FETCH_CALENDAR_ABORT = 'FETCH_CALENDAR_ABORT';
var FETCH_CALENDAR_TRIP_PRICE = 'FETCH_CALENDAR_TRIP_PRICE';
var FETCH_CALENDAR_TRIP_PRICE_ABORT = 'FETCH_CALENDAR_TRIP_PRICE_ABORT';
var FETCH_BOOKABLE_DATES = 'FETCH_BOOKABLE_DATES';
var FETCH_BOOKABLE_DATES_ABORT = 'FETCH_BOOKABLE_DATES_ABORT';
var CALENDAR_CHANGE_MONTH = 'CALENDAR_CHANGE_MONTH';
var CLEAR_CALENDAR = 'CLEAR_CALENDAR';
var CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE = 'CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE';
var CALENDAR_SET_INITIAL_DURATION = 'CALENDAR_SET_INITIAL_DURATION';
var CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION = 'CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION';
var QUOTATION_FORM_UPDATE = 'QUOTATION_FORM_UPDATE';
var QUOTATION_FORM_REQUEST = 'QUOTATION_FORM_REQUEST';
var UPDATE_TRIP_DATE_CRITERIA = 'UPDATE_TRIP_DATE_CRITERIA';

/***/ }),

/***/ "dFUt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function() {
  this._size = 0
  this._values = {}
}
Cache.prototype.get = function(key) {
  return this._values[key]
}
Cache.prototype.set = function(key, value) {
  this._size >= this._maxSize && this.clear()
  if (!this._values.hasOwnProperty(key)) {
    this._size++
  }
  return this._values[key] = value
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var contentSecurityPolicy = false,
  pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

try {
  new Function('')
} catch (error) {
  contentSecurityPolicy = true
}

module.exports = {
  Cache: Cache,

  expr: expr,

  split: split,

  normalizePath: normalizePath,

  setter: contentSecurityPolicy
    ? function(path) {
      var parts = normalizePath(path)
      return function(data, value) {
        return setterFallback(parts, data, value)
      }
    }
    : function(path) {
      return setCache.get(path) || setCache.set(
        path,
        new Function(
          'data, value',
          expr(path, 'data') + ' = value'
        )
      )
    },

  getter: contentSecurityPolicy
    ? function(path, safe) {
      var parts = normalizePath(path)
      return function(data) {
        return getterFallback(parts, safe, data)
      }
    }
    : function(path, safe) {
      var key = path + '_' + safe
      return getCache.get(key) || getCache.set(
        key,
        new Function('data', 'return ' + expr(path, safe, 'data'))
      )
    },

  join: function(segments) {
    return segments.reduce(function(path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function(path, cb, thisArg) {
    forEach(split(path), cb, thisArg)
  }
}

function setterFallback(parts, data, value) {
  var index = 0,
    len = parts.length
  while (index < len - 1) {
    data = data[parts[index++]]
  }
  data[parts[index]] = value
}

function getterFallback(parts, safe, data) {
  var index = 0,
    len = parts.length
  while (index < len) {
    if (data != null || !safe) {
      data = data[parts[index++]]
    } else {
      return
    }
  }
  return data
}

function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(
    path,
    split(path).map(function(part) {
      return part.replace(CLEAN_QUOTES_REGEX, '$2')
    })
  )
}

function split(path) {
  return path.match(SPLIT_REGEX)
}

function expr(expression, safe, param) {
  expression = expression || ''

  if (typeof safe === 'string') {
    param = safe
    safe = false
  }

  param = param || 'data'

  if (expression && expression.charAt(0) !== '[') expression = '.' + expression

  return safe ? makeSafe(expression, param) : param + expression
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function makeSafe(path, param) {
  var result = param,
    parts = split(path),
    isLast

  forEach(parts, function(part, isBracket, isArray, idx, parts) {
    isLast = idx === parts.length - 1

    part = isBracket || isArray ? '[' + part + ']' : '.' + part

    result += part + (!isLast ? ' || {})' : ')')
  })

  return new Array(parts.length + 1).join('(') + result
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),

/***/ "eZ08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export selectAttendeesByHouseholds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatHouseholds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectAttendeesWithInfosByHouseholds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addInfosToProposalAttendees; });
/* unused harmony export selectNumberOfHouseholds */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("T63A");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("fGyu");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_mergeWith__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("PuIx");
/* harmony import */ var lodash_mergeWith__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_mergeWith__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _logger_logger__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zytj");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("Jsmy");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("WeO/");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("apzf");



















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var selectAttendeesByHouseholds = function selectAttendeesByHouseholds(state) {
  return state.booking.attendees.attendeesByHouseHolds;
};
var formatHouseholds = function formatHouseholds(proposal, attendeesAfterPut) {
  var _proposal$households;

  return (proposal === null || proposal === void 0 ? void 0 : (_proposal$households = proposal.households) === null || _proposal$households === void 0 ? void 0 : _proposal$households.length) ? // $FlowFixMe
  proposal.households.map(function (household, index) {
    var _ref;

    var householdAttendees = (_ref = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])((household === null || household === void 0 ? void 0 : household.attendees) || [])) === null || _ref === void 0 ? void 0 : _ref.map(function (attendee) {
      var _proposal$attendees, _proposal$attendees$l;

      var attendeeWithInfos = proposal === null || proposal === void 0 ? void 0 : (_proposal$attendees = proposal.attendees) === null || _proposal$attendees === void 0 ? void 0 : (_proposal$attendees$l = _proposal$attendees.list) === null || _proposal$attendees$l === void 0 ? void 0 : _proposal$attendees$l.find(function (att) {
        return attendee.customerId ? att.customerId === attendee.customerId : attendee.id === att.id;
      });
      var attendeeWithGmNumber = (attendeesAfterPut === null || attendeesAfterPut === void 0 ? void 0 : attendeesAfterPut.find(function (att) {
        return attendee.customerId ? att.customerId === attendee.customerId : attendee.id === att.id;
      })) || {};
      return lodash_mergeWith__WEBPACK_IMPORTED_MODULE_17___default()(_objectSpread(_objectSpread({}, attendee), attendeeWithGmNumber), attendeeWithInfos || {}, function (a, b) {
        return a || b;
      });
    });
    return {
      all: householdAttendees,
      adults: householdAttendees === null || householdAttendees === void 0 ? void 0 : householdAttendees.filter(function (attendee) {
        return attendee.isAdult;
      }),
      children: (householdAttendees === null || householdAttendees === void 0 ? void 0 : householdAttendees.filter(function (attendee) {
        return !attendee.isAdult;
      })) || [],
      key: index
    };
  }) : [{
    all: [],
    adults: [],
    children: [],
    key: 0
  }];
};

var attendeeLabel = function attendeeLabel(proposalAttendee) {
  return Object(_utils_participants_participants_utils__WEBPACK_IMPORTED_MODULE_21__[/* getAttendeeNamePlaceholder */ "a"])(proposalAttendee, !proposalAttendee.isAdult, proposalAttendee.id === 'A');
};

var getAttendees = function getAttendees(_ref2) {
  var householdAttendees = _ref2.householdAttendees,
      householdId = _ref2.householdId,
      identifiedAttendees = _ref2.identifiedAttendees,
      connectedUserInfo = _ref2.connectedUserInfo;
  return householdAttendees.map(function (_ref3, attendeeIndex) {
    var _connectedUserInfo$tr;

    var id = _ref3.id,
        customerId = _ref3.customerId,
        birthdate = _ref3.birthdate,
        neolid = _ref3.neolid,
        householdAttendee = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(_ref3, ["id", "customerId", "birthdate", "neolid"]);

    var tripInformationAttendee = identifiedAttendees === null || identifiedAttendees === void 0 ? void 0 : identifiedAttendees.find(function (att) {
      return customerId ? att.customerId === customerId || att.neolid === customerId : att.id === id;
    });
    var connectedUserInfos = householdAttendee.isAdult && householdId === 0 && attendeeIndex === 0 && !!(connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.neolaneId) ? _objectSpread(_objectSpread({}, connectedUserInfo), {}, {
      neolid: connectedUserInfo.neolid || connectedUserInfo.customerId || connectedUserInfo.neolaneId,
      birthdate: connectedUserInfo.birthdate || connectedUserInfo.dateOfBirth,
      mobile: connectedUserInfo.mobilePhoneNumber
    }) : {};
    var child = (connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : (_connectedUserInfo$tr = connectedUserInfo.travelCompanions) === null || _connectedUserInfo$tr === void 0 ? void 0 : _connectedUserInfo$tr.find(function (_ref4) {
      var companionBirthdate = _ref4.birthdate;
      return moment__WEBPACK_IMPORTED_MODULE_20___default()(companionBirthdate).isSame(birthdate);
    })) || {};

    var attendeeWithInfos = lodash_mergeWith__WEBPACK_IMPORTED_MODULE_17___default()(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      birthdate: birthdate,
      customerId: customerId,
      neolid: customerId
    }, householdAttendee), connectedUserInfos), !householdAttendee.isAdult ? lodash_omit__WEBPACK_IMPORTED_MODULE_16___default()(child, 'id') : {}), {}, {
      householdId: householdId,
      isChild: !householdAttendee.isAdult,
      // should be kept here to change all attendees last name in case of travel companions
      lastName: householdAttendee.lastName || (tripInformationAttendee === null || tripInformationAttendee === void 0 ? void 0 : tripInformationAttendee.lastName) || (!householdAttendee.isAdult ? child === null || child === void 0 ? void 0 : child.lastName : '') || (connectedUserInfo === null || connectedUserInfo === void 0 ? void 0 : connectedUserInfo.lastName),
      id: id,
      attendeeIndex: attendeeIndex
    }), tripInformationAttendee || {}, function (objValue, srcValue) {
      return objValue || srcValue;
    });

    var lastValue = {};

    for (var _i = 0, _Object$entries = Object.entries(attendeeWithInfos); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      lastValue[key] = value === null ? undefined : value;
    }

    return _objectSpread(_objectSpread({}, lastValue), {}, {
      name: attendeeLabel(lastValue)
    });
  });
};

var getFormattedHouseholds = function getFormattedHouseholds(_ref5) {
  var households = _ref5.households,
      tripInformationAttendees = _ref5.tripInformationAttendees,
      connectedUserInfo = _ref5.connectedUserInfo;
  return households === null || households === void 0 ? void 0 : households.map(function (_ref6, householdId) {
    var adults = _ref6.adults,
        children = _ref6.children;
    var newAdultsList = getAttendees({
      householdAttendees: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(adults),
      householdId: householdId,
      identifiedAttendees: tripInformationAttendees ? Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(tripInformationAttendees.adults) : [],
      connectedUserInfo: connectedUserInfo
    });
    var newChildrenList = children.length ? getAttendees({
      householdAttendees: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(children),
      householdId: householdId,
      identifiedAttendees: tripInformationAttendees ? Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(tripInformationAttendees.kids) : [],
      connectedUserInfo: connectedUserInfo
    }) : [];
    return {
      key: householdId,
      adults: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(newAdultsList),
      children: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(newChildrenList),
      all: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(newAdultsList), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(newChildrenList))
    };
  });
};

var selectAttendeesWithInfosByHouseholds = function selectAttendeesWithInfosByHouseholds(state) {
  var formattedHouseholds = selectAttendeesByHouseholds(state);
  var tripInformationAttendees = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_19__[/* tripInformationSelector */ "d"])(state);
  var connectedUserInfo = Object(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_22__[/* userInfoSelector */ "a"])(state) || {};

  try {
    var households = getFormattedHouseholds({
      households: formattedHouseholds,
      tripInformationAttendees: tripInformationAttendees,
      connectedUserInfo: connectedUserInfo
    });
    return {
      households: households,
      attendees: households.reduce(function (attendees, value) {
        return {
          adults: attendees.adults.concat(value.adults),
          children: attendees.children.concat(value.children),
          list: attendees.list.concat(value.all)
        };
      }, {
        list: [],
        adults: [],
        children: []
      })
    };
  } catch (error) {
    _logger_logger__WEBPACK_IMPORTED_MODULE_18__["default"].error(error);
    return {
      households: [],
      attendees: {
        list: [],
        adults: [],
        children: []
      }
    };
  }
};
var addInfosToProposalAttendees = function addInfosToProposalAttendees(_ref7) {
  var proposal = _ref7.proposal,
      tripInformationAttendees = _ref7.tripInformationAttendees,
      connectedUserInfo = _ref7.connectedUserInfo;

  try {
    var formattedHouseholds = getFormattedHouseholds({
      households: formatHouseholds(proposal),
      tripInformationAttendees: tripInformationAttendees,
      connectedUserInfo: connectedUserInfo
    });
    var formattedAttendees = {
      list: [],
      adults: [],
      children: []
    };
    formattedHouseholds.map(function (value) {
      formattedAttendees.adults = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(formattedAttendees.adults), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(value.adults));
      formattedAttendees.children = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(formattedAttendees.children), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(value.children));
      formattedAttendees.list = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(formattedAttendees.list), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(value.all));
    });
    return {
      households: formattedHouseholds,
      attendees: formattedAttendees
    };
  } catch (error) {
    _logger_logger__WEBPACK_IMPORTED_MODULE_18__["default"].error(error);
    return {
      households: [{
        all: [],
        adults: [],
        children: [],
        key: 0
      }],
      attendees: {
        list: [],
        adults: [],
        children: []
      }
    };
  }
};
var selectNumberOfHouseholds = function selectNumberOfHouseholds(state) {
  return state.booking.attendees.numberOfHouseHolds;
};

/***/ }),

/***/ "evRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLastVisitedProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLastVisitedProductIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackLastVisitedProducts; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ToJy");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("fGyu");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _local_storage_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("1RIK");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("829J");













var _b2cPagesService$PAGE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["b2cPagesService"].PAGE_TYPES,
    RESORT = _b2cPagesService$PAGE.RESORT,
    TOUR = _b2cPagesService$PAGE.TOUR,
    CRUISE = _b2cPagesService$PAGE.CRUISE,
    RESORT_MICE = _b2cPagesService$PAGE.RESORT_MICE;
function getLastVisitedProducts() {
  var trackingShopping = Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_11__[/* getFromLocalStorage */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_TRACKING */ "A"]);
  var lastVisitedProducts = (trackingShopping === null || trackingShopping === void 0 ? void 0 : trackingShopping[_constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "x"]]) || []; // it handles old data: string[]
  // to delete when it's safe

  return lastVisitedProducts.map(function (visitedProduct, index) {
    if (typeof visitedProduct === 'string') {
      return {
        id: visitedProduct,
        be: false,
        timestamp: Date.now() + index
      };
    }

    return visitedProduct;
  });
}
function getLastVisitedProductIds() {
  return getLastVisitedProducts().map(function (_ref) {
    var id = _ref.id;
    return id;
  });
}
function trackLastVisitedProducts(pageType, product) {
  if ([RESORT, TOUR, CRUISE, RESORT_MICE].includes(pageType) && (product === null || product === void 0 ? void 0 : product.id)) {
    var lastVisitedProducts = getLastVisitedProducts();
    var targetProduct = lastVisitedProducts.find(function (visitedProduct) {
      return visitedProduct.id === product.id;
    });

    if (targetProduct) {
      // once it's true (BE) it can't go back to false
      targetProduct.be = product.be || targetProduct.be;
    } else {
      lastVisitedProducts = [product].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(lastVisitedProducts));
    }

    lastVisitedProducts = lastVisitedProducts.sort(function (a, b) {
      return Number(b.be) - Number(a.be) || b.timestamp - a.timestamp;
    }).slice(0, _constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_LAST_VISITED_PRODUCTS_NUMBER */ "y"]);
    Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_11__[/* setInLocalStorage */ "c"])(_constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_TRACKING */ "A"], Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "x"], lastVisitedProducts));
  }
}

/***/ }),

/***/ "fflk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureDate; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function setDepartureDate(departureDate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_DATE */ "o"], {
    departureDate: departureDate
  });
}



/***/ }),

/***/ "fnDY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = ValidationError;

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var strReg = /\$\{\s*(\w+)\s*\}/g;

var replace = function replace(str) {
  return function (params) {
    return str.replace(strReg, function (_, key) {
      return (0, _printValue.default)(params[key]);
    });
  };
};

function ValidationError(errors, value, field, type) {
  var _this = this;

  this.name = 'ValidationError';
  this.value = value;
  this.path = field;
  this.type = type;
  this.errors = [];
  this.inner = [];
  if (errors) [].concat(errors).forEach(function (err) {
    _this.errors = _this.errors.concat(err.errors || err);
    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
  });
  this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0];
  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
}

ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;

ValidationError.isError = function (err) {
  return err && err.name === 'ValidationError';
};

ValidationError.formatError = function (message, params) {
  if (typeof message === 'string') message = replace(message);

  var fn = function fn(params) {
    params.path = params.label || params.path || 'this';
    return typeof message === 'function' ? message(params) : message;
  };

  return arguments.length === 1 ? fn : fn(params);
};

module.exports = exports["default"];

/***/ }),

/***/ "fuxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPriceOfStayArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPriceOfStay; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("L73y");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");










function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}









var getChildrenBirthdates = function getChildrenBirthdates(_ref) {
  var _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids;
  return (// $FlowFixMe flow could not predict value after a filter and a map
    kids.filter(function (_ref2) {
      var birthdate = _ref2.birthdate;
      return !!birthdate;
    }).map(function (kid) {
      return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "b"])(kid.birthdate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* API_DATE_FORMAT */ "a"]);
    })
  );
};

var getNumberAttendees = function getNumberAttendees(_ref3) {
  var _ref3$adults = _ref3.adults,
      adults = _ref3$adults === void 0 ? [] : _ref3$adults,
      _ref3$kids = _ref3.kids,
      kids = _ref3$kids === void 0 ? [] : _ref3$kids;
  var kidsWithBirthdates = kids.filter(function (_ref4) {
    var birthdate = _ref4.birthdate;
    return !!birthdate;
  });
  return adults.length + kidsWithBirthdates.length;
};

var getPriceOfStayArgs = function getPriceOfStayArgs(searchCriteria) {
  var productId = searchCriteria.productId,
      departureDate = searchCriteria.departureDate,
      duration = searchCriteria.duration,
      departureCity = searchCriteria.departureCity,
      offerName = searchCriteria.offerName;
  var numberAttendees = getNumberAttendees(searchCriteria);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    productId: productId,
    departureDate: Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_11__[/* formatTimestampDate */ "b"])(departureDate, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* API_DATE_FORMAT */ "a"]),
    duration: duration
  }, numberAttendees && {
    numberAttendees: numberAttendees
  }), numberAttendees && {
    childrenBirthdates: getChildrenBirthdates(searchCriteria)
  }), departureCity !== _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_12__[/* DEFAULT_DEPARTURE_CITY_VALUE */ "q"] && {
    departureCity: departureCity
  }), offerName && {
    offerName: _clubmed_utils__WEBPACK_IMPORTED_MODULE_9__["url"].decodePath(offerName)
  });
};
var fetchPriceOfStay = function fetchPriceOfStay(appContext, searchCriteria) {
  var args = getPriceOfStayArgs(searchCriteria);
  var argsString = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_13__[/* buildArgs */ "a"])(args);
  var query = "query {\n      priceOfStay(".concat(argsString, ") {\n        ... on ErrorsPriceOfStayType {\n          errors {\n            errorCode\n            errorDescription\n            errorValue\n          }\n        }\n        ... on PriceOfStayType {\n          accommodationId\n          accommodationLabel\n          bestPrice {\n            value\n            formattedValue\n          }\n          currency\n          gap\n          includesChildcare\n          includesTransportation\n          initialPrice {\n            value\n            formattedValue\n          }\n          rate\n          resource\n          unit {\n            id\n            label\n          }\n          offerColor\n          productId\n          yieldPricingVariation\n        }\n      }\n    }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* STATE_PRODUCT_PRICE_OF_STAY */ "ed"]
  });
};

/***/ }),

/***/ "gA51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CollapsePanel_CollapsePanel; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/toggler/Toggler.jsx
var Toggler = __webpack_require__("7CPK");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.themes.js

var themes = {
  "default": function _default() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'border-b-1 border-lightGrey flex isolate relative',
      thHeaderDecorator: 'absolute arrow-down arrow-large arrow-white arrow-bg arrow-bg-large arrow-bg-sienna border-b-2 border-sienna -mb-1 opacity-0 bottom-0 start-0 w-full sm:w-1/5 sm:ms-25 transition-opacity duration-250 ease-in z-1',
      thHeaderDecoratorActive: 'opacity-100',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden py-20 text-initial text-black hocus:text-black-active transition-color',
      thTitle: 'flex-1 flex gap-10 items-center font-bold font-sans leading-tight max-w-full text-current text-20',
      thTitleHasEllipsis: true,
      thTitleIconColor: colors["a" /* COLORS */].SIENNA,
      thLabels: 'shrink-0 font-bold flex items-center text-14 text-sienna uppercase whitespace-nowrap',
      thLabel: 'hidden sm:inline-block',
      thLabelIcon: 'text-black transition-transform duration-250 ease-in ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.8125rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden shadow-inner-bottom',
      thContentInner: 'py-40'
    };
  },
  limpidSmall: function limpidSmall() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'flex relative text-14',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden p-20 text-initial text-black',
      thTitle: 'flex flex-1 gap-5 items-center font-bold max-w-full',
      thTitleHasEllipsis: false,
      thLabels: 'shrink-0 font-bold flex items-center ms-auto text-sienna uppercase whitespace-nowrap',
      thLabel: 'underline',
      thLabelIcon: 'text-black ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  homeDetails: function homeDetails() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500',
      thHeader: 'flex relative',
      thButton: 'flex items-center flex-1 max-w-full overflow-hidden text-initial text-black',
      thTitle: 'flex flex-1 gap-5 items-center max-w-full text-14 font-bold',
      thTitleHasEllipsis: false,
      thTitleIconColor: colors["a" /* COLORS */].SIENNA,
      thLabels: 'shrink-0 font-bold flex items-center ms-auto text-14 text-sienna uppercase whitespace-nowrap',
      thLabel: 'underline',
      thLabelIcon: 'text-black ms-10',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.75rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  remote: function remote() {
    return {
      thRoot: 'animate-fadeIn animation-duration-500 bg-white border-1 border-lightGrey rounded-12 shadow-diffuse',
      thHeader: 'flex isolate relative',
      thButton: 'flex flex-1 items-center max-w-full overflow-hidden p-15 text-initial text-black',
      thTitle: 'flex flex-1 font-semibold gap-10 items-center max-w-full',
      thTitleIconColor: colors["a" /* COLORS */].SIENNA,
      thTitleIconSize: 'calc(30rem / 16)',
      thLabels: 'flex items-center ms-auto shrink-0 text-14 text-black whitespace-nowrap',
      thLabelIcon: 'ms-10 text-black',
      thLabelIconActive: 'transform rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden',
      thInner: 'w-full'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var POSITIONS = {
  BOTTOM: 'bottom',
  TOP: 'top'
};

var hasLabels = function hasLabels(_ref, isActive) {
  var collapseIconName = _ref.collapseIconName,
      collapseLabel = _ref.collapseLabel,
      expandIconName = _ref.expandIconName,
      expandLabel = _ref.expandLabel;
  return isActive ? collapseIconName || collapseLabel : expandIconName || expandLabel;
};

var CollapsePanel_LoadMoreButton = function LoadMoreButton(_ref2) {
  var ariaId = _ref2.ariaId,
      isActive = _ref2.isActive,
      isDesktop = _ref2.isDesktop,
      toggle = _ref2.toggle,
      collapsePanelProps = Object(objectWithoutProperties["a" /* default */])(_ref2, ["ariaId", "isActive", "isDesktop", "toggle"]);

  var _collapsePanelProps$a = collapsePanelProps.as,
      HeaderTag = _collapsePanelProps$a === void 0 ? 'div' : _collapsePanelProps$a,
      collapseLabel = collapsePanelProps.collapseLabel,
      _collapsePanelProps$c = collapsePanelProps.collapseIconName,
      collapseIconName = _collapsePanelProps$c === void 0 ? icons["a" /* ICONS */].CROSS : _collapsePanelProps$c,
      expandLabel = collapsePanelProps.expandLabel,
      _collapsePanelProps$e = collapsePanelProps.expandIconName,
      expandIconName = _collapsePanelProps$e === void 0 ? icons["a" /* ICONS */].ARROW_DOWN : _collapsePanelProps$e,
      _collapsePanelProps$h = collapsePanelProps.headerClassName,
      headerClassName = _collapsePanelProps$h === void 0 ? '' : _collapsePanelProps$h,
      iconName = collapsePanelProps.iconName,
      iconSize = collapsePanelProps.iconSize,
      noIcons = collapsePanelProps.noIcons,
      _collapsePanelProps$t = collapsePanelProps.theme,
      theme = _collapsePanelProps$t === void 0 ? 'default' : _collapsePanelProps$t,
      title = collapsePanelProps.title;

  var _themes$theme = themes[theme]({
    isDesktop: isDesktop
  }),
      thButton = _themes$theme.thButton,
      thHeader = _themes$theme.thHeader,
      thHeaderDecorator = _themes$theme.thHeaderDecorator,
      thHeaderDecoratorActive = _themes$theme.thHeaderDecoratorActive,
      thLabels = _themes$theme.thLabels,
      thLabel = _themes$theme.thLabel,
      thLabelIcon = _themes$theme.thLabelIcon,
      thLabelIconActive = _themes$theme.thLabelIconActive,
      thLabelIconWidth = _themes$theme.thLabelIconWidth,
      thTitle = _themes$theme.thTitle,
      thTitleHasEllipsis = _themes$theme.thTitleHasEllipsis,
      thTitleIconColor = _themes$theme.thTitleIconColor,
      thTitleIconSize = _themes$theme.thTitleIconSize;

  return __jsx(HeaderTag, {
    className: classnames_default()(headerClassName, thHeader)
  }, __jsx("button", {
    "aria-controls": ariaId,
    "aria-expanded": isActive,
    className: thButton,
    onClick: toggle,
    type: "button"
  }, !!title && __jsx("span", {
    className: thTitle
  }, __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: thTitleIconColor,
    name: iconName,
    width: iconSize || thTitleIconSize || '1em'
  }), thTitleHasEllipsis ? __jsx("span", {
    className: "truncate w-full"
  }, title) : title), hasLabels(collapsePanelProps, isActive) && __jsx("span", {
    className: thLabels
  }, __jsx("span", {
    className: thLabel,
    "data-testid": "CollapsePanel-label"
  }, isActive ? collapseLabel : expandLabel), !noIcons && __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(thLabelIcon, Object(defineProperty["a" /* default */])({}, thLabelIconActive, isActive)),
    name: isActive ? collapseIconName : expandIconName,
    width: thLabelIconWidth
  }))), (thHeaderDecorator || thHeaderDecoratorActive) && __jsx("div", {
    className: classnames_default()(thHeaderDecorator, Object(defineProperty["a" /* default */])({}, thHeaderDecoratorActive, isActive))
  }));
};

var CollapsePanel_CollapsePanel = function CollapsePanel(props) {
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(props.isExpanded),
      isVisible = _useState[0],
      setVisible = _useState[1];

  if (!react["Children"].count(props.children)) {
    return null;
  }

  var children = props.children,
      className = props.className,
      _props$hasKeepCollaps = props.hasKeepCollapsedContent,
      hasKeepCollapsedContent = _props$hasKeepCollaps === void 0 ? true : _props$hasKeepCollaps,
      id = props.id,
      isExpanded = props.isExpanded,
      isSemiTransparent = props.isSemiTransparent,
      _props$loadMoreButton = props.loadMoreButtonPosition,
      loadMoreButtonPosition = _props$loadMoreButton === void 0 ? POSITIONS.TOP : _props$loadMoreButton,
      onClick = props.onClick,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title;

  var _themes$theme2 = themes[theme]({
    isDesktop: isDesktop
  }),
      thBody = _themes$theme2.thBody,
      thCollapsedTagInitialStyle = _themes$theme2.thCollapsedTagInitialStyle,
      thContent = _themes$theme2.thContent,
      thContentInner = _themes$theme2.thContentInner,
      thRoot = _themes$theme2.thRoot,
      thSemiTransparentDivStyle = _themes$theme2.thSemiTransparentDivStyle;

  var ariaId = Object(uniqueId["b" /* generateUniqueId */])([id || title || ''], 'CollapsePanel_');
  var CollapsedTag = hasKeepCollapsedContent ? lib["Collapse"] : lib["UnmountClosed"];
  return __jsx(Toggler["a" /* Toggler */], {
    isActive: isExpanded,
    onToggle: onClick
  }, function (toggle, isActive) {
    return __jsx("section", {
      className: classnames_default()(thRoot, className),
      id: id
    }, loadMoreButtonPosition === POSITIONS.TOP && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })), __jsx("div", {
      "aria-hidden": !isActive,
      className: classnames_default()(thBody, {
        invisible: !isVisible
      }),
      id: ariaId
    }, __jsx(CollapsedTag, {
      initialStyle: isSemiTransparent ? _objectSpread({
        height: 'auto',
        overflow: 'initial'
      }, thCollapsedTagInitialStyle) : thCollapsedTagInitialStyle,
      isOpened: isActive,
      onWork: function onWork() {
        setVisible(true);
      },
      onRest: function onRest(_ref3) {
        var isFullyClosed = _ref3.isFullyClosed;
        setVisible(!isFullyClosed);
      }
    }, __jsx("div", {
      className: thContent
    }, __jsx("div", {
      className: thContentInner
    }, children), isSemiTransparent && !isActive && __jsx("div", {
      style: thSemiTransparentDivStyle
    })))), loadMoreButtonPosition === POSITIONS.BOTTOM && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })));
  });
};

/***/ }),

/***/ "gqH2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var Lazy =
/*#__PURE__*/
function () {
  function Lazy(mapFn) {
    this._resolve = function (value, options) {
      var schema = mapFn(value, options);
      if (!(0, _isSchema.default)(schema)) throw new TypeError('lazy() functions must return a valid schema');
      return schema.resolve(options);
    };
  }

  var _proto = Lazy.prototype;

  _proto.resolve = function resolve(options) {
    return this._resolve(options.value, options);
  };

  _proto.cast = function cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  };

  _proto.validate = function validate(value, options) {
    return this._resolve(value, options).validate(value, options);
  };

  _proto.validateSync = function validateSync(value, options) {
    return this._resolve(value, options).validateSync(value, options);
  };

  _proto.validateAt = function validateAt(path, value, options) {
    return this._resolve(value, options).validateAt(path, value, options);
  };

  _proto.validateSyncAt = function validateSyncAt(path, value, options) {
    return this._resolve(value, options).validateSyncAt(path, value, options);
  };

  return Lazy;
}();

Lazy.prototype.__isYupSchema__ = true;
var _default = Lazy;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "gz38":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Collapse = /*#__PURE__*/function (_React$Component) {
  _inherits(Collapse, _React$Component);

  var _super = _createSuper(Collapse);

  function Collapse(props) {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "timeout", undefined);

    _defineProperty(_assertThisInitialized(_this), "container", undefined);

    _defineProperty(_assertThisInitialized(_this), "content", undefined);

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      clearTimeout(_this.timeout);

      if (!_this.container || !_this.content) {
        return;
      }

      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          checkTimeout = _this$props.checkTimeout;
      var containerHeight = Math.floor(_this.container.clientHeight);
      var contentHeight = Math.floor(_this.content.clientHeight);
      var isFullyOpened = isOpened && Math.abs(contentHeight - containerHeight) <= 1;
      var isFullyClosed = !isOpened && Math.abs(containerHeight) <= 1;

      if (isFullyOpened || isFullyClosed) {
        _this.onRest({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      } else {
        _this.onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });

        _this.timeout = setTimeout(function () {
          return _this.onResize();
        }, checkTimeout);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRest", function (_ref) {
      var isFullyOpened = _ref.isFullyOpened,
          isFullyClosed = _ref.isFullyClosed,
          isOpened = _ref.isOpened,
          containerHeight = _ref.containerHeight,
          contentHeight = _ref.contentHeight;

      if (!_this.container || !_this.content) {
        return;
      }

      var hasOpened = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var hasClosed = !isOpened && _this.container.style.height === '0px';

      if (hasOpened || hasClosed) {
        _this.container.style.overflow = isOpened ? 'initial' : 'hidden';
        _this.container.style.height = isOpened ? 'auto' : '0px';
        var onRest = _this.props.onRest;

        if (onRest) {
          onRest({
            isFullyOpened: isFullyOpened,
            isFullyClosed: isFullyClosed,
            isOpened: isOpened,
            containerHeight: containerHeight,
            contentHeight: contentHeight
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onWork", function (_ref2) {
      var isFullyOpened = _ref2.isFullyOpened,
          isFullyClosed = _ref2.isFullyClosed,
          isOpened = _ref2.isOpened,
          containerHeight = _ref2.containerHeight,
          contentHeight = _ref2.contentHeight;

      if (!_this.container || !_this.content) {
        return;
      }

      var isOpenining = isOpened && _this.container.style.height === "".concat(contentHeight, "px");
      var isClosing = !isOpened && _this.container.style.height === '0px';

      if (isOpenining || isClosing) {
        // No need to do any work
        return;
      }

      _this.container.style.overflow = 'hidden';
      _this.container.style.height = isOpened ? "".concat(contentHeight, "px") : '0px';
      var onWork = _this.props.onWork;

      if (onWork) {
        onWork({
          isFullyOpened: isFullyOpened,
          isFullyClosed: isFullyClosed,
          isOpened: isOpened,
          containerHeight: containerHeight,
          contentHeight: contentHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRefContainer", function (container) {
      _this.container = container;
    });

    _defineProperty(_assertThisInitialized(_this), "onRefContent", function (content) {
      _this.content = content;
    });

    if (props.initialStyle) {
      _this.initialStyle = props.initialStyle;
    } else {
      _this.initialStyle = props.isOpened ? {
        height: 'auto',
        overflow: 'initial'
      } : {
        height: '0px',
        overflow: 'hidden'
      };
    }

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onResize();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
          theme = _this$props2.theme,
          isOpened = _this$props2.isOpened,
          children = _this$props2.children;
      return children !== nextProps.children || isOpened !== nextProps.isOpened || Object.keys(theme).some(function (c) {
        return theme[c] !== nextProps.theme[c];
      });
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      if (!this.container || !this.content) {
        return null;
      }

      if (this.container.style.height === 'auto') {
        var contentHeight = this.content.clientHeight;
        this.container.style.height = "".concat(contentHeight, "px");
      }

      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          theme = _this$props3.theme,
          children = _this$props3.children,
          isOpened = _this$props3.isOpened;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.onRefContainer,
        className: theme.collapse,
        style: this.initialStyle,
        "aria-hidden": !isOpened
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.onRefContent,
        className: theme.content
      }, children));
    }
  }]);

  return Collapse;
}(_react["default"].Component);

exports.Collapse = Collapse;

_defineProperty(Collapse, "defaultProps", {
  theme: {
    collapse: 'ReactCollapse--collapse',
    content: 'ReactCollapse--content'
  },
  initialStyle: undefined,
  onRest: undefined,
  onWork: undefined,
  checkTimeout: 50
});

/***/ }),

/***/ "hA0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductLogo_ProductLogo; });

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.theme.js

var themes = {
  "default": function _default(_ref) {
    var isExclusiveCollection = _ref.isExclusiveCollection;
    return {
      thRoot: 'text-center',
      thIcon: classnames_default()('mb-15', {
        'bg-lightSand rounded-full text-black p-15': !isExclusiveCollection
      }, {
        'border-5 border-ultramarine rounded-12 text-ultramarine p-10': isExclusiveCollection
      }),
      thIconWidth: 'calc(100rem / 16)',
      thIsNotSquare: false,
      thProductInfo: 'flex flex-col-reverse text-initial',
      thProductCountry: 'font-bold text-14 text-sienna truncate w-full',
      thProductName: 'font-bold leading-tight text-18'
    };
  },
  calendar: function calendar() {
    return {
      thRoot: 'font-brand leading-tight text-black text-center text-16',
      thIconWidth: '5rem',
      thIsNotSquare: true
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx
var __jsx = react_default.a.createElement;




var ProductLogo_ProductLogo = function ProductLogo(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      iconName = _ref.iconName,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _themes$theme = themes[theme]({
    isExclusiveCollection: isExclusiveCollection
  }),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thIsNotSquare = _themes$theme.thIsNotSquare,
      thProductInfo = _themes$theme.thProductInfo,
      thProductName = _themes$theme.thProductName,
      thProductCountry = _themes$theme.thProductCountry;

  return __jsx("div", {
    className: classnames_default()(thRoot, className)
  }, __jsx(Icon["a" /* Icon */], {
    alt: productName,
    className: thIcon,
    isNotSquare: thIsNotSquare,
    name: iconName,
    width: thIconWidth
  }), __jsx("div", {
    className: thProductInfo
  }, productName && __jsx("p", {
    className: thProductName,
    "data-testid": "product-logo-name"
  }, productName), productCountry && __jsx("p", {
    className: thProductCountry,
    "data-testid": "product-logo-country"
  }, productCountry)));
};

/***/ }),

/***/ "hCAA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var Condition =
/*#__PURE__*/
function () {
  function Condition(refs, options) {
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!(0, _has.default)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    var is = options.is,
        then = options.then,
        otherwise = options.otherwise;
    var check = typeof is === 'function' ? is : function () {
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }

      return values.every(function (value) {
        return value === is;
      });
    };

    this.fn = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var options = args.pop();
      var schema = args.pop();
      var branch = check.apply(void 0, args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  var _proto = Condition.prototype;

  _proto.resolve = function resolve(base, options) {
    var values = this.refs.map(function (ref) {
      return ref.getValue(options);
    });
    var schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!(0, _isSchema.default)(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  };

  return Condition;
}();

var _default = Condition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "hLcx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _propertyExpr = __webpack_require__("dFUt");

var prefixes = {
  context: '$',
  value: '.'
};

var Reference =
/*#__PURE__*/
function () {
  function Reference(key, options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0, _propertyExpr.getter)(this.path, true);
    this.map = options.map;
  }

  var _proto = Reference.prototype;

  _proto.getValue = function getValue(options) {
    var result = this.isContext ? options.context : this.isValue ? options.value : options.parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  };

  _proto.cast = function cast(value, options) {
    return this.getValue((0, _extends2.default)({}, options, {
      value: value
    }));
  };

  _proto.resolve = function resolve() {
    return this;
  };

  _proto.describe = function describe() {
    return {
      type: 'ref',
      key: this.key
    };
  };

  _proto.toString = function toString() {
    return "Ref(" + this.key + ")";
  };

  Reference.isRef = function isRef(value) {
    return value && value.__isYupRef;
  };

  return Reference;
}();

exports.default = Reference;
Reference.prototype.__isYupRef = true;
module.exports = exports["default"];

/***/ }),

/***/ "hgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductHeader; });
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mRH6");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var ProductHeader = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_2__["memo"])(function ProductHeader(_ref) {
  var className = _ref.className,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? {} : _ref$heading,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {
    url: ''
  } : _ref$link,
      onClick = _ref.onClick;
  var _heading$title = heading.title,
      title = _heading$title === void 0 ? '' : _heading$title,
      _heading$subtitle = heading.subtitle,
      subtitle = _heading$subtitle === void 0 ? '' : _heading$subtitle;
  return __jsx("header", {
    className: className,
    "data-testid": "Product-Header"
  }, __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
    className: "flex flex-col-reverse min-w-0",
    "data-testid": "ProductHeader-link",
    onClick: onClick,
    tagname: "div",
    url: isLinkDisabled ? '' : link.url
  }, isLinkDisabled ? null : link), !isLinkDisabled && __jsx("div", {
    className: "absolute inset-0",
    "data-testid": "ProductHeader-link-overlay"
  }), __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_5__[/* Title */ "a"], {
    className: "flex font-sans font-semibold text-18",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLACK,
    hasEllipsis: true,
    hLevel: 2,
    theme: "none"
  }, title), __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_5__[/* Title */ "a"], {
    className: "flex font-sans font-semibold text-14",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].SIENNA,
    hasEllipsis: true,
    hLevel: 3,
    theme: "none"
  }, subtitle)));
});

/***/ }),

/***/ "hqKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "i0Sy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = printValue;
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings) {
  if (quoteStrings === void 0) {
    quoteStrings = false;
  }

  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

module.exports = exports["default"];

/***/ }),

/***/ "i6QF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var isIntegralNumber = __webpack_require__("6sUC");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});


/***/ }),

/***/ "jLVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAvailableDurations; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("uDfI");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ub5k");
/* harmony import */ var _store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("rueY");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("RBO1");
/* harmony import */ var _store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("05PS");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ldK3");











var SUMMER = 'SUMMER';
var WINTER = 'WINTER';
var useAvailableDurations = function useAvailableDurations(_ref) {
  var _prices$apiDate;

  var initialTransport = _ref.initialTransport,
      productId = _ref.productId;
  var availableDurations = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_9__[/* getAvailableDurations */ "a"]);
  var prices = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_9__[/* getPricesByDays */ "m"]);
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__[/* getDepartureDate */ "b"]);
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useSelector */ "e"])(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_8__[/* getDepartureCity */ "a"]);
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_5__[/* useDispatch */ "d"])();
  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__[/* useAppContext */ "c"])();
  var apiDate = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_10__[/* timestampToApiDate */ "n"])(departureDate);
  var isSiblingOpen = !!(prices === null || prices === void 0 ? void 0 : (_prices$apiDate = prices[apiDate]) === null || _prices$apiDate === void 0 ? void 0 : _prices$apiDate.siblingOpen);
  var seasonProductId = isSiblingOpen ? productId.includes(SUMMER) && productId.replace(SUMMER, WINTER) || productId.replace(WINTER, SUMMER) : productId;
  var transport = departureCity || initialTransport;
  Object(react__WEBPACK_IMPORTED_MODULE_4__["useEffect"])(function () {
    if (!availableDurations && transport) {
      dispatch(Object(_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_7__[/* fetchBookableDates */ "b"])({
        departureCity: departureCity || initialTransport,
        productId: seasonProductId
      }, appContext));
    }
  }, [seasonProductId, transport]);
  return availableDurations;
};

/***/ }),

/***/ "jLkM":
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__("s+R0");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ "jldR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Capsule_Capsule; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/capsule/Capsule.styles.js









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var style = {
  capsule: {
    width: '100%',
    isolation: 'isolate',
    position: 'relative'
  },
  upsideCapsule: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  header: {
    borderRadius: '12px 12px 0 0',
    backgroundColor: '#924833',
    height: '4px',
    position: 'static',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1
  },
  upsideHeader: {
    borderRadius: '0 0 12px 12px'
  },
  headerLarge: {
    backgroundColor: '#1E2643',
    height: '48px',
    position: 'relative'
  },
  headerAuto: {
    backgroundColor: '#1E2643',
    position: 'relative',
    padding: '10px',
    height: 'auto'
  },
  content: {
    position: 'relative',
    borderRadius: '0 0 12px 12px',
    backgroundColor: '#fff',
    overflow: 'hidden',
    border: 'solid 1px #d1d1d1'
  },
  upsideContent: {
    marginTop: '-1px',
    borderRadius: '12px 12px 0 0'
  },
  contentNoHeader: {
    marginTop: '-1px',
    borderRadius: '12px'
  },
  contentLargeHeader: {
    paddingTop: '34px',
    marginTop: '-35px'
  },
  upsideContentLargeHeader: {
    paddingTop: '0',
    marginTop: '0',
    paddingBottom: '34px',
    marginBottom: '-35px'
  },
  label: {
    fontFamily: 'Trident, Newsreader, Times New Roman, Times, serif',
    verticalAlign: '-3px'
  },
  checkIcon: {
    position: 'absolute',
    display: 'flex',
    top: '-12px',
    right: '-9px',
    left: '-9px',
    justifyContent: 'flex-end'
  }
};
var styles = function styles(_ref) {
  var _ref$additionalStyle = _ref.additionalStyle,
      additionalStyle = _ref$additionalStyle === void 0 ? {
    header: {},
    content: {},
    icon: {},
    label: {}
  } : _ref$additionalStyle,
      color = _ref.color,
      isHeaderNone = _ref.isHeaderNone,
      isLargeHeader = _ref.isLargeHeader,
      isHeaderAuto = _ref.isHeaderAuto,
      upside = _ref.upside;
  return {
    computedCapsuleStyle: _objectSpread(_objectSpread(_objectSpread({}, style.capsule), upside ? style.upsideCapsule : null), additionalStyle.root),
    computedHeaderStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header),
    computedHeaderFullStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), {}, {
      justifyContent: 'space-between',
      paddingLeft: '20px',
      paddingRight: '20px',
      cursor: 'pointer'
    }, isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header),
    computedHeaderFullStyleCollapsed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), {}, {
      justifyContent: 'space-between',
      paddingLeft: '20px',
      paddingRight: '20px',
      cursor: 'pointer'
    }, isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header), {}, {
      borderRadius: '5px'
    }),
    computedContentStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.content), upside ? style.upsideContent : null), isLargeHeader ? style.contentLargeHeader : null), isLargeHeader && upside ? style.upsideContentLargeHeader : null), isHeaderNone ? style.contentNoHeader : null), additionalStyle.content),
    computedIconWrapperStyle: _objectSpread({}, additionalStyle.icon),
    computedLabelStyle: _objectSpread(_objectSpread(_objectSpread({}, style.label), additionalStyle.label), {}, {
      marginLeft: '10px'
    }),
    computedCheckIconStyle: _objectSpread({}, style.checkIcon),
    computedChevronIconlStyle: {
      display: 'flex',
      width: '9px',
      height: '9px',
      stroke: 'white',
      strokeWidth: '2px',
      alignItems: 'center',
      marginTop: '-3px'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx
var __jsx = react_default.a.createElement;







var SMALL = 'small';
var LARGE = 'large';
var AUTO = 'auto';
var NONE = 'none';
var Capsule_Capsule = function Capsule(_ref) {
  var additionalStyle = _ref.additionalStyle,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      contentClassName = _ref.contentClassName,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? SMALL : _ref$header,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].ALL_INCLUSIVE : _ref$icon,
      label = _ref.label,
      upside = _ref.upside,
      validated = _ref.validated,
      _ref$isAccordion = _ref.isAccordion,
      isAccordion = _ref$isAccordion === void 0 ? false : _ref$isAccordion,
      dataTestId = _ref.dataTestId;
  var isLargeHeader = header === LARGE;
  var isHeaderNone = header === NONE;
  var isHeaderAuto = header === AUTO;

  var _styles = styles({
    additionalStyle: additionalStyle,
    color: color,
    isHeaderNone: isHeaderNone,
    isLargeHeader: isLargeHeader,
    isHeaderAuto: isHeaderAuto,
    upside: upside
  }),
      computedCapsuleStyle = _styles.computedCapsuleStyle,
      computedCheckIconStyle = _styles.computedCheckIconStyle,
      computedContentStyle = _styles.computedContentStyle,
      computedHeaderStyle = _styles.computedHeaderStyle,
      computedHeaderFullStyle = _styles.computedHeaderFullStyle,
      computedHeaderFullStyleCollapsed = _styles.computedHeaderFullStyleCollapsed,
      computedIconWrapperStyle = _styles.computedIconWrapperStyle,
      computedLabelStyle = _styles.computedLabelStyle,
      computedChevronIconlStyle = _styles.computedChevronIconlStyle;

  var _useState = Object(react["useState"])(!isAccordion ? true : false),
      displayed = _useState[0],
      setDisplayed = _useState[1];

  if (!react["Children"].count(children)) {
    return null;
  }

  var toggleDisplay = function toggleDisplay() {
    setDisplayed(function (display) {
      return !display;
    });
  };

  var custsomAccordionStyle = function custsomAccordionStyle() {
    if (isAccordion) {
      if (displayed) {
        return computedHeaderFullStyle;
      }

      return computedHeaderFullStyleCollapsed;
    }

    return computedHeaderStyle;
  };

  return __jsx("section", {
    className: classnames_default()('Capsule', className),
    style: computedCapsuleStyle,
    "data-testid": dataTestId
  }, header !== 'none' && __jsx("div", {
    onClick: isAccordion ? toggleDisplay : function () {},
    style: custsomAccordionStyle()
  }, (isLargeHeader || isHeaderAuto) && __jsx(react["Fragment"], null, __jsx("div", {
    className: "flex items-center"
  }, __jsx("div", {
    style: computedIconWrapperStyle
  }, __jsx(Icon["a" /* Icon */], {
    name: icon,
    width: computedIconWrapperStyle.width || '1.25rem'
  })), __jsx("span", {
    style: computedLabelStyle
  }, label)), isAccordion && __jsx("span", {
    style: computedChevronIconlStyle
  }, __jsx(Icon["a" /* Icon */], {
    name: "select",
    width: "1em",
    className: classnames_default()('flex', {
      'transform rotate-180': displayed
    })
  })))), __jsx("div", {
    className: contentClassName,
    style: computedContentStyle
  }, validated && __jsx("div", {
    style: {
      position: 'relative'
    }
  }, __jsx("div", {
    style: computedCheckIconStyle
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].SUCCESS,
    name: icons["a" /* ICONS */].CHECK_OUTLINE,
    width: "3rem"
  }))), isAccordion ? __jsx(lib["UnmountClosed"], {
    isOpened: displayed
  }, children) : children));
};

/***/ }),

/***/ "k9PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export redirectToOidc */
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hByQ");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Mkub");
/* harmony import */ var _graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ESA2");
/* harmony import */ var _ple_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("6jSF");










function redirectToUri(router) {
  return function (uri) {
    return function () {
      var redirectUri = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"](_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocation(), uri).toString();
      router.push(redirectUri);
    };
  };
}

function redirectToOidc(appContext) {
  var locale = appContext.locale,
      isSeller = appContext.isSeller,
      isCmta = appContext.isCmta;

  if (true) {
    var currentLocation = new urijs__WEBPACK_IMPORTED_MODULE_4___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocation()).removeSearch('forceAuth');
    var redirectPath = currentLocation.pathname();
    var redirectUri = new urijs__WEBPACK_IMPORTED_MODULE_4___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getOrigin()).path(redirectPath).query(currentLocation.search()).hash(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].getLocationPart('hash')).toString();
    Object(_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_7__[/* clearAllCacheFront */ "a"])();
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["windowWrapper"].setLocation(isSeller ? Object(_ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* buildSellerSigninUrl */ "e"])({
      locale: locale,
      redirectUri: redirectUri,
      isCmta: isCmta
    }) : Object(_ple_utils__WEBPACK_IMPORTED_MODULE_8__[/* buildSigninUrl */ "f"])({
      locale: locale,
      redirectUri: redirectUri
    }));
  }
}
/* harmony default export */ __webpack_exports__["a"] = ({
  redirectToOidc: redirectToOidc,
  redirectToUri: redirectToUri
});

/***/ }),

/***/ "kH/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addressFragment; });
var addressFragment = "\nfragment Address on Address {\n    additionalInformation1\n    additionalInformation2\n    addOn\n    city\n    country\n    countryCode\n    stateOrDistrict\n    streetName\n    streetNumber\n    town\n    zipCode\n  }\n";

/***/ }),

/***/ "kMkq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value == null;
};

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return synchronizeChildcareQPWithKidsQP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customFacetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return facetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getActiveFacetsFromQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateActiveFacetsQueries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasDepartureCityAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterFacetsToHide; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDepartureCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDepartureDateDisplayValue; });
/* unused harmony export getFormattedDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getInactiveFacetValues; });
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("yyme");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("4mDm");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Rfxz");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("i6QF");
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("YGK4");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("PKPk");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("3bBZ");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("zygG");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("15pl");
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("sW3P");
































var _facetsQueryParamMapp;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_CRITERIA_FACET_ID */ "d"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_CITY_FACET_ID */ "r"]);
}

function getInactiveFacetValues(facets, activeFacets, facetId) {
  var _matchingFacet$list$m, _matchingFacet$list, _activeFacets$facetId;

  var _facets$filter = facets.filter(function (_ref) {
    var id = _ref.id;
    return id === facetId;
  }),
      _facets$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_facets$filter, 1),
      matchingFacet = _facets$filter2[0];

  var matchingFacetValues = (_matchingFacet$list$m = matchingFacet === null || matchingFacet === void 0 ? void 0 : (_matchingFacet$list = matchingFacet.list) === null || _matchingFacet$list === void 0 ? void 0 : _matchingFacet$list.map(function (_ref2) {
    var value = _ref2.value;
    return value;
  })) !== null && _matchingFacet$list$m !== void 0 ? _matchingFacet$list$m : [];
  var matchingActiveFacetValues = Object.keys((_activeFacets$facetId = activeFacets[facetId]) !== null && _activeFacets$facetId !== void 0 ? _activeFacets$facetId : {});
  return matchingFacetValues.filter(function (option) {
    return !matchingActiveFacetValues.includes(option);
  });
}

function filterFacetsToHide(facets, facetsToHide) {
  var facetIdsWithOptionsToHide = Object.keys(facetsToHide !== null && facetsToHide !== void 0 ? facetsToHide : {});
  return facets.map(function (facet) {
    if (facetIdsWithOptionsToHide.includes(facet.id)) {
      return _objectSpread(_objectSpread({}, facet), {}, {
        list: facet.list.filter(function (_ref3) {
          var value = _ref3.value;
          return !facetsToHide[facet.id].includes(value);
        })
      });
    }

    return facet;
  });
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(facet, 'selected');
  });
  return selectedCity ? lodash_get__WEBPACK_IMPORTED_MODULE_29___default()(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_31___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(timestampDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_31___default()(), 'day') : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_31___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_31___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"]) {
    return lodash_times__WEBPACK_IMPORTED_MODULE_30___default()(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_31___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function convertQueryParamToKids(value) {
  if (!value) {
    return [];
  }

  return value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
}

function convertKidsToChildcareQueryParam(_ref4) {
  var departureDate = _ref4.departureDate,
      kids = _ref4.kids;

  if (!departureDate) {
    return [];
  }

  return kids.reduce(function (acc, _ref5) {
    var birthdate = _ref5.birthdate;
    return birthdate ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(acc), [moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate).diff(moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate), 'months')]) : acc;
  }, []).map(function (diffInMonths) {
    if (diffInMonths >= 4 && diffInMonths < 24) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_0_TO_2 */ "i"];
    }

    if (diffInMonths >= 24 && diffInMonths < 48) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_2_TO_3 */ "k"];
    }

    if (diffInMonths >= 48 && diffInMonths < 132) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_4_TO_10 */ "l"];
    }

    if (diffInMonths >= 132 && diffInMonths < 216) {
      return _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_OPTION_11_TO_17 */ "j"];
    }

    return '';
  }).filter(Boolean);
}

function unserializeKidsFromQueryParam(value, isSeller) {
  var maxKidsNumber = isSeller ? _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX_SELLER */ "H"] : _constants__WEBPACK_IMPORTED_MODULE_34__[/* KIDS_NUMBER_MAX */ "G"];

  if (!value) {
    return [];
  }

  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > maxKidsNumber) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) {
    return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* DEFAULT_KID_VALUE */ "a"]));
  }

  var kids = convertQueryParamToKids(value);
  return kids.length > maxKidsNumber ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref6, index) {
    var birthdate = _ref6.birthdate,
        childcareIncluded = _ref6.childcareIncluded;

    if (!birthdate || !kidsValidationState || (kidsValidationState === null || kidsValidationState === void 0 ? void 0 : kidsValidationState.length) > 0 && kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_32__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"]);
    return childcareIncluded ? "".concat(formattedBirthdate).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });
    return childcareIncluded ? "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_CHILDCARE_FLAG */ "c"]) : serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS_DELIMITER */ "k"]);
};
var synchronizeChildcareQPWithKidsQP = function synchronizeChildcareQPWithKidsQP(_ref7) {
  var childcareFacetQueryParam = _ref7.childcareFacetQueryParam,
      departureDate = _ref7.departureDate,
      departureDateQueryParam = _ref7.departureDateQueryParam,
      kids = _ref7.kids,
      _ref7$kidsQueryParam = _ref7.kidsQueryParam,
      kidsQueryParam = _ref7$kidsQueryParam === void 0 ? '' : _ref7$kidsQueryParam;
  var previousDepartureDate = formatDepartureDateForStore(departureDateQueryParam, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DATE_FORMAT */ "o"]);
  var previousKids = convertQueryParamToKids(kidsQueryParam);
  var previousChildcareIncluded = previousKids.some(function (kid) {
    return kid.childcareIncluded;
  });
  var childcareIncluded = kids.some(function (kid) {
    return kid.childcareIncluded;
  });

  if (!childcareIncluded && !previousChildcareIncluded) {
    // childcareIncluded checkbox unchecked and unchanged => no override
    return undefined;
  }

  var childcareRemoved = previousChildcareIncluded && !childcareIncluded;
  var kidsRemoved = previousKids.length > 0 && kids.length === 0;

  if (childcareRemoved || kidsRemoved) {
    // childcareIncluded checkbox unchecked or kids removed from FilterWho => reset childcare filter
    return '';
  } // childcareIncluded checkbox checked => override childcare filter with matching kids age range and existing childcare options


  var childcareFilterOptionsFromPreviousKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: previousDepartureDate,
    kids: previousKids
  })));

  var childcareFilterOptionsFromKids = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set(convertKidsToChildcareQueryParam({
    departureDate: departureDate,
    kids: kids
  })));

  var childcareFilterOptionsToRemove = childcareFilterOptionsFromPreviousKids.filter(function (option) {
    return !childcareFilterOptionsFromKids.includes(option);
  });
  var chilcareFilterOptions = childcareFacetQueryParam.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
  return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(new Set([].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(childcareFilterOptionsFromKids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(chilcareFilterOptions.filter(function (option) {
    return !childcareFilterOptionsToRemove.includes(option);
  }))))).filter(Boolean).join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref8) {
  var birthdate = _ref8.birthdate,
      departureDate = _ref8.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_31___default()().add(_constants__WEBPACK_IMPORTED_MODULE_34__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "s"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_31___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_31___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_31___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};
var customFacetsQueryParamMapping = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_34__[/* FLIGHT_DURATION_FACET_ID */ "C"], 'f');
var facetsQueryParamMapping = (_facetsQueryParamMapp = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* ACTIVITIES_FACET_ID */ "a"], 'a'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* CHILDCARE_FILTER_FACET_ID */ "f"], 'ch'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* COUNTRIES_FACET_ID */ "m"], 'c'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* DESTINATIONS_FACET_ID */ "w"], 'd'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "S"], 's'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_34__[/* TYPES_OF_STAY_FACET_ID */ "ab"], 't'), _facetsQueryParamMapp);
var getActiveFacetsFromQueryParams = function getActiveFacetsFromQueryParams(queryParams, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var _queryParams$queryPar;

    var activeFacets = ((_queryParams$queryPar = queryParams[queryParamMapping[facetId]]) === null || _queryParams$queryPar === void 0 ? void 0 : _queryParams$queryPar.split(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"])) || [];
    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, facetId, activeFacets.reduce(function (acc, activeFacet) {
      var facet = decodeURI(activeFacet);

      if (facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "S"]) {
        var _SEASON_FACET_QUERY_P;

        facet = (_SEASON_FACET_QUERY_P = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_EN_TO_FR */ "V"][facet]) !== null && _SEASON_FACET_QUERY_P !== void 0 ? _SEASON_FACET_QUERY_P : facet;
      }

      acc[facet] = true;
      return acc;
    }, {})));
    return facets;
  }, {});
};
var generateActiveFacetsQueries = function generateActiveFacetsQueries(activeFacets, queryParamMapping) {
  return Object.keys(queryParamMapping).reduce(function (facets, facetId) {
    var facet = Object.keys(activeFacets[facetId] || {});

    if (facet.length && facetId === _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_ID */ "S"]) {
      facet = facet.map(function (label) {
        var _SEASON_FACET_QUERY_P2;

        return (_SEASON_FACET_QUERY_P2 = _constants__WEBPACK_IMPORTED_MODULE_34__[/* SEASON_FACET_QUERY_PARAM_FR_TO_EN */ "W"][label]) !== null && _SEASON_FACET_QUERY_P2 !== void 0 ? _SEASON_FACET_QUERY_P2 : label;
      });
    }

    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])({}, queryParamMapping[facetId], facet.length ? facet.join(_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_FACET_OPTIONS_DELIMITER */ "i"]) : undefined));
    return facets;
  }, {});
};
var hasDepartureCityAvailable = function hasDepartureCityAvailable(departureCities, departureCity) {
  return departureCities === null || departureCities === void 0 ? void 0 : departureCities.some(function (_ref9) {
    var value = _ref9.value;
    return value === departureCity;
  });
};


/***/ }),

/***/ "kZEO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = function _default(obj) {
  return obj && obj.__isYupSchema__;
};

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "l/UU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_OPTION_VALIDITY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ALREADY_EXISTS; });
var SET_OPTION_VALIDITY = 'SET_OPTION_VALIDITY';
var BOOKING_ALREADY_EXISTS = 'BOOKING_ALREADY_EXISTS';

/***/ }),

/***/ "l1aQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return priceRemoteSelector; });
var priceRemoteSelector = function priceRemoteSelector(_ref) {
  var priceRemote = _ref.priceRemote;
  return priceRemote || {};
};

/***/ }),

/***/ "lZ21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOMMODATION_COMFORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORRESPONDANCE_ROOM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ROOM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VILLETA_ROOM_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORRESPONDENCE_CABIN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CABIN_TYPE; });
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("TWNs");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);




/**
 * @see src/components/utils/icon/icons.js l40
 */
var ACCOMMODATION_COMFORT_ORDER = ['000017', // club
'000048', // club seaside view
'000022', // superior
'000061', // superior
'000018', // deluxe
'000039', // deluxe zen
'000047', // deluxe seaside view
'000056', // Deluxe Exclusive
'000019', // suite
'000020', // suite 5 tridents
'000024', // chalet
'000038' // villa
];
var SINGLE_ROOM = 'simpleRoom';
var SEPARATE_ROOMS = 'separatedRooms';
var CONNECTING_ROOMS = 'simpleRooms';
var SEPARATE_ROOMS_3 = 'separatedRooms3';
var CORRESPONDANCE_ROOM_TYPE = {
  SINGLE_ROOM: SINGLE_ROOM,
  SEPARATE_ROOMS: SEPARATE_ROOMS,
  CONNECTING_ROOMS: CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: SEPARATE_ROOMS
};
var CORRESPONDENCE_CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins'
};
var ROOM_TYPE = {
  SINGLE_ROOM: SINGLE_ROOM,
  SEPARATE_ROOMS: SEPARATE_ROOMS,
  CONNECTING_ROOMS: CONNECTING_ROOMS,
  SEPARATE_ROOMS_3: SEPARATE_ROOMS_3
};
var CABIN_TYPE = {
  SINGLE_ROOM: 'simpleCabin',
  SEPARATE_ROOMS: 'separatedCabins',
  CONNECTING_ROOMS: 'simpleCabins',
  SEPARATE_ROOMS_3: 'separatedCabins3'
};
var VILLETA_ROOM_REGEX = new RegExp(/^(B2|B2\+|B2T)+$/);


/***/ }),

/***/ "loSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return toggleFacet; });
/* unused harmony export changeKids */
/* unused harmony export changeKidsNumberWith */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeKidsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeDepartureCity; });
/* unused harmony export changeDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setInitialProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setKidsValidationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetRedirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setCustomFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updateCustomFilters; });
/* unused harmony export resetCustomFilters */
/* unused harmony export setFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setSearchFilterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return updateFilters; });
/* unused harmony export resetFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetCriteria; });
/* unused harmony export setIsDateRequired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setProductsFilteredWithActiveCustomFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setProductsBeforeActiveCustomFacetsFiltering; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setIsSearchEnabled; });
/* unused harmony export setOrderByPrice */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("15pl");
/* harmony import */ var lodash_times__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_times__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("rJ95");
/* harmony import */ var _search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("0ibg");
/* harmony import */ var _search_search_selector__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("B3yO");
/* harmony import */ var _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("wQ38");
/* harmony import */ var _trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("1bWg");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("fflk");
/* harmony import */ var _trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("+mhw");
/* harmony import */ var _trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("C5R2");
/* harmony import */ var _trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("RBvG");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("Jsmy");
/* harmony import */ var _faceting_selector__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("vIa8");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("9QcM");

















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}















function setActiveFacet(categoryId, value, isSelected) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_TOGGLE_FACET_SELECTED */ "x"], {
    categoryId: categoryId,
    value: value,
    isSelected: isSelected
  });
}

function toggleFacet(_ref) {
  var categoryId = _ref.categoryId,
      isSelected = _ref.isSelected,
      value = _ref.value;
  return setActiveFacet(categoryId, value, isSelected);
}
function changeKids(value) {
  return function (dispatch, getState) {
    var oldKids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_26__[/* getKids */ "c"])(getState());
    var newKids = value.map(function (kid, index) {
      return _objectSpread(_objectSpread({}, kid), {}, {
        neolid: lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(oldKids, "[".concat(index, "].neolid"))
      });
    });
    return dispatch(Object(_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_21__[/* setKids */ "b"])(newKids));
  };
}

function _changeKidsSize(kids, newSize) {
  var emptyKids = lodash_times__WEBPACK_IMPORTED_MODULE_14___default()(newSize - kids.length, function () {
    return _objectSpread({}, _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_20__[/* DEFAULT_KID_VALUE */ "a"]);
  });

  if (newSize < kids.length) {
    return kids.slice(0, newSize);
  }

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(kids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(emptyKids));
} // use this export when testing.


var changeKidsNumberWith = function changeKidsNumberWith(changeKidsFunc) {
  return function changeKidsNumber(value) {
    return function (dispatch, getState) {
      var kids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_26__[/* getKids */ "c"])(getState());

      var newKids = _changeKidsSize(kids, value);

      return dispatch(changeKidsFunc(newKids));
    };
  };
}; // use this export in app code.

var changeKidsNumber = changeKidsNumberWith(changeKids);
function changeDepartureCity(value) {
  return Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_23__[/* setDepartureCity */ "a"])({
    value: value
  });
}
function changeDepartureDate(_ref2) {
  var value = _ref2.value;
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(value);
}
var clearDepartureDate = function clearDepartureDate() {
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(null);
};
var setSearchQuery = function setSearchQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    label: ''
  };
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_SEARCH_QUERY */ "w"], {
    value: query
  });
};
function clearTripDuration() {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_25__[/* DEFAULT_NO_DURATION */ "a"]);
}
function changeSearchQuery(value) {
  return function (dispatch, getState) {
    var store = getState();
    var keywords = Object(_search_search_selector__WEBPACK_IMPORTED_MODULE_19__[/* keywordsSelector */ "a"])(store);
    var searchQuery = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_27__[/* searchQuerySelector */ "q"])(getState());
    Object(react_redux__WEBPACK_IMPORTED_MODULE_16__[/* batch */ "b"])(function () {
      if (keywords) {
        dispatch(Object(_search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_18__[/* setKeywords */ "a"])(''));
      }

      if (searchQuery.label !== value.label) {
        dispatch(setSearchQuery(value));
      }
    });
  };
}
function changeTripDuration(value) {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__[/* setDuration */ "a"])(value);
}
function setInitialProductPrices(initialProductPrices) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_INITIAL_PRICES */ "n"], {
    initialProductPrices: initialProductPrices
  });
}
function setKidsValidationState(kidsValidationState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "q"], {
    kidsValidationState: kidsValidationState
  });
}
function clearFacets(categoryId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_CLEAR_FACETS */ "c"], {
    categoryId: categoryId
  });
}
function clearAll() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_CLEAR_ALL */ "b"]);
}
function resetRedirection() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_REDIRECTION */ "i"]);
}
function resetSearch() {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_SEARCH */ "j"])));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function setCustomFilters(customFilters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_CUSTOM_FILTERS */ "l"], {
    customFilters: customFilters
  });
}
function updateCustomFilters(customFilters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_UPDATE_CUSTOM_FILTERS */ "A"], {
    customFilters: customFilters
  });
}
function resetCustomFilters() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_CUSTOM_FILTERS */ "g"]);
}
function setFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_FILTERS */ "m"], {
    filters: filters
  });
}
function setSearchFilterList(searchFilterList) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_SEARCH_FILTERS */ "v"], {
    searchFilterList: searchFilterList
  });
}
function updateFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_UPDATE_FILTERS */ "B"], {
    filters: filters
  });
}
function resetFilters() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_RESET_FILTERS */ "h"]);
}
function resetCriteria() {
  return /*#__PURE__*/function () {
    var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.mark(function _callee2(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_15___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_16__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_23__[/* setDepartureCity */ "a"])({
                  value: null
                }));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_24__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_25__[/* DEFAULT_NO_DURATION */ "a"]));
                dispatch(resetCustomFilters());
                dispatch(resetFilters());
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function setIsDateRequired(isDateRequired) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_IS_DATE_REQUIRED */ "o"], {
    isDateRequired: isDateRequired
  });
}
function setProductsFilteredWithActiveCustomFacets(productsFilteredWithActiveCustomFacets) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_PRODUCTS_FILTERED_WITH_ACTIVE_CUSTOM_FACETS */ "t"], {
    productsFilteredWithActiveCustomFacets: productsFilteredWithActiveCustomFacets
  });
}
function setProductsBeforeActiveCustomFacetsFiltering(productsBeforeActiveCustomFacetsFiltering) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_PRODUCTS_BEFORE_ACTIVE_CUSTOM_FACETS_FILTERING */ "s"], {
    productsBeforeActiveCustomFacetsFiltering: productsBeforeActiveCustomFacetsFiltering
  });
}
function setIsSearchEnabled(isSearchEnabled) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_IS_SEARCH_ENABLED */ "p"], {
    isSearchEnabled: isSearchEnabled
  });
}
function setOrderByPrice(orderByPrice) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_28__[/* FACETING_SET_ORDER_BY_PRICE */ "r"], {
    orderByPrice: orderByPrice
  });
}

/***/ }),

/***/ "luEP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.addMethod = addMethod;
exports.lazy = exports.ref = exports.boolean = void 0;

var _mixed = _interopRequireDefault(__webpack_require__("tNma"));

exports.mixed = _mixed.default;

var _boolean = _interopRequireDefault(__webpack_require__("+Mso"));

exports.bool = _boolean.default;

var _string = _interopRequireDefault(__webpack_require__("E8R/"));

exports.string = _string.default;

var _number = _interopRequireDefault(__webpack_require__("4XSA"));

exports.number = _number.default;

var _date = _interopRequireDefault(__webpack_require__("+VQP"));

exports.date = _date.default;

var _object = _interopRequireDefault(__webpack_require__("5r8v"));

exports.object = _object.default;

var _array = _interopRequireDefault(__webpack_require__("AdY7"));

exports.array = _array.default;

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _Lazy = _interopRequireDefault(__webpack_require__("gqH2"));

var _ValidationError = _interopRequireDefault(__webpack_require__("fnDY"));

exports.ValidationError = _ValidationError.default;

var _reach = _interopRequireDefault(__webpack_require__("zBae"));

exports.reach = _reach.default;

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

exports.isSchema = _isSchema.default;

var _setLocale = _interopRequireDefault(__webpack_require__("Lo6J"));

exports.setLocale = _setLocale.default;
var boolean = _boolean.default;
exports.boolean = boolean;

var ref = function ref(key, options) {
  return new _Reference.default(key, options);
};

exports.ref = ref;

var lazy = function lazy(fn) {
  return new _Lazy.default(fn);
};

exports.lazy = lazy;

function addMethod(schemaType, name, fn) {
  if (!schemaType || !(0, _isSchema.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}

/***/ }),

/***/ "n4a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = prependDeep;

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function prependDeep(target, source) {
  for (var key in source) {
    if ((0, _has.default)(source, key)) {
      var sourceVal = source[key],
          targetVal = target[key];

      if (targetVal === undefined) {
        target[key] = sourceVal;
      } else if (targetVal === sourceVal) {
        continue;
      } else if ((0, _isSchema.default)(targetVal)) {
        if ((0, _isSchema.default)(sourceVal)) target[key] = sourceVal.concat(targetVal);
      } else if (isObject(targetVal)) {
        if (isObject(sourceVal)) target[key] = prependDeep(targetVal, sourceVal);
      } else if (Array.isArray(targetVal)) {
        if (Array.isArray(sourceVal)) target[key] = sourceVal.concat(targetVal);
      }
    }
  }

  return target;
}

module.exports = exports["default"];

/***/ }),

/***/ "ngAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDebounce; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // Our hook

function useDebounce(values, delay) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(values),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(values);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, values);
  return debouncedValue;
}

/***/ }),

/***/ "oL6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR_MESSAGES; });
/* unused harmony export buildTransportKey */
/* unused harmony export getAccommodationComfortIndex */
/* unused harmony export getAdultsCount */
/* unused harmony export getPackage */
/* unused harmony export getCurrency */
/* unused harmony export getRONPackage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getKidsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFormattedArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getFormattedDepartureDate; });
/* unused harmony export hasAllInclusive */
/* unused harmony export hasChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return hasChildcare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return hasTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getTotalPriceFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getMainHouseholdAttendee; });
/* unused harmony export hasTransport */
/* unused harmony export isTransportATrain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isCharterFlight; });
/* unused harmony export isDateAfterOptionRange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isOptionAllowed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return isRecommendedTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return saveRecommendedTransport; });
/* unused harmony export getArrivalDate */
/* unused harmony export getTripArrival */
/* unused harmony export getTripDeparture */
/* unused harmony export hasAccomodation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareAccommodationsByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return compareProposalsByComfort; });
/* unused harmony export getNbParticipants */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hasErroredProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return hasFetchProposalsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getResolvedProposals; });
/* unused harmony export getSelectedProposal */
/* unused harmony export getSelectedProposalById */
/* unused harmony export getStockWarning */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getTotalValue; });
/* unused harmony export getFormatedPrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFormatedPriceByLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getPriceDiff; });
/* unused harmony export hasTransportOrTransferSelected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDefaultProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return isPremiumAccommodation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isExclusiveCollectionRoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isExclusiveCollectionSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getComparatorErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getQuickSearchErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isExpiredDepartureDate; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("yq1k");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("yXV3");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Rfxz");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("B6y2");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("JTJg");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("CzFL");
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_snakeCase__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_nth__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Hz96");
/* harmony import */ var lodash_nth__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_nth__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("6R5o");
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _client_local_storage_api__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("1RIK");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("ldK3");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("kiXb");
/* harmony import */ var _accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("lZ21");
/* harmony import */ var _booking_process_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("XpIN");
/* harmony import */ var _label_labelUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("WGoB");
/* harmony import */ var _currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("wz9x");
/* harmony import */ var _client_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("z8xc");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("tI+f");



























var OPTIONS_DAYS_RANGE = 29;
var DEFAULT_STOCK_WARNING_LIMIT = 2;
var TWO_WEEKS_IN_MS = 14 * 24 * 3600 * 1000;

function getAccommodationComfortIndex(accommodation) {
  return _accommodation_accommodation_constants__WEBPACK_IMPORTED_MODULE_21__[/* ACCOMMODATION_COMFORT_ORDER */ "a"].indexOf(lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(accommodation, 'categoryId'));
}

function compareProposalsByComfort(proposal1, proposal2) {
  var proposal1Index = getAccommodationComfortIndex(lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal1, 'accommodations[0]'));
  var proposal2Index = getAccommodationComfortIndex(lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal2, 'accommodations[0]')); // if we have not sorted the accommodation we don't change the order returned by the api

  if (proposal1Index === -1 || proposal2Index === -1) {
    return 0;
  }

  return proposal1Index - proposal2Index;
}

function compareAccommodationsByComfort(accommodation1, accommodation2) {
  return getAccommodationComfortIndex(accommodation1) - getAccommodationComfortIndex(accommodation2);
}

function isCharterFlight(cancellationPolicy) {
  return [_booking_process_constants__WEBPACK_IMPORTED_MODULE_22__[/* LEGAL_INFO_THEO_ID */ "d"], _booking_process_constants__WEBPACK_IMPORTED_MODULE_22__[/* LEGAL_INFO_WEBTHEO_ID */ "e"]].includes(cancellationPolicy);
}

function isDateAfterOptionRange(date) {
  return date && date.isValid() && date.diff(moment__WEBPACK_IMPORTED_MODULE_17___default()(), 'days') >= OPTIONS_DAYS_RANGE;
}

function isOptionAllowed(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'optionAvailable');
}

function getAdultsCount(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'attendees.adults.length', 1);
}

function getCurrency(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'price.currency');
}

function getKidsCount(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'attendees.children.length', 0);
}

function getTotalPriceFormatted(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'price.total.formattedValue');
}

function getArrivalDate(proposal) {
  return Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_19__[/* momentFromApiDate */ "j"])(lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'arrivalDate'));
}

function getTripDeparture(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'transports.inbound.travelSections[0].departure.label', '');
}

function getTripArrival(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'transports.outbound.travelSections[0].departure.label', '');
}

function hasChildren(proposal) {
  return getKidsCount(proposal) > 0;
}

function hasChildcare(proposal) {
  return proposal.additionalServices.childcares.length > 0;
}

function hasAllInclusive(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'packageId') === _constants__WEBPACK_IMPORTED_MODULE_26__[/* PACKAGE_ALL_INCLUSIVE */ "f"];
}

function getFormattedDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD MMMM YYYY';
  return Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_19__[/* momentFromApiDate */ "j"])(date).format(dateFormat);
}

function getFormattedArrivalDate(proposal, dateFormat) {
  return getFormattedDate(lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'arrivalDate'), dateFormat);
}

function getFormattedDepartureDate(proposal, dateFormat) {
  return getFormattedDate(lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'departureDate'), dateFormat);
}

function getRONPackage(proposal) {
  var packages = lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'packages') || [];
  return lodash_find__WEBPACK_IMPORTED_MODULE_15___default()(packages, function (pkg) {
    return pkg.id === _constants__WEBPACK_IMPORTED_MODULE_26__[/* PACKAGE_ROOM_ONLY */ "h"];
  });
}

function getPackage(proposal, packageId) {
  var packages = lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'packages') || [];
  return lodash_find__WEBPACK_IMPORTED_MODULE_15___default()(packages, function (pkg) {
    return (pkg === null || pkg === void 0 ? void 0 : pkg.id) === packageId;
  }) || {};
}

function hasTransport(proposal) {
  return !!lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'transports');
}

function hasTransfer(proposal) {
  return hasTransport(proposal) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()(lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'additionalServices.transfers'));
}

function hasTransportOrTransferSelected(proposal) {
  return hasTransport(proposal) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_13___default()((proposal.additionalServices.transfers || []).filter(function (transfer) {
    return transfer.pricingInfo.isFullyRented;
  }));
}

function isTransportATrain(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'transports.inbound.travelSections[0].transport.type') === 'TRAIN' && lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'transports.outbound.travelSections[0].transport.type') === 'TRAIN';
}

function hasAccomodation(proposal) {
  return !!lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'accommodations.length');
}

function getResolvedProposals(proposals) {
  return proposals.filter(function (p) {
    return !p.errorCode;
  });
}

function hasErroredProposals(proposals) {
  return proposals.some(function (p) {
    return p.errorCode;
  });
}

function hasFetchProposalsFailed(_ref) {
  var _proposals$, _proposals$$price;

  var errors = _ref.errors,
      proposals = _ref.proposals;
  return errors && errors.length > 0 || hasErroredProposals(proposals) || !proposals || proposals.length === 0 || ((_proposals$ = proposals[0]) === null || _proposals$ === void 0 ? void 0 : (_proposals$$price = _proposals$.price) === null || _proposals$$price === void 0 ? void 0 : _proposals$$price.gap) >= _constants__WEBPACK_IMPORTED_MODULE_26__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "i"];
}

function getSelectedProposal(proposals, selectedProposalIndex) {
  return lodash_nth__WEBPACK_IMPORTED_MODULE_14___default()(proposals, selectedProposalIndex);
}

function getSelectedProposalById(proposals, selectedProposalId) {
  return proposals.find(function (proposal) {
    return proposal.id === selectedProposalId;
  }) || proposals[0];
}

function getStockWarning(i18n, remainingStock) {
  return {
    showStockWarning: remainingStock <= lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(i18n, 'stockWarningLimit', DEFAULT_STOCK_WARNING_LIMIT),
    stockWarning: "".concat(remainingStock, " ").concat(Object(_label_labelUtils__WEBPACK_IMPORTED_MODULE_23__[/* pluralizeLabel */ "d"])(lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(i18n, 'room', ''), lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(i18n, 'rooms', ''), remainingStock))
  };
}

function getNbParticipants(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'attendees.list.length', 0);
}

function getTotalValue(proposal) {
  return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'price.total.value', 0);
}

function getFormatedPrice(formatedPrice, amount) {
  if (amount === 0) {
    return "".concat(formatedPrice);
  }

  return amount > 0 ? "+".concat(formatedPrice) : "-".concat(formatedPrice);
}

function getFormatedPriceByLocale(price, locale, currency) {
  return getFormatedPrice(Object(_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_24__[/* formatAmountForLocale */ "b"])(Math.abs(price), locale, currency), price);
}

function getPriceDiff(proposalPrice, selectedProposalPrice, locale, currency) {
  var diffPrice = proposalPrice - selectedProposalPrice;
  return diffPrice === 0 ? null : getFormatedPriceByLocale(diffPrice, locale, currency);
}

var getDefaultProposal = function getDefaultProposal(proposals, resort) {
  /**
   * There is a random corner case that make selectedProposal as undefined
   * It should be the default one (mainly the first one).
   * Maybe proposals array is empty at some point...
   * Unable to reproduce the bug... See BookingEngine.container
   */
  var firstProposal = proposals[0] || {};

  if (resort && resort.id === _constants__WEBPACK_IMPORTED_MODULE_26__[/* CEFALU_RESORT */ "a"]) {
    var deluxeProposal = proposals.find(function (proposal) {
      return lodash_get__WEBPACK_IMPORTED_MODULE_16___default()(proposal, 'accommodations[0].comfortType') === _constants__WEBPACK_IMPORTED_MODULE_26__[/* DELUXE_COMFORT */ "e"];
    });
    return deluxeProposal ? deluxeProposal : firstProposal;
  }

  return firstProposal;
};

var isPremiumAccommodation = function isPremiumAccommodation(accommodation) {
  return !!(accommodation.comfortId && [_constants__WEBPACK_IMPORTED_MODULE_26__[/* COMFORT_TYPE_SUITE */ "c"], _constants__WEBPACK_IMPORTED_MODULE_26__[/* COMFORT_TYPE_CHALET */ "b"], _constants__WEBPACK_IMPORTED_MODULE_26__[/* COMFORT_TYPE_VILLA */ "d"]].includes(accommodation.comfortId));
};

var isExclusiveCollectionRoom = function isExclusiveCollectionRoom(accommodation, product) {
  return accommodation.exclusiveCollection || Number(product === null || product === void 0 ? void 0 : product.comfort) >= 5;
};

var isExclusiveCollectionSpace = function isExclusiveCollectionSpace(accommodation, product) {
  return accommodation.exclusiveCollection && (product === null || product === void 0 ? void 0 : product.comfort) === 4;
};

function buildTransportDetailKey(transportDetail) {
  return transportDetail.travelSections.map(function (section) {
    var _section$transport, _section$transport2, _section$transport2$c, _section$departure, _section$departure2, _section$departure3, _section$arrival, _section$arrival2, _section$arrival3;

    var transportClass = _client_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_25__[/* TRANSPORT_CLASS_TO_I18N */ "f"][(_section$transport = section.transport) === null || _section$transport === void 0 ? void 0 : _section$transport["class"]];
    var company = "".concat(transportClass).concat(((_section$transport2 = section.transport) === null || _section$transport2 === void 0 ? void 0 : (_section$transport2$c = _section$transport2.companyOperator) === null || _section$transport2$c === void 0 ? void 0 : _section$transport2$c.id) || '');
    return "".concat((_section$departure = section.departure) === null || _section$departure === void 0 ? void 0 : _section$departure.id).concat((_section$departure2 = section.departure) === null || _section$departure2 === void 0 ? void 0 : _section$departure2.date).concat((_section$departure3 = section.departure) === null || _section$departure3 === void 0 ? void 0 : _section$departure3.time, "-").concat((_section$arrival = section.arrival) === null || _section$arrival === void 0 ? void 0 : _section$arrival.id).concat((_section$arrival2 = section.arrival) === null || _section$arrival2 === void 0 ? void 0 : _section$arrival2.date).concat((_section$arrival3 = section.arrival) === null || _section$arrival3 === void 0 ? void 0 : _section$arrival3.time, "-").concat(company);
  }).join(':');
}

var buildTransportKey = function buildTransportKey(transport) {
  return "".concat(buildTransportDetailKey(transport.inbound), "/").concat(buildTransportDetailKey(transport.outbound));
};

var isRecommendedTransport = function isRecommendedTransport(transport, proposalId) {
  if (!transport || !transport.inbound || !transport.outbound) {
    return false;
  }

  return buildTransportKey(transport) === Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_18__[/* getFromLocalStorage */ "a"])("recommendedTransport-".concat(proposalId));
};

var saveRecommendedTransport = function saveRecommendedTransport(transport, proposalId) {
  var localStorageKey = "recommendedTransport-".concat(proposalId);

  if (!Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_18__[/* getFromLocalStorage */ "a"])(localStorageKey)) {
    Object(_client_local_storage_api__WEBPACK_IMPORTED_MODULE_18__[/* setInLocalStorage */ "c"])(localStorageKey, buildTransportKey(transport), {
      ttl: TWO_WEEKS_IN_MS
    });
  }
};

var getMainHouseholdAttendee = function getMainHouseholdAttendee(proposal, householdId) {
  var customerId = proposal.households[householdId].attendees[0].customerId;
  return proposal.attendees.list.find(function (attendee) {
    return attendee.customerId === customerId;
  });
};

var ERROR_MESSAGES = {
  RESORT_NOT_AVAILABLE: 'productsComparison.resortNotAvailable',
  NOT_ON_SALE_FOR_THE_PERIOD: 'booking.accommodation.errorMessages.calendar.resortNotOnSale',
  INVALID_PRODUCT_ID: 'booking.accommodation.errorMessages.calendar.resortNotOnSale',
  NO_TRANSPORT: 'booking.accommodation.errorMessages.noTransport',
  NO_ACCOMMODATION: 'booking.accommodation.errorMessages.noAccommodation',
  UNAVAILABLE_FOR_BIRTHDATES: 'booking.accommodation.errorMessages.ageIncorrectOrUnauthorized',
  INVALID_BOOKING_CRITERIA: 'booking.accommodation.errorMessages.invalidBookingCriteria',
  NO_PROPOSAL: 'booking.accommodation.errorMessages.noProposalAvailable',
  TECHNICAL_ERROR: 'booking.accommodation.errorMessages.technicalError',
  INVALID_VOUCHER_CODE: 'common.comparator.voucherCodeErrorMessage',
  AUTHORIZATION_ERROR: 'productsComparison.unknownAttendee'
};
var QUICK_SEARCH_ERROR_MESSAGES = {
  INVALID_PRODUCT_ID: 'booking.partners.errorMessages.invalidResort',
  NO_ACCOMMODATION: 'booking.partners.errorMessages.noAccommodation',
  NOT_ON_SALE_FOR_THE_PERIOD: 'booking.partners.errorMessages.resortNotOnSale',
  NO_TRANSPORT: 'booking.partners.errorMessages.noTransport',
  TOO_MANY_ATTENDEES: 'booking.partners.errorMessages.attendees',
  UNAUTHORIZED_SALES_NETWORK: 'booking.partners.errorMessages.salesNetwork',
  UNAVAILABLE_FOR_BIRTHDATES: 'booking.partners.errorMessages.ageIncorrectOrUnauthorized',
  NO_PROPOSAL: 'booking.partners.errorMessages.noProposalAvailable',
  INVALID_BOOKING_CRITERIA: 'booking.partners.errorMessages.invalidBookingCriteria',
  FIELD_EMPTY: 'booking.partners.errorMessages.emptyField',
  INVALID_RESORT_ARRIVAL_DATE: 'booking.partners.errorMessages.invalidArrivalDate',
  UNKNOWN_DEPARTURE_CITY: 'booking.partners.errorMessages.invalidDepartureCity',
  TECHNICAL_ERROR: 'booking.partners.errorMessages.technicalError'
};
var ERROR_LABELS = Object.values(ERROR_MESSAGES);
var QUICK_SEARCH_ERROR_LABELS = Object.keys(QUICK_SEARCH_ERROR_MESSAGES);

var toUpperSnakeCase = function toUpperSnakeCase(errorCode) {
  return lodash_snakeCase__WEBPACK_IMPORTED_MODULE_12___default()(errorCode).toUpperCase();
};

var getComparatorErrorMessage = function getComparatorErrorMessage(errorCode) {
  if (ERROR_LABELS.includes(errorCode)) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_20__[/* t */ "h"])(errorCode);
  }

  var errorLabel = toUpperSnakeCase(errorCode);
  var errorMessage = ERROR_MESSAGES[errorLabel] || ERROR_MESSAGES.RESORT_NOT_AVAILABLE;
  return Object(_i18n__WEBPACK_IMPORTED_MODULE_20__[/* t */ "h"])(errorMessage);
};

var getQuickSearchErrorMessage = function getQuickSearchErrorMessage(errorCode) {
  var errorLabel = toUpperSnakeCase(errorCode);
  return QUICK_SEARCH_ERROR_LABELS.includes(errorLabel) ? Object(_i18n__WEBPACK_IMPORTED_MODULE_20__[/* t */ "h"])(QUICK_SEARCH_ERROR_MESSAGES[errorLabel]) : Object(_i18n__WEBPACK_IMPORTED_MODULE_20__[/* t */ "h"])('booking.partners.errorMessages.defaultErrorMessage');
};

var isExpiredDepartureDate = function isExpiredDepartureDate(router) {
  return moment__WEBPACK_IMPORTED_MODULE_17___default()(router.query.departureDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_17___default()(new Date()), 'day');
};



/***/ }),

/***/ "p532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var IS_PURE = __webpack_require__("xDBR");
var NativePromiseConstructor = __webpack_require__("0lZ3");
var fails = __webpack_require__("0Dky");
var getBuiltIn = __webpack_require__("0GbY");
var isCallable = __webpack_require__("Fib7");
var speciesConstructor = __webpack_require__("SEBh");
var promiseResolve = __webpack_require__("zfnd");
var defineBuiltIn = __webpack_require__("yy0I");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ "pP7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setCms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BOOKING_ENGINE_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBookingEngineI18n; });
/* harmony import */ var _views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9LZ4");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");


var SET_CMS = 'SET_CMS';
var setCms = function setCms(config, legalInformations) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SET_CMS, {
    config: config,
    legalInformations: legalInformations
  });
};
var GET_BOOKING_ENGINE_I18N = 'GET_BOOKING_ENGINE_I18N';
var getBookingEngineI18n = function getBookingEngineI18n(appContext) {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(GET_BOOKING_ENGINE_I18N, {}, {
      promise: Object(_views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__[/* fetchBookingEngineI18nQuery */ "a"])(appContext)
    }));
  };
};

/***/ }),

/***/ "pjDv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var from = __webpack_require__("TfTi");
var checkCorrectnessOfIteration = __webpack_require__("HH4o");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "pteD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TripDatePicker_TripDatePicker; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("oVuX");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__("nFOY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx + 2 modules
var Datepicker = __webpack_require__("Dm6d");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.themes.js
var Datepicker_themes = __webpack_require__("MZFe");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("UxlC");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/debounce.js
var debounce = __webpack_require__("RNvQ");
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.themes.js

var TripDatePicker_themes_themes = function themes(_ref) {
  var isBestPrice = _ref.isBestPrice,
      isHighlighted = _ref.isHighlighted,
      isSelectable = _ref.isSelectable,
      isSelected = _ref.isSelected,
      isTablet = _ref.isTablet,
      lastAvailability = _ref.lastAvailability,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      siblingOpen = _ref.siblingOpen;
  return {
    "default": {
      thDay: classnames_default()("cursor-pointer flex flex-1 flex-col group items-center justify-center ".concat(isTablet ? 'h-[6.25rem] p-5' : 'h-[3.25rem]', " text-14 text-center duration-250 ease-in transition-all border-t border-r border-grey relative"), {
        'text-black hocus:text-white': isSelectable
      }),
      thDayCornerMark: classnames_default()({
        'corner-mark-tr-turquoise': siblingOpen && isTablet,
        'corner-mark-tr-turquoise-sm': siblingOpen && !isTablet
      }),
      thDayMessage: 'hidden md:inline w-full font-normal text-12',
      thDayNumber: classnames_default()('md:absolute top-0 left-0 md:p-5 text-10', {
        'font-normal md:text-12': !isSelectable,
        'font-bold md:text-16': isSelectable,
        'text-current': siblingOpen
      }),
      thDayOldPrice: 'text-12 line-through hidden md:block text-current',
      thDayPrice: 'text-12 md:text-16',
      thStatusMessage: shouldDisplayDoubleSeasonButton ? "bg-turquoise cursor-pointer font-bold p-1 md:px-5 rounded-2 text-10 md:text-18 text-white uppercase".concat(!isTablet ? ' w-full' : '') : 'hidden md:inline w-full font-normal',
      thFrom: 'hidden md:inline w-full font-normal'
    },
    compact: {
      thDay: 'cursor-pointer flex flex-1 flex-col group items-center justify-center h-[3rem] leading-tight relative text-14 text-center',
      thDayMessage: 'hidden',
      thDayNumberContainer: classnames_default()('isolate relative'),
      thDayNumber: classnames_default()('relative z-1', {
        'text-white': (lastAvailability || isBestPrice || siblingOpen) && isHighlighted,
        'text-grey group-hover:text-white': !lastAvailability && !isBestPrice && !siblingOpen && isHighlighted
      }),
      thDayUnavailable: 'line-through',
      thDayHighlight: 'absolute bg-current group-hover:bg-transparent h-[1.625rem] left-1/2 rounded-4 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[1.625rem]',
      thDayOldPrice: 'hidden',
      thDayPrice: classnames_default()('block font-bold mx-auto -mb-5 mt-5 self-end text-10', {
        'text-black group-hover:text-white': !isSelected,
        'text-white': isSelected
      }),
      thStatusMessage: 'hidden',
      thFrom: 'hidden',
      thShowPricePlaceholder: true
    }
  };
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDetails.jsx
var __jsx = react_default.a.createElement;




var DayPriceDetails_DayPriceDetails = function DayPriceDetails(_ref) {
  var day = _ref.day,
      duration = _ref.duration,
      departureCity = _ref.departureCity,
      hasTransport = _ref.hasTransport,
      isJoyview = _ref.isJoyview,
      isVisible = _ref.isVisible,
      setIsVisible = _ref.setIsVisible,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      unit = _ref.unit;
  Object(react["useEffect"])(function () {
    setIsVisible(shouldDisplayDetails);
  }, [shouldDisplayDetails]);
  var dateFormat = Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  var startDate = moment_default()(day).format(dateFormat);
  var endDate = moment_default()(day).add({
    days: duration
  }).format(dateFormat);
  return isVisible && shouldDisplayDetails && __jsx("div", {
    className: "absolute font-normal left-1/2 text-initial top-0 transform -translate-x-1/2 z-2",
    style: {
      width: '25rem'
    }
  }, __jsx("div", {
    className: "absolute bottom-full animate-fadeIn animation-duration-500 inset-x-0"
  }, __jsx("div", {
    className: "arrow-down arrow-large arrow-white bg-white after:drop-shadow-md rounded-12 shadow-md"
  }, __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
    city: departureCity,
    endDate: endDate,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    startDate: startDate,
    unit: unit
  }))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeasonPopin.jsx
var DayPriceDoubleSeasonPopin = __webpack_require__("uMuQ");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeason.jsx
var DayPriceDoubleSeason_jsx = react_default.a.createElement;





var DayPriceDoubleSeason_DayPriceDoubleSeason = function DayPriceDoubleSeason(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      isMouseOverDoubleSeasonPopin = _ref.isMouseOverDoubleSeasonPopin,
      isVisible = _ref.isVisible,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var stopEventBubbling = function stopEventBubbling(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var closeModal = function closeModal(e) {
    stopEventBubbling(e);
    setInvisible();
  };

  var trackingData = {
    actionGA: 'calendarPrice'
  };
  return (isVisible || isMouseOverDoubleSeasonPopin) && DayPriceDoubleSeason_jsx("div", {
    onClick: stopEventBubbling
  }, isTablet ? DayPriceDoubleSeason_jsx("aside", {
    className: "absolute arrow arrow-bg-lightGrey arrow-down arrow-white animate-fadeIn animation-duration-500 font-normal left-1/2 shadow-diffuse bottom-full transform -translate-x-1/2 w-[17.5rem] z-3"
  }, DayPriceDoubleSeason_jsx("div", {
    className: "bg-white overflow-hidden border border-lightGrey rounded-12 text-initial"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  }))) : DayPriceDoubleSeason_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayWithPrice.jsx




var DayWithPrice_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */












var COMPACT_MAX_CHARACTERS = 5;
var DayWithPrice_DayWithPrice = function DayWithPrice(_ref) {
  var day = _ref.day,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 7 : _ref$duration,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? false : _ref$hasInstalment,
      isJoyview = _ref.isJoyview,
      isLoading = _ref.isLoading,
      _ref$isSelectable = _ref.isSelectable,
      isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$isHighlighted = _ref.isHighlighted,
      isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
      locale = _ref.locale,
      _ref$price = _ref.price,
      availability = _ref$price.availability,
      currency = _ref$price.currency,
      departureCity = _ref$price.departureCity,
      hasTransport = _ref$price.hasTransport,
      isBestPrice = _ref$price.isBestPrice,
      lastAvailability = _ref$price.lastAvailability,
      formattedPriceValue = _ref$price.price,
      oldPrice = _ref$price.oldPrice,
      priceValue = _ref$price.priceValue,
      _ref$price$siblingOpe = _ref$price.siblingOpen,
      siblingOpen = _ref$price$siblingOpe === void 0 ? false : _ref$price$siblingOpe,
      unit = _ref$price.unit,
      product = _ref.product,
      selectedBestPrice = _ref.selectedBestPrice,
      selectedDuration = _ref.selectedDuration,
      selectedRealPrice = _ref.selectedRealPrice,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      shouldDisplayPrice = _ref.shouldDisplayPrice,
      shouldDisplaySelectedDepartureDateMessage = _ref.shouldDisplaySelectedDepartureDateMessage,
      shouldDisplaySelectedDepartureDateMessageWithPrice = _ref.shouldDisplaySelectedDepartureDateMessageWithPrice,
      shouldDisplaySelectedReturningDateMessage = _ref.shouldDisplaySelectedReturningDateMessage,
      shouldDisplayStatusMessage = _ref.shouldDisplayStatusMessage,
      theme = _ref.theme,
      withPriceDetails = _ref.withPriceDetails;

  var _useState = Object(react["useState"])(false),
      isMouseOverDoubleSeasonPopin = _useState[0],
      setIsMouseOverDoubleSeasonPopin = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isVisible = _useState2[0],
      setIsVisibleState = _useState2[1];

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var statusMessageKey = "booking.priceCalendar.priceStatus.".concat(availability);
  var _themes$theme = TripDatePicker_themes_themes({
    isBestPrice: isBestPrice,
    isHighlighted: isHighlighted,
    isSelectable: isSelectable,
    isSelected: isSelected,
    isTablet: isTablet,
    lastAvailability: lastAvailability,
    shouldDisplayDoubleSeasonButton: shouldDisplayDoubleSeasonButton,
    siblingOpen: siblingOpen
  })[theme],
      thDayCornerMark = _themes$theme.thDayCornerMark,
      thDayMessage = _themes$theme.thDayMessage,
      thDayNumberContainer = _themes$theme.thDayNumberContainer,
      thDayNumber = _themes$theme.thDayNumber,
      thDayHighlight = _themes$theme.thDayHighlight,
      thDayOldPrice = _themes$theme.thDayOldPrice,
      thDayPrice = _themes$theme.thDayPrice,
      thStatusMessage = _themes$theme.thStatusMessage,
      thFrom = _themes$theme.thFrom,
      thShowPricePlaceholder = _themes$theme.thShowPricePlaceholder;

  var setIsVisible = debounce_default()(function (visible) {
    setIsVisibleState(visible);
  }, 150);

  var setVisible = function setVisible() {
    if (!isVisible) {
      setIsVisible(true);
    }
  };

  var setInvisible = function setInvisible() {
    setIsVisible(false);
  };

  var getCompactPrice = function getCompactPrice(rawPrice) {
    var compactPrice = (rawPrice === null || rawPrice === void 0 ? void 0 : rawPrice.replace(/[\s|.,]/gi, '')) || '';
    return compactPrice.length <= COMPACT_MAX_CHARACTERS ? compactPrice : DayWithPrice_jsx("span", {
      className: "text-8 md:px-1 md:mx-1 md:text-10"
    }, compactPrice);
  };

  var price = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])({
    currency: currency,
    formattedValue: formattedPriceValue,
    value: priceValue
  }, locale) : formattedPriceValue;
  var selectedPrice = selectedRealPrice || selectedBestPrice;
  var isDateSelectable = ['open', 'noDeparture'].includes(availability);
  return DayWithPrice_jsx(react["Fragment"], null, DayWithPrice_jsx("div", {
    className: classnames_default()({
      'absolute h-full inset-0 w-full z-3': withPriceDetails || shouldDisplayDoubleSeasonButton,
      'pointer-events-auto': shouldDisplayDoubleSeasonButton
    }),
    onBlur: function onBlur() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onClick: function onClick(e) {
      if (shouldDisplayDoubleSeasonButton) {
        e.preventDefault();
        e.stopPropagation();

        if (!isDesktop) {
          setVisible();
        }
      }
    },
    onFocus: function onFocus() {
      if (isDesktop) {
        setVisible();
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onMouseOver: function onMouseOver() {
      if (isDesktop) {
        setVisible();
      }
    },
    tabIndex: 0
  }), siblingOpen && DayWithPrice_jsx("span", {
    className: thDayCornerMark
  }), withPriceDetails && DayWithPrice_jsx(DayPriceDetails_DayPriceDetails, {
    duration: duration,
    departureCity: departureCity,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    isVisible: isVisible,
    setIsVisible: setIsVisible,
    shouldDisplayDetails: !!price && shouldDisplayDetails,
    day: day,
    unit: unit
  }), product && siblingOpen && shouldDisplayDoubleSeasonButton && DayWithPrice_jsx(DayPriceDoubleSeason_DayPriceDoubleSeason, {
    availability: availability,
    product: product,
    isMouseOverDoubleSeasonPopin: isMouseOverDoubleSeasonPopin,
    isVisible: isVisible,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    setVisible: setVisible,
    statusMessageKey: statusMessageKey
  }), (!shouldDisplayDoubleSeasonButton || isTablet) && DayWithPrice_jsx("div", {
    className: thDayNumberContainer
  }, DayWithPrice_jsx("span", {
    className: classnames_default()(thDayNumber)
  }, moment_default()(day).format('D')), isHighlighted && DayWithPrice_jsx("div", {
    className: thDayHighlight
  })), shouldDisplayStatusMessage && Object(i18n["f" /* has */])(statusMessageKey) && !price && !isLoading && (siblingOpen ? shouldDisplayDoubleSeasonButton && DayWithPrice_jsx("span", {
    className: classnames_default()(thStatusMessage, {
      'shadow-md': isVisible || isMouseOverDoubleSeasonPopin
    })
  }, Object(i18n["h" /* t */])(statusMessageKey)) : DayWithPrice_jsx("span", {
    className: thStatusMessage
  }, Object(i18n["h" /* t */])(statusMessageKey))), shouldDisplaySelectedDepartureDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), ' ', DayWithPrice_jsx("div", {
    className: "mt-5"
  }, Object(i18n["h" /* t */])('booking.priceCalendar.endDateMessage'))), shouldDisplaySelectedDepartureDateMessageWithPrice && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage').toUpperCase(), selectedPrice && selectedDuration && DayWithPrice_jsx("div", {
    className: "flex flex-col"
  }, DayWithPrice_jsx("span", null, Object(i18n["h" /* t */])('price.format.unitTotalPerTripIndicative').toUpperCase()), DayWithPrice_jsx("span", {
    className: "font-bold leading-tight text-12 md:text-16",
    "data-testid": "selected-date-best-price"
  }, theme === 'compact' ? getCompactPrice(selectedPrice) : selectedPrice))), shouldDisplaySelectedReturningDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedReturningDateMessage').toUpperCase()), isLoading ? DayWithPrice_jsx(Spinner["a" /* Spinner */], {
    size: "tiny",
    color: colors["a" /* COLORS */].BLACK
  }) : DayWithPrice_jsx(react["Fragment"], null, shouldDisplayPrice && !!price && DayWithPrice_jsx("div", {
    className: "flex flex-col text-current",
    "data-testid": "price-calendar-date-price"
  }, !!price && DayWithPrice_jsx("span", {
    className: thFrom
  }, Object(i18n["h" /* t */])('price.format.from')), DayWithPrice_jsx("span", {
    "data-testid": "price",
    className: thDayPrice
  }, theme === 'compact' ? getCompactPrice(price) : price), price !== oldPrice && DayWithPrice_jsx("span", {
    className: thDayOldPrice
  }, oldPrice)), thShowPricePlaceholder && (!shouldDisplayPrice || !price) && DayWithPrice_jsx("span", {
    className: classnames_default()(thDayPrice, {
      'opacity-0': !isDateSelectable
    })
  }, isDateSelectable ? Object(string_util["e" /* truncate */])(Object(i18n["h" /* t */])('faceting.when.dateSelect'), 6) : DayWithPrice_jsx(react_default.a.Fragment, null, "\xA0"))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx








var TripDatePicker_jsx = react_default.a.createElement;














var selector = function selector(state) {
  var _state$calendar;

  return {
    isBookableDatesLoading: state === null || state === void 0 ? void 0 : (_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.bookableDatesLoading
  };
}; // $FlowFixMe


var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return TripDatePicker_jsx("div", {
    className: className,
    title: weekdayName
  }, weekdayName);
};

var TripDatePicker_TripDatePicker = function TripDatePicker(_ref2) {
  var _modifiers;

  var className = _ref2.className,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      hasInstalment = _ref2.hasInstalment,
      isJoyview = _ref2.isJoyview,
      navbarElement = _ref2.navbarElement,
      navigationByYear = _ref2.navigationByYear,
      offsetCalendar = _ref2.offsetCalendar,
      onDayMouseOver = _ref2.onDayMouseOver,
      onSelect = _ref2.onSelect,
      openCalendarToDate = _ref2.openCalendarToDate,
      openingDates = _ref2.openingDates,
      optionsDuration = _ref2.optionsDuration,
      prices = _ref2.prices,
      product = _ref2.product,
      selectedBestPrice = _ref2.selectedBestPrice,
      _ref2$selectedDays = _ref2.selectedDays,
      from = _ref2$selectedDays.from,
      to = _ref2$selectedDays.to,
      selectedDuration = _ref2.selectedDuration,
      selectedMonth = _ref2.selectedMonth,
      selectedRealPrice = _ref2.selectedRealPrice,
      _ref2$shouldAllowSele = _ref2.shouldAllowSelectingSiblingOpenDays,
      shouldAllowSelectingSiblingOpenDays = _ref2$shouldAllowSele === void 0 ? false : _ref2$shouldAllowSele,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      withLongDayFormat = _ref2.withLongDayFormat,
      _ref2$withPriceDetail = _ref2.withPriceDetails,
      withPriceDetails = _ref2$withPriceDetail === void 0 ? false : _ref2$withPriceDetail,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["className", "departureDate", "duration", "hasInstalment", "isJoyview", "navbarElement", "navigationByYear", "offsetCalendar", "onDayMouseOver", "onSelect", "openCalendarToDate", "openingDates", "optionsDuration", "prices", "product", "selectedBestPrice", "selectedDays", "selectedDuration", "selectedMonth", "selectedRealPrice", "shouldAllowSelectingSiblingOpenDays", "theme", "withLongDayFormat", "withPriceDetails"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _props$displayPrices = props.displayPrices,
      displayPrices = _props$displayPrices === void 0 ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('datePicker.displayPrices') : _props$displayPrices;

  var _useSelector = Object(es["e" /* useSelector */])(selector),
      isBookableDatesLoading = _useSelector.isBookableDatesLoading;

  var onMouseOver = function onMouseOver(day) {
    onDayMouseOver && onDayMouseOver(day);
  };

  var pricesIds = Object.keys(prices || {});
  var flattenedPrices = prices ? Object(TripDatePicker_utils["f" /* flattenPrices */])(prices) : '';
  var hasPrices = pricesIds.length > 0;
  var doDisplayPricesInDatePicker = hasPrices && displayPrices || theme === 'compact';
  var bothDatesSelected = Boolean(from && to);
  var resolvePrice = Object(react["useCallback"])(function (dayId) {
    return get_default()(prices, "[".concat(dayId, "]"), {});
  }, [flattenedPrices]);
  var isSeller = appContext.isSeller,
      locale = appContext.locale;
  var disabledDays = Object(react["useMemo"])(function () {
    return Object(TripDatePicker_utils["g" /* getDisabledDays */])({
      from: from,
      to: to,
      prices: prices,
      isSeller: isSeller,
      optionsDuration: optionsDuration,
      openingDates: openingDates,
      resolvePrice: resolvePrice,
      shouldAllowSelectingSiblingOpenDays: shouldAllowSelectingSiblingOpenDays
    });
  }, [from, isSeller, optionsDuration.join(), flattenedPrices, to]);
  var dayIsClosed = Object(react["useCallback"])(Object(TripDatePicker_utils["b" /* closedDaysFactory */])(resolvePrice, from, moment_default()(to).subtract(1, 'day').toDate(), shouldAllowSelectingSiblingOpenDays), [from, to, flattenedPrices]);
  var modifiers = (_modifiers = {}, Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].DARK_GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREEN_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].GREY,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].ORANGE_OPACITY_45,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].WHITE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE, Object(TripDatePicker_utils["h" /* getPriceColor */])({
    classColor: TripDatePicker_utils["a" /* PRICE_COLOR_CLASS_NAMES */].TURQUOISE,
    from: from,
    hasPrices: hasPrices,
    resolvePrice: resolvePrice,
    selectedMonth: selectedMonth,
    to: to
  })), Object(defineProperty["a" /* default */])(_modifiers, '!text-lightGrey', disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "disabledDays", disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "firstSiblingOpenDayOfSelectedMonth", Object(TripDatePicker_utils["e" /* firstSiblingOpenDayOfSelectedMonthFactory */])(resolvePrice, selectedMonth)), Object(defineProperty["a" /* default */])(_modifiers, "siblingOpenDays", Object(TripDatePicker_utils["k" /* siblingOpenDaysFactory */])(resolvePrice)), Object(defineProperty["a" /* default */])(_modifiers, 'pointer-events-none', function pointerEventsNone(day) {
    var dayIsSelected = from && to && Object(TripDatePicker_utils["d" /* dateToInt */])(day) >= Object(TripDatePicker_utils["d" /* dateToInt */])(from) && Object(TripDatePicker_utils["d" /* dateToInt */])(day) <= Object(TripDatePicker_utils["d" /* dateToInt */])(to);

    if (hasPrices && dayIsSelected) {
      return dayIsClosed(day);
    }
  }), _modifiers);
  var firstDateWithPrices = Object(react["useMemo"])(function () {
    var today = Object(TripDatePicker_utils["d" /* dateToInt */])(new Date());
    var dayWithPrice = pricesIds.find(function (pricesKey) {
      return Object(TripDatePicker_utils["d" /* dateToInt */])(moment_default()(pricesKey, apiDate["a" /* API_DATE_FORMAT */]).toDate()) > today && prices && prices[pricesKey].available;
    });
    return dayWithPrice || null;
  }, [JSON.stringify(flattenedPrices)]);
  var firstDateOpened = Object(react["useMemo"])(function () {
    if (!Array.isArray(openingDates) || openingDates.length === 0) {
      return null;
    }

    var _openingDates = Object(slicedToArray["a" /* default */])(openingDates, 1),
        opening = _openingDates[0].opening;

    return opening;
  }, [JSON.stringify(openingDates)]);
  var thDay = TripDatePicker_themes_themes({
    isTablet: isTablet
  })[theme].thDay; // If bookable dates are loading only define current or selected day as range

  var datesRange = isBookableDatesLoading ? {
    min: moment_default()(from).toDate(),
    max: moment_default()(from).toDate()
  } : {
    min: Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar),
    max: Object(TripDatePicker_utils["i" /* maxDatepickerDate */])()
  };

  var _useState = Object(react["useState"])(openCalendarToDate),
      openCalendarDate = _useState[0],
      setOpenCalendarDate = _useState[1];

  Object(react["useEffect"])(function () {
    setOpenCalendarDate(openCalendarToDate);
  }, [moment_default()(openCalendarToDate).format(apiDate["a" /* API_DATE_FORMAT */])]);
  Object(react["useEffect"])(function () {
    if (from) {
      setOpenCalendarDate(from);
    }
  }, [moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */])]);
  var initialMonth = Object(react["useMemo"])(function () {
    return moment_default()(openCalendarDate || from || firstDateWithPrices || firstDateOpened || Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar)).toDate();
  }, [moment_default()(openCalendarDate).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateWithPrices).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateOpened).format(apiDate["a" /* API_DATE_FORMAT */]), offsetCalendar]);
  return TripDatePicker_jsx(Datepicker["a" /* Datepicker */], Object(esm_extends["a" /* default */])({
    hasRangeMode: true,
    className: className,
    selectedDays: {
      from: from,
      to: to
    },
    disabledDays: disabledDays,
    customModifiers: modifiers,
    hasNavigationByYear: navigationByYear,
    minDate: datesRange.min,
    maxDate: datesRange.max,
    navbarElement: navbarElement,
    initialMonth: initialMonth,
    onSelect: onSelect,
    onMouseOver: onMouseOver,
    onFocus: onMouseOver,
    theme: theme,
    shouldHoverSiblingOpenDays: shouldAllowSelectingSiblingOpenDays,
    weekdayElement: withLongDayFormat ? TripDatePicker_jsx(Weekday, null) : undefined
  }, doDisplayPricesInDatePicker ? {
    // eslint-disable-next-line clubmed/no-fake-component
    renderDay: function renderDay(day, dayModifiers) {
      var shouldDisplayPrice = theme === 'compact' ? hasPrices && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] : hasPrices && !to && !moment_default()(from).isSame(day, 'day');
      var price = resolvePrice(Object(TripDatePicker_utils["d" /* dateToInt */])(day));
      return TripDatePicker_jsx(DayWithPrice_DayWithPrice, {
        day: day,
        duration: duration,
        hasInstalment: hasInstalment,
        hasPrices: hasPrices,
        isSelectable: Boolean(!dayModifiers.disabledDays && from && !to && !DayPicker["DateUtils"].isSameDay(day, from)),
        isSelected: Boolean(dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected]),
        isLoading: departureDate && isBookableDatesLoading && moment_default()(day).isAfter(departureDate) ? true : false,
        isJoyview: isJoyview,
        locale: locale,
        price: price,
        product: product,
        selectedBestPrice: selectedBestPrice,
        selectedDuration: selectedDuration,
        selectedRealPrice: selectedRealPrice,
        isHighlighted: (dayModifiers.today || price.isBestPrice || price.lastAvailability || price.siblingOpen) && !dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected],
        shouldDisplayDetails: withPriceDetails && !!dayModifiers[Datepicker_themes["a" /* themes */][theme].thDayPicker.selected] && !from && !to,
        shouldDisplayDoubleSeasonButton: dayModifiers.firstSiblingOpenDayOfSelectedMonth,
        shouldDisplayPrice: shouldDisplayPrice,
        shouldDisplaySelectedDepartureDateMessage: !!from && !to && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedDepartureDateMessageWithPrice: bothDatesSelected && moment_default()(from).isSame(day, 'day'),
        shouldDisplaySelectedReturningDateMessage: bothDatesSelected && moment_default()(to).isSame(day, 'day'),
        shouldDisplayStatusMessage: !from,
        withPriceDetails: withPriceDetails,
        theme: theme
      });
    },
    datePickerClassNames: {
      day: thDay
    }
  } : null));
};

/***/ }),

/***/ "q/8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPrice; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);






var getProductArgs = function getProductArgs(_ref) {
  var duration = _ref.duration,
      location = _ref.location,
      productId = _ref.productId,
      transport = _ref.transport,
      withDate = _ref.withDate;
  var queryParams = location.queryParams,
      urlParams = location.urlParams;
  var offerName = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["url"].decodePath(queryParams.offer) || '';
  var tripDuration = withDate ? duration || queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DURATION */ "h"]] : null;
  var productArgsToBuild = {};
  productArgsToBuild.offerName = offerName;
  productArgsToBuild.date = withDate ? queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DEPARTURE_DATE */ "g"]] || '' : '';
  productArgsToBuild.departureCity = transport || queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_TRANSPORT */ "m"]] || '';

  if (tripDuration) {
    productArgsToBuild.duration = parseInt(tripDuration, 10);
  }

  return Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams, productArgsToBuild);
};

function fetchPrice(_ref2) {
  var appContext = _ref2.appContext,
      duration = _ref2.duration,
      _ref2$forceAdultPerTr = _ref2.forceAdultPerTrip,
      forceAdultPerTrip = _ref2$forceAdultPerTr === void 0 ? false : _ref2$forceAdultPerTr,
      location = _ref2.location,
      productId = _ref2.productId,
      transport = _ref2.transport,
      _ref2$withDate = _ref2.withDate,
      withDate = _ref2$withDate === void 0 ? true : _ref2$withDate;
  var queryParams = location.queryParams;
  var offerName = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["url"].decodePath(queryParams.offer) || '';
  var _appContext$cmsConten = appContext.cmsContent,
      cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
  var productArgs = getProductArgs({
    duration: duration,
    location: location,
    productId: productId,
    transport: transport,
    withDate: withDate
  });
  var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
  var query = "query {\n    price(".concat(productArgs, ") {\n      offerColor( offerName : \"").concat(offerName, "\")\n      bestPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      initialPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      productId\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        departureCity {\n          value\n          name\n        }\n        numberOfAdults\n        accommodationComfortLabel\n        accommodationId\n        offerId\n      }\n    }\n  }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* STATE_PRODUCT_PRICE_TICKET */ "fd"]
  });
}



/***/ }),

/***/ "qYhz":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("c7Qd"),
    isArrayLike = __webpack_require__("9y2L"),
    isString = __webpack_require__("nDih"),
    toInteger = __webpack_require__("m2YG"),
    values = __webpack_require__("0iyY");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),

/***/ "qr7w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = exports.array = exports.object = exports.boolean = exports.date = exports.number = exports.string = exports.mixed = void 0;

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " must be a `" + type + "` type, " + ("but the final value was: `" + (0, _printValue.default)(value, true) + "`") + (isCast ? " (cast from the value `" + (0, _printValue.default)(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  }
};
exports.mixed = mixed;
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
exports.string = string;
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
exports.number = number;
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
exports.date = date;
var boolean = {};
exports.boolean = boolean;
var object = {
  noUnknown: '${path} field cannot have keys not specified in the object shape'
};
exports.object = object;
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items'
};
exports.array = array;
var _default = {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
};
exports.default = _default;

/***/ }),

/***/ "rFVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Participants_Participants; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("pNMO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("yyme");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("QWBl");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("pjDv");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("5DmW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("27RR");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("PKPk");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("FZtP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/common-validator/CommonValidators.js
var CommonValidators = __webpack_require__("cjjV");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("yXV3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("TWNs");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("Rm1S");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/sortBy.js
var sortBy = __webpack_require__("u6DZ");
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: /opt/webapp/node_modules/create-react-class/index.js
var create_react_class = __webpack_require__("Y3fD");
var create_react_class_default = /*#__PURE__*/__webpack_require__.n(create_react_class);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-dom/index.js
var react_dom = __webpack_require__("7nmT");
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Label.jsx
var Label = __webpack_require__("vJSV");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-input-tel-date/FormInputTelDate.jsx



















var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable clubmed/no-fake-component */








var dayDefaultStruct = {
  ref: 'day',
  stateName: 'dayValue',
  placeholderPropName: 'dayPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null
};
var monthDefaultStruct = {
  ref: 'month',
  stateName: 'monthValue',
  placeholderPropName: 'monthPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null
};
var yearDefaultStruct = {
  ref: 'year',
  stateName: 'yearValue',
  placeholderPropName: 'yearPlaceholder',
  maxLength: 4,
  onChange: null,
  placeholder: null
};
var datePatterns = [{
  key: 'd',
  struct: dayDefaultStruct
}, {
  key: 'm',
  struct: monthDefaultStruct
}, {
  key: 'y',
  struct: yearDefaultStruct
}];
/* DEPRECATED : DO NOT USE ANYMORE */

var FormInputTelDate = create_react_class_default()({
  displayName: "FormInputTelDate",
  // TODO: cleanup !!
  // eslint-disable-next-line react/no-unused-class-component-methods
  getDefaultProps: function getDefaultProps() {
    return {
      dateFormat: 'DDMMYYYY',
      onBlur: function onBlur() {},
      onChange: function onChange() {}
    };
  },
  getInitialState: function getInitialState() {
    var formattedDate = moment_default()(this.props.value, this.props.dateFormat);
    return this.props.value && formattedDate.isValid() ? {
      dayValue: formattedDate.format('DD'),
      monthValue: formattedDate.format('MM'),
      yearValue: formattedDate.format('YYYY')
    } : {
      dayValue: '',
      monthValue: '',
      yearValue: ''
    };
  },
  areAllInputsFilled: function areAllInputsFilled() {
    return this.state.dayValue.length === dayDefaultStruct.maxLength && this.state.monthValue.length === monthDefaultStruct.maxLength && this.state.yearValue.length === yearDefaultStruct.maxLength;
  },
  getFormattedDate: function getFormattedDate() {
    if (isEmpty_default()(this.state.yearValue) && isEmpty_default()(this.state.monthValue) && isEmpty_default()(this.state.dayValue)) {
      return '';
    }

    return this.areAllInputsFilled() ? moment_default()([+this.state.yearValue, +this.state.monthValue - 1, +this.state.dayValue]).format(this.props.dateFormat) : moment_default.a.invalid().toString();
  },
  handleChange: function handleChange(value, event, nextInput, maxLength) {
    var _this = this;

    this.setState(Object(defineProperty["a" /* default */])({}, value, event.target.value), function () {
      _this.props.onChange(_this.getFormattedDate());
    });

    if (nextInput && maxLength && event.target.value.length === maxLength) {
      react_dom_default.a.findDOMNode(nextInput).focus();
    }
  },
  handleBlur: function handleBlur(value, event, nextInput) {
    if (!nextInput || get_default()(event, 'relatedTarget.className', '').indexOf('FormInputTelDate-input') === -1) {
      this.props.onBlur(this.getFormattedDate());
    }
  },
  getHandleChangeFunction: function getHandleChangeFunction(field, nextRef, maxLength) {
    var _this2 = this;

    return function (event) {
      return _this2.handleChange(field, event, nextRef, maxLength);
    };
  },
  getHandleBlurFunction: function getHandleBlurFunction(field, nextRef) {
    var _this3 = this;

    return function (event) {
      return _this3.handleBlur(field, event, nextRef);
    };
  },
  buildFormatStructure: function buildFormatStructure(_ref, index, patterns) {
    var struct = _ref.struct,
        size = _ref.size;
    var nextRef = index + 1 < patterns.length ? get_default()(this.refs, patterns[index + 1].struct.ref) : null;
    return _objectSpread(_objectSpread({}, struct), {}, {
      id: "".concat(this.props.id, "-").concat(index),
      maxLength: size,
      onChange: this.getHandleChangeFunction(struct.stateName, nextRef, size),
      onBlur: this.getHandleBlurFunction(struct.stateName, nextRef),
      placeholder: get_default()(this.props, struct.placeholderPropName)
    });
  },
  getPatternPos: function getPatternPos(dateFormat) {
    return function (datePattern) {
      return _objectSpread(_objectSpread({}, datePattern), {}, {
        pos: dateFormat.indexOf(datePattern.key)
      });
    };
  },
  getPatternSize: function getPatternSize(dateFormat) {
    return function (datePattern) {
      return _objectSpread(_objectSpread({}, datePattern), {}, {
        size: (dateFormat.match(new RegExp(datePattern.key, 'g')) || []).length
      });
    };
  },
  getDateStructure: function getDateStructure(dateFormat) {
    return sortBy_default()(datePatterns.map(this.getPatternPos(dateFormat)), ['pos']).map(this.getPatternSize(dateFormat)).map(this.buildFormatStructure);
  },
  getValidationState: function getValidationState() {
    var validationState = this.props.validationState;
    return validationState === 'IS_VALID' && !this.areAllInputsFilled() ? 'NOT_VALIDATED' : validationState;
  },
  render: function render() {
    var _this4 = this;

    var _this$props = this.props,
        className = _this$props.className,
        id = _this$props.id,
        label = _this$props.label,
        isRequired = _this$props.isRequired;
    var structures = this.getDateStructure(this.props.dateFormat.toLowerCase());
    var validationState = this.getValidationState();
    var isValid = validationState === 'IS_VALID';
    var isInvalid = validationState === 'IS_INVALID';
    return __jsx("div", {
      className: classnames_default()('flex flex-col', className)
    }, !!label && __jsx(Label["a" /* Label */], {
      className: "mb-5 mx-15",
      htmlFor: id,
      isRequired: isRequired,
      label: label
    }), __jsx("div", {
      className: classnames_default()('border-1 flex overflow-hidden outline-custom rounded-pill duration-250 ease-in transition-all', {
        'border-success': isValid,
        'border-red': isInvalid
      })
    }, __jsx("div", {
      className: "flex items-center text-14 w-full"
    }, structures.map(function (structure, index) {
      return __jsx("div", {
        className: "flex flex-1 items-center relative",
        key: "".concat(_this4.state[structure.id], "-").concat(index)
      }, !!index && __jsx("span", null, "/"), __jsx("input", {
        className: classnames_default()('bg-transparent text-center w-full', {
          'cursor-progress': _this4.props.isLoading
        }),
        id: _this4.state[structure.id],
        maxLength: structure.maxLength,
        onBlur: structure.onBlur,
        onChange: structure.onChange,
        placeholder: structure.placeholder,
        ref: structure.ref,
        style: {
          height: '2.6875rem'
        },
        type: "tel",
        value: _this4.state[structure.stateName]
      }));
    })), (isValid || isInvalid) && __jsx("span", {
      className: classnames_default()('flex items-center justify-center px-10 text-10 duration-250 ease-in transition-all', {
        'text-success': isValid,
        'text-red': isInvalid
      })
    }, __jsx(Icon["a" /* Icon */], {
      name: isValid ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS,
      width: "0.8125rem"
    }))));
  }
});
// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/FormValidator.jsx + 1 modules
var FormValidator = __webpack_require__("/013");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx + 1 modules
var InputNumber = __webpack_require__("xGYs");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-information/participants/participants.constants.js
var participants_constants = __webpack_require__("93Yv");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-information/participants/Participants.jsx























var Participants_jsx = react_default.a.createElement;

function Participants_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Participants_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Participants_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Participants_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }














var Participants_Participants = /*#__PURE__*/function (_FormValidator) {
  Object(inherits["a" /* default */])(Participants, _FormValidator);

  var _super = _createSuper(Participants);

  function Participants() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Participants);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onAdultsNumberChange", function (_, value) {
      _this.props.setAdultsNumber(value);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKidsNumberChange", function (_, value) {
      var kids = Array(value).fill(undefined).map(function (kid, i) {
        if (_this.props.kids[i]) {
          return _this.props.kids[i];
        }

        return kid;
      });

      var kidsValidations = _this.state.fields.map(function (_ref) {
        var validationState = _ref.validationState;
        return validationState;
      });

      _this.props.setKids({
        kids: kids,
        kidsValidations: kidsValidations
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleKids", function (idx) {
      return function (value) {
        var kidsValidations = _this.validateFields().map(function (kidsValidation) {
          return kidsValidation.validationState;
        });

        var kids = _this.props.kids.map(function (kid, index) {
          return idx !== index ? kid : Participants_objectSpread(Participants_objectSpread({}, kid), {}, {
            birthdate: moment_default()(value, _this.props.dateFormat).valueOf()
          });
        });

        _this.props.setKids({
          kids: kids,
          kidsValidations: kidsValidations
        });
      };
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Participants, [{
    key: "getFields",
    value: function getFields(props) {
      var _this2 = this;

      var dateFormat = props.dateFormat,
          kids = props.kids,
          _props$adultAge = props.adultAge,
          adultAge = _props$adultAge === void 0 ? participants_constants["a" /* DEFAULT_MAX_AGE */] : _props$adultAge,
          _props$childAge = props.childAge,
          childAge = _props$childAge === void 0 ? participants_constants["b" /* DEFAULT_MIN_AGE */] : _props$childAge,
          departureDate = props.departureDate;
      return kids.map(function (kid, idx) {
        var birthdate = _this2.getKidBirthdate(idx);

        var adultAgeInYear = +adultAge;
        var childAgeInYear = +childAge / 12;
        var params = {
          birthdayFormat: dateFormat,
          onDate: departureDate,
          onDateFormat: 'YYYYMMDD'
        };
        return {
          name: "birthdate.".concat(idx),
          value: birthdate,
          validators: [Object(CommonValidators["c" /* maxAge */])(Participants_objectSpread(Participants_objectSpread({}, params), {}, {
            ageRequired: adultAgeInYear
          })), Object(CommonValidators["d" /* minAge */])(Participants_objectSpread(Participants_objectSpread({}, params), {}, {
            ageRequired: childAgeInYear
          }))]
        };
      });
    }
  }, {
    key: "getKidBirthdate",
    value: function getKidBirthdate(idx) {
      var birthdate = get_default()(this.props.kids[idx], 'birthdate');

      return get_default()(this.state, "fields.".concat(idx, ".value")) || (birthdate ? moment_default()(birthdate).format(this.props.dateFormat) : '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          adultsLabel = _this$props.adultsLabel,
          adultsNumber = _this$props.adultsNumber,
          childrenBirthdayDateFormatPlaceholder = _this$props.childrenBirthdayDateFormatPlaceholder,
          className = _this$props.className,
          kids = _this$props.kids,
          kidsAgeLimit = _this$props.kidsAgeLimit,
          kidsLabel = _this$props.kidsLabel,
          minAgeInformation = _this$props.minAgeInformation;
      var maxPax = this.context.isSeller ? constants["L" /* MAX_PAX_SELLER */] : constants["K" /* MAX_PAX */] + 1;

      var getMaxAdultsAvailable = function getMaxAdultsAvailable() {
        return maxPax - kids.length;
      };

      var getMaxKidsAvailable = function getMaxKidsAvailable() {
        return maxPax - adultsNumber;
      };

      return Participants_jsx("section", {
        className: classnames_default()('gap-20 md:gap-40 grid grid-cols-1 md:grid-cols-2', className)
      }, Participants_jsx("div", null, Participants_jsx("div", {
        className: "bg-white flex md:inline-flex flex-col md:flex-row gap-10 justify-between p-15 md:px-40 rounded-12"
      }, Participants_jsx(InputNumber["a" /* InputNumber */], {
        dataTestId: "ParticipantsAdultsSelect",
        label: adultsLabel,
        max: getMaxAdultsAvailable(),
        min: 1,
        onChange: this.onAdultsNumberChange,
        step: 1,
        value: adultsNumber
      }), !this.props.adultOnly && Participants_jsx(InputNumber["a" /* InputNumber */], {
        dataTestId: "ParticipantsChildrenSelect",
        max: getMaxKidsAvailable(),
        label: kidsLabel,
        min: 0,
        notes: kidsAgeLimit,
        onChange: this.onKidsNumberChange,
        step: 1,
        value: kids.length
      })), minAgeInformation && kids.length > 0 && Participants_jsx("p", {
        className: "flex font-sans gap-10 items-center md:justify-end mt-10 text-10 text-center text-orange",
        "data-selector": "ParticipantsKidsAgeMessage"
      }, Participants_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].WARNING,
        size: "1rem"
      }), minAgeInformation)), kids.length > 0 && Participants_jsx("ul", {
        className: "gap-20 grid grid-cols-1 md:grid-cols-2"
      }, Array.from({
        length: this.props.kids.length
      }).map(function (child, idx) {
        var label = Object(dist["messageFormat"])(childrenBirthdayDateFormatPlaceholder).format({
          childIndex: "".concat(idx + 1)
        });

        var birthdate = _this3.getKidBirthdate(idx);

        var _get2 = get_default()(_this3.state, "fields.".concat(idx), {}),
            validationState = _get2.validationState;

        return Participants_jsx("li", {
          key: idx
        }, Participants_jsx(FormInputTelDate, {
          className: "direction-ltr",
          dateFormat: _this3.props.dateFormat,
          dayPlaceholder: _this3.props.dayPlaceholder,
          id: "birthday".concat(idx),
          isRequired: true,
          label: label,
          monthPlaceholder: _this3.props.monthPlaceholder,
          onBlur: _this3.handleKids(idx),
          onChange: _this3.updateFieldValue("birthdate.".concat(idx)),
          validationState: validationState,
          value: birthdate,
          yearPlaceholder: _this3.props.yearPlaceholder
        }));
      })));
    }
  }]);

  return Participants;
}(FormValidator["a" /* default */]);

Object(defineProperty["a" /* default */])(Participants_Participants, "defaultProps", {
  kids: []
});

Object(defineProperty["a" /* default */])(Participants_Participants, "contextType", ReactAppContext["a" /* B2CAppContext */]);

/***/ }),

/***/ "rFb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BookingErrors; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1JJ2");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var PROPOSAL_SEARCH_ERROR_MAPPING = {
  invalidProductId: 'calendar.resortNotOnSale',
  invalidBookingCriteria: 'invalidBookingCriteria',
  noAccommodation: 'noAccommodation',
  noProposalAvailable: 'noProposalAvailable',
  noProposalWithFlight: 'noProposalWithFlight',
  notOnSaleForThePeriod: 'calendar.resortNotOnSale',
  noTransport: 'noTransport',
  technicalError: 'technicalError',
  unableToMakeProposal: 'unableToMakeProposal',
  unavailableForBirthdates: 'ageIncorrectOrUnauthorized'
};
var BookingErrors = function BookingErrors(_ref) {
  var className = _ref.className,
      errorCode = _ref.errorCode;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_2__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet;

  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()({
      'arrow-upRight arrow-large arrow-lightSand arrow-bg arrow-bg-lightGrey md:border-t-1 md:relative': isTablet
    }, className),
    id: "Package-error"
  }, __jsx("div", {
    className: "md:max-w-1/2 md:py-25 m-auto text-red text-center text-20"
  }, errorCode && PROPOSAL_SEARCH_ERROR_MAPPING[errorCode] ? Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])("booking.accommodation.errorMessages.".concat(PROPOSAL_SEARCH_ERROR_MAPPING[errorCode])) : Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('booking.accommodation.errorMessageNoProposal')));
};

/***/ }),

/***/ "rJ95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createOptimisticAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");









function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function createAction(type, payload) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}

function createOptimisticAction(type, payload, meta) {
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}


/* harmony default export */ __webpack_exports__["b"] = (createAction);

/***/ }),

/***/ "raDx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = makePath;

function makePath(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var path = strings.reduce(function (str, next) {
    var value = values.shift();
    return str + (value == null ? '' : value) + next;
  });
  return path.replace(/^\./, '');
}

module.exports = exports["default"];

/***/ }),

/***/ "rcxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGE_BE_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAGE_BE_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_BE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAGE_BE_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAGE_BE_SERVICES_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_BE_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_BE_BANKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getBookingEngineUri; });
/* unused harmony export getBookingCriteriaOffsetSell */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getBookingCriteriaDepartureCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return checkIsDepartureDateAvailaible; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("U2CP");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("PIvV");
/* harmony import */ var _proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("oL6k");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");












function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}






var PAGE_BE_ACCOMMODATION = 'accommodation';
var PAGE_BE_TRANSPORT = 'transport';
var PAGE_BE_SERVICES = 'services';
var PAGE_BE_ACTIVITIES = 'activities';
var PAGE_BE_SERVICES_ALL_INCLUSIVE = 'allInclusive';
var PAGE_BE_PARTICIPANTS = 'participants';
var PAGE_BE_BANKING = 'banking';
function getBookingEngineUri() {
  var _getDefaultProposal;

  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PAGE_BE_ACCOMMODATION;
  var proposals = arguments.length > 1 ? arguments[1] : undefined;
  var resort = arguments.length > 2 ? arguments[2] : undefined;
  var selectedProposalId = arguments.length > 3 ? arguments[3] : undefined;
  var otherQueryParameters = arguments.length > 4 ? arguments[4] : undefined;
  var proposalIds = proposals.map(function (proposal) {
    return proposal.id;
  });

  var _selectedProposalId = selectedProposalId || ((_getDefaultProposal = Object(_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_14__[/* getDefaultProposal */ "e"])(proposals, resort)) === null || _getDefaultProposal === void 0 ? void 0 : _getDefaultProposal.id);

  var queryParams = _objectSpread(_objectSpread({}, otherQueryParameters), {}, {
    proposalIds: proposalIds,
    selectedProposalId: _selectedProposalId,
    coderesort: resort === null || resort === void 0 ? void 0 : resort.id
  });

  return _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_12__[/* buildUrl */ "a"]('booking', {
    page: page
  }, queryParams);
}
var getBookingCriteriaOffsetSell = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee(productId, appContext) {
    var getQuery, query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getQuery = function getQuery() {
              return "query {\n                  bookingCriteria(productId: \"".concat(productId, "\") {\n                    offsetSell\n                  }\n            }");
            };

            query = getQuery();
            return _context.abrupt("return", _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* CRITERIA_OFFSETSELL */ "i"]
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getBookingCriteriaOffsetSell(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getBookingCriteriaDepartureCities = /*#__PURE__*/function () {
  var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee2(productId, appContext) {
    var query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = "query {\n                  bookingCriteria(productId: \"".concat(productId, "\") {\n                      departureCities {\n                        value\n                        name\n                      }\n                  }\n            }");
            return _context2.abrupt("return", _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* CRITERIA_DEPARTURE_CITIES */ "h"]
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getBookingCriteriaDepartureCities(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}(); // check if the departureDate comes after today plus the offsetSell (in days), which is defined by the API

var checkIsDepartureDateAvailaible = function checkIsDepartureDateAvailaible(departureDate, offsetSell) {
  return moment__WEBPACK_IMPORTED_MODULE_11___default()(departureDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_11___default()().add(offsetSell, 'd'), 'day');
};

/***/ }),

/***/ "rokF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = inherits;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

function inherits(ctor, superCtor, spec) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  (0, _extends2.default)(ctor.prototype, spec);
}

module.exports = exports["default"];

/***/ }),

/***/ "rueY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchCalendarTripPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setPossibleDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setInitialDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setIsPriceCalendarSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setCalendarBlockInputDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearCalendar; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("uDfI");
/* harmony import */ var _calendar_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("VtPb");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("cvSI");
/* harmony import */ var _priceTicket_priceTicket_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("q/8t");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fflk");
/* harmony import */ var _trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Mn1B");
/* harmony import */ var _trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("6wD6");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("L73y");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("nv//");


















function fetchCalendar(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar, _state$calendar2, _state$calendar$calen, _state$calendar3;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.isLoading) && ((_state$calendar2 = state.calendar) === null || _state$calendar2 === void 0 ? void 0 : _state$calendar2.lastRequestId) !== -1;

    if (calendarRequestInProgress || JSON.stringify(options) === JSON.stringify((_state$calendar$calen = (_state$calendar3 = state.calendar) === null || _state$calendar3 === void 0 ? void 0 : _state$calendar3.calendarCriteria) !== null && _state$calendar$calen !== void 0 ? _state$calendar$calen : {})) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_ABORT */ "i"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR */ "h"], {
      departureCity: options.transport,
      productId: options.resortId,
      options: options
    }, {
      optimist: true,
      promise: Object(_calendar_helper__WEBPACK_IMPORTED_MODULE_7__[/* queryFetchCalendar */ "g"])(appContext, options)
    }));
  };
}
function fetchCalendarTripPrice(options) {
  return function (dispatch, getState) {
    var _state$calendar4, _state$calendar5;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar4 = state.calendar) === null || _state$calendar4 === void 0 ? void 0 : _state$calendar4.isLoading) && ((_state$calendar5 = state.calendar) === null || _state$calendar5 === void 0 ? void 0 : _state$calendar5.lastRequestId) !== -1;

    if (calendarRequestInProgress) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_TRIP_PRICE_ABORT */ "k"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_TRIP_PRICE */ "j"], {}, {
      optimist: true,
      promise: Object(_priceTicket_priceTicket_helper__WEBPACK_IMPORTED_MODULE_9__[/* fetchPrice */ "a"])(options)
    }));
  };
}
function fetchBookableDates(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar6, _state$calendar7, _state$calendar8, _state$calendar9;

    var state = getState();
    var bookableDateRequestInProgress = ((_state$calendar6 = state.calendar) === null || _state$calendar6 === void 0 ? void 0 : _state$calendar6.bookableDatesLoading) && ((_state$calendar7 = state.calendar) === null || _state$calendar7 === void 0 ? void 0 : _state$calendar7.bookableDateLastRequestId) !== -1;

    if (bookableDateRequestInProgress || options.departureCity === ((_state$calendar8 = state.calendar) === null || _state$calendar8 === void 0 ? void 0 : _state$calendar8.bookableDatesCriteria.departureCity) && options.productId === ((_state$calendar9 = state.calendar) === null || _state$calendar9 === void 0 ? void 0 : _state$calendar9.bookableDatesCriteria.productId)) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_BOOKABLE_DATES_ABORT */ "g"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_BOOKABLE_DATES */ "f"], {}, {
      optimist: true,
      promise: Object(_calendar_helper__WEBPACK_IMPORTED_MODULE_7__[/* queryFetchBookableDates */ "f"])(appContext, options)
    }));
  };
}
function selectMonth(selectedMonth) {
  // format YYYYMM (number)
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_CHANGE_MONTH */ "a"], {
    selectedMonth: selectedMonth
  });
}

function determineDepartureDate(state) {
  if (!Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state)) {
    var departureDateFromUrl = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_17__[/* getQueryParameters */ "k"])(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["windowWrapper"].getLocation()), _utils_uri_constants__WEBPACK_IMPORTED_MODULE_16__[/* QUERY_DEPARTURE_DATE */ "g"]);

    return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__[/* formatTimestampDate */ "b"])(departureDateFromUrl, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]) || Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state);
  }

  return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__[/* formatTimestampDate */ "b"])(Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state), _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]);
}

function setPossibleDepartureDate() {
  return function (dispatch, getState) {
    var findDayInMonths = function findDayInMonths() {
      var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var dayId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var id = parseInt(dayId, 10);
      var allDays = months.reduce(function (acc, m) {
        return [].concat(acc, m.days);
      }, []);
      return allDays.find(function (d) {
        return lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(d, 'dayContent.id') === id;
      });
    };

    var departureDate = determineDepartureDate(getState());

    if (departureDate) {
      var calendarMonth = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(getState(), 'calendar.calendar.months');

      var day = findDayInMonths(calendarMonth, departureDate);

      var dayContent = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(day, 'dayContent', null);

      if (dayContent) {
        if (lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(dayContent, 'canGoToBooking')) {
          var yearAndMonth = parseInt(dayContent.id / 100, 10);
          Object(react_redux__WEBPACK_IMPORTED_MODULE_6__[/* batch */ "b"])(function () {
            dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__[/* updateTripDateCriteria */ "a"])({
              day: dayContent
            })); // makes sure tripCriteria.departureDate in store is synchronised
            // TODO: merge tripDateCriteria into tripCriteria #12563

            dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__[/* setDepartureDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_5___default()("".concat(dayContent.id), _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]).valueOf()));
            dispatch(selectMonth(yearAndMonth));
          });
        } else {
          Object(react_redux__WEBPACK_IMPORTED_MODULE_6__[/* batch */ "b"])(function () {
            dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__[/* updateTripDateCriteria */ "a"])({
              day: null
            }));
            dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__[/* setDepartureDate */ "a"])(null));
          });
        }
      }
    }
  };
}
var setInitialDuration = function setInitialDuration(duration) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_INITIAL_DURATION */ "c"],
    payload: {
      duration: duration
    }
  };
};
var setIsPriceCalendarSelection = function setIsPriceCalendarSelection(isPriceCalendarSelection) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_IS_PRICE_CALENDAR_SELCTION */ "d"],
    payload: {
      isPriceCalendarSelection: isPriceCalendarSelection
    }
  };
};
var setCalendarBlockInputDepartureDate = function setCalendarBlockInputDepartureDate(blockInputDepartureDate) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE */ "b"],
    payload: {
      blockInputDepartureDate: blockInputDepartureDate
    }
  };
};
var clearCalendar = function clearCalendar() {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CLEAR_CALENDAR */ "e"]
  };
};

/***/ }),

/***/ "s+R0":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("JBn+"),
    arrayIncludes = __webpack_require__("OfKG"),
    arrayIncludesWith = __webpack_require__("sCL+"),
    cacheHas = __webpack_require__("S0iI"),
    createSet = __webpack_require__("9TP6"),
    setToArray = __webpack_require__("XlL0");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "sLNG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("uDfI");
/* harmony import */ var _tracking_tracking_pageload_TrackingPageLoad__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("TVUe");
/* harmony import */ var _components_widgets_booking_engine_form_BookingEngineForm_container__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("JSB9");









var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}







function DynamicPageLoadTracking(_ref) {
  var trackingData = _ref.trackingData; // $FlowFixMe

  return __jsx(_tracking_tracking_pageload_TrackingPageLoad__WEBPACK_IMPORTED_MODULE_12__[/* TrackingPageLoad */ "a"], trackingData);
}

function mapStateToProps(state, props) {
  var queryParams = props.queryParams,
      _props$trackingData = props.trackingData,
      trackingData = _props$trackingData === void 0 ? {} : _props$trackingData,
      _props$resort = props.resort,
      resort = _props$resort === void 0 ? {} : _props$resort;
  var _trackingData$isProdu = trackingData.isProductPage,
      isProductPage = _trackingData$isProdu === void 0 ? false : _trackingData$isProdu;

  if (!isProductPage) {
    return {
      trackingData: trackingData
    };
  }

  var _mapStateToPropsBooki = Object(_components_widgets_booking_engine_form_BookingEngineForm_container__WEBPACK_IMPORTED_MODULE_13__[/* mapStateToProps */ "b"])(state, _objectSpread(_objectSpread({}, trackingData), {}, {
    queryParams: queryParams,
    resort: resort
  })),
      adultsNumber = _mapStateToPropsBooki.adultsNumber,
      kids = _mapStateToPropsBooki.kids,
      duration = _mapStateToPropsBooki.duration;

  var kidsNumber = kids.length;
  delete trackingData.bookingCriteria;
  return {
    trackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
      resortAdult: adultsNumber,
      resortChildren: kidsNumber,
      resortNightNumber: duration,
      resortTotalParticipant: adultsNumber + kidsNumber
    })
  };
}

var ConnectedDynamicPageLoadTracking = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* connect */ "c"])(mapStateToProps)(DynamicPageLoadTracking);

var PageTrackingLine = function PageTrackingLine(props) {
  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_9__["useRouter"])(),
      queryParams = _useRouter.query;

  return __jsx(ConnectedDynamicPageLoadTracking, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])({}, props, {
    queryParams: queryParams
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (PageTrackingLine);

/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return MAX_PAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return MAX_PAX_SELLER; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHILDCARE_CRITERIA_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHILDCARE_FILTER_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return KIDS_NUMBER_MAX_SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SEASON_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return TOP_COUNTRIES_FACET_LIST_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FLIGHT_DURATION_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SORT_BY_PRICE_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PRODUCTS_TO_COMPARE_QUERY_PARAM; });
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CUSTOM_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GROUP_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHILDCARE_FILTER_FACET_OPTION_0_TO_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CHILDCARE_FILTER_FACET_OPTION_2_TO_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHILDCARE_FILTER_FACET_OPTION_4_TO_10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHILDCARE_FILTER_FACET_OPTION_11_TO_17; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHILDCARE_FILTER_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHILDCARE_FILTER_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHILDCARE_FILTER_FACET_AVERAGE_MONTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FLIGHT_DURATION_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FLIGHT_DURATION_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FLIGHT_DURATION_FACET_AS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SEASON_FACET_FIRST_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SEASON_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SEASON_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SEASON_FACET_QUERY_PARAM_FR_TO_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SEASON_FACET_QUERY_PARAM_EN_TO_FR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return TYPES_OF_STAY_FACET_BADGE_ICON_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return TYPES_OF_STAY_FACET_LABELS_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return TYPES_OF_STAY_FACET_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UCZK");
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");



var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var MAX_PAX = 6;
var MAX_PAX_SELLER = 8;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_CRITERIA_FACET_ID = 'facette_childcare_age_in_month';
var CHILDCARE_FILTER_FACET_ID = 'facette_childcare_age_in_month_list';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var KIDS_NUMBER_MAX_SELLER = 7;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var SEASON_FACET_ID = 'seasons_ns';
var TOP_COUNTRIES_FACET_LIST_ID = 'facet_list_top_destination_countries';
var TYPES_OF_STAY_FACET_ID = 'facette_types';
var FLIGHT_DURATION_FACET_ID = 'facette_flight_duration';
var QUERY_QUERY_PARAM = 'search';
var SORT_BY_PRICE_QUERY_PARAM = 'sortByPrice';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, CHILDCARE_FILTER_FACET_ID, COUNTRIES_FACET_ID, DESTINATIONS_FACET_ID, SEASON_FACET_ID, TYPES_OF_STAY_FACET_ID];
var CUSTOM_FACETS_IDS = [FLIGHT_DURATION_FACET_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  trackingPrefixLabel: 'childcare'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  trackingPrefixLabel: 'season'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}];
var GROUP_STRING = 'group::';
var CHILDCARE_FILTER_FACET_OPTION_0_TO_2 = "".concat(GROUP_STRING, "from_0_to_2");
var CHILDCARE_FILTER_FACET_OPTION_2_TO_3 = "".concat(GROUP_STRING, "from_2_to_3");
var CHILDCARE_FILTER_FACET_OPTION_4_TO_10 = "".concat(GROUP_STRING, "from_4_to_10");
var CHILDCARE_FILTER_FACET_OPTION_11_TO_17 = "".concat(GROUP_STRING, "from_11_to_17");
var CHILDCARE_FILTER_FACET_LABELS_PREFIX = 'faceting.filters.childcare.label_';
var CHILDCARE_FILTER_FACET_LABELS = {
  from_0_to_2: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "babyClub"),
  from_2_to_3: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "miniClub"),
  from_4_to_10: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "petitClub"),
  from_11_to_17: "".concat(CHILDCARE_FILTER_FACET_LABELS_PREFIX, "teenClub")
};
var CHILDCARE_FILTER_FACET_AVERAGE_MONTHS = {
  from_0_to_2: 12,
  from_2_to_3: 30,
  from_4_to_10: 84,
  from_11_to_17: 168
};
var FLIGHT_DURATION_FACET_LABELS_PREFIX = 'faceting.filters.flightDuration.label_';
var FLIGHT_DURATION_FACET_LABELS = {
  '2h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "2h"),
  '4h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "4h"),
  '8h': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h"),
  '8hmore': "".concat(FLIGHT_DURATION_FACET_LABELS_PREFIX, "8h_more")
};
var FLIGHT_DURATION_FACET_AS_LIST = {
  id: FLIGHT_DURATION_FACET_ID,
  name: FLIGHT_DURATION_FACET_ID,
  list: [{
    label: '2h',
    value: '2h',
    count: -1
  }, {
    label: '4h',
    value: '4h',
    count: -1
  }, {
    label: '8h',
    value: '8h',
    count: -1
  }, {
    label: '8hmore',
    value: '8hmore',
    count: -1
  }]
};
var SEASON_FACET_FIRST_OPTION = 'SOLEIL';
var SEASON_FACET_LABELS_PREFIX = 'faceting.filters.season.label_';
var SEASON_FACET_LABELS = {
  NEIGE: "".concat(SEASON_FACET_LABELS_PREFIX, "snow"),
  SOLEIL: "".concat(SEASON_FACET_LABELS_PREFIX, "sun")
};
var SEASON_FACET_QUERY_PARAM_FR_TO_EN = {
  NEIGE: 'SNOW',
  SOLEIL: 'SUN'
};
var SEASON_FACET_QUERY_PARAM_EN_TO_FR = {
  SNOW: 'NEIGE',
  SUN: 'SOLEIL'
};
var NON_LOCALIZED_TYPES_OF_STAY_FACET_RESORT_TYPES = ['CRUISE', 'JOYVIEW', 'TOUR'];
var TYPES_OF_STAY_FACET_BADGE_ICON_PROPS = {
  3: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SAFFRON,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SAFFRON,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLACK,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TRIDENT3,
    size: 40
  },
  4: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SAFFRON,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SAFFRON,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLACK,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TRIDENT4,
    size: 40
  },
  5: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].ULTRAMARINE,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].ULTRAMARINE,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].DIAMOND,
    size: 40
  },
  6: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].ULTRAMARINE,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].ULTRAMARINE,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TRIDENT6,
    size: 40
  },
  CRUISE: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SIENNA,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SIENNA,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].CRUISE,
    size: 40
  },
  JOYVIEW: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLUE_WAVE,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].BLUE_WAVE,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TRIDENT_JOYVIEW,
    size: 40
  },
  TOUR: {
    className: 'rounded-4',
    colorBg: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SIENNA,
    colorBorder: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].SIENNA,
    color: _client_components_utils_color_colors__WEBPACK_IMPORTED_MODULE_1__[/* COLORS */ "a"].WHITE,
    iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].TOUR,
    size: 40
  }
};
var TYPES_OF_STAY_FACET_LABELS_PREFIX = 'faceting.filters.typesOfStay.label_';
var TYPES_OF_STAY_FACET_LABELS = {
  3: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "3_tridents"),
  4: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "4_tridents"),
  5: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "exclusive_collection"),
  6: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "villa"),
  CRUISE: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "cruise"),
  JOYVIEW: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "joyview"),
  TOUR: "".concat(TYPES_OF_STAY_FACET_LABELS_PREFIX, "tour")
};
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.filters.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.filters.where.countriesTitle'
  }],
  titleLabel: 'faceting.filters.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  titleLabel: 'faceting.filters.activities.title'
}, {
  id: CHILDCARE_FILTER_FACET_ID,
  dataLabel: 'childcare',
  facetLists: [{
    deep: false,
    id: CHILDCARE_FILTER_FACET_ID,
    facetLabels: CHILDCARE_FILTER_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.childcare.title',
  trackingPrefixLabel: 'childcare'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: TYPES_OF_STAY_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FLIGHT_DURATION_FACET_ID,
  dataLabel: 'flightDuration',
  facetLists: [{
    deep: false,
    id: FLIGHT_DURATION_FACET_ID,
    facetLabels: FLIGHT_DURATION_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.flightDuration.title',
  trackingPrefixLabel: 'flightDuration'
}, {
  id: SEASON_FACET_ID,
  capitalizeLabels: true,
  dataLabel: 'season',
  facetLists: [{
    deep: false,
    id: SEASON_FACET_ID,
    facetLabels: SEASON_FACET_LABELS
  }],
  titleLabel: 'faceting.filters.season.title',
  trackingPrefixLabel: 'season'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "tI+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PACKAGE_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PACKAGE_ROOM_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CEFALU_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELUXE_COMFORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PACKAGE_FOOD_AND_BEVERAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMFORT_TYPE_SUITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMFORT_TYPE_CHALET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMFORT_TYPE_VILLA; });
var PACKAGE_ALL_INCLUSIVE = 'PAI';
var PACKAGE_ROOM_ONLY = 'RON';
var PACKAGE_FOOD_AND_BEVERAGE = 'FFB';
var CEFALU_RESORT = 'CFAC';
var DELUXE_COMFORT = 'Deluxe';
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var COMFORT_TYPE_SUITE = 'typeoflodging_comfort_type_suite';
var COMFORT_TYPE_CHALET = 'typeoflodging_comfort_type_chalet';
var COMFORT_TYPE_VILLA = 'typeoflodging_comfort_type_villa';


/***/ }),

/***/ "tNma":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.default = SchemaType;

var _extends2 = _interopRequireDefault(__webpack_require__("97Jx"));

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var _cloneDeepWith = _interopRequireDefault(__webpack_require__("NdXQ"));

var _toArray2 = _interopRequireDefault(__webpack_require__("Vk6K"));

var _locale = __webpack_require__("qr7w");

var _Condition = _interopRequireDefault(__webpack_require__("hCAA"));

var _runValidations = _interopRequireDefault(__webpack_require__("wM5X"));

var _prependDeep = _interopRequireDefault(__webpack_require__("n4a0"));

var _isSchema = _interopRequireDefault(__webpack_require__("kZEO"));

var _createValidation = _interopRequireDefault(__webpack_require__("JeoY"));

var _printValue = _interopRequireDefault(__webpack_require__("i0Sy"));

var _Reference = _interopRequireDefault(__webpack_require__("hLcx"));

var _reach = __webpack_require__("zBae");

var RefSet =
/*#__PURE__*/
function () {
  function RefSet() {
    this.list = new Set();
    this.refs = new Map();
  }

  var _proto = RefSet.prototype;

  _proto.toArray = function toArray() {
    return (0, _toArray2.default)(this.list).concat((0, _toArray2.default)(this.refs.values()));
  };

  _proto.add = function add(value) {
    _Reference.default.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  };

  _proto.delete = function _delete(value) {
    _Reference.default.isRef(value) ? this.refs.delete(value.key, value) : this.list.delete(value);
  };

  _proto.has = function has(value, resolve) {
    if (this.list.has(value)) return true;
    var item,
        values = this.refs.values();

    while (item = values.next(), !item.done) {
      if (resolve(item.value) === value) return true;
    }

    return false;
  };

  return RefSet;
}();

function SchemaType(options) {
  var _this = this;

  if (options === void 0) {
    options = {};
  }

  if (!(this instanceof SchemaType)) return new SchemaType();
  this._deps = [];
  this._conditions = [];
  this._options = {
    abortEarly: true,
    recursive: true
  };
  this._exclusive = Object.create(null);
  this._whitelist = new RefSet();
  this._blacklist = new RefSet();
  this.tests = [];
  this.transforms = [];
  this.withMutation(function () {
    _this.typeError(_locale.mixed.notType);
  });
  if ((0, _has.default)(options, 'default')) this._defaultDefault = options.default;
  this._type = options.type || 'mixed';
}

var proto = SchemaType.prototype = {
  __isYupSchema__: true,
  constructor: SchemaType,
  clone: function clone() {
    var _this2 = this;

    if (this._mutate) return this; // if the nested value is a schema we can skip cloning, since
    // they are already immutable

    return (0, _cloneDeepWith.default)(this, function (value) {
      if ((0, _isSchema.default)(value) && value !== _this2) return value;
    });
  },
  label: function label(_label) {
    var next = this.clone();
    next._label = _label;
    return next;
  },
  meta: function meta(obj) {
    if (arguments.length === 0) return this._meta;
    var next = this.clone();
    next._meta = (0, _extends2.default)(next._meta || {}, obj);
    return next;
  },
  withMutation: function withMutation(fn) {
    var before = this._mutate;
    this._mutate = true;
    var result = fn(this);
    this._mutate = before;
    return result;
  },
  concat: function concat(schema) {
    if (!schema || schema === this) return this;
    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + schema._type);
    var next = (0, _prependDeep.default)(schema.clone(), this); // new undefined default is overriden by old non-undefined one, revert

    if ((0, _has.default)(schema, '_default')) next._default = schema._default;
    next.tests = this.tests;
    next._exclusive = this._exclusive; // manually add the new tests to ensure
    // the deduping logic is consistent

    next.withMutation(function (next) {
      schema.tests.forEach(function (fn) {
        next.test(fn.OPTIONS);
      });
    });
    return next;
  },
  isType: function isType(v) {
    if (this._nullable && v === null) return true;
    return !this._typeCheck || this._typeCheck(v);
  },
  resolve: function resolve(options) {
    var schema = this;

    if (schema._conditions.length) {
      var conditions = schema._conditions;
      schema = schema.clone();
      schema._conditions = [];
      schema = conditions.reduce(function (schema, condition) {
        return condition.resolve(schema, options);
      }, schema);
      schema = schema.resolve(options);
    }

    return schema;
  },
  cast: function cast(value, options) {
    if (options === void 0) {
      options = {};
    }

    var resolvedSchema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));

    var result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      var formattedValue = (0, _printValue.default)(value);
      var formattedResult = (0, _printValue.default)(result);
      throw new TypeError("The value of " + (options.path || 'field') + " could not be cast to a value " + ("that satisfies the schema type: \"" + resolvedSchema._type + "\". \n\n") + ("attempted value: " + formattedValue + " \n") + (formattedResult !== formattedValue ? "result of cast: " + formattedResult : ''));
    }

    return result;
  },
  _cast: function _cast(rawValue) {
    var _this3 = this;

    var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
      return fn.call(_this3, value, rawValue);
    }, rawValue);

    if (value === undefined && (0, _has.default)(this, '_default')) {
      value = this.default();
    }

    return value;
  },
  _validate: function _validate(_value, options) {
    var _this4 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _value;
    var originalValue = options.originalValue != null ? options.originalValue : _value;

    var isStrict = this._option('strict', options);

    var endEarly = this._option('abortEarly', options);

    var sync = options.sync;
    var path = options.path;
    var label = this._label;

    if (!isStrict) {
      value = this._cast(value, (0, _extends2.default)({
        assert: false
      }, options));
    } // value is cast, we can check if it meets type requirements


    var validationParams = {
      value: value,
      path: path,
      schema: this,
      options: options,
      label: label,
      originalValue: originalValue,
      sync: sync
    };
    var initialTests = [];
    if (this._typeError) initialTests.push(this._typeError(validationParams));
    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
    return (0, _runValidations.default)({
      validations: initialTests,
      endEarly: endEarly,
      value: value,
      path: path,
      sync: sync
    }).then(function (value) {
      return (0, _runValidations.default)({
        path: path,
        sync: sync,
        value: value,
        endEarly: endEarly,
        validations: _this4.tests.map(function (fn) {
          return fn(validationParams);
        })
      });
    });
  },
  validate: function validate(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));
    return schema._validate(value, options);
  },
  validateSync: function validateSync(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve((0, _extends2.default)({}, options, {
      value: value
    }));
    var result, err;

    schema._validate(value, (0, _extends2.default)({}, options, {
      sync: true
    })).then(function (r) {
      return result = r;
    }).catch(function (e) {
      return err = e;
    });

    if (err) throw err;
    return result;
  },
  isValid: function isValid(value, options) {
    return this.validate(value, options).then(function () {
      return true;
    }).catch(function (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    });
  },
  isValidSync: function isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    }
  },
  getDefault: function getDefault(options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    return schema.default();
  },
  default: function _default(def) {
    if (arguments.length === 0) {
      var defaultValue = (0, _has.default)(this, '_default') ? this._default : this._defaultDefault;
      return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, _cloneDeepWith.default)(defaultValue);
    }

    var next = this.clone();
    next._default = def;
    return next;
  },
  strict: function strict(isStrict) {
    if (isStrict === void 0) {
      isStrict = true;
    }

    var next = this.clone();
    next._options.strict = isStrict;
    return next;
  },
  _isPresent: function _isPresent(value) {
    return value != null;
  },
  required: function required(message) {
    if (message === void 0) {
      message = _locale.mixed.required;
    }

    return this.test({
      message: message,
      name: 'required',
      exclusive: true,
      test: function test(value) {
        return this.schema._isPresent(value);
      }
    });
  },
  notRequired: function notRequired() {
    var next = this.clone();
    next.tests = next.tests.filter(function (test) {
      return test.OPTIONS.name !== 'required';
    });
    return next;
  },
  nullable: function nullable(isNullable) {
    if (isNullable === void 0) {
      isNullable = true;
    }

    var next = this.clone();
    next._nullable = isNullable;
    return next;
  },
  transform: function transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  },

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test: function test() {
    var opts;

    if (arguments.length === 1) {
      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
        opts = {
          test: arguments.length <= 0 ? undefined : arguments[0]
        };
      } else {
        opts = arguments.length <= 0 ? undefined : arguments[0];
      }
    } else if (arguments.length === 2) {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        test: arguments.length <= 1 ? undefined : arguments[1]
      };
    } else {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        message: arguments.length <= 1 ? undefined : arguments[1],
        test: arguments.length <= 2 ? undefined : arguments[2]
      };
    }

    if (opts.message === undefined) opts.message = _locale.mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    var next = this.clone();
    var validate = (0, _createValidation.default)(opts);
    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;

    if (opts.exclusive && !opts.name) {
      throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    next._exclusive[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(function (fn) {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  },
  when: function when(keys, options) {
    if (arguments.length === 1) {
      options = keys;
      keys = '.';
    }

    var next = this.clone(),
        deps = [].concat(keys).map(function (key) {
      return new _Reference.default(key);
    });
    deps.forEach(function (dep) {
      if (dep.isSibling) next._deps.push(dep.key);
    });

    next._conditions.push(new _Condition.default(deps, options));

    return next;
  },
  typeError: function typeError(message) {
    var next = this.clone();
    next._typeError = (0, _createValidation.default)({
      message: message,
      name: 'typeError',
      test: function test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }
    });
    return next;
  },
  oneOf: function oneOf(enums, message) {
    if (message === void 0) {
      message = _locale.mixed.oneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = (0, _createValidation.default)({
      message: message,
      name: 'oneOf',
      test: function test(value) {
        if (value === undefined) return true;
        var valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }
    });
    return next;
  },
  notOneOf: function notOneOf(enums, message) {
    if (message === void 0) {
      message = _locale.mixed.notOneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = (0, _createValidation.default)({
      message: message,
      name: 'notOneOf',
      test: function test(value) {
        var invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }
    });
    return next;
  },
  strip: function strip(_strip) {
    if (_strip === void 0) {
      _strip = true;
    }

    var next = this.clone();
    next._strip = _strip;
    return next;
  },
  _option: function _option(key, overrides) {
    return (0, _has.default)(overrides, key) ? overrides[key] : this._options[key];
  },
  describe: function describe() {
    var next = this.clone();
    return {
      type: next._type,
      meta: next._meta,
      label: next._label,
      tests: next.tests.map(function (fn) {
        return {
          name: fn.OPTIONS.name,
          params: fn.OPTIONS.params
        };
      }).filter(function (n, idx, list) {
        return list.findIndex(function (c) {
          return c.name === n.name;
        }) === idx;
      })
    };
  }
};
var _arr = ['validate', 'validateSync'];

var _loop = function _loop() {
  var method = _arr[_i];

  proto[method + "At"] = function (path, value, options) {
    if (options === void 0) {
      options = {};
    }

    var _getIn = (0, _reach.getIn)(this, path, value, options.context),
        parent = _getIn.parent,
        parentPath = _getIn.parentPath,
        schema = _getIn.schema;

    return schema[method](parent && parent[parentPath], (0, _extends2.default)({}, options, {
      parent: parent,
      path: path
    }));
  };
};

for (var _i = 0; _i < _arr.length; _i++) {
  _loop();
}

var _arr2 = ['equals', 'is'];

for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
  var alias = _arr2[_i2];
  proto[alias] = proto.oneOf;
}

var _arr3 = ['not', 'nope'];

for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
  var _alias = _arr3[_i3];
  proto[_alias] = proto.notOneOf;
}

proto.optional = proto.notRequired;
module.exports = exports["default"];

/***/ }),

/***/ "tPlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParticipantsErrors; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DwNm");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var ParticipantsErrors = function ParticipantsErrors(_ref) {
  var className = _ref.className,
      config = _ref.config,
      errors = _ref.errors,
      isSubmitted = _ref.isSubmitted;
  var maxPax = errors.maxPax,
      departureDate = errors.departureDate,
      birthdays = errors.birthdays,
      birthdaysErrorMessage = errors.birthdaysErrorMessage;

  if (maxPax) {
    return __jsx(_components_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__[/* FormFeedback */ "a"], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: config.errorMaxGuestsLabel
    });
  }

  if (isSubmitted && departureDate) {
    return __jsx(_components_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__[/* FormFeedback */ "a"], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: config.departureDateErrorMessage
    });
  }

  if (isSubmitted && birthdays) {
    return __jsx(_components_frameworks_form_feedback_FormFeedback__WEBPACK_IMPORTED_MODULE_1__[/* FormFeedback */ "a"], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: birthdaysErrorMessage
    });
  }

  return null;
};

/***/ }),

/***/ "tX1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return camelToSnakeCase; });
/* unused harmony export getValidString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return titleCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelCasify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return upperCaseLetterToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return snakeToCamel; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("uqXc");
/* harmony import */ var core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("SYor");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("nDih");
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_8__);










function getValidString(str) {
  return lodash_isString__WEBPACK_IMPORTED_MODULE_8___default()(str) ? str.trim() : '';
}

function truncate(str, characters) {
  var preserveWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var strTrimed = getValidString(str);

  if (!characters) {
    return strTrimed;
  }

  if (characters < 0) {
    return '';
  }

  if (strTrimed.length > characters) {
    var length = preserveWords ? strTrimed.lastIndexOf(' ', characters) : characters;
    return strTrimed.substring(0, length) + '…';
  }

  return strTrimed;
}

function titleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function camelCasify(text) {
  return text.split(' ').map(function (word, i) {
    if (i > 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    return word.toLowerCase();
  }).join('');
}

var upperCaseLetterToInt = function upperCaseLetterToInt(letter) {
  return letter.charCodeAt(0) - 64;
};

function snakeToCamel(s) {
  return s.replace(/(_\w)/g, function (match) {
    return match.toUpperCase().substr(1);
  });
}

var camelToSnakeCase = function camelToSnakeCase(str) {
  return str ? str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  }) : '';
};



/***/ }),

/***/ "ttFy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("Km8e");

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {}

var validateFormat = function validateFormat(format) {};

if (false) {}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) { var printWarning; }

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {}
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {}
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {}
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {}
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) { var isMixinValid, typeofSpec; }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {}
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) { var _bind, componentName; }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {}
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {}

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {}
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {}

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {}

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ "tuzA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRateMessagesProperties; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var FLEX_RATES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["constants"].FLEX_RATES;
var getRateMessagesProperties = function getRateMessagesProperties(rate) {
  switch (rate) {
    case FLEX_RATES.NRR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.nonRefundableRateLegal')
      };

    case FLEX_RATES.FLR:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.flexibleRateLegal')
      };

    default:
      return {
        rateTitle: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLabel'),
        rateContent: Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.accommodation.packageContent.standardLegal')
      };
  }
};

/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uL19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCustomerSearchResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterProposalBySamePackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAdditionalTransportsError; });
/* unused harmony export getAllChildcaresByProductInfoId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCityTransportsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getIsLoadingAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getFilteredAccommodationsAlternativesByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getIsLoadingFilteredAccommodationsAlternativesByComfort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getIsLoadingAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAdditionalAccommodationsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdditionalAccommodationsPmrChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAdditionalAccommodationsError; });
/* unused harmony export getFilteredAdditionalAccommodations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getFilteredAdditionalAccommodationsSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getSearchCriteriaTransports; });
/* unused harmony export getSearchCriteriaTransportsInbound */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getReservedServicesByAttendee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getSelectedProposalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getCurrentResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getPaymentProviders; });
/* unused harmony export getProposalsWithMappedAttendees */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCurrentProposal; });
/* unused harmony export getCurrentTotalPrice */
/* unused harmony export getProposalHasAnyEquipmentForRent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getDetailedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getConnectedUserInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return proposalsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getInsurancesStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getStreetViews; });
/* unused harmony export getTransportAxes */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("x0AG");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ToJy");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("T63A");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("B6y2");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("uZih");
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("oL6k");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("apzf");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Jsmy");
/* harmony import */ var _attendees_attendees_selector__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("eZ08");




















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}







var bookingSelector = function bookingSelector(_ref) {
  var booking = _ref.booking;
  return booking || {};
};

var additionalTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref2) {
  var additionalTransports = _ref2.additionalTransports;
  return additionalTransports || {};
});
var getCityTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref3) {
  var additionalTransports = _ref3.additionalTransports;
  return additionalTransports.transports.cityTransports || {};
});
var getPaymentProviders = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref4) {
  var paymentProviders = _ref4.paymentProviders;
  return paymentProviders;
});
var getInsurancesStore = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref5) {
  var insurance = _ref5.insurance;
  return insurance;
});
var getSearchCriteriaTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref6) {
  var searchCriteria = _ref6.searchCriteria;
  return searchCriteria;
});
var getSearchCriteriaTransportsInbound = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref7) {
  var searchCriteria = _ref7.searchCriteria;
  return searchCriteria && searchCriteria[0];
});
var getAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref8) {
  var transports = _ref8.transports;
  return transports;
});
var getAdditionalTransportsError = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref9) {
  var error = _ref9.error;
  return error;
});
var getIsLoadingAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalTransportsSelector, function (_ref10) {
  var isLoading = _ref10.isLoading;
  return isLoading;
});
var additionalAccommodationsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref11) {
  var additionalAccommodations = _ref11.additionalAccommodations;
  return additionalAccommodations || {};
});
var getIsLoadingAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref12) {
  var isLoading = _ref12.isLoading;
  return isLoading;
});
var getIsLoadingFilteredAccommodationsAlternativesByComfort = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref13) {
  var isLoadingFilteredAccommodationsAlternativesByComfort = _ref13.isLoadingFilteredAccommodationsAlternativesByComfort;
  return isLoadingFilteredAccommodationsAlternativesByComfort;
});
var getAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref14) {
  var accommodationsSets = _ref14.accommodationsSets;
  return accommodationsSets;
});
var getAdditionalAccommodationsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref15) {
  var filters = _ref15.filters;
  return filters;
});
var getAdditionalAccommodationsPmrChecked = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref16) {
  var isPmrChecked = _ref16.isPmrChecked;
  return isPmrChecked;
});
var getAdditionalAccommodationsError = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref17) {
  var error = _ref17.error;
  return error;
});
var getFilteredAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref18) {
  var filteredAccommodations = _ref18.filteredAccommodations;
  return filteredAccommodations;
});
var getFilteredAdditionalAccommodationsSets = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getFilteredAdditionalAccommodations, getAdditionalAccommodations, function (filteredAccommodations, additionalAccommodations) {
  return filteredAccommodations && filteredAccommodations.length > 0 ? filteredAccommodations : additionalAccommodations;
});
var getFilteredAccommodationsAlternativesByComfort = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(additionalAccommodationsSelector, function (_ref19) {
  var filteredAccommodationsAlternativesByComfort = _ref19.filteredAccommodationsAlternativesByComfort;
  return filteredAccommodationsAlternativesByComfort;
});
var proposalsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref20) {
  var proposals = _ref20.proposals;
  return proposals || [];
});
var getCurrentResort = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref21) {
  var resort = _ref21.resort;
  return resort;
});

var findAttendeeByNeolid = function findAttendeeByNeolid(attendees, neolid) {
  return attendees.find(function (attendee) {
    return attendee.neolid === neolid;
  });
};

var getSelectedProposalId = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref22) {
  var selectedProposalId = _ref22.selectedProposalId;
  return selectedProposalId;
});
/**
 * It should be getSelectedProposal but there is a selector getSelectedProposal
 * witch get the proposal from paymentInfoSelector
 * I do not know why...
 */

var getCurrentProposal = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref23) {
  var proposals = _ref23.proposals,
      selectedProposalId = _ref23.selectedProposalId;
  return (
    /**
     * return the selected proposal if found,
     * if not (for any reason) the default proposal for keeping the return shape value consistent
     */
    proposals.find(function (proposal) {
      return proposal.id === selectedProposalId;
    }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* getDefaultProposal */ "e"])(proposals)
  );
});
var getAllChildcaresByProductInfoId = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getCurrentProposal, function (state, productInfoId) {
  return productInfoId;
}, function (_ref24, productInfoId) {
  var additionalServices = _ref24.additionalServices;
  return additionalServices.childcares.filter(function (_ref25) {
    var id = _ref25.pricingInfo.id;
    return id === productInfoId;
  });
});
var getCurrentTotalPrice = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getCurrentProposal, function (proposal) {
  return proposal.price.total.value;
});

var filterProposalBySamePackage = function filterProposalBySamePackage(proposals, selectedProposal) {
  var errorsProposals = proposals.filter(function (proposal) {
    return proposal.errorCode;
  });

  if (errorsProposals.length) {
    return errorsProposals;
  }

  return proposals.filter(function (item) {
    var _item$accommodations = item.accommodations,
        accommodations = _item$accommodations === void 0 ? [] : _item$accommodations,
        packageId = item.packageId;
    return accommodations.length && packageId === selectedProposal.packageId;
  });
};

var getProposals = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(proposalsSelector, getCurrentProposal, filterProposalBySamePackage);
var getProposalsWithMappedAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getProposals, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__[/* tripInformationSelector */ "d"], function (proposals, tripInformation) {
  if (!proposals) {
    return proposals;
  }

  return proposals.map(function (proposal) {
    return _objectSpread(_objectSpread({}, proposal), {}, {
      attendees: _objectSpread(_objectSpread({}, proposal.attendees), {}, {
        list: proposal.attendees.list.map(function (attendee) {
          // if there is a birthdate it's a children otherwise it's an adult
          var attendeeData = attendee.birthdate ? findAttendeeByNeolid(tripInformation.kids, attendee.customerId) : findAttendeeByNeolid(tripInformation.adults, attendee.customerId);

          if (!attendeeData) {
            return attendee;
          }

          return _objectSpread(_objectSpread({}, attendee), {}, {
            firstName: attendeeData.firstName,
            lastName: attendeeData.lastName
          });
        })
      })
    });
  });
});
var getProposalHasAnyEquipmentForRent = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref26) {
  var rentalEquipments = _ref26.rentalEquipments;
  return rentalEquipments.hasAnyEquipmentForRent;
});
var getConnectedUserInfoSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_21__[/* userInfoSelector */ "a"], function (connectedUserInfo) {
  return connectedUserInfo.isQuickLoggedIn ? {} : lodash_omit__WEBPACK_IMPORTED_MODULE_18___default()(_objectSpread(_objectSpread({}, connectedUserInfo), {}, {
    birthdate: connectedUserInfo.dateOfBirth,
    neolid: connectedUserInfo.neolaneId,
    // harmonize the neolid between user and seller
    mobile: connectedUserInfo.mobilePhoneNumber
  }), ['dateOfBirth', 'GMNumber', 'homePhoneNumber', 'isProspect', 'neolaneId', 'unicodeCivility', 'expirationDate', 'mobilePhoneNumber']);
});
var getStreetViews = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref27) {
  var streetViews = _ref27.streetViews;
  return streetViews;
});
var getSuggestions = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref28) {
  var suggestions = _ref28.suggestions;
  return suggestions;
});
var getCustomerSearchResult = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (booking) {
  return booking.customerSearch;
});
var getReservedServicesByAttendee = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(getCurrentProposal, function (state) {
  return Object(_attendees_attendees_selector__WEBPACK_IMPORTED_MODULE_23__[/* selectAttendeesWithInfosByHouseholds */ "c"])(state).attendees;
}, function (_ref29, attendeesWithInfos) {
  var additionalServices = _ref29.additionalServices; // defensive code if store is not available (ex: confirmation page)

  if (!additionalServices || !attendeesWithInfos) {
    return [];
  }

  var attendeesWithServiceRented = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(additionalServices.activities), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(additionalServices.rentals)).reduce(function (acc, service) {
    var pricingInfo = service.pricingInfo,
        productInfo = service.productInfo;
    pricingInfo.attendees.forEach(function (attendee) {
      var product = {
        price: attendee.rentedAmount.value,
        services: [service]
      };

      if (attendee.rentedAmount.value > 0) {
        if (!acc[attendee.id]) {
          acc[attendee.id] = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])({}, productInfo.id, _objectSpread({}, product));
        } else if (!acc[attendee.id][productInfo.id]) {
          acc[attendee.id][productInfo.id] = _objectSpread({}, product);
        } else {
          acc[attendee.id][productInfo.id].services.push(service);
        }
      }
    });
    return acc;
  }, {});
  return Object.entries(attendeesWithServiceRented).reduce(function (reservedServicesByAttendee, _ref30) {
    var _ref31 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_ref30, 2),
        id = _ref31[0],
        rentedServices = _ref31[1];

    var childIndex = attendeesWithInfos.children.findIndex(function (attendee) {
      return attendee.id === id;
    });

    if (childIndex > -1) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.children[childIndex]), {}, {
        id: id,
        index: childIndex + 1,
        isAdult: false,
        // $FlowFixMe 🤷‍️
        rentedServices: Object.values(rentedServices)
      })]);
    }

    var adultIndex = attendeesWithInfos.adults.findIndex(function (attendee) {
      return attendee.id === id;
    });
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.adults[adultIndex]), {}, {
      id: id,
      index: adultIndex + 1,
      isAdult: true,
      // $FlowFixMe 🤷‍️
      rentedServices: Object.values(rentedServices)
    })]);
  }, []).sort(function (a, b) {
    if (a.isAdult && !b.isAdult) {
      return -1;
    }

    if (!a.isAdult && b.isAdult) {
      return 1;
    }

    return a.index - b.index;
  });
});

var getDetailedAttendees = function getDetailedAttendees(_ref32) {
  var booking = _ref32.booking;
  return booking.attendees;
};

var getTransportAxes = Object(reselect__WEBPACK_IMPORTED_MODULE_19__["createSelector"])(bookingSelector, function (_ref33) {
  var additionalTransports = _ref33.additionalTransports;
  return additionalTransports.transportAxes;
});


/***/ }),

/***/ "uMuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayPriceDoubleSeasonPopin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QWBl");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5DmW");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("27RR");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("tkto");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("rB9j");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("UxlC");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("EnZy");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("FZtP");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("fGyu");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("05v4");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("e0Ti");
/* harmony import */ var _product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("hA0C");
















var __jsx = react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */








var DayPriceDoubleSeasonPopin = function DayPriceDoubleSeasonPopin(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey,
      trackingData = _ref.trackingData;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_19__[/* useTracking */ "a"])();
  var router = Object(next_router__WEBPACK_IMPORTED_MODULE_16__["useRouter"])();
  var uri = router.asPath;
  var doubleSeasonPopinMessageKey = "booking.priceCalendar.priceStatus.".concat(availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 'siblingDescriptionSummer' : 'siblingDescriptionWinter');
  var productCountry = product.destination.country,
      _product$href = product.href,
      href = _product$href === void 0 ? '' : _product$href,
      productName = product.name,
      iconName = product.resortId;
  var splittedHref = href.split('/');
  var siblingHref = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(splittedHref.slice(0, splittedHref.length - 1)), [availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_20__[/* API_SIBLING_SUMMER */ "h"] ? 's' : 'w']).join('/');

  var handleBlur = function handleBlur() {
    if (setIsMouseOverDoubleSeasonPopin) {
      setTimeout(function () {
        setIsMouseOverDoubleSeasonPopin(false);
      }, 200);
    }

    setInvisible && setInvisible();
  };

  var handleFocus = function handleFocus() {
    return setIsMouseOverDoubleSeasonPopin && setIsMouseOverDoubleSeasonPopin(true);
  };

  return __jsx("div", {
    className: "bg-white cursor-default flex flex-col gap-20 items-center justify-center p-30 pointer-events-auto",
    onBlur: handleBlur,
    onFocus: handleFocus,
    onKeyDown: function onKeyDown(e) {
      e.preventDefault();
      e.stopPropagation();

      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_21__[/* ENTER */ "f"]) {
        router.push(uri.replace(href, siblingHref));
      } else {
        handleBlur();
      }
    },
    onMouseOver: handleFocus,
    onMouseLeave: handleBlur,
    tabIndex: -1
  }, __jsx("div", {
    className: "flex flex-col gap-10 items-center justify-center"
  }, __jsx(_product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__[/* ProductLogo */ "a"], {
    iconName: iconName,
    productCountry: productCountry,
    productName: productName,
    theme: "calendar"
  }), __jsx("p", {
    className: "bg-turquoise font-bold px-10 py-5 rounded-4 text-12 text-white"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(statusMessageKey))), __jsx("p", {
    className: "leading-tight sm:leading-normal text-14 text-black text-center"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])(doubleSeasonPopinMessageKey)), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__[/* Button */ "a"], {
    className: "pointer-events-auto w-full",
    dataTestId: "DayWithPrice-DoubleSeasonPopin-seeOtherSeason",
    onBlur: handleBlur,
    onClick: function onClick(e) {
      track(_objectSpread({
        categoryGA: 'resort',
        labelGA: 'switchSeason'
      }, trackingData));
      e.preventDefault();
      e.stopPropagation();
      router.push(uri.replace(href, siblingHref));
    },
    onFocus: handleFocus,
    size: "medium",
    tabIndex: 0
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('booking.priceCalendar.priceStatus.siblingButton')));
};

/***/ }),

/***/ "uqXc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var lastIndexOf = __webpack_require__("5Yz+");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "vIa8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ activeCustomFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ activeFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ bannersSelector; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ customFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ facetingCriteriaSelector; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ facetsSelector; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ filteredProductsSelector; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ productsBeforeActiveCustomFacetsFilteringSelector; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ recommandedProductsSelector; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ filteredProductsCountSelector; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ filteredProductsSeasonsSelector; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ filtersSelector; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getFacetingProductIds; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ getSearchFilterList; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getKidsValidationState; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ searchQuerySelector; });

// UNUSED EXPORTS: facetingSelector, facetingPricesSelector, productsFilteredWithActiveCustomFacetsSelector

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("ma9I");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("yq1k");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("2B1R");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("E9XD");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("T63A");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("tkto");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("JTJg");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("TeQF");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("fbCW");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("rB9j");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("EnZy");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__("nnRT");
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqWith.js
var uniqWith = __webpack_require__("SqqE");
var uniqWith_default = /*#__PURE__*/__webpack_require__.n(uniqWith);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/inRange.js
var inRange = __webpack_require__("+ILc");
var inRange_default = /*#__PURE__*/__webpack_require__.n(inRange);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/includes.js
var includes = __webpack_require__("qYhz");
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/utils/faceting/facetingFilters.js


















var facetingFilters_FacetFilters = /*#__PURE__*/function () {
  function FacetFilters(list) {
    Object(classCallCheck["a" /* default */])(this, FacetFilters);

    Object(defineProperty["a" /* default */])(this, "_list", void 0);

    this._list = list || [];
  }

  Object(createClass["a" /* default */])(FacetFilters, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this._list.push({
        id: filter.id,
        name: filter.name
      });

      return this;
    }
  }, {
    key: "addFilters",
    value: function addFilters(filters) {
      if (filters) {
        filters.map(this.addFilter.bind(this));
      }

      return this;
    }
  }, {
    key: "removeFilters",
    value: function removeFilters(ids) {
      this._list = this._list.filter(function (item) {
        return !includes_default()(ids, item.id);
      });
      return this;
    }
  }, {
    key: "addChildcareFilters",
    value: function addChildcareFilters(args) {
      var kids = args.kids,
          _args$childcareFacets = args.childcareFacets,
          facets = _args$childcareFacets === void 0 ? [] : _args$childcareFacets,
          departureDate = args.departureDate;
      var childcareFacets = isEmpty_default()(facets) ? constants["p" /* DEFAULT_CHILDCARE_FACETS */].map(function (f) {
        return {
          label: f,
          value: f
        };
      }) : facets;
      var childcareRanges = childcareFacets.map(function (_ref) {
        var name = _ref.label;
        var facetRange = name.split('-');
        return {
          name: name,
          min: parseInt(facetRange[0], 10),
          max: parseInt(facetRange[1], 10)
        };
      });
      var childcareFilters = kids.filter(function (_ref2) {
        var childcareIncluded = _ref2.childcareIncluded;
        return childcareIncluded;
      }).map(function (_ref3) {
        var birthdate = _ref3.birthdate;
        var kidAgeInMonths = Object(facetingUtils["k" /* getKidAgeInMonths */])({
          birthdate: birthdate,
          departureDate: departureDate
        });
        var matchingFacet = childcareRanges.find(function (_ref4) {
          var min = _ref4.min,
              max = _ref4.max;
          return inRange_default()(kidAgeInMonths, min, max + 1);
        }); // lodash inRange exludes the max value

        if (!matchingFacet || !matchingFacet.name) {
          return null;
        }

        return {
          id: constants["d" /* CHILDCARE_CRITERIA_FACET_ID */],
          name: matchingFacet.name
        };
      }).filter(Boolean);
      this._list = this._list.concat(uniqWith_default()(childcareFilters, isEqual_default.a));
      return this;
    }
  }, {
    key: "addAdultOnlyFilter",
    value: function addAdultOnlyFilter() {
      var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return isEmpty_default()(kids) ? this : this.addFilter({
        id: constants["c" /* ADULTS_ONLY_FACET_ID */],
        name: false
      });
    }
  }, {
    key: "value",
    value: function value() {
      return this._list.map(function (item) {
        return pick_default()(item, ['id', 'name']);
      });
    }
  }]);

  return FacetFilters;
}();
// CONCATENATED MODULE: ./src/client/store/faceting/faceting.selector.js









/* eslint-disable max-params */








var facetingSelector = function facetingSelector(_ref) {
  var faceting = _ref.faceting;
  return faceting || {};
};

var activeCustomFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref2) {
  var activeCustomFacets = _ref2.activeCustomFacets;
  return activeCustomFacets || {};
});
var activeFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref3) {
  var activeFacets = _ref3.activeFacets;
  return activeFacets || {};
});
var searchQuerySelector = Object(lib["createSelector"])(facetingSelector, function (_ref4) {
  var query = _ref4.query;
  return query || {
    label: ''
  };
});
var facetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref5) {
  var facets = _ref5.facets;
  return facets || [];
});
var customFiltersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref6) {
  var customFilters = _ref6.customFilters;
  return customFilters || [];
});
var filtersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref7) {
  var filters = _ref7.filters;
  return filters || [];
});
var facetingPricesSelector = Object(lib["createSelector"])(facetingSelector, function (_ref8) {
  var prices = _ref8.prices;
  return prices;
});
var filteredProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref9) {
  var _ref9$products = _ref9.products,
      products = _ref9$products === void 0 ? [] : _ref9$products;
  return products;
});
var productsBeforeActiveCustomFacetsFilteringSelector = Object(lib["createSelector"])(facetingSelector, function (_ref10) {
  var _ref10$productsBefore = _ref10.productsBeforeActiveCustomFacetsFiltering,
      productsBeforeActiveCustomFacetsFiltering = _ref10$productsBefore === void 0 ? null : _ref10$productsBefore;
  return productsBeforeActiveCustomFacetsFiltering;
});
var productsFilteredWithActiveCustomFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref11) {
  var _ref11$productsFilter = _ref11.productsFilteredWithActiveCustomFacets,
      productsFilteredWithActiveCustomFacets = _ref11$productsFilter === void 0 ? null : _ref11$productsFilter;
  return productsFilteredWithActiveCustomFacets;
});
var recommandedProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref12) {
  var _ref12$recommandedPro = _ref12.recommandedProducts,
      recommandedProducts = _ref12$recommandedPro === void 0 ? [] : _ref12$recommandedPro;
  return recommandedProducts;
});
var bannersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref13) {
  var banners = _ref13.banners;
  return banners || [];
});
var filteredProductsCountSelector = Object(lib["createSelector"])(facetingSelector, function (_ref14) {
  var _ref14$products = _ref14.products,
      products = _ref14$products === void 0 ? [] : _ref14$products;
  return products.length;
});
var filteredProductsSeasonsSelector = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.reduce(function (seasons, product) {
    return seasons.includes(product.seasonName) ? seasons : [].concat(Object(toConsumableArray["a" /* default */])(seasons), [product.seasonName]);
  }, []);
});
var getFacetingProductIds = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.map(function (_ref15) {
    var id = _ref15.id;
    return id;
  });
});
var getKidsValidationState = Object(lib["createSelector"])(facetingSelector, function (_ref16) {
  var _ref16$kidsValidation = _ref16.kidsValidationState,
      kidsValidationState = _ref16$kidsValidation === void 0 ? [] : _ref16$kidsValidation;
  return kidsValidationState;
});
var getSearchFilterList = Object(lib["createSelector"])(facetingSelector, function (_ref17) {
  var _ref17$searchFilterLi = _ref17.searchFilterList,
      searchFilterList = _ref17$searchFilterLi === void 0 ? [] : _ref17$searchFilterLi;
  return searchFilterList;
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * representing active facets to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var activeFacetsCriteriaSelector = Object(lib["createSelector"])(activeFacetsSelector, function (activeFacets) {
  return Object.keys(activeFacets).reduce(function (acc, categoryId) {
    Object.entries(activeFacets[categoryId]).map(function (_ref18) {
      var _ref19 = Object(slicedToArray["a" /* default */])(_ref18, 2),
          filter = _ref19[0],
          isSelected = _ref19[1];

      if (isSelected) {
        acc.push({
          id: categoryId,
          name: filter
        });
      }
    });
    return acc;
  }, []);
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * containing aggregation of both facets and criterias to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'facette_adult_only', name: false },
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var getFiltersSelector = Object(lib["createSelector"])(storeHelper["c" /* getKids */], tripCriteria_selector["b" /* getDepartureDate */], activeFacetsCriteriaSelector, filtersSelector, tripCriteria_selector["a" /* getDepartureCity */], facetsSelector, function (kids, departureDate, activeFacets, filters, departureCity, facets) {
  var allFilters = new facetingFilters_FacetFilters(filters).removeFilters([constants["a" /* ACTIVITIES_FACET_ID */], constants["c" /* ADULTS_ONLY_FACET_ID */], constants["d" /* CHILDCARE_CRITERIA_FACET_ID */], constants["r" /* DEPARTURE_CITY_FACET_ID */]].concat(Object(toConsumableArray["a" /* default */])(constants["y" /* FILTERABLE_FACETS_IDS */]))).addAdultOnlyFilter(kids).addChildcareFilters({
    kids: kids,
    childcareFacets: Object(facetingUtils["g" /* getChildcareFacets */])(facets),
    departureDate: departureDate
  }).addFilters(activeFacets);

  if (departureCity) {
    allFilters.addFilter({
      id: constants["r" /* DEPARTURE_CITY_FACET_ID */],
      name: departureCity
    });
  }

  return allFilters.value();
});
/**
 * Returns an object with an aggregation of criterias for Pertimm:
 *
 * Example:
 * ```json
 * {
 *    departureDate: '',
 *    tripDuration: '7',
 *    filters: [
 *      { id: 'facette_departure_city',  name: 'PAR' },
 *      { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 *    ]
 * }
 * ```
 */

var facetingCriteriaSelector = Object(lib["createSelector"])([tripCriteria_selector["b" /* getDepartureDate */], tripCriteria_selector["c" /* getTripDuration */], getFiltersSelector, storeHelper["c" /* getKids */]], function (departureDate, tripDuration, filters, kids) {
  return {
    departureDate: departureDate,
    tripDuration: tripDuration,
    filters: filters,
    kids: kids
  };
});


/***/ }),

/***/ "wM5X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.propagateErrors = propagateErrors;
exports.settled = settled;
exports.collectErrors = collectErrors;
exports.default = runValidations;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("LdEA"));

var _synchronousPromise = __webpack_require__("V5RX");

var _ValidationError = _interopRequireDefault(__webpack_require__("fnDY"));

var promise = function promise(sync) {
  return sync ? _synchronousPromise.SynchronousPromise : Promise;
};

var unwrapError = function unwrapError(errors) {
  if (errors === void 0) {
    errors = [];
  }

  return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
};

function scopeToValue(promises, value, sync) {
  //console.log('scopeToValue', promises, value)
  var p = promise(sync).all(promises); //console.log('scopeToValue B', p)

  var b = p.catch(function (err) {
    if (err.name === 'ValidationError') err.value = value;
    throw err;
  }); //console.log('scopeToValue c', b)

  var c = b.then(function () {
    return value;
  }); //console.log('scopeToValue d', c)

  return c;
}
/**
 * If not failing on the first error, catch the errors
 * and collect them in an array
 */


function propagateErrors(endEarly, errors) {
  return endEarly ? null : function (err) {
    errors.push(err);
    return err.value;
  };
}

function settled(promises, sync) {
  var Promise = promise(sync);
  return Promise.all(promises.map(function (p) {
    return Promise.resolve(p).then(function (value) {
      return {
        fulfilled: true,
        value: value
      };
    }, function (value) {
      return {
        fulfilled: false,
        value: value
      };
    });
  }));
}

function collectErrors(_ref) {
  var validations = _ref.validations,
      value = _ref.value,
      path = _ref.path,
      sync = _ref.sync,
      errors = _ref.errors,
      sort = _ref.sort;
  errors = unwrapError(errors);
  return settled(validations, sync).then(function (results) {
    var nestedErrors = results.filter(function (r) {
      return !r.fulfilled;
    }).reduce(function (arr, _ref2) {
      var error = _ref2.value;

      // we are only collecting validation errors
      if (!_ValidationError.default.isError(error)) {
        throw error;
      }

      return arr.concat(error);
    }, []);
    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

    errors = nestedErrors.concat(errors);
    if (errors.length) throw new _ValidationError.default(errors, value, path);
    return value;
  });
}

function runValidations(_ref3) {
  var endEarly = _ref3.endEarly,
      options = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["endEarly"]);
  if (endEarly) return scopeToValue(options.validations, options.value, options.sync);
  return collectErrors(options);
}

/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3KgV");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__);

var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "waz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ToastContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__["createContext"]({
  ref: null
});

/***/ }),

/***/ "wg0c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("2oRo");
var fails = __webpack_require__("0Dky");
var uncurryThis = __webpack_require__("4zBA");
var toString = __webpack_require__("V37c");
var trim = __webpack_require__("WKiH").trim;
var whitespaces = __webpack_require__("WJkJ");

var $parseInt = global.parseInt;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "xGYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputNumber_InputNumber; });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("sMBO");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("qePV");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("07d7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("SuFq");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("JfAA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasColumnLayout = _ref.hasColumnLayout,
        hasValue = _ref.hasValue,
        isDisabled = _ref.isDisabled,
        isReadOnly = _ref.isReadOnly,
        validationState = _ref.validationState;
    return {
      thRoot: classnames_default()('flex items-center', {
        'flex-col gap-5 text-center': hasColumnLayout,
        'gap-10 justify-between': !hasColumnLayout
      }),
      thLabel: classnames_default()('text-14', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thNotes: 'block text-10',
      thInputs: 'flex gap-5 items-center shrink-0',
      thInput: classnames_default()('font-bold text-18 text-center outline-custom', {
        'text-black': validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thButton: 'aspect-square cursor-pointer disabled:cursor-default bg-saffron hocus:enabled:bg-saffron-active disabled:bg-pearl h-[3rem] rounded-pill shrink-0 disabled:text-grey transition-colors duration-250 ease-in w-[3rem]',
      thButtonIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx














var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var InputNumber_InputNumber = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputNumber, _Component);

  var _super = _createSuper(InputNumber);

  function InputNumber(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputNumber);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop_default.a : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = Number(e.target.value);

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "decrease", function () {
      var _this$props2 = _this.props,
          _this$props2$name = _this$props2.name,
          name = _this$props2$name === void 0 ? '' : _this$props2$name,
          _this$props2$min = _this$props2.min,
          min = _this$props2$min === void 0 ? 0 : _this$props2$min,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? 1 : _this$props2$step,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? noop_default.a : _this$props2$onChange;
      var currentValue = _this.state.value || min;
      var decreasedValue = currentValue - step;
      var nextValue = decreasedValue >= min ? decreasedValue : min;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "increase", function () {
      var _this$props3 = _this.props,
          _this$props3$name = _this$props3.name,
          name = _this$props3$name === void 0 ? '' : _this$props3$name,
          _this$props3$min = _this$props3.min,
          min = _this$props3$min === void 0 ? 0 : _this$props3$min,
          _this$props3$max = _this$props3.max,
          max = _this$props3$max === void 0 ? 10 : _this$props3$max,
          _this$props3$step = _this$props3.step,
          step = _this$props3$step === void 0 ? 1 : _this$props3$step,
          _this$props3$onChange = _this$props3.onChange,
          onChange = _this$props3$onChange === void 0 ? noop_default.a : _this$props3$onChange;
      var currentValue = _this.state.value || min;
      var increasedValue = currentValue + step;
      var nextValue = increasedValue <= max ? increasedValue : max;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputNumber, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ariaLabel = _this$props4.ariaLabel,
          autoComplete = _this$props4.autoComplete,
          className = _this$props4.className,
          _this$props4$dataTest = _this$props4.dataTestId,
          dataTestId = _this$props4$dataTest === void 0 ? 'InputNumber' : _this$props4$dataTest,
          _this$props4$hasColum = _this$props4.hasColumnLayout,
          hasColumnLayout = _this$props4$hasColum === void 0 ? false : _this$props4$hasColum,
          _this$props4$id = _this$props4.id,
          id = _this$props4$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputNumber_') : _this$props4$id,
          isDisabled = _this$props4.isDisabled,
          isLoading = _this$props4.isLoading,
          isReadOnly = _this$props4.isReadOnly,
          isRequired = _this$props4.isRequired,
          label = _this$props4.label,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? 10 : _this$props4$max,
          _this$props4$min = _this$props4.min,
          min = _this$props4$min === void 0 ? 1 : _this$props4$min,
          name = _this$props4.name,
          notes = _this$props4.notes,
          onBlur = _this$props4.onBlur,
          onClick = _this$props4.onClick,
          onFocus = _this$props4.onFocus,
          onKeyDown = _this$props4.onKeyDown,
          onKeyUp = _this$props4.onKeyUp,
          placeholder = _this$props4.placeholder,
          step = _this$props4.step,
          theme = _this$props4.theme,
          validationState = _this$props4.validationState;
      var value = this.state.value;
      var hasValue = Boolean(value);
      var decreaseDisabled = isDisabled || isLoading || Number(value) <= min;
      var increaseDisabled = isDisabled || isLoading || Number(value) >= max;

      var _themes$theme = themes[theme]({
        hasColumnLayout: hasColumnLayout,
        hasValue: hasValue,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        validationState: validationState
      }),
          thButton = _themes$theme.thButton,
          thButtonIconWidth = _themes$theme.thButtonIconWidth,
          thInput = _themes$theme.thInput,
          thInputs = _themes$theme.thInputs,
          thLabel = _themes$theme.thLabel,
          thNotes = _themes$theme.thNotes,
          thRoot = _themes$theme.thRoot;

      if (false) {}

      return __jsx("div", {
        className: classnames_default()(thRoot, className),
        "data-testid": dataTestId
      }, !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, label, !!notes && __jsx("span", {
        className: thNotes
      }, notes)), __jsx("div", {
        className: thInputs
      }, !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-decrease"),
        disabled: decreaseDisabled,
        onClick: this.decrease,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].MINUS,
        width: thButtonIconWidth
      })), __jsx("input", Object(esm_extends["a" /* default */])({
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        id: id,
        max: max,
        min: min // $FlowFixMe

      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
      }, placeholder ? {
        placeholder: placeholder
      } : null, {
        readOnly: true,
        required: isRequired,
        step: step,
        style: {
          width: "".concat(max.toString().length + 0.5, "em"),
          height: '1.875em',
          lineHeight: '1.875em'
        },
        type: "number",
        value: value
      })), !isReadOnly && __jsx("button", {
        className: thButton,
        "data-testid": "".concat(dataTestId, "-increase"),
        disabled: increaseDisabled,
        onClick: this.increase,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PLUS,
        width: thButtonIconWidth
      }))));
    }
  }]);

  return InputNumber;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputNumber_InputNumber, "defaultProps", {
  autoComplete: 'off',
  max: 10,
  min: 0,
  step: 1,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "y/CH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = parseIsoDate;

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    } // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

module.exports = exports["default"];

/***/ }),

/***/ "y2Ah":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("wC3K"),
    baseForOwn = __webpack_require__("zKkv"),
    baseIteratee = __webpack_require__("S3pA");

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ "y5Lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CNIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EMAIL_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SMS_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MAIL_OPTIN; });
/* unused harmony export CGV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IDENTITY_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PHONE_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PROFILING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FOSUN_PARTNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLUBMED_PLUS; });
/* unused harmony export THEO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PASSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IDCARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOCUMENT_TYPES; });
var CNIL = 'CNIL';
var EMAIL_OPTIN = 'EMAIL_OPTIN';
var SMS_OPTIN = 'SMS_OPTIN';
var MAIL_OPTIN = 'MAIL_OPTIN';
var CGV = 'CGV';
var IDENTITY_NUMBER = 'IDENTITY_NUMBER';
var PHONE_OPTIN = 'PHONE_OPTIN';
var PROFILING = 'PROFILING';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var CLUBMED_PLUS = 'CLUBMED_PLUS';
var THEO = 'WEBTHEO';
var PASSPORT = 'PASSPORT';
var IDCARD = 'IDCARD'; // right now we only manage these two document types

var DOCUMENT_TYPES = [PASSPORT, IDCARD];

/***/ }),

/***/ "yFoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransportCriteria; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uDfI");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("RUiN");
/* harmony import */ var _criteria_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+Rc+");
/* harmony import */ var _criteria_criteria_transport_filter_transport_FilterTransport__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("M3jp");
/* harmony import */ var _hooks_use_sync_departure_city_useSyncDepartureCity__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Akr5");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kiXb");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("loSl");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;










var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].NO_TRANSPORT_VALUE;
var TransportCriteria = function TransportCriteria(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      departureCity = _ref.departureCity,
      handleDepartureCity = _ref.handleDepartureCity,
      initialTransport = _ref.initialTransport,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$transportIcon = _ref.transportIcon,
      transportIcon = _ref$transportIcon === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].TRANSPORT : _ref$transportIcon,
      withValidDepartureCity = _ref.withValidDepartureCity;
  var isInitialMount = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])(true);
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useDispatch */ "d"])();

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      isTransportCriteriaOpen = _useState[0],
      setTransportCriteriaIsOpen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      isTransportCriteriaSet = _useState2[0],
      setTransportCriteriaIsSet = _useState2[1]; // Store update effect


  var _useSyncDepartureCity = Object(_hooks_use_sync_departure_city_useSyncDepartureCity__WEBPACK_IMPORTED_MODULE_8__[/* useSyncDepartureCity */ "a"])({
    departureCitiesOptions: departureCitiesOptions,
    departureCity: departureCity,
    initialTransport: initialTransport,
    onChange: function onChange(newDepartureCity) {
      setTransportCriteriaIsSet(Boolean(newDepartureCity));
    },
    withValidDepartureCity: withValidDepartureCity
  }),
      inputDepartureCity = _useSyncDepartureCity.inputDepartureCity,
      setInputDepartureCity = _useSyncDepartureCity.setInputDepartureCity;

  var noDepartureCitiesOptions = [{
    isDisabled: true,
    isSelected: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('booking.priceCalendar.priceStatus.noFlight'),
    value: ''
  }];
  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    if (!isInitialMount.current && inputDepartureCity) {
      saveTransport();
    }

    isInitialMount.current = false;
  }, [inputDepartureCity]);

  var saveTransport = function saveTransport() {
    if (inputDepartureCity !== departureCity || !inputDepartureCity) {
      if (handleDepartureCity) {
        handleDepartureCity(inputDepartureCity || NO_TRANSPORT_VALUE);
      } else {
        dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_10__[/* changeDepartureCity */ "a"])(inputDepartureCity || NO_TRANSPORT_VALUE));
      }
    }

    setTransportCriteriaIsOpen(false);
    setTransportCriteriaIsSet(Boolean(inputDepartureCity));
  };

  var getIcon = function getIcon() {
    if (!departureCity || departureCity === NO_TRANSPORT_VALUE) {
      return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].NO_TRANSPORT;
    }

    return transportIcon;
  };

  var getLabel = function getLabel() {
    if (!isTransportCriteriaSet) {
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.subTitle');
    }

    var valueToMatch = departureCity || NO_TRANSPORT_VALUE;
    var selectedOption = departureCitiesOptions.find(function (item) {
      return item.value === valueToMatch;
    });
    return selectedOption ? selectedOption.label : Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.subTitle');
  };

  var buttonLabel = __jsx("span", {
    className: "flex-1 block truncate"
  }, getLabel());

  var onOpen = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
    setTransportCriteriaIsOpen(true);
    Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_5__[/* scrollToElement */ "a"])('[data-testid="TransportCriteria-trigger"]');
  }, []);
  var onClear = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
    if (handleDepartureCity) {
      handleDepartureCity(NO_TRANSPORT_VALUE);
    } else {
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_10__[/* changeDepartureCity */ "a"])(NO_TRANSPORT_VALUE));
    }

    setTransportCriteriaIsSet(false);
  }, []);
  return __jsx(_criteria_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_6__[/* CriteriaTrigger */ "a"], {
    dataTestId: "TransportCriteria-trigger",
    buttonLabel: buttonLabel,
    buttonIcon: getIcon(),
    buttonIsFilled: Boolean(isTransportCriteriaSet && departureCity && departureCity !== NO_TRANSPORT_VALUE),
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.reset'),
      onClick: function onClick() {
        setInputDepartureCity('');
      },
      theme: 'link'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.validate'),
      dataTestId: 'TransportCriteria-trigger-validate',
      onClick: saveTransport
    }],
    hasSwitch: true,
    isJoyview: isJoyview,
    isOpen: isTransportCriteriaOpen,
    onClear: onClear,
    onClose: saveTransport,
    onOpen: onOpen,
    theme: "default",
    trackingLabel: "departureCity"
  }, __jsx(_criteria_criteria_transport_filter_transport_FilterTransport__WEBPACK_IMPORTED_MODULE_7__[/* FilterTransport */ "a"], {
    changeDepartureCity: function changeDepartureCity(newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
    },
    className: "h-full",
    dataTestId: "TransportCriteria-input",
    departureCity: !departureCitiesOptions.length ? '' : inputDepartureCity,
    isDisabled: !departureCitiesOptions.length,
    labelDepartingFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.departingFrom'),
    optionsDepartureCities: departureCitiesOptions.length > 0 ? departureCitiesOptions : noDepartureCitiesOptions,
    placeholderFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.titleFrom'),
    selectPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_9__[/* t */ "h"])('faceting.transport.selectPlaceholder'),
    validateDepartureCity: saveTransport
  }));
};

/***/ }),

/***/ "yWCo":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("T0aG")["default"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ "yfdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductPriceModal_ProductPriceModal; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.utils.js

var ProductPriceModal_utils_getLabel = function getLabel(_ref) {
  var isJoyview = _ref.isJoyview,
      isTour = _ref.isTour;

  if (isTour) {
    return '';
  }

  return isJoyview ? Object(i18n["h" /* t */])('resort.startingPrice.roomOnly') : Object(i18n["h" /* t */])('resort.startingPrice.allInclusive');
};
// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx
var __jsx = react_default.a.createElement;




var ProductPriceModal_ProductPriceModal = function ProductPriceModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      city = _ref.city,
      endDate = _ref.endDate,
      _ref$hasTransport = _ref.hasTransport,
      hasTransport = _ref$hasTransport === void 0 ? false : _ref$hasTransport,
      _ref$isCruise = _ref.isCruise,
      isCruise = _ref$isCruise === void 0 ? false : _ref$isCruise,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isTour = _ref.isTour,
      isTour = _ref$isTour === void 0 ? false : _ref$isTour,
      onClick = _ref.onClick,
      onClickButton = _ref.onClickButton,
      rate = _ref.rate,
      startDate = _ref.startDate,
      unit = _ref.unit;

  if (!react["Children"].count(children)) {
    return null;
  }

  return __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: ProductPriceModal_utils_getLabel({
      isJoyview: isJoyview,
      isTour: isTour
    }),
    className: className,
    content: __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
      city: city,
      endDate: endDate,
      hasTransport: hasTransport,
      isCruise: isCruise,
      isJoyview: isJoyview,
      isTour: isTour,
      onClick: onClickButton,
      rate: rate,
      startDate: startDate,
      unit: unit
    }),
    isModalOnly: true,
    onClick: onClick
  }, children);
};

/***/ }),

/***/ "yjkv":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    baseUniq = __webpack_require__("s+R0");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ "z8xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLANE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLIGHT_CLASS_AVAILABLE_TO_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRAIN_CLASS_AVAILABLE_TO_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRANSPORT_CLASS_TO_I18N; });
/* unused harmony export SNCF_ID */
/* unused harmony export getFindSectionTransportTypeFn */
/* unused harmony export getClassLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getDiffAbsoluteDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return formatDate; });
/* unused harmony export getWayLabel */
/* unused harmony export formatConnectionLabel */
/* unused harmony export getStep */
/* unused harmony export hasPlane */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasOnlyPlanes; });
/* unused harmony export isTransportPlaneTicket */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return tripsHaveSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return transformMinutesInHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getTransportIcon; });
/* unused harmony export hasCancellationPolicy */
/* unused harmony export getCancellationPolicyDescription */
/* unused harmony export getNDCCancelationPolicyDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCompanyOperators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCompanyOperatorsName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTransportClasses; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("pNMO");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4Brf");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("piMb");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("oVuX");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("E9XD");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Rfxz");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("qePV");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("TZCg");
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("jLkM");
/* harmony import */ var lodash_uniq__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("yjkv");
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("ZHrn");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_booking_process_constants__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("XpIN");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("WGoB");



























var BOAT = 'BOAT';
var PLANE = 'PLANE';
var TRAIN = 'TRAIN';
var FLIGHT_CLASS_AVAILABLE_TO_SEARCH = ['PLANE_ECONOMY', 'PLANE_ECONOMY_PLUS', 'PLANE_BUSINESS', 'PLANE_PREMIUM', 'PLANE_FIRST'];
var TRAIN_CLASS_AVAILABLE_TO_SEARCH = ['TRAIN_SECOND', 'TRAIN_FIRST'];
var TRANSPORT_CLASS_TO_I18N = {
  '1CL': 'firstClassLabel',
  '2CL': 'secondClassLabel',
  BUS: 'businessClassLabel',
  DIB: 'emeraldClassLabel',
  DIV: 'economyClassLabel',
  ECO: 'economyClassLabel',
  'EC+': 'alizeeClassLabel',
  FIR: 'firstClassLabel',
  PLANE_BUSINESS: 'businessClassLabel',
  PLANE_ECONOMY: 'economyClassLabel',
  PLANE_ECONOMY_PLUS: 'alizeeClassLabel',
  PLANE_FIRST: 'firstClassLabel',
  PLANE_PREMIUM: 'premiumClassLabel',
  PRC: 'premiumClassLabel',
  PRE: 'premiumClassLabel',
  TRAIN_FIRST: 'firstClassLabel',
  TRAIN_SECOND: 'secondClassLabel'
};
var SNCF_ID = 'SNC';

function getDiffAbsoluteDays(fromDate, toDate) {
  var fromMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__[/* momentFromApiDate */ "j"])(fromDate);
  var toMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__[/* momentFromApiDate */ "j"])(toDate);

  if (fromMoment.isValid() && toMoment.isValid()) {
    return toMoment.diff(fromMoment, 'days');
  }

  return null;
}

function formatTime(time, format) {
  var renderedTime = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__[/* momentFromApiTime */ "l"])(time).format(format);
  return renderedTime !== 'Invalid date' ? renderedTime : null;
}

function formatDate(date, format) {
  return Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_26__[/* capitalizeName */ "a"])(Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_24__[/* momentFromApiDate */ "j"])(date).format(format || Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])('common.verboseDateFormatTechnicalID')));
}

function getWayLabel(i18n, way) {
  if (way === 'INBOUND') {
    var _i18n$common, _i18n$common$transpor;

    return i18n === null || i18n === void 0 ? void 0 : (_i18n$common = i18n.common) === null || _i18n$common === void 0 ? void 0 : (_i18n$common$transpor = _i18n$common.transport) === null || _i18n$common$transpor === void 0 ? void 0 : _i18n$common$transpor.inboundLabel;
  }

  if (way === 'OUTBOUND') {
    var _i18n$common2, _i18n$common2$transpo;

    return i18n === null || i18n === void 0 ? void 0 : (_i18n$common2 = i18n.common) === null || _i18n$common2 === void 0 ? void 0 : (_i18n$common2$transpo = _i18n$common2.transport) === null || _i18n$common2$transpo === void 0 ? void 0 : _i18n$common2$transpo.outboundLabel;
  }

  return null;
}

function formatConnectionLabel(label, duration) {
  var durationAsNumber = duration ? +duration : 0;
  var durationFormated = moment__WEBPACK_IMPORTED_MODULE_18___default.a.utc(moment__WEBPACK_IMPORTED_MODULE_18___default.a.duration(durationAsNumber, 'minutes').asMilliseconds());
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["messageFormat"])('{label} {duration}').format({
    label: label,
    duration: "".concat(durationFormated.format('HH'), "h").concat(durationFormated.format('mm'))
  });
}

function getStep(i18n) {
  var _i18n$common3, _i18n$common3$transpo;

  var _ref = (i18n === null || i18n === void 0 ? void 0 : i18n.common) || {},
      timeFormat = _ref.timeFormat;

  var transportConnectionLabel = i18n === null || i18n === void 0 ? void 0 : (_i18n$common3 = i18n.common) === null || _i18n$common3 === void 0 ? void 0 : (_i18n$common3$transpo = _i18n$common3.transport) === null || _i18n$common3$transpo === void 0 ? void 0 : _i18n$common3$transpo.connection;
  return function (step) {
    var connectionDuration = lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'connectionDurationInMin');

    var stopOverDuration = lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'stopDurationInMin');

    var information = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16___default()(stopOverDuration) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16___default()(connectionDuration) ? formatConnectionLabel(transportConnectionLabel, stopOverDuration || connectionDuration) : null;
    return {
      id: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.reference'),
      type: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.type'),
      information: information,
      operator: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.companyOperator.label'),
      operatorId: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.companyOperator.id'),
      operatorLogo: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'transport.companyOperator.logo'),
      start: {
        label: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'departure.airportLabel'),
        time: formatTime(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'departure.time'), timeFormat),
        date: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'departure.date')
      },
      end: {
        label: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'arrival.airportLabel'),
        time: formatTime(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'arrival.time'), timeFormat),
        date: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'arrival.date')
      },
      technicalStops: lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(step, 'technicalStops')
    };
  };
}

function hasOnlyBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'transport.type') === BOAT;
  });
}

function hasBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'transport.type') === BOAT;
  });
}

function hasPlane(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'transport.type') === PLANE;
  });
}

function hasTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyPlanes(travelSections) {
  return !(hasTrain(travelSections) || hasBoat(travelSections));
}

function isTransportPlaneTicket(inbound, outbound) {
  return hasOnlyPlanes(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(inbound, 'travelSections')) && hasOnlyPlanes(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(outbound, 'travelSections'));
}

function getTransportIcon(inbound, outbound) {
  var isTrain = hasTrain(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(inbound, 'travelSections')) && hasTrain(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(outbound, 'travelSections'));

  if (isTrain) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].TRAIN;
  }

  var isBoat = hasOnlyBoat(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(inbound, 'travelSections')) && hasOnlyBoat(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(outbound, 'travelSections'));

  if (isBoat) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].BOAT;
  }

  return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].TRANSPORT;
}

function tripHasSchedules(travelSections) {
  return !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_16___default()(travelSections) ? (travelSections || []).some(function (section) {
    return lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'arrival.time') || lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(section, 'departure.time');
  }) : false;
}

function tripsHaveSchedules(inbound, outbound) {
  return tripHasSchedules(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(inbound, 'travelSections')) || tripHasSchedules(lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(outbound, 'travelSections'));
}

function transformMinutesInHours(minutes) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var numberMinutes = Number(minutes);
  var time = [Math.floor(numberMinutes / 60), Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])('options.countdownLabels.hours'), "".concat(isRTL ? '-' : ''), (numberMinutes % 60).toString().padStart(2, '0'), Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])('options.countdownLabels.min')];
  return time.join(' ');
}

function hasCancellationPolicy(transport) {
  var _transport$inbound, _transport$outbound;

  return (// $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_25__[/* isCharterFlight */ "t"])(((_transport$inbound = transport.inbound) === null || _transport$inbound === void 0 ? void 0 : _transport$inbound.cancellationPolicyType) || '') || // $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_25__[/* isCharterFlight */ "t"])(((_transport$outbound = transport.outbound) === null || _transport$outbound === void 0 ? void 0 : _transport$outbound.cancellationPolicyType) || '')
  );
}

function getCompanyOperators() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var companyOperators = travelSections.reduce(function (companies, section) {
    var _section$transport, _section$transport$co, _section$transport2, _section$transport2$c;

    if ((section === null || section === void 0 ? void 0 : (_section$transport = section.transport) === null || _section$transport === void 0 ? void 0 : (_section$transport$co = _section$transport.companyOperator) === null || _section$transport$co === void 0 ? void 0 : _section$transport$co.id) && (section === null || section === void 0 ? void 0 : (_section$transport2 = section.transport) === null || _section$transport2 === void 0 ? void 0 : (_section$transport2$c = _section$transport2.companyOperator) === null || _section$transport2$c === void 0 ? void 0 : _section$transport2$c.label)) {
      companies.push(section.transport.companyOperator);
    }

    return companies;
  }, []);
  return lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15___default()(companyOperators, 'id');
}

function getCompanyOperatorsName() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var companyOperators = getCompanyOperators(travelSections);
  return lodash_uniqBy__WEBPACK_IMPORTED_MODULE_15___default()(companyOperators, 'id').map(function (company) {
    return Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_26__[/* capitalizeName */ "a"])(company.label);
  });
}

function getTransportClasses() {
  var travelSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allClasses = travelSections.map(function (section) {
    var _section$transport3;

    return section === null || section === void 0 ? void 0 : (_section$transport3 = section.transport) === null || _section$transport3 === void 0 ? void 0 : _section$transport3["class"];
  }).filter(Boolean);
  return lodash_uniq__WEBPACK_IMPORTED_MODULE_14___default()(allClasses);
} // TODO: check business rule


var getCancellationPolicy = function getCancellationPolicy(transport) {
  var _transport$inbound2, _transport$outbound2; // $FlowFixMe at this point it's an Transport object


  return ((_transport$inbound2 = transport.inbound) === null || _transport$inbound2 === void 0 ? void 0 : _transport$inbound2.cancellationPolicyType) || ((_transport$outbound2 = transport.outbound) === null || _transport$outbound2 === void 0 ? void 0 : _transport$outbound2.cancellationPolicyType);
};

var getCancellationPolicyDescription = function getCancellationPolicyDescription(transport, i18n) {
  if (hasCancellationPolicy(transport)) {
    var _i18n$bookingProcess$;

    var cancellationPolicy = getCancellationPolicy(transport);
    return i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingProcess$ = i18n.bookingProcess.find(function (legalInformation) {
      return legalInformation.id === cancellationPolicy;
    })) === null || _i18n$bookingProcess$ === void 0 ? void 0 : _i18n$bookingProcess$.description;
  }
};

var getNDCCancelationPolicyDescription = function getNDCCancelationPolicyDescription(transports, i18n) {
  var cancellationPolicy = getCancellationPolicy(transports);

  if (cancellationPolicy === _utils_booking_process_constants__WEBPACK_IMPORTED_MODULE_23__[/* LEGAL_INFO_NDC_ID */ "c"]) {
    var _getOptinsInfos, _getOptinsInfos$ndc;

    return (_getOptinsInfos = Object(_contact_info_ContactInfoUtils__WEBPACK_IMPORTED_MODULE_20__[/* getOptinsInfos */ "j"])(i18n === null || i18n === void 0 ? void 0 : i18n.bookingProcess)) === null || _getOptinsInfos === void 0 ? void 0 : (_getOptinsInfos$ndc = _getOptinsInfos.ndc) === null || _getOptinsInfos$ndc === void 0 ? void 0 : _getOptinsInfos$ndc.description;
  }
};

var getFindSectionTransportTypeFn = function getFindSectionTransportTypeFn(transportType) {
  return function (_ref2) {
    var type = _ref2.transport.type;
    return type === transportType;
  };
};
var getClassLabel = function getClassLabel(_ref3) {
  var transportType = _ref3.transportType,
      travelSections = _ref3.travelSections,
      inboundCriteria = _ref3.inboundCriteria;

  var transportClass = (inboundCriteria === null || inboundCriteria === void 0 ? void 0 : inboundCriteria.flightClass) || lodash_get__WEBPACK_IMPORTED_MODULE_17___default()(transportType ? travelSections.find(getFindSectionTransportTypeFn(transportType)) : travelSections[0], 'transport.class');

  if (!TRANSPORT_CLASS_TO_I18N[transportClass]) {
    return null;
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_22__[/* t */ "h"])("common.transport.transportClass.".concat(TRANSPORT_CLASS_TO_I18N[transportClass]));
};


/***/ }),

/***/ "zBae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("IGGJ");

exports.__esModule = true;
exports.getIn = getIn;
exports.default = void 0;

var _propertyExpr = __webpack_require__("dFUt");

var _has = _interopRequireDefault(__webpack_require__("1mr4"));

var trim = function trim(part) {
  return part.substr(0, part.length - 1).substr(1);
};

function getIn(schema, path, value, context) {
  var parent, lastPart, lastPartDebug; // if only one "value" arg then use it for both

  context = context || value;
  if (!path) return {
    parent: parent,
    parentPath: path,
    schema: schema
  };
  (0, _propertyExpr.forEach)(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim(_part) : _part;

    if (isArray || (0, _has.default)(schema, '_subType')) {
      // we skipped an array: foo[].bar
      var idx = isArray ? parseInt(part, 10) : 0;
      schema = schema.resolve({
        context: context,
        parent: parent,
        value: value
      })._subType;

      if (value) {
        if (isArray && idx >= value.length) {
          throw new Error("Yup.reach cannot resolve an array item at index: " + _part + ", in the path: " + path + ". " + "because there is no value at that index. ");
        }

        value = value[idx];
      }
    }

    if (!isArray) {
      schema = schema.resolve({
        context: context,
        parent: parent,
        value: value
      });
      if (!(0, _has.default)(schema, 'fields') || !(0, _has.default)(schema.fields, part)) throw new Error("The schema does not contain the path: " + path + ". " + ("(failed at: " + lastPartDebug + " which is a type: \"" + schema._type + "\") "));
      schema = schema.fields[part];
      parent = value;
      value = value && value[part];
      lastPart = part;
      lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    }
  });
  return {
    schema: schema,
    parent: parent,
    parentPath: lastPart
  };
}

var reach = function reach(obj, path, value, context) {
  return getIn(obj, path, value, context).schema;
};

var _default = reach;
exports.default = _default;

/***/ }),

/***/ "zKZe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("I+eb");
var assign = __webpack_require__("YNrV");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ })

}]);